webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PREVIEWBOX_TIME_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PREVIEWBOX_CLASSROOM_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PREVIEWBOX_STYLE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PREVIEWBOX_SHOW_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PREVIEWBOX_HIDE_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RESERVATIONBOX_ENTER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return EDITINGBOX_TIME_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EDITINGBOX_CLASSROOM_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EDITINGBOX_STYLE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EDITING_POPUP_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EDITING_POPUP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EDITINGBOX_DRAG_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EDITINGBOX_DRAG_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RESERVATIONBOX_FINISH_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return EDITINGSTATE_SET_STUDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return EDITINGSTATE_SET_TEACHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return EDITINGSTATE_SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return EDITINGSTATE_SET_HAS_TEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return EDITINGSTATE_SET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return EDITINGSTATE_SET_RECURRENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return EDITINGSTATE_SET_IS_ONLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RESERVATION_SHOW_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RESERVATION_HIDE_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return RRULE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESERVATIONS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIMETABLE_CHANGE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USERINFO_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LECTURE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_LECTURES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return USER_LIST_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLASSROOMS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SPINNER_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SPINNER_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_HEADER_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SHOW_INFORMATION_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return HIDE_INFORMATION_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ATTENDANCE_UPDATE; });
/* unused harmony export TOGGLE_USER_ATTENDANCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_RESCHEDULING_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RESERVATIONBOX_ENTER_RESCHEDULING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RESCHEDULING_POPUP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_SCHOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOW_ONLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return MODAL; });

var PREVIEWBOX_TIME_UPDATE = 'PREVIEWBOX_TIME_UPDATE';

var PREVIEWBOX_CLASSROOM_UPDATE = 'PREVIEWBOX_CLASSROOM_UPDATE';

var PREVIEWBOX_STYLE_UPDATE = 'PREVIEWBOX_STYLE_UPDATE';

var PREVIEWBOX_SHOW_POPUP = 'PREVIEWBOX_SHOW_POPUP';

var PREVIEWBOX_HIDE_POPUP = 'PREVIEWBOX_HIDE_POPUP';

var RESERVATIONBOX_ENTER_EDIT = 'RESERVATIONBOX_ENTER_EDIT';

var EDITINGBOX_TIME_UPDATE = 'EDITINGBOX_TIME_UPDATE';

var EDITINGBOX_CLASSROOM_UPDATE = 'EDITINGBOX_CLASSROOM_UPDATE';

var EDITINGBOX_STYLE_UPDATE = 'EDITINGBOX_STYLE_UPDATE';

var EDITING_POPUP_SHOW = 'EDITING_POPUP_SHOW';

var EDITING_POPUP_HIDE = 'EDITING_POPUP_HIDE';

var EDITINGBOX_DRAG_START = 'EDITINGBOX_DRAG_START';

var EDITINGBOX_DRAG_END = 'EDITINGBOX_DRAG_END';

var RESERVATIONBOX_FINISH_EDIT = 'RESERVATIONBOX_FINISH_EDIT';

var EDITINGSTATE_SET_STUDENT = 'EDITINGSTATE_SET_STUDENT';
var EDITINGSTATE_SET_TEACHER = 'EDITINGSTATE_SET_TEACHER';
var EDITINGSTATE_SET_MESSAGE = 'EDITINGSTATE_SET_MESSAGE';
var EDITINGSTATE_SET_HAS_TEST = 'EDITINGSTATE_SET_HAS_TEST';
var EDITINGSTATE_SET_TYPE = 'EDITINGSTATE_SET_TYPE';
var EDITINGSTATE_SET_RECURRENCE = 'EDITINGSTATE_SET_RECURRENCE';
var EDITINGSTATE_SET_IS_ONLINE = 'EDITINGSTATE_SET_IS_ONLINE';

var RESERVATION_SHOW_POPUP = 'RESERVATION_SHOW_POPUP';

var RESERVATION_HIDE_POPUP = 'RESERVATION_HIDE_POPUP';

var RRULE_UPDATE = 'RRULE_UPDATE';

var RESERVATIONS_UPDATE = 'RESERVATIONS_UPDATE';

var TIMETABLE_CHANGE_DATE = 'TIMETABLE_CHANGE_DATE';

var USERINFO_UPDATE = 'USERINFO_UPDATE';

var LECTURE_UPDATE = 'LECTURE_UPDATE';

var USER_LECTURES_FETCH = 'USER_LECTURES_FETCH';

var USER_LIST_UPDATE = 'USER_LIST_UPDATE';

var CLASSROOMS_FETCH = 'CLASSROOMS_FETCH';

var LOGIN = 'LOGIN';

var LOGIN_SUCCESS = 'LOGIN_SUCCESS';

var LOGOUT = 'LOGOUT';

var SPINNER_SHOW = 'SPINNER_SHOW';

var SPINNER_HIDE = 'SPINNER_HIDE';

var UPDATE_HEADER_HEIGHT = 'UPDATE_HEADER_HEIGHT';

var SHOW_INFORMATION_POPUP = 'SHOW_INFORMATION_POPUP';

var HIDE_INFORMATION_POPUP = 'HIDE_INFORMATION_POPUP';

var ATTENDANCE_UPDATE = 'ATTENDANCE_UPDATE';

var TOGGLE_USER_ATTENDANCE = 'TOGGLE_USER_ATTENDANCE';

var SET_RESCHEDULING_INFO = 'SET_RESCHEDULING_INFO';

var RESERVATIONBOX_ENTER_RESCHEDULING = 'RESERVATIONBOX_ENTER_RESCHEDULING';
var RESCHEDULING_POPUP_HIDE = 'RESCHEDULING_POPUP_HIDE';

var CHANGE_SCHOOL = 'CHANGE_SCHOOL';
var SHOW_ONLINE = 'SHOW_ONLINE';

var MODAL = 'MODAL';

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hosts__ = __webpack_require__(55);





var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  'baseURL': __WEBPACK_IMPORTED_MODULE_2__hosts__["a" /* default */]
});
api.interceptors.request.use(function (config) {
  config.headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config.headers, {
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  });
  return config;
});
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class(time) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    var hours = Number(time.slice(0, 2));
    this.minuites = Number(time.slice(3, 5)) + hours * 60;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'addMinuites',
    value: function addMinuites(mins) {
      this.minuites += mins;
      return this;
    }
  }, {
    key: 'decresaseMinuites',
    value: function decresaseMinuites(mins) {
      this.minuites -= mins;
      return this;
    }
  }, {
    key: 'toString',
    value: function toString() {
      var hours = Math.floor(this.minuites / 60);
      var mins = Math.floor(this.minuites % 60);
      var formatedHours = '';
      if (hours < 10) {
        formatedHours = '0' + String(hours);
      } else {
        formatedHours = String(hours);
      }
      var formatedMins = '';
      if (mins < 10) {
        formatedMins = '0' + String(mins);
      } else {
        formatedMins = String(mins);
      }

      return formatedHours + ':' + formatedMins;
    }
  }, {
    key: 'getMinutes',
    value: function getMinutes() {
      return this.minuites;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  "data-v-9c35dec2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(702),
  /* scopeId */
  "data-v-49e21edc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ismobilejs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ismobilejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ismobilejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_token__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_timetable_Timetable__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_timetable_Timetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_timetable_Timetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ReservationListPage_ReservationListPage__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ReservationListPage_ReservationListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ReservationListPage_ReservationListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReservationListPage_ReservationList__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReservationListPage_ReservationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ReservationListPage_ReservationList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MainPage__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UserInfo_UserInfoPage__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UserInfo_UserInfoPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_UserInfo_UserInfoPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ManagementPage_ManagementPage__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ManagementPage_ManagementPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ManagementPage_ManagementPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ManagementPage_UserList__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ManagementPage_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ManagementPage_UserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ManagementPage_UserRegistrationForm__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ManagementPage_UserRegistrationForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ManagementPage_UserRegistrationForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ManagementPage_ReschedulingList__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ManagementPage_ReschedulingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_ManagementPage_ReschedulingList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HelpPage_SimpleHelpPage__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HelpPage_SimpleHelpPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_HelpPage_SimpleHelpPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ManagementPage_UserPage__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ManagementPage_UserPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ManagementPage_UserPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ManagementPage_EditLecturePage__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ManagementPage_EditLecturePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_ManagementPage_EditLecturePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ManagementPage_EditClassroomPage__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ManagementPage_EditClassroomPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_ManagementPage_EditClassroomPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ManagementPage_EditInformationPage__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ManagementPage_EditInformationPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_ManagementPage_EditInformationPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ManagementPage_InformationNotification__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ManagementPage_InformationNotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_ManagementPage_InformationNotification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Logout__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ReschedulingPage_ReschedulingSenderPage__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ReschedulingPage_ReschedulingSenderPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_ReschedulingPage_ReschedulingSenderPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_ReschedulingPage_ReschedulingSenderForm__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_ReschedulingPage_ReschedulingSenderForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_ReschedulingPage_ReschedulingSenderForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ReschedulingPage_ReschedulingSenderConfirmation__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ReschedulingPage_ReschedulingSenderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_ReschedulingPage_ReschedulingSenderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_ReschedulingPage_ReschedulingSenderCompletion__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_ReschedulingPage_ReschedulingSenderCompletion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_ReschedulingPage_ReschedulingSenderCompletion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ReschedulingPage_ReschedulingReceiverPage__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ReschedulingPage_ReschedulingReceiverPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_ReschedulingPage_ReschedulingReceiverPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ReschedulingPage_ReschedulingReceiverForm__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ReschedulingPage_ReschedulingReceiverForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_ReschedulingPage_ReschedulingReceiverForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ReschedulingPage_ReschedulingReceiverConfirmation__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ReschedulingPage_ReschedulingReceiverConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_ReschedulingPage_ReschedulingReceiverConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_ReschedulingPage_ReschedulingReceiverCompletion__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_ReschedulingPage_ReschedulingReceiverCompletion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_ReschedulingPage_ReschedulingReceiverCompletion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_ReschedulingPage_ReschedulingReceiverClassroom__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_ReschedulingPage_ReschedulingReceiverClassroom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_ReschedulingPage_ReschedulingReceiverClassroom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_ReschedulingPage_ReschedulingListPage__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_ReschedulingPage_ReschedulingListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_ReschedulingPage_ReschedulingListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Mobile_SpMainPage__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Mobile_SpMainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Mobile_SpMainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Mobile_timetable_SpTable__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Mobile_timetable_SpTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Mobile_timetable_SpTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Mobile_UserInfo_SpUserInfo__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Mobile_UserInfo_SpUserInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Mobile_UserInfo_SpUserInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Mobile_UserInfo_Spchangeuserinfo__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Mobile_UserInfo_Spchangeuserinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Mobile_UserInfo_Spchangeuserinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Mobile_ReschedulingPage_SpSenderForm__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Mobile_ReschedulingPage_SpSenderForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Mobile_ReschedulingPage_SpSenderForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Mobile_ReschedulingPage_SpSenderConfirmation__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Mobile_ReschedulingPage_SpSenderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Mobile_ReschedulingPage_SpSenderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Mobile_ReschedulingPage_SpSenderCompletion__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Mobile_ReschedulingPage_SpSenderCompletion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Mobile_ReschedulingPage_SpSenderCompletion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Mobile_ReschedulingPage_SpReceiverPage__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Mobile_ReschedulingPage_SpReceiverPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Mobile_ReschedulingPage_SpReceiverPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Mobile_ReschedulingPage_SpReceiverClassroom__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Mobile_ReschedulingPage_SpReceiverClassroom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Mobile_ReschedulingPage_SpReceiverClassroom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Mobile_ReschedulingPage_Spconfirmation_rcvr__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Mobile_ReschedulingPage_Spconfirmation_rcvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Mobile_ReschedulingPage_Spconfirmation_rcvr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Mobile_ReschedulingPage_SpReceiverCompletion__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Mobile_ReschedulingPage_SpReceiverCompletion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Mobile_ReschedulingPage_SpReceiverCompletion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Mobile_ReschedulingPage_SpreschedulingList__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Mobile_ReschedulingPage_SpreschedulingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Mobile_ReschedulingPage_SpreschedulingList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Mobile_HelpPage_SpHelpPage__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Mobile_HelpPage_SpHelpPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Mobile_HelpPage_SpHelpPage__);

















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/table',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_9__components_MainPage___default.a,
    meta: { requiresAuth: true },
    children: [{
      path: 'table',
      name: 'Timetable',
      component: __WEBPACK_IMPORTED_MODULE_5__components_timetable_Timetable___default.a,

      meta: { requiresAuth: true }
    }, {
      path: 'reservation_list',
      name: 'ReservationListPage',
      component: __WEBPACK_IMPORTED_MODULE_7__components_ReservationListPage_ReservationListPage___default.a,

      meta: { requiresAuth: true }
    }, {
      path: 'reservationlist',
      name: 'ReservationList',
      component: __WEBPACK_IMPORTED_MODULE_8__components_ReservationListPage_ReservationList___default.a,

      meta: { requiresAuth: true }
    }, {
      path: 'help',
      name: 'HelpPage',
      component: __WEBPACK_IMPORTED_MODULE_15__components_HelpPage_SimpleHelpPage___default.a,

      meta: { requiresAuth: true }
    }, {
      path: 'userinfo',
      name: 'UserInfo',
      component: __WEBPACK_IMPORTED_MODULE_10__components_UserInfo_UserInfoPage___default.a,

      meta: { requiresAuth: true }
    }, {
      path: 'management',
      name: 'ManagementPage',
      component: __WEBPACK_IMPORTED_MODULE_11__components_ManagementPage_ManagementPage___default.a,
      meta: { requiresAuth: true },
      children: [{
        path: 'users',
        name: 'UserList',
        component: __WEBPACK_IMPORTED_MODULE_12__components_ManagementPage_UserList___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'user_registration',
        name: 'UserRegistrationForm',
        component: __WEBPACK_IMPORTED_MODULE_13__components_ManagementPage_UserRegistrationForm___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'lecture_registration',
        name: 'EditLecturePage',
        component: __WEBPACK_IMPORTED_MODULE_17__components_ManagementPage_EditLecturePage___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'classroom_registration',
        name: 'EditClassroomPage',
        component: __WEBPACK_IMPORTED_MODULE_18__components_ManagementPage_EditClassroomPage___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'information',
        name: 'EditInformationPage',
        component: __WEBPACK_IMPORTED_MODULE_19__components_ManagementPage_EditInformationPage___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'reschedulings',
        name: 'ReschedulingList',
        component: __WEBPACK_IMPORTED_MODULE_14__components_ManagementPage_ReschedulingList___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'InformationNotification',
        name: 'InformationNotification',
        component: __WEBPACK_IMPORTED_MODULE_20__components_ManagementPage_InformationNotification___default.a,
        meta: { requiresAuth: true }
      }]
    }, {
      path: 'management/user/:id',
      name: 'UserPage',
      component: __WEBPACK_IMPORTED_MODULE_16__components_ManagementPage_UserPage___default.a,
      meta: { requiresAuth: true }
    }, {
      path: 'management/lecture_edit',
      name: 'EditLecturePage',
      component: __WEBPACK_IMPORTED_MODULE_17__components_ManagementPage_EditLecturePage___default.a,
      meta: { requiresAuth: true }
    }, {
      path: 'management/classroom_edit',
      name: 'EditClassroomPage',
      component: __WEBPACK_IMPORTED_MODULE_18__components_ManagementPage_EditClassroomPage___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/rescheduling',
      name: 'ReschedulingSenderPage',
      component: __WEBPACK_IMPORTED_MODULE_22__components_ReschedulingPage_ReschedulingSenderPage___default.a,
      meta: { requiresAuth: true },
      children: [{
        path: '',
        name: 'ReschedulingSenderForm',
        component: __WEBPACK_IMPORTED_MODULE_23__components_ReschedulingPage_ReschedulingSenderForm___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'confirmation',
        name: 'ReschedulingSenderConfirmation',
        component: __WEBPACK_IMPORTED_MODULE_24__components_ReschedulingPage_ReschedulingSenderConfirmation___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'completion',
        name: 'ReschedulingSenderCompletion',
        component: __WEBPACK_IMPORTED_MODULE_25__components_ReschedulingPage_ReschedulingSenderCompletion___default.a,
        meta: { requiresAuth: true }
      }]
    }, {
      path: '/rescheduling/:rescheduling_hash',
      name: 'ReschedulingReceiverPage',
      component: __WEBPACK_IMPORTED_MODULE_26__components_ReschedulingPage_ReschedulingReceiverPage___default.a,
      meta: { requiresAuth: true },
      children: [{
        path: '',
        name: 'ReschedulingReceiverForm',
        component: __WEBPACK_IMPORTED_MODULE_27__components_ReschedulingPage_ReschedulingReceiverForm___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'confirmation_rcvr',
        name: 'ReschedulingReceiverConfirmation',
        component: __WEBPACK_IMPORTED_MODULE_28__components_ReschedulingPage_ReschedulingReceiverConfirmation___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'ReschedulingReceiverClassroom',
        name: 'ReschedulingReceiverClassroom',
        component: __WEBPACK_IMPORTED_MODULE_30__components_ReschedulingPage_ReschedulingReceiverClassroom___default.a,
        meta: { requiresAuth: true }
      }, {
        path: 'final_confirmation',
        name: 'ReschedulingReceiverCompletion',
        component: __WEBPACK_IMPORTED_MODULE_29__components_ReschedulingPage_ReschedulingReceiverCompletion___default.a,
        meta: { requiresAuth: true }
      }]
    }]
  }, {
    path: '/SpTop',
    name: 'SpMainPage',
    redirect: '/Sptable',
    component: __WEBPACK_IMPORTED_MODULE_32__components_Mobile_SpMainPage___default.a,
    children: [{
      path: '/SpTable',
      name: 'SpTimeTable',
      component: __WEBPACK_IMPORTED_MODULE_33__components_Mobile_timetable_SpTable___default.a,

      meta: { requiresAuth: true }
    }, {
      path: '/Spuser',
      name: 'Spuser',
      component: __WEBPACK_IMPORTED_MODULE_34__components_Mobile_UserInfo_SpUserInfo___default.a,

      meta: { requiresAuth: true }
    }, {
      path: '/Spchangeuser',
      name: 'Spchangeuser',
      component: __WEBPACK_IMPORTED_MODULE_35__components_Mobile_UserInfo_Spchangeuserinfo___default.a,

      meta: { requiresAuth: true }
    }, {
      path: '/SpRescheduling',
      name: 'SpRescheduling',
      component: __WEBPACK_IMPORTED_MODULE_36__components_Mobile_ReschedulingPage_SpSenderForm___default.a,

      meta: { requiresAuth: true }
    }, {
      path: '/SpSenderConfirmation',
      name: 'SpSenderConfirmation',
      component: __WEBPACK_IMPORTED_MODULE_37__components_Mobile_ReschedulingPage_SpSenderConfirmation___default.a,

      meta: { requiresAuth: true }
    }, {
      path: '/SpSenderCompletion',
      name: 'SpSenderCompletion',
      component: __WEBPACK_IMPORTED_MODULE_38__components_Mobile_ReschedulingPage_SpSenderCompletion___default.a,

      meta: { requiresAuth: true }
    }, {
      path: '/SpRescheduling/:rescheduling_hash',
      name: 'SpReceiverPage',
      component: __WEBPACK_IMPORTED_MODULE_39__components_Mobile_ReschedulingPage_SpReceiverPage___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/SpRescheduling/:rescheduling_hash/SpReceiverClassroom',
      name: 'SpReceiverClassroom',
      component: __WEBPACK_IMPORTED_MODULE_40__components_Mobile_ReschedulingPage_SpReceiverClassroom___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/SpRescheduling/:rescheduling_hash/Spconfirmation_rcvr',
      name: 'Spconfirmation_rcvr',
      component: __WEBPACK_IMPORTED_MODULE_41__components_Mobile_ReschedulingPage_Spconfirmation_rcvr___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/SpRescheduling/:rescheduling_hash/SpReceiverCompletion',
      name: 'SpReceiverCompletion',
      component: __WEBPACK_IMPORTED_MODULE_42__components_Mobile_ReschedulingPage_SpReceiverCompletion___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/SpReschedulingList',
      name: 'SpReschedulingList',
      component: __WEBPACK_IMPORTED_MODULE_43__components_Mobile_ReschedulingPage_SpreschedulingList___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/SpHelpPage',
      name: 'SpHelpPage',
      component: __WEBPACK_IMPORTED_MODULE_44__components_Mobile_HelpPage_SpHelpPage___default.a,
      meta: { requiresAuth: true }
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Login___default.a
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Logout___default.a
  }, {
    path: '/reschedulinglist',
    name: 'ReschedulingListPage',
    component: __WEBPACK_IMPORTED_MODULE_31__components_ReschedulingPage_ReschedulingListPage___default.a,
    meta: { requiresAuth: true }
  }],
  linkActiveClass: 'currentLink',
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 48 }
      };
    }
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_4__api_token__["a" /* default */].getValidity().then(function (res) {
        if (!res.data.is_valid) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          });
        } else {
          var checkPath = function checkPath() {
            var isSmartPhone = __WEBPACK_IMPORTED_MODULE_3_ismobilejs___default.a.phone;
            if (isSmartPhone) {
              if (!to.path.match(/Sp/)) {
                next({
                  path: '/SpTop'
                });
              }
            }
            if (to.path.includes('/management') && !__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.userInfo.user_type === 'admin') {
              next({
                path: '/'
              });
            } else if (to.path === '/rescheduling/confirmation' && from.path !== '/rescheduling' && from.path !== '/rescheduling/' || to.path === '/rescheduling/complition' && from.path !== '/rescheduling/confirmation' && from.path !== '/rescheduling/confirmation/') {
              next({
                path: '/rescheduling'
              });
            } else {
              next();
            }
          };
          if (!__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.userInfo.hasOwnProperty('user_id')) {
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('getUserInfo').then(checkPath);
          } else {
            checkPath();
          }
        }
      });
    }
  } else {
    next();
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  headerHeight: 50,
  rulerWidth: 70,
  tbHeaderHeight: 50,
  mobileWidthMagnification: 1.5,
  mobileHeightMagnification: 1,
  rowHeight: 50,
  columnWidth: 100,
  classrooms: [{ name: '3-1', id: 0 }, { name: '3-2', id: 1 }, { name: '5-1', id: 2 }, { name: '5-2', id: 3 }, { name: '5-3', id: 4 }, { name: '4-3', id: 5 }, { name: '4-4', id: 6 }, { name: '4-5', id: 7 }, { name: '4-6', id: 8 }, { name: '4-7', id: 9 }, { name: '4-8', id: 10 }, { name: '4-1(オンライン)', id: 11 }, { name: '4-2(オンライン)', id: 12 }, { name: '面談1', id: 13 }, { name: '面談2', id: 14 }],
  timeScaleTicks: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00'],
  timeDivMin: 10,
  previewBox: {
    start: '10:00',
    end: '10:00',
    classroom: '',
    style: {
      top: 0,
      left: 0,
      height: 0,
      bottom: 0
    },
    isPopupShown: false
  },
  reservationbox: {
    isPopupShown: false
  },
  recurrentRule: '',
  editingState: {
    id: 0,
    start: '10:00',
    end: '10:00',
    classroom: '',
    recurrence_id: 0,
    message: '',
    hasTest: false,
    reservationType: '通常',
    teacher: 0,
    student: 0,
    isRecurrent: false,
    style: {
      top: 0,
      left: 0,
      height: 0
    },
    isPopupShown: false
  },
  rescherdulingState: {
    id: 0,
    date: null,
    start: '10:00',
    end: '10:00',
    classroom: '',
    recurrence_id: 0,
    message: '',
    hasTest: false,
    reservationType: '通常',
    teacher: 0,
    student: 0,
    isRecurrent: false,
    isPopupShown: false
  },
  informationPopup: {
    reservation: {}
  },
  isInfoPopupShown: false,
  curDate: new Date(),
  isLoggedIn: !!localStorage.getItem('token'),
  pending: false,
  reservations: [],
  lectureInfo: [],
  userInfo: {},
  userLectures: [],
  userlist: [],
  spinning: false,
  attendance: [],
  reschedulingInfo: null,
  reschedulingHash: null,
  modal: {
    trigger: false,
    text: 'テスト'
  },
  showOnline: false });

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var HOST = "https://api.kyushinjuku.kyuseat.site";

/* harmony default export */ __webpack_exports__["a"] = (HOST);

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7218440.png";

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(325);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* default */]);

var state = __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */];
var getters = __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */];
var mutations = __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */];
var actions = __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* default */].Store({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}));

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/lectures');
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/lectures/' + id);
  },
  getByUserId: function getByUserId(userId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/lectures', {
      params: {
        user_id: userId
      }
    });
  },
  post: function post(lecture) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/lectures', lecture);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].delete('/lectures/' + id);
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reservations', {
      params: {
        school_id: id
      }
    }).catch(function (err) {
      console.log(err);
    });
  },

  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reservations/' + id).catch(function (err) {
      console.log(err);
    });
  },

  getByDate: function getByDate(data) {
    console.log('getByDate');
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reservations', {
      params: {
        date: data.date,
        school_id: data.school_id
      }
    }).catch(function (err) {
      console.log(err);
    });
  },

  getByUserId: function getByUserId(uid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reservations', {
      params: {
        user_id: uid
      }
    }).catch(function (err) {
      console.log(err);
    });
  },

  getByRecurrenceId: function getByRecurrenceId(rid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reservations', {
      params: {
        recurrence_id: rid
      }
    }).catch(function (err) {
      console.log(err);
    });
  },

  getAllByDate: function getAllByDate(data) {
    console.log('getAllByDate');
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reservations', {
      params: {
        all: 1,
        date: data.date,
        school_id: data.school_id
      }
    }).catch(function (err) {
      console.log(err);
    });
  },

  post: function post(reservation) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/reservations', reservation);
  },

  put: function put(id, reservation) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/reservations/' + id, reservation);
  },

  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].delete('/reservations/' + id).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hosts__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_base__ = __webpack_require__(8);






var api = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  'baseURL': __WEBPACK_IMPORTED_MODULE_1__hosts__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(creds, cb) {
    var params = {
      'id': creds.id,
      'password': creds.password
    };

    return api.post('/token', params);
  },

  getValidity: function getValidity() {
    return __WEBPACK_IMPORTED_MODULE_2__api_base__["a" /* default */].get('/token/validity');
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  spareRooms: ['予備席'] });

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(680),
  /* scopeId */
  "data-v-2ab84f7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(683),
  /* scopeId */
  "data-v-34ffb580",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  "data-v-0ee74cda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  "data-v-54364d91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(701),
  /* scopeId */
  "data-v-49c9765a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  "data-v-442389a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  "data-v-66c74814",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  "data-v-676ad11c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  "data-v-7eb4f5f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  "data-v-0d6ec2ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(487)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  "data-v-02aed6dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var windowStatePlugin = {
  install: function install(Vue) {
    var state = {
      scrollX: 0,
      scrollY: 0
    };

    var onScroll = function onScroll() {
      state.scrollX = window.pageXOffset;
      state.scrollY = window.pageYOffset;
    };
    document.addEventListener('scroll', onScroll);
    window.addEventListener('load', function () {
      onScroll();
    });

    Vue.util.defineReactive(Vue.prototype, '$window', state);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (windowStatePlugin);

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/attendance').catch(function (err) {
      console.log(err);
    });
  },

  getByUserId: function getByUserId(uid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/attendance/' + uid).catch(function (err) {
      console.log(err);
    });
  },

  post: function post(uid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/attendance', { user_id: uid });
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/classrooms?id=' + id);
  },

  post: function post(classroom) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/classrooms', classroom);
  },

  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].delete('/classrooms/' + id);
  },

  put: function put(classroom) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/classrooms', classroom);
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hosts__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_base__ = __webpack_require__(8);






var api = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  'baseURL': __WEBPACK_IMPORTED_MODULE_1__hosts__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return api.get('/information');
  },

  post: function post(information) {
    return __WEBPACK_IMPORTED_MODULE_2__api_base__["a" /* default */].post('/information', information);
  },

  put: function put(information) {
    return __WEBPACK_IMPORTED_MODULE_2__api_base__["a" /* default */].put('/information', information);
  },

  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_2__api_base__["a" /* default */].delete('/information/' + id);
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  postUserInfoChange: function postUserInfoChange(data) {
    console.log(data);
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/mails/userinfo_change_notification', data).catch(function (err) {
      console.log(err);
      throw err;
    });
  },

  postReschedulingRequest: function postReschedulingRequest(hash) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/mails/rescheduling_request', { hash: hash }).catch(function (err) {
      console.log(err);
      throw err;
    });
  },
  postReschedulingResult: function postReschedulingResult(hash) {
    if (!hash.newhash) {
      return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('mails/rescheduling_result', { hash: hash }).catch(function (err) {
        throw err;
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('mails/rescheduling_result', {
        hash: hash.hash,
        newhash: hash.newhash
      }).catch(function (err) {
        throw err;
      });
    }
  },
  postReschedulingError: function postReschedulingError(hash) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('mails/rescheduling_error', { hash: hash }).catch(function (err) {
      throw err;
    });
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/monthReport', data);
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  getByFullname: function getByFullname(fullname) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/not_temporal_students/' + fullname);
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/recurrent_reservations').catch(function (err) {
      alert(err.response.data.message);
      console.log(err);
    });
  },

  post: function post(reservation) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/recurrent_reservations', reservation).catch(function (err) {
      alert(err.response.data.message);
      console.log(err);
    });
  },

  put: function put(id, reservation) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/recurrent_reservations/' + id, reservation).catch(function (err) {
      alert(err.response.data.message);
      console.log(err);
    });
  },

  delete: function _delete(id, fromReservaitonId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].delete('/recurrent_reservations/' + id + '?from=' + fromReservaitonId).catch(function (err) {
      alert(err.response.data.message);
      console.log(err);
    });
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reschedulings').catch(function (err) {
      console.log(err);
    });
  },

  getByHash: function getByHash(hash) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/reschedulings/' + hash).catch(function (err) {
      console.log(err);
    });
  },
  getList: function getList(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('reservationslist/' + id).catch(function (err) {
      console.log(err);
    });
  },

  post: function post(params) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/reschedulings', params);
  },

  put: function put(hash, params) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/reschedulings/' + hash, params);
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/sunday_teachers', { teacher_id: id });
  },

  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].delete('/sunday_teachers/' + id);
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  getByFullname: function getByFullname(fullname) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/temporal_students/' + fullname);
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/user_information');
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(user) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].post('/users', user);
  },

  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].delete('/users/' + id);
  },

  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].get('/users');
  },

  put: function put(id, param) {
    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/users/' + id, param);
  },

  putPassword: function putPassword(_ref) {
    var id = _ref.id,
        currentPassword = _ref.currentPassword,
        newPassword = _ref.newPassword;

    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/users/' + id + '/password', {
      current_password: currentPassword,
      new_password: newPassword
    });
  },

  putUserName: function putUserName(_ref2) {
    var id = _ref2.id,
        newUserName = _ref2.newUserName;

    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/users/' + id + '/user_name', {
      new_user_name: newUserName
    });
  },

  putFullname: function putFullname(_ref3) {
    var id = _ref3.id,
        newFullname = _ref3.newFullname,
        newKana = _ref3.newKana;

    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/users/' + id + '/fullname', {
      new_fullname: newFullname,
      new_kana: newKana
    });
  },
  putMailAddress: function putMailAddress(_ref4) {
    var id = _ref4.id,
        newMailAddress = _ref4.newMailAddress;

    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('/users/' + id + '/mail_address', {
      new_mail_address: newMailAddress
    });
  },
  putStatus: function putStatus(_ref5) {
    var id = _ref5.id,
        newStatus = _ref5.newStatus;

    return __WEBPACK_IMPORTED_MODULE_0__api_base__["a" /* default */].put('users/' + id + '/status', {
      new_status: newStatus
    });
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es5_shim__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es5_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es5_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_shim__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fontawesome__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_state__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_ja__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_scrollStatePlugin__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_touch_events__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue2_touch_events__);














__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default.a);






__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_ja___default.a });

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__modules_scrollStatePlugin__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue2_touch_events___default.a);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.errorHandler = function (err, vm, info) {
  console.error(vm);
  var text = '\n内容:' + err + '\n発生箇所:' + vm.$el.outerHTML + '近辺' + '\n:' + info;
  text = text.replace(/"/g, '`');
  console.warn(text);
  var BASE_URL = 'https://hooks.slack.com/services/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';
  var user = __WEBPACK_IMPORTED_MODULE_8__vuex_state__["a" /* default */].userInfo.fullname;
  var now = new Date();
  var year = now.getFullYear();
  var mon = now.getMonth() + 1;
  var day = now.getDate();
  var hour = now.getHours();
  var min = now.getMinutes();
  var sec = now.getSeconds();

  var date = year + '年' + mon + '月' + day + '日' + hour + '時' + min + '分' + sec + '秒';
  var sendMesseage = 'フロントでエラー発生\n発生日時:' + date + '\n報告者:' + user + text;
  var options = {
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: 'payload={\n        "text": "' + sendMesseage + '",\n    }'
  };
  __WEBPACK_IMPORTED_MODULE_9_axios___default.a.request(options);
};

new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */],
  template: '<App/>',
  components: {
    'App': __WEBPACK_IMPORTED_MODULE_5__App___default.a
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_token__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_reservations__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_lectures__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_user_information__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_recurrent_reservations__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_users__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_informations__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_classrooms__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_attendance__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_temporal_students__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_not_temporal_students__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_reschedulings__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_mails__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_month_end_report__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router_index__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__state__ = __webpack_require__(53);























function sendErrorSlack(text) {
  var BASE_URL = 'https://hooks.slack.com/services/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';
  var user = __WEBPACK_IMPORTED_MODULE_20__state__["a" /* default */].userInfo.fullname;
  var now = new Date();
  var year = now.getFullYear();
  var mon = now.getMonth() + 1;
  var day = now.getDate();
  var hour = now.getHours();
  var min = now.getMinutes();
  var sec = now.getSeconds();

  var date = year + '年' + mon + '月' + day + '日' + hour + '時' + min + '分' + sec + '秒';
  var sendMesseage = '発生日時:' + date + '\n報告者:' + user + '\n内容:' + text;
  var options = {
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: 'payload={\n        "text": "' + sendMesseage + '",\n    }'
  };
  __WEBPACK_IMPORTED_MODULE_4_axios___default.a.request(options);
}

function handleErrorGetReservations(error) {
  if (error.response) {
    var status = error.response.status;
    var message = error.response.data.message;
    sendErrorSlack(message);
    if (status === 401) {
      alert('セッションがタイムアウトしました　再度ログインして下さい');
      __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
    } else {
      console.error(message);
      alert('予約情報取得に失敗しました：' + message);
    }
  } else {
    alert('Error:' + error.message);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getReservations: function getReservations(_ref, query) {
    var commit = _ref.commit;

    console.log(query);
    if (query.id !== undefined) {
      return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].getById(query.id).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */], response.data.reservations);
        return response;
      }).catch(function (err) {
        handleErrorGetReservations(err);
      });
    } else if (query.date !== undefined) {
      if (query.all) {
        return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].getAllByDate(query).then(function (response) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */], response.data.reservations);
        }).catch(function (err) {
          handleErrorGetReservations(err);
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].getByDate(query).then(function (response) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */], response.data.reservations);
        }).catch(function (err) {
          handleErrorGetReservations(err);
        });
      }
    } else if (query.user_id !== undefined) {
      return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].getByUserId(query.user_id).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */], response.data.reservations);
      }).catch(function (err) {
        handleErrorGetReservations(err);
      });
    } else if (query.recurrence_id !== undefined) {
      return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].getByRecurrenceId(query.recurrence_id).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */], response.data.reservations);
      }).catch(function (err) {
        handleErrorGetReservations(err);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].get().then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */], response.data.reservations);
      }).catch(function (err) {
        handleErrorGetReservations(err);
      });
    }
  },
  postReservation: function postReservation(_ref2, reservation) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].post(reservation).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */]);
      return res;
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(reservation);
        sendErrorSlack(errormessage);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else if (status === 400) {
          if (message === '日時と教室が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と教室が重なっています');
          } else if (message === '日時と生徒または教師が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と生徒または教師が重なっています');
          } else {
            console.error(message);
            alert('予約登録に失敗しました：' + message);
          }
        } else {
          console.error(message);
          alert('予約登録に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  editReservation: function editReservation(_ref3, reservation) {
    var commit = _ref3.commit;

    return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].put(reservation.id, reservation.reservation).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */]);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(reservation);
        sendErrorSlack(errormessage);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else if (status === 400) {
          if (message === '日時と教室が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と教室が重なっています');
          } else if (message === '日時と生徒または教師が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と生徒または教師が重なっています');
          } else {
            console.error(message);
            alert('予約の変更に失敗しました：' + message);
          }
        } else {
          console.error(message);
          alert('予約の変更に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  deleteReservation: function deleteReservation(_ref4, id) {
    var commit = _ref4.commit;

    return __WEBPACK_IMPORTED_MODULE_6__api_reservations__["a" /* default */].delete(id).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + id;
        sendErrorSlack(errormessage);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else if (status === 400) {
          alert('予約の削除に失敗しました：' + message);
        } else {
          console.error(message);
          alert('予約の削除に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  getUserInfo: function getUserInfo(_ref5) {
    var commit = _ref5.commit;

    return __WEBPACK_IMPORTED_MODULE_8__api_user_information__["a" /* default */].get().then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* USERINFO_UPDATE */], res.data);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('ユーザ情報取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  getLectures: function getLectures(_ref6, query) {
    var commit = _ref6.commit;

    if (query.hasOwnProperty('id')) {
      return __WEBPACK_IMPORTED_MODULE_7__api_lectures__["a" /* default */].getById().catch(function (err) {
        if (err.response) {
          var status = err.response.status;
          var message = err.response.data.message;
          var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(query);
          sendErrorSlack(errormessage);
          if (status === 401) {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else {
            console.error(message);
            alert('講義情報取得に失敗しました：' + message);
          }
        } else {
          alert('Error:' + err.message);
        }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_7__api_lectures__["a" /* default */].get().then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* LECTURE_UPDATE */], res.data.lectures);
      }).catch(function (err) {
        if (err.response) {
          var status = err.response.status;
          var message = err.response.data.message;
          sendErrorSlack(message);
          if (status === 401) {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else {
            console.error(message);
            alert('講義情報取得に失敗しました：' + message);
          }
        } else {
          alert('Error:' + err.message);
        }
      });
    }
  },
  addLecture: function addLecture(_ref7, lecture) {
    var commit = _ref7.commit;

    return __WEBPACK_IMPORTED_MODULE_7__api_lectures__["a" /* default */].post(lecture).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        switch (status) {
          case 401:
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
            break;
          case 400:
            console.error(message);
            if (message.includes('パラメータが不正')) {
              alert('講義の登録に失敗しました． :' + message);
            } else {
              alert('講義の登録に失敗しました． :指定された教師または生徒が存在しません．');
            }
            break;
          case 409:
            alert('すでに登録済みの講義です．');
            break;
          default:
            alert('講義の登録に失敗しました． :' + message);
            break;
        }
      } else {
        alert('Error :' + err.message);
      }
    });
  },
  deleteLecture: function deleteLecture(_ref8, id) {
    var commit = _ref8.commit;

    return __WEBPACK_IMPORTED_MODULE_7__api_lectures__["a" /* default */].delete(id).then(function (res) {}).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('講義の削除に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  getRecurrentReservations: function getRecurrentReservations(_ref9) {
    var commit = _ref9.commit;

    return __WEBPACK_IMPORTED_MODULE_9__api_recurrent_reservations__["a" /* default */].get().then(function (res) {}).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('繰り返し予約情報取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  postRecurrentReservations: function postRecurrentReservations(_ref10, reservation) {
    var commit = _ref10.commit;

    return __WEBPACK_IMPORTED_MODULE_9__api_recurrent_reservations__["a" /* default */].post(reservation).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(reservation);
        sendErrorSlack(errormessage);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('繰り返し予約情報登録に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  editRecurrentReservations: function editRecurrentReservations(_ref11, reservation) {
    var commit = _ref11.commit;

    return __WEBPACK_IMPORTED_MODULE_9__api_recurrent_reservations__["a" /* default */].put(reservation.id, reservation.reservation).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(reservation);
        sendErrorSlack(errormessage);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('繰り返し予約の変更に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  deleteRecurrentReservations: function deleteRecurrentReservations(_ref12, param) {
    var commit = _ref12.commit;

    return __WEBPACK_IMPORTED_MODULE_9__api_recurrent_reservations__["a" /* default */].delete(param.id, param.fromReservaitonId).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('繰り返し予約の削除に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  addUser: function addUser(_ref13, user) {
    var commit = _ref13.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].post(user).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(user);
        sendErrorSlack(errormessage);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else if (status === 409) {
          alert('ユーザーの登録に失敗しました．同じユーザー名がすでに登録されています');
          console.error(message);
        } else {
          alert('ユーザーの登録に失敗しました．:' + message);
        }
      } else {
        alert('Error: ' + err.message);
      }
    });
  },
  deleteUser: function deleteUser(_ref14, id) {
    var commit = _ref14.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].delete(id).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('ユーザーの削除に失敗しました. :' + message);
        }
      } else {
        alert('Error: ' + err.message);
      }
    });
  },
  getUserLectures: function getUserLectures(_ref15, userId) {
    var commit = _ref15.commit;

    return __WEBPACK_IMPORTED_MODULE_7__api_lectures__["a" /* default */].getByUserId(userId).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* USER_LECTURES_FETCH */], res.data.lectures);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('講義情報取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  getClassrooms: function getClassrooms(_ref16, id) {
    var commit = _ref16.commit;

    return __WEBPACK_IMPORTED_MODULE_12__api_classrooms__["a" /* default */].get(id).then(function (res) {
      var classrooms = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.data.classrooms.slice(0, 2)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.data.classrooms.slice(2).sort(function (a, b) {
        return a.name.split('\n')[1] < b.name.split('\n')[1] ? -1 : 1;
      })));

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* CLASSROOMS_FETCH */], classrooms);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('教室情報の取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  createClassroom: function createClassroom(_ref17, classroom) {
    var commit = _ref17.commit;

    return __WEBPACK_IMPORTED_MODULE_12__api_classrooms__["a" /* default */].post(classroom).then(function (res) {
      if (res.data.id) {
        alert('教室の登録に成功しました．');
      }
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('教室情報の登録に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  deleteClassroom: function deleteClassroom(_ref18, id) {
    var commit = _ref18.commit;

    return __WEBPACK_IMPORTED_MODULE_12__api_classrooms__["a" /* default */].delete(id).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('教室の削除に失敗しました. :' + message);
        }
      } else {
        alert('Error: ' + err.message);
      }
    });
  },
  editClassroom: function editClassroom(_ref19, classroom) {
    var commit = _ref19.commit;

    return __WEBPACK_IMPORTED_MODULE_12__api_classrooms__["a" /* default */].put(classroom).then(function (res) {
      if (res.data.id) {
        alert('教室情報の変更に成功しました．');
      }
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('教室情報の変更に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  updateUserList: function updateUserList(_ref20) {
    var commit = _ref20.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].get().then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* USER_LIST_UPDATE */], res.data.users);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('生徒一覧の取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  changeUserInfo: function changeUserInfo(_ref21, param) {
    var commit = _ref21.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].put(param.id, param.user_info).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else if (message === '現在のパスワードが間違っています') {
            alert('現在のパスワードが間違っています．');
          } else {
            console.error(message);
            alert('ユーザ情報の変更に失敗しました ' + message);
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません');
        } else {
          console.error(message);
          alert('ユーザ情報の変更に失敗しました ' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
    });
  },
  changeUserPassword: function changeUserPassword(_ref22, creds) {
    var commit = _ref22.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].putPassword(creds).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else if (message === '現在のパスワードが間違っています') {
            alert('現在のパスワードが間違っています．');
          } else {
            console.error(message);
            alert('パスワードの変更に失敗しました： ' + message);
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません');
        } else {
          console.error(message);
          alert('パスワードの変更に失敗しました： ' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  changeUserName: function changeUserName(_ref23, param) {
    var commit = _ref23.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].putUserName(param).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else {
            console.error(message);
            alert('ユーザ名の変更に失敗しました： ' + message);
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません');
        } else {
          console.error(message);
          alert('ユーザ名の変更に失敗しました： ' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  changeFullname: function changeFullname(_ref24, param) {
    var commit = _ref24.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].putFullname(param).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else {
            console.error(message);
            alert('氏名の変更に失敗しました： ' + message);
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません');
        } else {
          console.error(message);
          alert('氏名の変更に失敗しました： ' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  changeMailAddress: function changeMailAddress(_ref25, param) {
    var commit = _ref25.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].putMailAddress(param).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else {
            console.error(message);
            alert('メールアドレスの変更に失敗しました： ' + message);
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません');
        } else {
          console.error(message);
          alert('メールアドレスの変更に失敗しました： ' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  changeStatus: function changeStatus(_ref26, param) {
    var commit = _ref26.commit;

    return __WEBPACK_IMPORTED_MODULE_10__api_users__["a" /* default */].putStatus(param).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          } else {
            console.error(message);
            alert('ステータスの変更に失敗しました： ' + message);
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません');
        } else {
          console.error(message);
          alert('ステータスの変更に失敗しました： ' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  login: function login(_ref27, creds) {
    var commit = _ref27.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* LOGIN */]);
    var ret = {};
    return __WEBPACK_IMPORTED_MODULE_5__api_token__["a" /* default */].post(creds).then(function (res) {
      ret = res.data.access_token;
      localStorage.setItem('token', ret);
    });
  },
  logout: function logout(_ref28) {
    var commit = _ref28.commit;

    localStorage.removeItem('token');
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* LOGOUT */]);
  },
  getAttendance: function getAttendance(_ref29) {
    var commit = _ref29.commit;

    return __WEBPACK_IMPORTED_MODULE_13__api_attendance__["a" /* default */].get().then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* ATTENDANCE_UPDATE */], response.data.attendance);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          console.error(message);
          alert('来塾状況取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  toggleAttendance: function toggleAttendance(_ref30, userId) {
    var commit = _ref30.commit;

    return __WEBPACK_IMPORTED_MODULE_13__api_attendance__["a" /* default */].post(userId).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else {
          console.error(message);
          alert('来塾状況の変更に失敗しました： ' + message);
        }
      }
    });
  },
  getTemporalStudentByFullname: function getTemporalStudentByFullname(_ref31, fullname) {
    var commit = _ref31.commit;

    return __WEBPACK_IMPORTED_MODULE_14__api_temporal_students__["a" /* default */].getByFullname(fullname).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n' + fullname;
        sendErrorSlack(errormessage);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else if (status === 404) {
          throw err;
        } else {
          console.error(message);
          alert('一時的な生徒の取得に失敗しました' + message);
        }
      }
    });
  },
  setReschedulingInfo: function setReschedulingInfo(_ref32, reschedulingInfo) {
    var commit = _ref32.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_RESCHEDULING_INFO */], reschedulingInfo);
  },
  postReschedulings: function postReschedulings(_ref33, params) {
    var commit = _ref33.commit;

    return __WEBPACK_IMPORTED_MODULE_16__api_reschedulings__["a" /* default */].post(params).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        var errormessage = message + '\n[header]\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params);
        sendErrorSlack(errormessage);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else {
          console.error(message);
          alert('授業振替情報の登録に失敗しました ' + message);
        }
      }
    });
  },
  getAllReschedulings: function getAllReschedulings(_ref34) {
    var commit = _ref34.commit;

    return __WEBPACK_IMPORTED_MODULE_16__api_reschedulings__["a" /* default */].get().catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else if (status === 404) {
          console.error(message);
        } else {
          console.error(message);
          alert('授業振替情報の取得に失敗しました　' + message);
        }
      }
    });
  },
  getReschedulingByHash: function getReschedulingByHash(_ref35, hash) {
    var commit = _ref35.commit;

    return __WEBPACK_IMPORTED_MODULE_16__api_reschedulings__["a" /* default */].getByHash(hash).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else if (status === 404) {
          console.error(message);
        } else {
          console.error(message);
          alert('授業振替情報の取得に失敗しました　' + message);
        }
      }
    });
  },
  getReschedulingetList: function getReschedulingetList(_ref36, id) {
    var commit = _ref36.commit;

    return __WEBPACK_IMPORTED_MODULE_16__api_reschedulings__["a" /* default */].getList(id).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else if (status === 404) {
          console.error(message);
        } else {
          console.error(message);
          alert('授業振替情報の取得に失敗しました　' + message);
        }
      }
    });
  },
  sendUserInfoMail: function sendUserInfoMail(_ref37, data) {
    var commit = _ref37.commit;

    return __WEBPACK_IMPORTED_MODULE_17__api_mails__["a" /* default */].postUserInfoChange(data).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else {
          console.error(message);
          alert('変更通知メールの送信に失敗しました(' + message + ')');
        }
      }
      throw err;
    });
  },
  sendMailReschedulingRequest: function sendMailReschedulingRequest(_ref38, hash) {
    var commit = _ref38.commit;

    return __WEBPACK_IMPORTED_MODULE_17__api_mails__["a" /* default */].postReschedulingRequest(hash).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else {
          console.error(message);
          alert('授業振替依頼メールの送信に失敗しました(' + message + ')');
        }
      }
      throw err;
    });
  },
  updateReschedulingInfo: function updateReschedulingInfo(_ref39, reservation) {
    var commit = _ref39.commit;

    return __WEBPACK_IMPORTED_MODULE_16__api_reschedulings__["a" /* default */].put(reservation.hash, reservation.reservation).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* RESERVATIONS_UPDATE */]);
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else if (status === 400) {
          if (message === '日時と教室が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と教室が重なっています');
          } else if (message === '日時と生徒または教師が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と生徒または教師が重なっています');
          } else {
            console.error(message);
            alert('予約登録に失敗しました：' + message);
          }
        } else {
          console.error(message);
          alert('予約登録に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  sendMailReschedulingResult: function sendMailReschedulingResult(_ref40, hashs) {
    var commit = _ref40.commit;

    return __WEBPACK_IMPORTED_MODULE_17__api_mails__["a" /* default */].postReschedulingResult(hashs).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else {
          console.error(message);
          alert('授業振替依頼メールの送信に失敗しました( ' + message + ')');
        }
      }
    });
  },
  sendMailReschedulingError: function sendMailReschedulingError(_ref41, hashs) {
    var commit = _ref41.commit;

    return __WEBPACK_IMPORTED_MODULE_17__api_mails__["a" /* default */].postReschedulingError(hashs).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい');
            __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
          }
        } else {
          console.error(message);
          alert('事務局へのエラー報告に失敗しました(' + message + ')');
        }
      }
    });
  },
  getNotTemporalStudentByFullname: function getNotTemporalStudentByFullname(_ref42, fullname) {
    var commit = _ref42.commit;

    return __WEBPACK_IMPORTED_MODULE_15__api_not_temporal_students__["a" /* default */].getByFullname(fullname);
  },
  getInformation: function getInformation(_ref43) {
    var commit = _ref43.commit;

    return __WEBPACK_IMPORTED_MODULE_11__api_informations__["a" /* default */].get().then(function (res) {
      return res.data.informations;
    }).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('ユーザ情報取得に失敗しました：' + message);
        }
      } else {
        alert('Error:' + err.message);
      }
    });
  },
  addinformation: function addinformation(_ref44, information) {
    var commit = _ref44.commit;

    return __WEBPACK_IMPORTED_MODULE_11__api_informations__["a" /* default */].post(information).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('お知らせの登録に失敗しました．:' + message);
          return 1;
        }
      } else {
        alert('Error: ' + err.message);
        return 1;
      }
    });
  },
  editinformation: function editinformation(_ref45, data) {
    var commit = _ref45.commit;

    return __WEBPACK_IMPORTED_MODULE_11__api_informations__["a" /* default */].put(data).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('お知らせの編集に失敗しました. :' + message);
          return 1;
        }
      } else {
        alert('Error: ' + err.message);
        return 1;
      }
    });
  },
  deleteinformation: function deleteinformation(_ref46, id) {
    var commit = _ref46.commit;

    return __WEBPACK_IMPORTED_MODULE_11__api_informations__["a" /* default */].delete(id).catch(function (err) {
      if (err.response) {
        var status = err.response.status;
        var message = err.response.data.message;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('お知らせの削除に失敗しました. :' + message);
          return 1;
        }
      } else {
        alert('Error: ' + err.message);
        return 1;
      }
    });
  },
  exportRport: function exportRport(_ref47, data) {
    var commit = _ref47.commit;

    return __WEBPACK_IMPORTED_MODULE_18__api_month_end_report__["a" /* default */].post(data).catch(function (err) {
      if (err.response) {
        console.log(err.response);
        var status = err.response.status;
        var message = err.response.data;
        sendErrorSlack(message);
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい');
          __WEBPACK_IMPORTED_MODULE_19__router_index__["a" /* default */].push('/login');
        } else {
          alert('月末報告書の発行に失敗しました. :' + message);
          return 1;
        }
      } else {
        alert('Error: ' + err.message);
        return 1;
      }
    });
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_time__ = __webpack_require__(26);




/* harmony default export */ __webpack_exports__["a"] = ({
  classroomNames: function classroomNames(state) {
    return state.classrooms.map(function (x) {
      return x.name;
    });
  },
  edgeClassrooms: function edgeClassrooms(state) {
    return state.classrooms.filter(function (elem, index, self) {
      if (index < self.length - 1) {
        return self[index].name.slice(0, 3) !== self[index + 1].name.slice(0, 3);
      }
    });
  },
  timelinesWidth: function timelinesWidth(state) {
    return state.columnWidth * state.classrooms.length;
  },
  timelineHeight: function timelineHeight(state) {
    return state.rowHeight * state.timeScaleTicks.length;
  },
  tableWidth: function tableWidth(state, getters) {
    return state.rulerWidth + getters.timelinesWidth;
  },

  getLeftPosOfClassroom: function getLeftPosOfClassroom(state, getters) {
    return function (classroom) {
      return getters.classroomNames.indexOf(classroom) * state.columnWidth;
    };
  },

  getClassroomAt: function getClassroomAt(state, getters) {
    return function (pos) {
      var index = Math.floor(pos / state.columnWidth);
      return getters.classroomNames[index];
    };
  },

  positionToTime: function positionToTime(state) {
    return function (point) {
      var rate = 30 / state.rowHeight;

      var offsetTime = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](state.timeScaleTicks[0]);
      var t = offsetTime.addMinuites(Math.floor(rate * point));
      return t;
    };
  },

  timeToPosition: function timeToPosition(state) {
    return function (time) {
      var rate = state.rowHeight / 30;
      var t = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](time);
      var offsetTime = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](state.timeScaleTicks[0]);
      var diffedMins = t.decresaseMinuites(offsetTime.getMinutes()).getMinutes();
      var pixs = Math.floor(rate * diffedMins);
      return pixs;
    };
  },

  fitToNearDivTime: function fitToNearDivTime(state) {
    return function (time) {
      var t = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](time.toString());
      var mins = t.getMinutes();
      var offset = mins % state.timeDivMin;
      if (offset < state.timeDivMin / 2) {
        return t.decresaseMinuites(offset);
      } else {
        return t.decresaseMinuites(offset).addMinuites(state.timeDivMin);
      }
    };
  },

  previewBox: function previewBox(state) {
    return state.previewBox;
  },

  getCurDateFormated: function getCurDateFormated(state) {
    var day = state.curDate.getDate();

    var month = state.curDate.getMonth() + 1;
    var year = state.curDate.getFullYear();
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return '' + year + '-' + month + '-' + day;
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.isLoggedIn;
  },

  reservationsInRange: function reservationsInRange(state) {
    return function (start, end) {
      var startT = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](start);
      var endT = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](end);
      return state.reservations.filter(function (elem, index, self) {
        var elemStartTime = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](elem.start_time);
        var elemEndTime = new __WEBPACK_IMPORTED_MODULE_0__modules_time__["a" /* default */](elem.end_time);
        return startT.getMinutes() < elemEndTime.getMinutes() && startT.getMinutes() >= elemStartTime.getMinutes() || endT.getMinutes() <= elemEndTime.getMinutes() && endT.getMinutes() > elemStartTime.getMinutes() || startT.getMinutes() < elemStartTime.getMinutes() && endT.getMinutes() > elemEndTime.getMinutes();
      });
    };
  },
  teacherList: function teacherList(state) {
    return state.userlist.filter(function (user, index, array) {
      return user.user_type === 'teacher';
    });
  },
  studentList: function studentList(state) {
    return state.userlist.filter(function (user, index, array) {
      return user.user_type === 'student';
    });
  },
  sortedLectureList: function sortedLectureList(state) {
    return state.lectureInfo.sort(function (a, b) {
      if (a.teacher.id < b.teacher.id) {
        return -1;
      } else if (a.teacher.id > b.teacher.id) {
        return 1;
      } else if (a.student.id < b.student.id) {
        return -1;
      } else if (a.student.id > b.student.id) {
        return 1;
      } else {
        return 0;
      }
    });
  },

  school_id: function school_id(state) {
    return state.userInfo.school_id;
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(4);



var _PREVIEWBOX_TIME_UPDA;



/* harmony default export */ __webpack_exports__["a"] = (_PREVIEWBOX_TIME_UPDA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], function (state, times) {
  if (times.start !== undefined) {
    state.previewBox.start = times.start;
  }
  if (times.end !== undefined) {
    state.previewBox.end = times.end;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* PREVIEWBOX_STYLE_UPDATE */], function (state, style) {
  state.previewBox.style['top'] = style['top'];
  state.previewBox.style['left'] = style['left'];
  state.previewBox.style['bottom'] = style['bottom'];
  state.previewBox.style['height'] = style['height'];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* PREVIEWBOX_CLASSROOM_UPDATE */], function (state, classroom) {
  state.previewBox.classroom = classroom;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* PREVIEWBOX_SHOW_POPUP */], function (state) {
  state.previewBox.isPopupShown = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */], function (state) {
  state.previewBox.isPopupShown = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* RESERVATION_SHOW_POPUP */], function (state) {
  state.reservationbox.isPopupShown = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* RESERVATION_HIDE_POPUP */], function (state) {
  state.reservationbox.isPopupShown = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* RESERVATIONBOX_ENTER_EDIT */], function (state, reservation) {
  state.editingState.id = reservation.id;
  state.editingState.classroom = reservation.classroom;
  state.editingState.start = reservation.start_time.slice(0, 5);
  state.editingState.end = reservation.end_time.slice(0, 5);
  state.editingState.recurrence_id = reservation['recurrence_id'];
  state.editingState.teacher = reservation.teacher.id;
  state.editingState.student = reservation.student.id;
  state.editingState.message = reservation.message;
  state.editingState.hasTest = reservation.has_test;
  state.editingState.online = reservation.online === '1';
  state.editingState.reservationType = reservation.reservation_type;
  state.editingState.isRecurrent = reservation.recurrence_id !== null && reservation.recurrence_id !== 0;
  state.editingState.isPopupShown = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], function (state, times) {
  if (times.start !== undefined) {
    state.editingState.start = times.start;
  }
  if (times.end !== undefined) {
    state.editingState.end = times.end;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], function (state, classroom) {
  state.editingState.classroom = classroom;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* EDITINGBOX_STYLE_UPDATE */], function (state, style) {
  state.editingState.style['top'] = style['top'];
  state.editingState.style['left'] = style['left'];
  state.editingState.style['height'] = style['height'];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["y" /* EDITING_POPUP_SHOW */], function (state) {
  state.editingState.isPopupShown = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["z" /* EDITING_POPUP_HIDE */], function (state) {
  state.editingState.isPopupShown = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["A" /* EDITINGBOX_DRAG_START */], function (state) {
  state.editingState.isDragging = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["B" /* EDITINGBOX_DRAG_END */], function (state) {
  state.editingState.isDragging = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["C" /* RESERVATIONBOX_ENTER_RESCHEDULING */], function (state, reservation) {
  state.rescherdulingState.id = reservation.id;
  state.rescherdulingState.classroom = reservation.classroom;
  state.rescherdulingState.start = reservation.start_time.slice(0, 5);
  state.rescherdulingState.date = reservation.date;
  state.rescherdulingState.end = reservation.end_time.slice(0, 5);
  state.rescherdulingState.recurrence_id = reservation['recurrence_id'];
  state.rescherdulingState.teacher = reservation.teacher.id;
  state.rescherdulingState.student = reservation.student.id;
  state.rescherdulingState.message = reservation.message;
  state.rescherdulingState.hasTest = reservation.has_test;
  state.rescherdulingState.online = reservation.online === '1';
  state.rescherdulingState.reservationType = reservation.reservation_type;
  state.rescherdulingState.isRecurrent = reservation.recurrence_id !== null && reservation.recurrence_id !== 0;
  state.rescherdulingState.isPopupShown = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["D" /* RESCHEDULING_POPUP_HIDE */], function (state) {
  state.rescherdulingState.isPopupShown = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */], function (state) {
  state.editingState.id = 0;
  state.editingState.recurrence_id = 0;
  state.editingState.teacher = 0;
  state.editingState.student = 0;
  state.editingState.message = '';
  state.editingState.hasTest = false;
  state.editingState.reservationType = '通常';
  state.editingState.isRecurrent = false;
  state.editingState.isPopupShown = false;
  state.editingState.online = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* RRULE_UPDATE */], function (state, rrule) {
  state.recurrentRule = rrule;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* RESERVATIONS_UPDATE */], function (state, reservations) {
  state.reservations = reservations;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* USERINFO_UPDATE */], function (state, userinfo) {
  state.userInfo = userinfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* LECTURE_UPDATE */], function (state, lectures) {
  state.lectureInfo = lectures;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* USER_LECTURES_FETCH */], function (state, lectures) {
  state.userLectures = lectures;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* USER_LIST_UPDATE */], function (state, userlist) {
  state.userlist = userlist;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* CLASSROOMS_FETCH */], function (state, classrooms) {
  state.classrooms = classrooms;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* TIMETABLE_CHANGE_DATE */], function (state, payload) {
  state.curDate = payload.date;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* LOGIN */], function (state) {
  state.pending = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["G" /* LOGIN_SUCCESS */], function (state) {
  state.isLoggedIn = true;
  state.pending = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* LOGOUT */], function (state) {
  state.isLoggedIn = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["H" /* SPINNER_SHOW */], function (state) {
  state.spinning = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["I" /* SPINNER_HIDE */], function (state) {
  state.spinning = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["J" /* UPDATE_HEADER_HEIGHT */], function (state, height) {
  state.tbHeaderHeight = height;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["K" /* HIDE_INFORMATION_POPUP */], function (state) {
  state.isInfoPopupShown = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["L" /* SHOW_INFORMATION_POPUP */], function (state, reservation) {
  state.informationPopup.reservation = reservation;
  state.isInfoPopupShown = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["M" /* EDITINGSTATE_SET_TEACHER */], function (state, teacher) {
  state.editingState.teacher = teacher;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["N" /* EDITINGSTATE_SET_STUDENT */], function (state, student) {
  state.editingState.student = student;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["O" /* EDITINGSTATE_SET_MESSAGE */], function (state, val) {
  state.editingState.message = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["P" /* EDITINGSTATE_SET_HAS_TEST */], function (state, val) {
  state.editingState.hasTest = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["Q" /* EDITINGSTATE_SET_TYPE */], function (state, val) {
  state.editingState.reservationType = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["R" /* EDITINGSTATE_SET_RECURRENCE */], function (state, val) {
  state.editingState.isRecurrent = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["S" /* EDITINGSTATE_SET_IS_ONLINE */], function (state, val) {
  state.editingState.online = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* ATTENDANCE_UPDATE */], function (state, attendanceList) {
  var list = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(attendanceList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var atd = _step.value;

      list.push(atd.user_id);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  state.attendance = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_RESCHEDULING_INFO */], function (state, reschedulingInfo) {
  state.reschedulingInfo = reschedulingInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* CHANGE_SCHOOL */], function (state, schoolid) {
  state.userInfo.school_id = schoolid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SHOW_ONLINE */], function (state, showOnline) {
  state.showOnline = showOnline;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PREVIEWBOX_TIME_UPDA, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["T" /* MODAL */], function (state, modal) {
  state.modal.trigger = true;
  state.modal.text = modal;
}), _PREVIEWBOX_TIME_UPDA);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: 'auto',
        fill: this.color
      };
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader___default.a
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ismobilejs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ismobilejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ismobilejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_sort__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_sort__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active: true,
      test1: '',
      idtext: '',
      password: '',
      isShownPassword: false,
      information_list: [],
      time: new Date(),
      modal_switch: false,
      modal_text: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getInformation']), {
    doLogin: function doLogin() {
      var _this = this;

      var isSmartPhone = __WEBPACK_IMPORTED_MODULE_3_ismobilejs___default.a.phone;
      var creds = {
        id: this.idtext,
        password: this.password
      };
      this.$store.dispatch('login', creds).then(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["G" /* LOGIN_SUCCESS */]);
        if (_this.$route.query.redirect === undefined) {
          if (isSmartPhone) {
            _this.$router.push('/SpTop');
          } else {
            _this.$router.push('/table');
          }
        } else {
          _this.$router.push(_this.$route.query.redirect);
        }
      }).catch(function (err) {
        if (err.response) {
          var status = err.response.status;
          var message = err.response.data.message;
          if (status === 400) {
            alert('IDとパスワードを入力して下さい');
          } else if (status === 401) {
            alert('IDまたはパスワードが違います');
          } else {
            console.log(message);
            alert('ログインに失敗しました：' + message);
          }
        } else {
          alert('Error:' + err.message);
        }
        return;
      });
    },
    checke_date: function checke_date(inputdate) {
      var indate = new Date(inputdate.day);
      var indetaY = indate.getFullYear();
      var indateM = indate.getMonth() + 1;
      var indated = indate.getDate();
      var nowTimeY = this.time.getFullYear();
      var nowTimeM = this.time.getMonth() + 1;
      var nowTimed = this.time.getDate();
      return indetaY === nowTimeY && nowTimeM === indateM && nowTimed - indated <= 7 && nowTimed - indated >= 0;
    },
    show: function show() {
      this.$modal.show('important_info');
    },
    hide: function hide() {
      this.$modal.hide('important_info');
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.getInformation().then(function (res) {
      _this2.information_list = res;
    }).then(function (res) {
      var x = _this2.information_list.filter(function (v) {
        return v.importance === '緊急';
      });
      var y = null;
      x = __WEBPACK_IMPORTED_MODULE_4_array_sort___default()(x, 'show_date');
      x.forEach(function (value) {
        var indate = new Date(value.show_date);

        var now = new Date();
        if (indate > now) {
          y = {
            modal_switch: true,
            modal_text: value.text
          };
        }
      });
      _this2.modal_switch = y.modal_switch;
      if (_this2.modal_switch === true) {
        _this2.$modal.show('important_info');
        var s = y.modal_text.replace(/<p>/g, '');
        s = s.replace(/<\/p>/g, '');
        s = s.replace(/<br>/g, '　');
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["T" /* MODAL */], s);
      }
      _this2.modal_text = y.modal_text;
    });
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      message: 'ログアウトしています…'
    };
  },

  methods: {
    doLogout: function doLogout() {
      var _this = this;

      this.$store.dispatch('logout').then(function () {
        _this.message = 'ログアウトしました';
        setTimeout(function () {
          _this.$router.push('/login');
        }, 2000);
      }).catch(function (err) {
        console.log('エラーが発生しました． :' + err);
        return;
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["c" /* SHOW_ONLINE */], false);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["k" /* LOGOUT */]);
    }
  },
  created: function created() {
    this.doLogout();
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_header_AppHeader___default.a
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      classroomName: '',
      classroomid: 1,
      editingId: null,
      editingClassroomName: '',
      originalEditingName: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['deleteClassroom', 'createClassroom', 'getClassrooms', 'editClassroom']), {
    eraseClassroom: function eraseClassroom(classroom) {
      var _this = this;

      this.deleteClassroom(classroom.id).then(function (res) {
        _this.getClassrooms(_this.$store.state.userInfo.school_id);
      });
    },
    addClassroom: function addClassroom() {
      var _this2 = this;

      if (this.classroomName === '') {
        alert('教室名を入力してください');
        return;
      }
      this.classroomid = this.$store.state.userInfo.school_id;
      this.createClassroom({
        name: this.classroomName, school_id: this.classroomid
      }).then(function () {
        _this2.getClassrooms(_this2.$store.state.userInfo.school_id);
      }).then(function () {
        console.log(_this2.$store.state.classrooms);
        _this2.classroomName = '';
      });
    },
    editClassroomName: function editClassroomName() {
      var _this3 = this;

      if (!this.editingId) {
        alert('編集中の教室はありません');
        return;
      }
      if (this.editingClassroomName === '') {
        alert('教室名を入力してください');
        return;
      }
      this.classroomid = this.editingId;
      this.editClassroom({
        name: this.editingClassroomName, classroom_id: this.editingId
      }).then(function () {
        _this3.getClassrooms(_this3.$store.state.userInfo.school_id);
      }).then(function () {
        console.log(_this3.$store.state.classrooms);
        _this3.editingId = null;
        _this3.editClassroomName = '';
      });
    },
    startEditClassroom: function startEditClassroom(id) {
      this.editingId = id;
      var classroom = this.$store.state.classrooms.find(function (c) {
        return c.id === id;
      });
      this.editingClassroomName = classroom.name;
      this.originalName = classroom.name;
    },
    cancelEdit: function cancelEdit() {
      this.editingClassroomName = this.originalEditingName;
      this.editingId = null;
    }
  })
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-list',
  data: function data() {
    return {
      show_date: null,
      customToolbar: [[{ size: ['small', false, 'large', 'huge'] }], ['bold', 'italic', 'underline', 'strike'], [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }], [{ list: 'ordered' }, { list: 'bullet' }], [{ color: [] }, { background: [] }], [{ indent: '-1' }, { indent: '+1' }], ['link']],
      content: null,
      information_list: [],
      information_text: '',
      edit_trigger: false,
      edit_id: '',
      edit_text: '',
      edit_target: '',
      edit_importance: '',
      time: new Date(),
      target: null,
      importance_value: null,
      importance: [{
        value: '最重要',
        label: '最重要'
      }, {
        value: '重要',
        label: '重要'
      }, {
        value: '緊急',
        label: '緊急'
      }, {
        value: '障害情報',
        label: '障害情報'
      }, {
        value: 'お知らせ',
        label: 'お知らせ'
      }],
      url: null
    };
  },

  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_2_vue2_editor__["a" /* VueEditor */]
  },
  mounted: function mounted() {
    var _this = this;

    this.getInformation().then(function (res) {
      _this.information_list = res;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getInformation', 'addinformation', 'deleteinformation', 'editinformation']), {
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    formattedDate: function formattedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('YYYYMMDD');
    },
    add_information: function add_information() {
      var _this2 = this;

      if (!this.information_text) {
        this.$notify({
          title: '警告',
          message: '内容を入力してください',
          customClass: 'error',
          offset: 50,
          type: 'error'
        });
        return;
      }
      if (!this.target) {
        this.$notify({
          title: '警告',
          message: '対象を入力してください',
          customClass: 'error',
          offset: 50,
          type: 'error'
        });
        return;
      }
      if (!this.importance_value) {
        this.$notify({
          title: '警告',
          message: '重要度を入力してください',
          customClass: 'error',
          offset: 50,
          type: 'error'
        });
        return;
      }
      if (this.importance_value === '緊急') {
        if (!this.show_date) {
          this.$notify({
            title: '警告',
            message: '期間を入力してください',
            customClass: 'error',
            offset: 50,
            type: 'error'
          });
          return;
        }
      }
      this.addinformation({
        day: this.formattedDate(this.time),
        text: this.information_text,
        target: this.target,
        importance: this.importance_value,
        show_date: this.show_date
      }).then(function (res) {
        if (res !== 1) {
          _this2.$notify({
            title: '成功',
            message: 'お知らせの登録に成功しました。',
            customClass: 'notify',
            offset: 50,
            type: 'success'
          });
          _this2.getInformation().then(function (res) {
            _this2.information_list = res;
          });
          _this2.information_text = '';
          _this2.hide();
        }
      });
    },
    delete_information: function delete_information(id) {
      var _this3 = this;

      var yesno = confirm('お知らせを削除します． よろしいでしょうか？');
      if (yesno) {
        this.deleteinformation(id).then(function (res) {
          if (res !== 1) {
            _this3.$notify({
              title: '成功',
              message: 'お知らせの削除に成功しました。',
              offset: 50,
              type: 'success'
            });
            _this3.getInformation().then(function (res) {
              _this3.information_list = res;
            });
            _this3.information_text = '';
          }
        });
      }
    },
    Edit_trigger: function Edit_trigger(id) {
      if (this.edit_trigger === false) {
        this.edit_id = this.information_list[id].information_id;
        this.edit_text = this.information_list[id].text;
        this.edit_target = this.information_list[id].target;
        this.edit_importance = this.information_list[id].importance;
        this.$modal.show('edit');
      } else {
        this.edit_id = '';
        this.edit_text = '';
        this.edit_target = '';
        this.edit_importance = '';
        this.$modal.hide('edit');
      }
    },
    close_editer: function close_editer() {
      if (this.edit_trigger === false) {
        this.$modal.show('edit');
      } else {
        this.$modal.hide('edit');
      }
    },
    Edit_information: function Edit_information() {
      var _this4 = this;

      var yesno = confirm('お知らせの変更を確定します。 よろしいでしょうか？');
      if (yesno) {
        var data = {
          id: this.edit_id,
          text: this.edit_text,
          target: this.edit_target,
          importance: this.edit_importance
        };
        this.editinformation(data).then(function (res) {
          if (res !== 1) {
            _this4.$notify({
              title: '成功',
              message: 'お知らせの変更に成功しました。',
              offset: 50,
              type: 'success'
            });
            _this4.getInformation().then(function (res) {
              _this4.information_list = res;
            });
            _this4.edit_trigger = false;
          }
        });
      }
    },
    show: function show() {
      this.$modal.show('hello-world');
    },
    hide: function hide() {
      this.$modal.hide('hello-world');
    }
  })
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lecture: {
        teacher: 0,
        student: 0
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['updateUserList', 'addLecture', 'getLectures', 'deleteLecture']), {
    registerLecture: function registerLecture() {
      var _this = this;

      this.addLecture({
        teacher: parseInt(this.lecture.teacher),
        student: parseInt(this.lecture.student)
      }).then(function () {
        _this.getLectures({});
      });
    },
    removeLecture: function removeLecture(id) {
      var _this2 = this;

      if (window.confirm('登録情報を削除します。\nよろしいですか？')) {
        this.deleteLecture(id).then(function () {
          _this2.getLectures({});
        });
      }
    },
    sortByKana: function sortByKana(userList) {
      return userList.sort(function (a, b) {
        return a.kana > b.kana ? 1 : a.kana < b.kana ? -1 : 0;
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['teacherList', 'studentList', 'sortedLectureList']), {
    sortedTeacherList: function sortedTeacherList() {
      var _this3 = this;

      console.log(this.sortByKana(this.teacherList));
      return this.sortByKana(this.teacherList.filter(function (user, index, array) {
        return user.school_id === parseInt(_this3.$store.state.userInfo.school_id);
      }));
    },
    sortedStudentList: function sortedStudentList() {
      var _this4 = this;

      return this.sortByKana(this.studentList.filter(function (user, index, array) {
        return user.school_id === parseInt(_this4.$store.state.userInfo.school_id);
      }));
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (_this5.$store.state.userlist.length === 0) {
        return _this5.updateUserList();
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }
    }).then(function () {
      _this5.getLectures({});
    });
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InformationNotification',
  data: function data() {
    return {
      modal_switch: false,
      modal_form: {
        user_id: '',
        user_name: '',
        fullname: '',
        pass: '',
        mail_address: ''
      },
      loading: false,
      dialogVisible: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateUserList', 'changeUserName', 'changeUserPassword', 'sendUserInfoMail']), {
    show: function show(userData) {
      this.modal_form.user_id = userData.user_id;
      this.modal_form.fullname = userData.fullname;
      this.modal_form.user_name = userData.user_name;
      this.modal_form.mail_address = userData.mail_address;
      this.$modal.show('important_info');
    },
    hide: function hide() {
      this.$modal.hide('important_info');
    },
    sendMail: function sendMail() {
      var _this = this;

      this.dialogVisible = false;

      this.loading = true;

      this.changeUserName({
        id: this.modal_form.user_id,
        newUserName: this.modal_form.user_name
      }).then(function (res) {
        if (res) {
          _this.$notify({
            title: '成功',
            message: 'ユーザ名の変更に成功しました',
            type: 'success',
            offset: 50,
            duration: 1200
          });
        }
      });

      this.changeUserPassword({
        id: this.modal_form.user_id,
        currentPassword: this.current_password,
        newPassword: this.modal_form.pass
      }).then(function (res) {
        if (res) {
          _this.$notify({
            title: '成功',
            message: 'パスワードの変更に成功しました',
            type: 'success',
            offset: 50,
            duration: 1500
          });
        }
      });

      console.log(this.modal_form);
      this.sendUserInfoMail({
        fullname: this.modal_form.fullname,
        user_name: this.modal_form.user_name,
        pass: this.modal_form.pass,
        mail_address: this.modal_form.mail_address
      }).then(function (res) {
        _this.$notify({
          title: '成功',
          message: '通知メールを送信しました',
          type: 'success',
          offset: 50,
          duration: 1000
        });
      });
      this.loading = false;
      this.$modal.hide('important_info');
      this.updateUserList();
    },
    confirm: function confirm() {
      if (this.modal_form.user_name === '') {
        this.$notify({
          title: '失敗',
          message: 'IDが記入されていません',
          type: 'error',
          offset: 50
        });
        return;
      }
      if (this.modal_form.pass === '') {
        this.$notify({
          title: '失敗',
          message: 'パスワードが記入されていません',
          type: 'error',
          offset: 50
        });
        return;
      }
      if (this.modal_form.mail_address === null) {
        this.$notify({
          title: '失敗',
          message: 'メールアドレスが記入されていません',
          type: 'error',
          offset: 50
        });
        return;
      }

      this.dialogVisible = true;
    },
    userStatusDisplay: function userStatusDisplay(status) {
      if (status === 'trial') {
        return '体験';
      } else if (status === 'temporal') {
        return '短期';
      } else if (status === 'normal') {
        return '通常';
      } else if (status === 'temp/temp') {
        return '短期';
      } else if (status === 'temp/norm') {
        return '通常/短期';
      } else {
        return 'Unknown';
      }
    }
  }),
  computed: {
    userlistFiltered: function userlistFiltered() {
      return this.$store.state.userlist.filter(function (user, index, array) {
        return user.user_name.match('tanki') && (user.user_status === 'temp/norm' || user.user_status === 'nomal');
      });
    }
  },
  mounted: function mounted() {
    this.updateUserList();
  }
});

/***/ }),
/* 337 */
/***/ (function(module, exports) {



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-list',
  data: function data() {
    return {
      reschedulings: [],
      display_type: 'all'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getAllReschedulings']), {
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    userDisplayName: function userDisplayName(user) {
      return user.user_type === 'teacher' ? user.fullname + '先生' : user.fullname + '様';
    },
    reservationInfo: function reservationInfo(reservation) {
      return reservation.date + reservation.start_time + '〜' + reservation.end_time + reservation.classroom_name;
    },
    reschedulingStatus: function reschedulingStatus(rescheduling) {
      if (rescheduling.status === 'accepted') {
        return '承認';
      } else if (rescheduling.status === 'denied') {
        return '不承認';
      } else if (rescheduling.status === 'pending') {
        return '進行中';
      } else if (rescheduling.status === 'error') {
        return 'エラー!';
      }
    },
    formattedDate: function formattedDate(datetime) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(datetime, format).format('YYYY年MM月DD日');
    },
    formattedTime: function formattedTime(datetime) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(datetime, format).format('HH時mm分');
    },
    compareReschedulings: function compareReschedulings(a, b) {
      var aTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.registered_datetime);
      var bTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(b.registered_datetime);
      return aTime.isAfter(bTime) ? -1 : aTime.isSame(bTime) ? 0 : 1;
    }
  }),
  computed: {
    filteredReschedulings: function filteredReschedulings() {
      var _this = this;

      var sorted = this.reschedulings.sort(this.compareReschedulings);
      if (this.display_type === 'all') {
        return sorted;
      } else {
        return sorted.filter(function (r) {
          return r.status === _this.display_type;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getAllReschedulings().then(function (res) {
      _this2.reschedulings = res.data.reschedulings;
      console.log(_this2.reschedulings);
    });
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-list',
  data: function data() {
    return {
      isShowAdmin: true,
      isShowStudent: true,
      isShowTeacher: true,
      searchText: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateUserList', 'deleteUser']), {
    deleteUserHandler: function deleteUserHandler(id) {
      var _this = this;

      var yesno = confirm('ユーザーを削除します． よろしいでしょうか？');
      if (yesno) {
        this.deleteUser(id).then(function (res) {
          alert('ユーザーの削除に成功しました．');
          _this.updateUserList();
        });
      }
    },
    userTypeDisplay: function userTypeDisplay(type) {
      if (type === 'student') {
        return '生徒';
      } else if (type === 'teacher') {
        return '教師';
      } else if (type === 'admin') {
        return '管理者';
      } else if (type === 'viewer') {
        return '閲覧者';
      } else {
        return 'Unknown';
      }
    },
    userStatusDisplay: function userStatusDisplay(status) {
      if (status === 'trial') {
        return '体験';
      } else if (status === 'temporal') {
        return '短期';
      } else if (status === 'normal') {
        return '通常';
      } else if (status === 'temp/temp') {
        return '短期';
      } else if (status === 'temp/norm') {
        return '通常/短期';
      } else {
        return 'Unknown';
      }
    },
    kanaToHira: function kanaToHira(str) {
      return str.replace(/[\u3041-\u3096]/g, function (matchs) {
        var chr = matchs.charCodeAt(0) + 0x60;
        return String.fromCharCode(chr);
      });
    }
  }),
  computed: {
    userlistFiltered: function userlistFiltered() {
      var _this2 = this;

      if (this.searchText) {
        return this.$store.state.userlist.filter(function (user, index, array) {
          return user.fullname.match(_this2.searchText) || user.kana.match(_this2.searchText) || user.kana.match(_this2.kanaToHira(_this2.searchText));
        });
      }
      if (this.isShowAdmin) {
        if (this.isShowStudent) {
          if (this.isShowTeacher) {
            return this.$store.state.userlist;
          } else {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return user.user_type !== 'teacher';
            });
          }
        } else {
          if (this.isShowTeacher) {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return user.user_type !== 'student';
            });
          } else {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return user.user_type === 'admin';
            });
          }
        }
      } else {
        if (this.isShowStudent) {
          if (this.isShowTeacher) {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return user.user_type !== 'admin';
            });
          } else {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return user.user_type === 'student';
            });
          }
        } else {
          if (this.isShowTeacher) {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return user.user_type === 'teacher';
            });
          } else {
            return this.$store.state.userlist.filter(function (user, index, array) {
              return;
            });
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.updateUserList();
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInfo_PasswordChangePanel__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInfo_PasswordChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserInfo_PasswordChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserInfo_UserNameChangePanel__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserInfo_UserNameChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserInfo_UserNameChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserInfo_FullnameChangePanel__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserInfo_FullnameChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserInfo_FullnameChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserInfo_MailAddressChangePanel__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserInfo_MailAddressChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserInfo_MailAddressChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserInfo_StatusChangePanel__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserInfo_StatusChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserInfo_StatusChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_sunday_teachers__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_lectures__ = __webpack_require__(90);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'password-change-panel': __WEBPACK_IMPORTED_MODULE_3__UserInfo_PasswordChangePanel___default.a,
    'user-name-change-panel': __WEBPACK_IMPORTED_MODULE_4__UserInfo_UserNameChangePanel___default.a,
    'fullname-change-panel': __WEBPACK_IMPORTED_MODULE_5__UserInfo_FullnameChangePanel___default.a,
    'mail-address-change-panel': __WEBPACK_IMPORTED_MODULE_6__UserInfo_MailAddressChangePanel___default.a,
    'status-change-panel': __WEBPACK_IMPORTED_MODULE_7__UserInfo_StatusChangePanel___default.a
  },
  data: function data() {
    return {
      lecture: {
        teacher: 0,
        student: 0
      },
      isSunday: false
    };
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getUserLectures', 'addLecture', 'updateUserList']), {
    getListItem: function getListItem(ulect) {
      var type = this.getWho.type;
      switch (type) {
        case 'teacher':
          return ulect.student.fullname;
        case 'student':
          return ulect.teacher.fullname;
        default:
          return '';
      }
    },
    purgeLecture: function purgeLecture(partner) {
      var _this = this;

      var isYes = confirm('講義を削除します．よろしいですか？' + partner.id);
      console.log(partner);
      if (isYes) {
        __WEBPACK_IMPORTED_MODULE_9__api_lectures__["a" /* default */].getByUserId(this.getWho.id).then(function (res) {
          console.log(res.data.lectures);
          var lectid = res.data.lectures.find(function (item) {
            return item.student.id === partner.id;
          }).id;
          _this.$store.dispatch('deleteLecture', lectid);
        }).then(function (res) {
          alert('講義の削除に成功しました．');
          _this.$store.dispatch('updateUserList').then(function () {
            _this.$store.dispatch('getUserLectures', _this.getWho.id);
          });
        });
      }
    },
    registerLecture: function registerLecture() {
      var _this2 = this;

      this.addLecture({
        teacher: parseInt(this.lecture.teacher),
        student: parseInt(this.lecture.student)
      }).then(function () {
        _this2.getUserLectures(_this2.getWho.id);
      });
    },
    setHiddenID: function setHiddenID(type) {
      switch (type) {
        case 'teacher':
          this.lecture.teacher = parseInt(this.getWho.id);
          return this.teacher;
        case 'student':
          this.lecture.student = parseInt(this.getWho.id);
          return this.student;
        default:
          break;
      }
    },
    registerSunday: function registerSunday() {
      var _this3 = this;

      if (this.getWho.type === 'teacher') {
        __WEBPACK_IMPORTED_MODULE_8__api_sunday_teachers__["a" /* default */].post(this.getWho.id).then(function (res) {
          alert('登録に成功しました');
          _this3.$store.dispatch('updateUserList').then(function () {
            _this3.$store.dispatch('getUserLectures', _this3.getWho.id);
          });
        }).catch(function (err) {
          alert('登録に失敗しました: ' + err.response.data.message);
        });
      }
    },
    deleteSunday: function deleteSunday() {
      var _this4 = this;

      if (this.getWho.type === 'teacher') {
        __WEBPACK_IMPORTED_MODULE_8__api_sunday_teachers__["a" /* default */].delete(this.getWho.id).then(function (res) {
          alert('削除に成功しました');
          _this4.$store.dispatch('updateUserList').then(function () {
            _this4.$store.dispatch('getUserLectures', _this4.getWho.id);
          });
        }).catch(function (err) {
          alert('削除に失敗しました: ' + err.response.data.message);
        });
      }
    },
    userInfoChanged: function userInfoChanged() {
      this.$store.dispatch('updateUserList');
      this.$store.dispatch('getUserLectures', this.getWho.id);
    },
    sortByKana: function sortByKana(userList) {
      return userList.sort(function (a, b) {
        return a.kana > b.kana ? 1 : a.kana < b.kana ? -1 : 0;
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['teacherList', 'studentList']), {
    sortedTeacherList: function sortedTeacherList() {
      var _this5 = this;

      return this.sortByKana(this.teacherList.filter(function (user, index, array) {
        return _this5.$store.state.userInfo;
      }));
    },
    sortedStudentList: function sortedStudentList() {
      var _this6 = this;

      return this.sortByKana(this.studentList.filter(function (user, index, array) {
        return user.school_id === parseInt(_this6.$store.state.userInfo.school_id);
      }));
    },
    partnerList: function partnerList() {
      var _this7 = this;

      return this.sortByKana(this.$store.state.userLectures.map(function (lect) {
        return _this7.getWho.type === 'teacher' ? lect.student : lect.teacher;
      }));
    },
    getWho: function getWho() {
      var id = parseInt(this.$route.params.id);

      var theuser = this.$store.state.userlist.find(function (user, index, array) {
        return user.user_id === id;
      });
      if (theuser) {
        return {
          fullname: theuser.fullname,
          kana: theuser.kana,
          id: theuser.user_id,
          type: theuser.user_type,
          user_name: theuser.user_name,
          mail_address: theuser.mail_address,
          status: theuser.status
        };
      }

      return 'Unknown';
    }
  }),
  created: function created() {
    var _this8 = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (_this8.$store.state.userlist.length === 0) {
        return _this8.updateUserList();
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }
    }).then(function () {
      if (_this8.getWho.type === 'teacher') {
        var index = _this8.$store.state.userlist.findIndex(function (elem, index, self) {
          return elem.user_id === _this8.getWho.id;
        });
        _this8.isSunday = _this8.$store.state.userlist[index].is_Sunday_user;
      }
      _this8.getUserLectures(_this8.getWho.id);
    });
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-registration-form',
  data: function data() {
    return {
      additionalUser: {
        name: '',
        password: '',
        fullname: '',
        type: '',
        kana: '',
        mail_address: '',
        status: 'normal'
      },
      isPasswordShown: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getTemporalStudentByFullname', 'addUser', 'changeUserInfo', 'updateUserList']), {
    registerUser: function registerUser() {
      var _this = this;

      if (!this.checkKana()) {
        alert('フリガナは全角カナのみで入力してください');
        return;
      }
      if (this.additionalUser.type !== 'student') {
        this.addNewUser();
      } else {
        this.getTemporalStudentByFullname(this.additionalUser.fullname).then(function (res) {
          _this.changeTempUser(res.data.temporal_student);
        }).catch(function (err) {
          if (err.response.status === 404) {
            _this.addNewUser();
          }
        });
      }
    },
    addNewUser: function addNewUser() {
      var _this2 = this;

      this.addUser({
        user_name: this.additionalUser.name,
        password: this.additionalUser.password,
        fullname: this.additionalUser.fullname,
        type: this.additionalUser.type,
        kana: this.additionalUser.kana,
        mail_address: this.additionalUser.mail_address,
        school_id: this.$store.state.userInfo.school_id,
        status: this.additionalUser.status
      }).then(function (res) {
        alert('ユーザーの登録に成功しました id:' + res.data.id);
        _this2.updateUserList();
        _this2.additionalUser = {
          name: '',
          password: '',
          fullname: '',
          mail_address: '',
          type: '',
          kana: '',
          status: 'normal'
        };
      });
    },
    changeTempUser: function changeTempUser(id) {
      var _this3 = this;

      var userInfo = {
        new_user_name: this.additionalUser.name,
        new_password: this.additionalUser.password,
        new_fullname: this.additionalUser.fullname,
        new_kana: this.additionalUser.kana,
        new_mail_address: this.additionalUser.mail_address,
        new_status: this.additionalUser.status
      };
      this.changeUserInfo({
        id: id,
        user_info: userInfo
      }).then(function () {
        alert('ユーザーの登録に成功しました\n（同姓同名の短期ユーザの情報を変更しました）');
        _this3.updateUserList();
        _this3.additionalUser = {
          name: '',
          password: '',
          fullname: '',
          mail_address: '',
          type: '',
          kana: ''
        };
      }).catch(function () {});
    },
    checkKana: function checkKana() {
      if (!this.additionalUser.kana.match(/^[ァ-ヴ]+$/)) {
        return false;
      }
      return true;
    }
  })
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpHelpPage'
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notificationBox',
  props: {
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return value === 'ok' || value === 'warning';
      }
    },
    text: String }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reschedulingReceiverClassroom',
  components: {},
  data: function data() {
    return {
      reschedulingInfo: null,
      reservations: null,
      classrooms: null,
      reschedulingclassroom: null,
      errormessage: ''
    };
  },
  created: function created() {
    var _this = this;

    this.reschedulingInfo = this.$store.state.reschedulingInfo;
    this.getClassrooms(this.$store.state.userInfo.school_id).then(function () {
      console.log(_this.$store.state.classrooms);
      _this.classrooms = _this.$store.state.classrooms;
    }).then(function () {
      _this.getReservations({ date: _this.reschedulingInfo.rescheduled_reservation.date }).then(function () {
        _this.reservations = _this.$store.state.reservations;
        for (var i = 0; i < _this.reservations.length; ++i) {
          if (_this.reservations[i].start_time <= _this.reschedulingInfo.rescheduled_reservation.end_time && _this.reservations[i].end_time >= _this.reschedulingInfo.rescheduled_reservation.start_time) {
            for (var j = 0; j < _this.classrooms.length; ++j) {
              if (_this.classrooms[j].name === _this.reservations[i].classroom) {
                if (_this.reservations[i].id !== _this.reschedulingInfo.target_reservation.id) {
                  _this.classrooms[j].name = 'prohibited';
                }
              }
            }
          }
        }
      }).then(function () {
        if (!(_this.classrooms instanceof Object)) {
          alert('教室のフィルタリングに失敗しました。戻って修正するを押して前のページに戻って再度やり直してください。');
        }
        _this.classrooms.forEach(function (value, index) {
          if (this.sender.id !== 18 && this.receiver.id !== 18) {
            if (value.name.match('301')) {
              value.name = 'prohibited';
            }
          }
          if (this.rescheduled_reservation.start_time < '15:00') {
            if (value.name.match('307')) {
              value.name = 'prohibited';
            }
          }
        }, _this.reschedulingInfo);
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getReservations', 'getClassrooms', 'setReschedulingInfo']), {
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    timeDuplicateCheck: function timeDuplicateCheck(date1, date2) {
      return date1.start_time <= date2.end_time && date1.end_time >= date2.start_time;
    },
    selectedclassroom: function selectedclassroom(value) {
      this.reschedulingclassroom = value;
    },
    cancelButtonClicked: function cancelButtonClicked() {
      this.classrooms = null;
      this.reschedulingclassroom = null;
      this.$router.push('/SpRescheduling/' + this.$route.params.rescheduling_hash);
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      if (this.reschedulingclassroom === null) {
        this.errormessage = '教室が選択されていません';
      } else {
        this.reschedulingInfo.rescheduled_reservation.classroom_name = this.reschedulingclassroom;

        this.setReschedulingInfo(this.reschedulingInfo);

        this.$router.push('/SpRescheduling/' + this.$route.params.rescheduling_hash + '/Spconfirmation_rcvr');
      }
    }
  })
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reschedulingInfo: this.$store.state.reschedulingInfo
    };
  },

  computed: {
    senderDisplayName: function senderDisplayName() {
      return this.reschedulingInfo.sender.fullname + (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様');
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpNotificationBox__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpNotificationBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SpNotificationBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReschedulingPage_ReschedulingOptionForm__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReschedulingPage_ReschedulingOptionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReschedulingPage_ReschedulingOptionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reschedulingReceiverForm',
  components: {
    'notificationBox': __WEBPACK_IMPORTED_MODULE_3__SpNotificationBox___default.a,
    'reschedulingOptionForm': __WEBPACK_IMPORTED_MODULE_4__ReschedulingPage_ReschedulingOptionForm___default.a
  },
  data: function data() {
    return {
      reschedulingInfo: null,
      windowWidth: document.documentElement.clientWidth,
      selectedCandidate: null,
      isDenying: false,
      commitMessage: '座席を選択する',
      check: 0,
      timeslot: {
        start_time: null,
        end_time: null
      },
      reservationOption: {
        reservationType: '通常',
        hasTest: false,
        reservationMessage: ''
      },
      isCompletenessChecking: false,
      reservationsOnCandidateDates: {},
      alternative_datetimes: [{
        date: '',
        mode: 'slot',
        start_time: '',
        end_time: '',
        duration: 0
      }],
      otherReservation: {
        date: '',
        startTime: '',
        endTime: '',
        receiver: 0
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getReschedulingByHash(this.$route.params.rescheduling_hash).then(function (res) {
      if (res) {
        _this.reschedulingInfo = res.data;
        var candidateDates = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(res.data.candidate_datetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cand = _step.value;

            if (candidateDates.indexOf(cand.date) === -1) {
              candidateDates.push(cand.date);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _loop = function _loop(date) {
          _this.getReservations({ date: date }).then(function () {
            _this.reservationsOnCandidateDates[date] = _this.$store.state.reservations;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.reschedulingInfo.candidate_datetimes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var info = _step3.value;

                info.duration = _this.reservationDuration;
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          });
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(candidateDates), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var date = _step2.value;

            _loop(date);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    });
    window.addEventListener('resize', function () {
      _this.windowWidth = document.documentElement.clientWidth;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['getReschedulingByHash', 'getReservations', 'setReschedulingInfo', 'updateReschedulingInfo', 'sendMailReschedulingResult']), {
    moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a,
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    selectedCandidateChanged: function selectedCandidateChanged() {
      if (this.selectedCandidate.mode === 'slot') {
        this.timeslot.start_time = this.selectedCandidate.start_time;
        this.timeslot.end_time = this.selectedCandidate.end_time;
      } else {
        this.timeslot.start_time = null;
        this.timeslot.end_time = null;
      }
    },
    timeslotStartTimeChanged: function timeslotStartTimeChanged() {
      if (this.timeslot.start_time) {
        this.timeslot.end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.timeslot.start_time, 'HH:mm').add(this.selectedCandidate.duration, 'minutes').format('HH:mm');
      } else {
        this.timeslot.end_time = null;
      }
    },
    timeslotEndTimeChanged: function timeslotEndTimeChanged() {
      if (this.timeslot.end_time) {
        this.timeslot.start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.timeslot.end_time, 'HH:mm').add(-this.selectedCandidate.duration, 'minutes').format('HH:mm');
      } else {
        this.timeslot.start_time = null;
      }
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      if (this.isSelectionCompleted && this.isTimeslotCompleted && !this.isDenying) {
        var date = this.selectedCandidate.date;
        this.check = 0;
        for (var i = 0; i < this.reservationsOnCandidateDates[date].length; i++) {
          if (this.reservationsOnCandidateDates[date][i].student.id === this.reschedulingInfo.receiver.id || this.reservationsOnCandidateDates[date][i].student.id === this.reschedulingInfo.sender.id) {
            if (this.timeslot.start_time <= this.reservationsOnCandidateDates[date][i].end_time && this.timeslot.end_time >= this.reservationsOnCandidateDates[date][i].start_time) {
              alert(this.reschedulingInfo.receiver.fullname + '様が同時間帯に他の授業を予約しています');
              this.check = 1;
            }
          }
          if (this.reservationsOnCandidateDates[date][i].teacher.id === this.reschedulingInfo.sender.id || this.reservationsOnCandidateDates[date][i].teacher.id === this.reschedulingInfo.receiver.id) {
            if (this.timeslot.start_time <= this.reservationsOnCandidateDates[date][i].end_time && this.timeslot.end_time >= this.reservationsOnCandidateDates[date][i].start_time) {
              alert(this.reschedulingInfo.sender.fullname + '様が同時間帯に他の授業を予約しています');
              this.check = 1;
            }
          }
        }
        if (this.check === 0) {
          this.reschedulingInfo.rescheduled_reservation.date = this.selectedCandidate.date;
          this.reschedulingInfo.rescheduled_reservation.start_time = this.timeslot.start_time;
          this.reschedulingInfo.rescheduled_reservation.end_time = this.timeslot.end_time;

          if (this.reschedulingInfo.receiver.user_type === 'teacher') {
            this.reschedulingInfo.reservationOption = this.reservationOption;
            this.reschedulingInfo.rescheduled_reservation.has_test = this.reservationOption.hasTest;
            this.reschedulingInfo.rescheduled_reservation.reservation_message = this.reservationOption.reservationMessage;
            this.reschedulingInfo.rescheduled_reservation.reservation_type = this.reservationOption.reservationType;
          }

          this.reschedulingInfo.isDenying = this.isDenying;

          this.setReschedulingInfo(this.reschedulingInfo);

          this.$router.push('/SpRescheduling/' + this.$route.params.rescheduling_hash + '/SpReceiverClassroom');
        }
      } else {
        this.isCompletenessChecking = true;
        alert('入力内容にエラーがあります！');
        window.scrollTo(0, 0);
      }
    },
    denyButtonClicked: function denyButtonClicked() {
      var _this2 = this;

      if (this.isDenying && this.isAlternativeDatetimes) {
        this.reschedulingInfo.isDenying = this.isDenying;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.alternative_datetimes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var date = _step4.value;

            date.duration = this.reservationDuration;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        this.reschedulingInfo.alternative_datetimes = this.alternative_datetimes;
        if (this.reschedulingInfo.receiver.user_type === 'teacher') {
          this.reschedulingInfo.reservationOption = this.reservationOption;
          this.reschedulingInfo.rescheduled_reservation.has_test = this.reservationOption.hasTest;
          this.reschedulingInfo.rescheduled_reservation.reservation_message = this.reservationOption.reservationMessage;
          this.reschedulingInfo.rescheduled_reservation.reservation_type = this.reservationOption.reservationType;
        }
        this.setReschedulingInfo(this.reschedulingInfo).then(function () {
          _this2.$router.push('/SpRescheduling/' + _this2.$route.params.rescheduling_hash + '/Spconfirmation_rcvr');
        });
      } else {
        this.isCompletenessChecking = true;
        alert('入力内容にエラーがあります！');
        window.scrollTo(0, 0);
      }
    },
    deleteCandidate: function deleteCandidate(index) {
      this.alternative_datetimes.splice(index, 1);
    },
    getWeekday: function getWeekday(date) {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    },
    disabledDate: function disabledDate(date) {
      var nowdt = new Date();
      nowdt.setDate(nowdt.getDate() + 1);
      var stdt = new Date(nowdt.getFullYear(), nowdt.getMonth(), nowdt.getDate(), 0, 0, 0);
      var enddt = new Date();
      enddt.setMonth(enddt.getMonth() + 1);
      return date < stdt || !this.$store.state.userInfo.is_Sunday_user && date.getDay() === 0 || date > enddt;
    },
    getMaxStartTime: function getMaxStartTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.end_time ? cand.end_time : '23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    getMinEndTime: function getMinEndTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.start_time ? cand.start_time : '10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    candidateStartTimeChanged: function candidateStartTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.start_time) {
          cand.end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.start_time, 'HH:mm').add(this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.end_time = null;
        }
      }
    },
    candidateEndTimeChanged: function candidateEndTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.end_time) {
          cand.start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.end_time, 'HH:mm').add(-this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.start_time = null;
        }
      }
    },
    addEmptyCandidate: function addEmptyCandidate() {
      this.alternative_datetimes.push({
        date: '',
        mode: 'slot',
        start_time: '',
        end_time: '',
        duration: this.reservationDuration
      });
      this.$nextTick(function () {
        var list = document.getElementById('candidate-list');
        list.scrollTop = list.scrollHeight;
      });
    }
  }),
  computed: {
    senderDisplayName: function senderDisplayName() {
      return this.reschedulingInfo.sender.fullname + (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様');
    },
    receiverDisplayName: function receiverDisplayName() {
      return this.reschedulingInfo.receiver.fullname + (this.reschedulingInfo.receiver.user_type === 'teacher' ? '先生' : '様');
    },
    isNarrowMode: function isNarrowMode() {
      return this.windowWidth < 670;
    },
    isSelectionCompleted: function isSelectionCompleted() {
      return this.isDenying || this.selectedCandidate !== null;
    },
    isTimeslotCompleted: function isTimeslotCompleted() {
      return this.isDenying || this.selectedCandidate.mode === 'slot' || this.timeslot.start_time && this.timeslot.end_time;
    },
    isAlternativeDatetimes: function isAlternativeDatetimes() {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.alternative_datetimes), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var candidate = _step5.value;

          if (!candidate.date || !candidate.start_time || !candidate.end_time) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return true;
    },
    checkExpireDate: function checkExpireDate() {
      var regdate = this.reschedulingInfo.registered_datetime.split(' ');
      var date = regdate[0].split('-');
      var time = regdate[1].split(':');
      if (date[1] !== '10') {
        date[1] = date[1].replace('0', '');
      }
      date[1] = Number(date[1]) - 1;
      var scheduledDate = new Date(date[0], date[1], date[2], time[0], time[1], time[2]);
      scheduledDate.setDate(scheduledDate.getDate() + 1);
      return new Date() < scheduledDate;
    },
    reservationDuration: function reservationDuration() {
      var calcMinutesDiff = function calcMinutesDiff(t1, t2) {
        var tmpDate = '2018-01-01';
        return (new Date(tmpDate + 'T' + t1).getTime() - new Date(tmpDate + 'T' + t2).getTime()) / 1000 / 60;
      };
      if (this.reschedulingInfo.target_reservation && !this.isOther) {
        return calcMinutesDiff(this.reschedulingInfo.target_reservation.end_time.slice(0, -3), this.reschedulingInfo.target_reservation.start_time.slice(0, -3));
      } else if (this.isOther && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime) {
        return calcMinutesDiff(this.otherReservation.endTime, this.otherReservation.startTime);
      } else {
        return 0;
      }
    }
  },
  watch: {
    isDenying: function isDenying() {
      if (this.isDenying) {
        this.commitMessage = '確認画面へ';
      } else {
        this.commitMessage = '座席を選択する';
      }
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reschedulingInfo: null,
      receiverInfo: {},
      ClickCheck: 0,
      Message: ''
    };
  },

  name: 'reschedulingSenderConfirmation',
  mounted: function mounted() {
    var _this = this;

    this.reschedulingInfo = this.$store.state.reschedulingInfo;
    var receiverId = this.reschedulingInfo.receiver;
    this.getLectures({}).then(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.$store.state.lectureInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lecture = _step.value;

          if (lecture.teacher.id === receiverId) {
            _this.receiverInfo = lecture.teacher;
            _this.receiverInfo.user_type = 'teacher';
          } else if (lecture.student.id === receiverId) {
            _this.receiverInfo = lecture.student;
            _this.receiverInfo.user_type = 'student';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
    window.addEventListener('beforeunload', function (e) {
      e.returnValue = 'まだ振替依頼は完了していません';
      return 'まだ振替依頼は完了していません';
    });
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLectures', 'postReschedulings', 'sendMailReschedulingRequest', 'setReschedulingInfo', 'updateReschedulingInfo', 'sendMailReschedulingError']), {
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    cancelButtonClicked: function cancelButtonClicked() {
      this.$router.push('/SpRescheduling');
    },
    okButtonClicked: function okButtonClicked() {
      var _this2 = this;

      if (this.ClickCheck === 0) {
        this.ClickCheck = 1;
        var paramTargetReservation = this.reschedulingInfo.targetReservation.id ? {
          id: this.reschedulingInfo.targetReservation.id
        } : {
          date: this.reschedulingInfo.targetReservation.date,
          start_time: this.reschedulingInfo.targetReservation.startTime,
          end_time: this.reschedulingInfo.targetReservation.endTime
        };
        var paramCandidateDatetimes = this.reschedulingInfo.candidateDatetimes.map(function (cand) {
          return {
            date: cand.date,
            start_time: cand.startTime,
            end_time: cand.endTime,
            mode: cand.mode,
            duration: Number(cand.duration)
          };
        });
        var paramReservationOption = {
          reservation_type: this.reschedulingInfo.reservationOption.reservationType,
          has_test: this.reschedulingInfo.reservationOption.hasTest,
          reservation_message: this.reschedulingInfo.reservationOption.reservationMessage
        };
        this.postReschedulings({
          sender: this.reschedulingInfo.sender,
          receiver: this.reschedulingInfo.receiver,
          target_reservation: paramTargetReservation,
          candidate_datetimes: paramCandidateDatetimes,
          reason: this.reschedulingInfo.reason,
          reservation_option: paramReservationOption,
          school_id: this.$store.state.userInfo.school_id
        }).then(function (res) {
          _this2.reschedulingInfo.hash = res.data.hash;
          _this2.sendMailReschedulingRequest(res.data.hash).then(function (response) {
            _this2.$store.state.reschedulingInfo = null;
            _this2.$router.push('/SpSenderCompletion');
          }).catch(function (err) {
            console.error(err);
            _this2.updateReschedulingInfo({
              hash: _this2.reschedulingInfo.hash,
              reservation: {
                is_status: 'error',
                rescheduled_reservation: _this2.reschedulingInfo.targetReservation.id,
                receiver_message: _this2.reschedulingInfo.reason,
                alternative_datetimes: _this2.reschedulingInfo.candidateDatetimes
              }
            }).then(function (res) {
              _this2.sendMailReschedulingError(_this2.reschedulingInfo.hash).catch(function (err) {
                console.error(err);
              });
            }).then(function () {
              _this2.reschedulingInfo.status = 'error';
              _this2.setReschedulingInfo(_this2.reschedulingInfo);
              _this2.ClickCheck = 0;
            });
          });
        }).catch(function (err) {
          console.error(err);
          _this2.ClickCheck = 0;
        });
      } else {
        this.Message = '処理中です。少々お待ちください。';
      }
    }
  })
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpNotificationBox__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpNotificationBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpNotificationBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReschedulingPage_ReschedulingOptionForm__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReschedulingPage_ReschedulingOptionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ReschedulingPage_ReschedulingOptionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpSenderForm',
  data: function data() {
    return {
      studentList: null,
      teacherList: null,
      selectedReservation: null,
      isOther: false,
      otherReservation: {
        date: '',
        startTime: '',
        endTime: '',
        receiver: 0
      },
      reservations: [],
      candidateDatetimes: [{
        date: '',
        mode: 'slot',
        startTime: '',
        endTime: '',
        duration: 0
      }],
      reason: '',
      isCompletenessChecking: false,
      reservationOption: {
        reservationType: '通常',
        hasTest: false,
        reservationMessage: ''
      }
    };
  },

  components: {
    'autocomplete': __WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection___default.a,
    'datepicker': __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a,
    'notificationBox': __WEBPACK_IMPORTED_MODULE_5__SpNotificationBox___default.a,
    'reschedulingOptionForm': __WEBPACK_IMPORTED_MODULE_6__ReschedulingPage_ReschedulingOptionForm___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.getReservations({ user_id: this.$store.state.userInfo.user_id }).then(function () {
      var filteredList = _this.$store.state.reservations.filter(function (reservation) {
        return _this.parseDateTime(reservation.date) > new Date();
      });
      filteredList.sort(function (a, b) {
        var dateA = _this.parseDateTime(a.date, a.start_time);
        var dateB = _this.parseDateTime(b.date, b.start_time);
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filteredList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;

          var selectedDate = _this.parseDateTime(r.date, r.start_time);
          if (selectedDate.getDay() === 1) {
            selectedDate.setDate(selectedDate.getDate() - 2);
          } else {
            selectedDate.setDate(selectedDate.getDate() - 1);
          }
          var limitDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 22, 0, 0);
          _this.reservations.push({
            id: r.id,
            date: r.date,
            startTime: r.start_time,
            endTime: r.end_time,
            type: r.reservation_type,
            has_test: r.has_test,
            message: r.message,
            receiver: _this.$store.state.userInfo.user_type === 'teacher' ? r.student.id : r.teacher.id,
            receiverUserName: r.student.user_name,
            text: (_this.$store.state.userInfo.user_type === 'teacher' ? r.student.fullname + ' 様' : r.teacher.fullname + ' 先生') + '　' + r.date.replace(/-/g, '/') + '　' + r.start_time.slice(0, -3) + ' 〜 ' + r.end_time.slice(0, -3),
            expireCheck: new Date() > limitDate,
            mailCheck: r.student.mail_address != null && r.teacher.mail_address != null
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }).catch(function (err) {
      console.error(err);
    });
    this.getLectures({}).then(function () {
      if (_this.$store.state.userInfo.user_type === 'teacher') {
        _this.studentList = _this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this.$store.state.userInfo.user_id === lect.teacher.id && !/^tanki_/.test(lect.student.user_name);
        }).map(function (lect, index, self) {
          return lect.student;
        });
      } else if (_this.$store.state.userInfo.user_type === 'student') {
        _this.teacherList = _this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this.$store.state.userInfo.user_id === lect.student.id;
        }).map(function (lect, index, self) {
          return lect.teacher;
        });
      }
    }).catch(function (err) {
      console.error(err);
    });
    if (this.$store.state.reschedulingInfo) {
      var reschedulingInfo = this.$store.state.reschedulingInfo;
      if (reschedulingInfo.targetReservation.id) {
        this.selectedReservation = reschedulingInfo.targetReservation;
        this.isOther = false;
      } else {
        this.selectedReservation = null;
        this.isOther = true;
        this.otherReservation = reschedulingInfo.targetReservation;
        this.otherReservation.receiver = reschedulingInfo.receiver;
      }
      this.candidateDatetimes = reschedulingInfo.candidateDatetimes;
      this.reason = reschedulingInfo.reason;
      if (this.$store.state.userInfo.user_type === 'teacher') {
        this.reservationOption = reschedulingInfo.reservationOption;
      }
    }
  },

  computed: {
    isFirstCompleted: function isFirstCompleted() {
      return this.selectedReservation && !this.isOther || this.isOther && this.otherReservation.receiver && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime;
    },
    isSecondCompleted: function isSecondCompleted() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.candidateDatetimes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var candidate = _step2.value;

          if (!candidate.date || !candidate.startTime || !candidate.endTime) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return true;
    },
    isThirdCompleted: function isThirdCompleted() {
      return !!this.reason;
    },
    isFourthCompleted: function isFourthCompleted() {
      return this.$store.state.userInfo.user_type === 'teacher' && this.reservationOption.reservationType !== null && this.has_test !== null;
    },
    reservationDuration: function reservationDuration() {
      var calcMinutesDiff = function calcMinutesDiff(t1, t2) {
        var tmpDate = '2018-01-01';
        return (new Date(tmpDate + 'T' + t1).getTime() - new Date(tmpDate + 'T' + t2).getTime()) / 1000 / 60;
      };
      if (this.selectedReservation && !this.isOther) {
        return calcMinutesDiff(this.selectedReservation.endTime, this.selectedReservation.startTime);
      } else if (this.isOther && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime) {
        return calcMinutesDiff(this.otherReservation.endTime, this.otherReservation.startTime);
      } else {
        return 0;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['getReservations', 'setReschedulingInfo', 'getLectures']), {
    moment: __WEBPACK_IMPORTED_MODULE_4_moment___default.a,
    parseDateTime: function parseDateTime(date) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      date = date.split('-');
      if (time) {
        time = time.split(':');
        return new Date(date[0], date[1] - 1, date[2], time[0], time[1]);
      } else {
        return new Date(date[0], date[1] - 1, date[2]);
      }
    },
    disabledDate: function disabledDate(date) {
      var nowdt = new Date();
      nowdt.setDate(nowdt.getDate() + 1);
      var stdt = new Date(nowdt.getFullYear(), nowdt.getMonth(), nowdt.getDate(), 0, 0, 0);
      var enddt = new Date();
      enddt.setMonth(enddt.getMonth() + 1);
      return date < stdt || !this.$store.state.userInfo.is_Sunday_user && date.getDay() === 0 || date > enddt;
    },
    getWeekday: function getWeekday(date) {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    },
    addEmptyCandidate: function addEmptyCandidate() {
      this.candidateDatetimes.push({
        date: '',
        mode: 'slot',
        startTime: '',
        endTime: '',
        duration: this.reservationDuration
      });
      this.$nextTick(function () {
        var list = document.getElementById('candidate-list');
        list.scrollTop = list.scrollHeight;
      });
    },
    deleteCandidate: function deleteCandidate(index) {
      this.candidateDatetimes.splice(index, 1);
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      if (!this.selectedReservation.mailCheck) {
        alert('生徒様または講師様のメールアドレスがシステムに登録されていないため，授業振替依頼をご使用いただくことが出来ません\n究進塾事務局までご連絡ください');
        return;
      }
      if (!this.isOther) {
        if (this.selectedReservation.receiverUserName.match('tanki')) {
          alert('恐れ入りますが、短期利用者の振り替え依頼は究進塾事務局(info@kyushinjuku.com)へ、授業前日22時までにご連絡ください。');
          return;
        }
      }
      if (this.isFirstCompleted && this.isSecondCompleted && this.isThirdCompleted) {
        this.setReschedulingInfo(this.makeReschedulingInfo());
        this.$router.push('/SpSenderConfirmation');
      } else {
        this.isCompletenessChecking = true;
        alert('入力内容にエラーがあります！');
        window.scrollTo(0, 0);
      }
    },
    candidateStartTimeChanged: function candidateStartTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.startTime) {
          cand.endTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.startTime, 'HH:mm').add(this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.endTime = null;
        }
      }
    },
    candidateEndTimeChanged: function candidateEndTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.endTime) {
          cand.startTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.endTime, 'HH:mm').add(-this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.startTime = null;
        }
      }
    },
    reservationChanged: function reservationChanged() {
      this.clearCandidateTimes();
      if (this.$store.state.userInfo.user_type === 'teacher') {
        if (this.selectedReservation) {
          this.reservationOption.reservationType = this.selectedReservation.type;
          this.reservationOption.hasTest = this.selectedReservation.has_test;
          this.reservationOption.reservationMessage = this.selectedReservation.message;
        } else {
          this.reservationOption.reservationType = '通常';
          this.reservationOption.hasTest = false;
          this.reservationOption.reservationMessage = '';
        }
      }
    },
    clearCandidateTimes: function clearCandidateTimes() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.candidateDatetimes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var cand = _step3.value;

          cand.startTime = null;
          cand.endTime = null;
          cand.duration = this.reservationDuration;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    getMaxStartTime: function getMaxStartTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()('23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.endTime ? cand.endTime : '23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    getMinEndTime: function getMinEndTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()('10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.startTime ? cand.startTime : '10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    makeReschedulingInfo: function makeReschedulingInfo() {
      var sender = this.$store.state.userInfo.user_id;
      var receiver = this.selectedReservation && !this.isOther ? this.selectedReservation.receiver : this.otherReservation.receiver;
      var targetReservation = this.selectedReservation && !this.isOther ? this.selectedReservation : {
        date: this.otherReservation.date,
        startTime: this.otherReservation.startTime + ':00',
        endTime: this.otherReservation.endTime + ':00'
      };
      return {
        sender: sender,
        receiver: receiver,
        targetReservation: targetReservation,
        candidateDatetimes: this.candidateDatetimes,
        reason: this.reason,
        reservationOption: this.reservationOption,
        school_id: this.$store.state.userInfo.school_id

      };
    },
    check_tankiuser: function check_tankiuser() {
      if (this.$store.state.userInfo.user_name.match('tanki')) {
        return true;
      } else {
        return false;
      }
    }
  })
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reschedulingInfo: this.$store.state.reschedulingInfo,
      receiverInfo: null
    };
  },

  name: 'reschedulingReceiverConfirmation',
  moundted: function moundted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['postReservation', 'updateReschedulingInfo', 'postReschedulings', 'setReschedulingInfo', 'editReservation', 'sendMailReschedulingResult', 'sendMailReschedulingRequest']), {
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    cancelButtonClicked: function cancelButtonClicked() {
      this.$router.push('/SpRescheduling/' + this.$route.params.rescheduling_hash);
    },
    updateReservationDB: function updateReservationDB(teacherId, studentId, reschedulingInfo) {
      if (!reschedulingInfo.target_reservation.id) {
        return this.postReservation({
          student: studentId,
          teacher: teacherId,
          start_time: reschedulingInfo.rescheduled_reservation.start_time,
          end_time: reschedulingInfo.rescheduled_reservation.end_time,
          classroom: reschedulingInfo.rescheduled_reservation.classroom_name,
          date: reschedulingInfo.rescheduled_reservation.date,
          has_test: reschedulingInfo.rescheduled_reservation.has_test,
          reservation_type: reschedulingInfo.rescheduled_reservation.reservation_type,
          message: reschedulingInfo.rescheduled_reservation.reservation_message
        });
      } else {
        return this.editReservation({
          id: reschedulingInfo.target_reservation.id,
          reservation: {
            student: studentId,
            teacher: teacherId,
            start_time: reschedulingInfo.rescheduled_reservation.start_time,
            end_time: reschedulingInfo.rescheduled_reservation.end_time,
            classroom: reschedulingInfo.rescheduled_reservation.classroom_name,
            date: reschedulingInfo.rescheduled_reservation.date,
            has_test: reschedulingInfo.rescheduled_reservation.has_test,
            reservation_type: reschedulingInfo.rescheduled_reservation.reservation_type,
            message: reschedulingInfo.rescheduled_reservation.reservation_message
          }
        });
      }
    },
    confirmButtonClicked: function confirmButtonClicked() {
      var _this = this;

      var teacherId = void 0;
      var studentId = void 0;
      var targetId = void 0;
      if (this.reschedulingInfo.sender.user_type === 'teacher') {
        teacherId = this.reschedulingInfo.sender.id;
        studentId = this.reschedulingInfo.receiver.id;
      } else {
        teacherId = this.reschedulingInfo.receiver.id;
        studentId = this.reschedulingInfo.sender.id;
      }
      this.updateReservationDB(teacherId, studentId, this.reschedulingInfo).then(function (res) {
        if (res) {
          targetId = res.data.id;
        } else {
          targetId = parseInt(_this.reschedulingInfo.target_reservation.id);
        }
        _this.updateReschedulingInfo({
          hash: _this.reschedulingInfo.hash,
          reservation: {
            is_status: 'accepted',
            rescheduled_reservation: targetId,
            receiver_message: _this.reschedulingInfo.receiver_message
          }
        }).then(function (res) {
          _this.sendMailReschedulingResult(_this.reschedulingInfo.hash);
        }).then(function () {
          _this.reschedulingInfo.status = 'accepted';

          _this.setReschedulingInfo(_this.reschedulingInfo);
          _this.$router.push('/SpRescheduling/' + _this.$route.params.rescheduling_hash + '/SpReceiverCompletion');
        });
      });
    },
    denyButtonClicked: function denyButtonClicked() {
      var _this2 = this;

      this.updateReschedulingInfo({
        hash: this.reschedulingInfo.hash,
        reservation: {
          is_status: 'denied',
          rescheduled_reservation: this.reschedulingInfo.target_reservation.id,
          receiver_message: this.reschedulingInfo.receiver_message,
          alternative_datetimes: this.reschedulingInfo.alternative_datetimes
        }
      }).then(function () {
        var paramTargetReservation = _this2.reschedulingInfo.target_reservation.id ? {
          id: _this2.reschedulingInfo.target_reservation.id
        } : {
          date: _this2.reschedulingInfo.target_reservation.date,
          start_time: _this2.reschedulingInfo.target_reservation.startTime,
          end_time: _this2.reschedulingInfo.target_reservation.endTime
        };
        var paramCandidateDatetimes = _this2.reschedulingInfo.alternative_datetimes.map(function (cand) {
          return {
            date: cand.date,
            start_time: cand.start_time,
            end_time: cand.end_time,
            mode: cand.mode,
            duration: cand.duration
          };
        });
        var paramReservationOption = {
          reservation_type: _this2.reschedulingInfo.rescheduled_reservation.reservation_type,
          has_test: _this2.reschedulingInfo.rescheduled_reservation.has_test,
          reservation_message: _this2.reschedulingInfo.rescheduled_reservation.reservation_message
        };
        _this2.postReschedulings({
          sender: _this2.reschedulingInfo.receiver.id,
          receiver: _this2.reschedulingInfo.sender.id,
          target_reservation: paramTargetReservation,
          candidate_datetimes: paramCandidateDatetimes,
          reason: '依頼の日程の都合が悪いため代替の日程を提案します',
          reservation_option: paramReservationOption
        }).then(function (res) {
          _this2.reschedulingInfo.status = 'denied';

          _this2.setReschedulingInfo(_this2.reschedulingInfo);

          _this2.sendMailReschedulingResult({
            hash: _this2.reschedulingInfo.hash,
            newhash: res.data.hash
          }).then(function () {
            _this2.$router.push('/SpRescheduling/' + _this2.$route.params.rescheduling_hash + '/SpReceiverCompletion');
          }).catch(function (err) {
            console.error(err);
          });
        }).catch(function (err) {
          console.error(err);
        });
      });
    }
  }),
  computed: {
    senderDisplayName: function senderDisplayName() {
      return this.reschedulingInfo.sender.fullname + (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様');
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpReschedulingList',
  data: function data() {
    return {
      list: null,
      receiverInfo: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getReschedulingetList(this.$store.state.userInfo.user_id).then(function (res) {
      _this.list = res.data;
    }).then(function () {
      _this.getLectures({});
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getReschedulingetList', 'getLectures']), {
    getUsername: function getUsername(id) {
      var receiverId = Number(id);
      var name = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$store.state.lectureInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lecture = _step.value;

          if (lecture.teacher.id === receiverId) {
            name = lecture.teacher.fullname;
          } else if (lecture.student.id === receiverId) {
            name = lecture.student.fullname;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return name;
    }
  })
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Mobile_header_SpAppHeader__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Mobile_header_SpAppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Mobile_header_SpAppHeader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_Mobile_header_SpAppHeader___default.a
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'userinfo',
  deta: function deta() {
    return {
      userType: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getUserInfo', 'getInformation']), {
    getinformation: function getinformation() {
      this.getInformation().then(function (res) {});
    }
  }),
  created: function created() {
    this.getUserInfo().then(function (res) {});
    if (this.$store.state.userInfo.user_type === 'admin') {
      this.userType = '管理者';
    } else if (this.$store.state.userInfo.user_type === 'teacher') {
      this.userType = '教師';
    } else if (this.$store.state.userInfo.user_type === 'student') {
      this.userType = '生徒';
    } else {
      this.userType = '閲覧者';
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'userinfo',
  deta: function deta() {
    return {
      user_id: null,
      fullname: null,
      kana: null,
      user_name: null,
      mail_address: null,
      password: null,
      current_fullname: null,
      current_kana: null,
      current_user_name: null,
      current_mail_address: null,
      current_password: null
    };
  },
  created: function created() {
    this.user_id = this.$store.state.userInfo.user_id;
    this.fullname = this.$store.state.userInfo.fullname;
    this.kana = this.$store.state.userInfo.kana;
    this.user_name = this.$store.state.userInfo.user_name;
    this.mail_address = this.$store.state.userInfo.mail_address;
    this.password = null;
    this.current_fullname = this.$store.state.userInfo.fullname;
    this.current_kana = this.$store.state.userInfo.kana;
    this.current_user_name = this.$store.state.userInfo.user_name;
    this.current_mail_address = this.$store.state.userInfo.mail_address;
    this.current_password = null;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeFullname', 'changeMailAddress', 'changeUserName', 'changeUserPassword']), {
    checkKana: function checkKana() {
      if (!this.kana.match(/^[ァ-ヴ]+$/)) {
        return false;
      }
      return true;
    },
    Apply: function Apply() {
      var _this = this;

      if (this.current_kana !== this.kana || this.current_fullname !== this.fullname) {
        if (!this.checkKana()) {
          alert('フリガナは全角カナのみで入力してください');
          return;
        }
        this.changeFullname({
          id: this.user_id,
          newFullname: this.fullname,
          newKana: this.kana
        }).then(function (res) {
          if (res) {
            _this.$emit('changed');
            alert('氏名の変更に成功しました.');
          }
        });
      }
      if (this.current_mail_address !== this.mail_address) {
        this.changeMailAddress({
          id: this.user_id,
          newMailAddress: this.mail_address
        }).then(function (res) {
          if (res) {
            _this.$emit('ehanged');
            alert('変更に成功しました');
          }
        });
      }
      if (this.current_user_name !== this.user_name) {
        this.changeUserName({
          id: this.user_id,
          newUserName: this.user_name
        }).then(function (res) {
          if (res) {
            _this.$emit('changed');
            alert('ユーザ名の変更に成功しました.');
          }
        });
      }
      if (this.password !== null) {
        this.changeUserPassword({
          id: this.user_id,
          currentPassword: this.current_password,
          newPassword: this.password
        }).then(function (res) {
          if (res) {
            alert('パスワードの変更に成功しました.');
          }
        });
      }
      this.$router.push('/Spuser');
    }
  })
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hover: '',
      reschedulinglist: false
    };
  },

  components: {
    'datepicker': __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a,
    'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['getCurDateFormated']), {
    isAdmin: function isAdmin() {
      if (this.$store.state.userInfo.user_type) {
        return this.$store.state.userInfo.user_type === 'admin';
      }
      return false;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var target = document.getElementsByClassName('vdp-datepicker__calendar');
    for (var i = 0; i < target.length; i++) {
      target[i].style.width = '100%';
    }
    this.getReschedulingetList(this.$store.state.userInfo.user_id).then(function (res) {
      if (res.data.length > 0) {
        _this.reschedulinglist = true;
      } else {
        _this.reschedulinglist = false;
      }
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getReservations', 'getReschedulingetList', 'getClassrooms']), {
    swipeHandler: function swipeHandler() {
      this.close_Menu();
    },
    dateSelectHandler: function dateSelectHandler(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["a" /* TIMETABLE_CHANGE_DATE */], {
        date: payload
      });
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      });
    },
    beforeLogout: function beforeLogout() {
      var isYes = confirm('ログアウトします．よろしいでしょうか．');
      if (isYes) {
        this.$router.push('/logout');
      }
    },
    getDisableDays: function getDisableDays() {
      var ddays = {
        days: [0]
      };
      if (this.$store.state.userInfo.is_Sunday_user === true) {
        return { days: [] };
      } else {
        return ddays;
      }
    },
    open_Menu: function open_Menu() {
      document.getElementById('nav-input').checked = true;
    },
    close_Menu: function close_Menu() {
      var _this2 = this;

      this.getReschedulingetList(this.$store.state.userInfo.user_id).then(function (res) {
        if (res.data.length > 0) {
          _this2.reschedulinglist = true;
        } else {
          _this2.reschedulinglist = false;
        }
      });
      document.getElementById('nav-input').checked = false;
    },
    schoolChange: function schoolChange() {
      if (this.$store.state.userInfo.school_id === '1') {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["b" /* CHANGE_SCHOOL */], '2');
        this.getClassrooms(this.$store.state.userInfo.school_id);
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["b" /* CHANGE_SCHOOL */], '1');
        this.getClassrooms(this.$store.state.userInfo.school_id);
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        });
      }
    },
    showOnline: function showOnline(event) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["c" /* SHOW_ONLINE */], event.target.checked);
      console.log(this.$store.state.showOnline);
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      });
    }
  })
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tl-header',
  props: ['classroom'],
  computed: {
    getStyle: function getStyle() {
      var style = {
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification + 'px',
        height: this.$store.state.tbHeaderHeight * this.$store.state.mobileHeightMagnification + 'px',
        'border-top-style': 'none',
        'border-top-width': '0px'
      };
      return style;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["J" /* UPDATE_HEADER_HEIGHT */], _this.$el.getBoundingClientRect().height);
    });
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ruler',
  data: function data() {
    return {
      ticksCellStyle: {
        height: this.$store.state.rowHeight * this.$store.state.mobileHeightMagnification + 'px'
      }
    };
  },

  methods: {
    getTicksClass: function getTicksClass(index) {
      if (index === 0) {
        return 'tickTop';
      } else if (index % 2 === 0) {
        return 'ticksMain';
      } else {
        return 'ticksSub';
      }
    }
  },
  computed: {
    getStyle: function getStyle() {
      var style = {};
      style.width = this.$store.state.rulerWidth + 'px';

      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.top = this.$store.state.tbHeaderHeight + this.$store.state.headerHeight + 2 + 'px';
        style.left = this.$window.scrollX + 2 + 'px';
        style['z-index'] = 1001;
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute';
        style.left = this.$window.scrollX + 2 + 'px';
        style.top = this.$store.state.tbHeaderHeight + this.$store.state.headerHeight + 3 + 'px';
        style['border-left'] = 'solid 2px black';
        style['z-index'] = 1001;
      } else if (this.$window.scrollY > 0) {
        style.position = 'relative';
        style.top = this.$store.state.tbHeaderHeight + 'px';
        style['z-index'] = 1001;
      } else {
        style['margin-top'] = '-1px';
      }
      return style;
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['classroom'],
  computed: {
    getStyle: function getStyle() {
      var style = {};
      style.height = this.$store.state.tbHeaderHeight + 'px';
      style.width = this.$store.state.rulerWidth + 'px';
      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.top = '0px';
        style.left = this.$window.scrollX + 'px';
        style['border-top'] = 'solid 1px black';
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px';
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute';
        style.left = this.$window.scrollX + 2 + 'px';
        style.top = this.$store.state.headerHeight + 2 + 'px';
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px';
        style['border-left'] = 'solid 2px black';
      } else if (this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.left = this.$window.scrollX + 'px';
        style.top = '0px';
        style['border-left'] = 'solid 1px black';
        style['border-top'] = 'solid 1px black';
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px';
      } else {}
      return style;
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpTicker__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpTicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SpTicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpRuler__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpRuler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SpRuler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpRulerHeader__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpRulerHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SpRulerHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpClassroomHeader__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpClassroomHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SpClassroomHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpTimelineContainer__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpTimelineContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpTimelineContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__boxes_SpInformationPopup__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__boxes_SpInformationPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__boxes_SpInformationPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__boxes_SpEditingPopup__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__boxes_SpEditingPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__boxes_SpEditingPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__boxes_SpReservationPopup__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__boxes_SpReservationPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__boxes_SpReservationPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__boxes_SpReschedulingPopup__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__boxes_SpReschedulingPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__boxes_SpReschedulingPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timetable',
  props: [],
  data: function data() {
    return {
      style: {},
      classrooms: '',
      lastOnlineState: false
    };
  },

  components: {
    ticker: __WEBPACK_IMPORTED_MODULE_1__SpTicker___default.a,
    ruler: __WEBPACK_IMPORTED_MODULE_2__SpRuler___default.a,
    rulerHeader: __WEBPACK_IMPORTED_MODULE_3__SpRulerHeader___default.a,
    classroomHeader: __WEBPACK_IMPORTED_MODULE_4__SpClassroomHeader___default.a,
    timelineContainer: __WEBPACK_IMPORTED_MODULE_5__SpTimelineContainer___default.a,
    informtionPopup: __WEBPACK_IMPORTED_MODULE_6__boxes_SpInformationPopup___default.a,
    editingPopup: __WEBPACK_IMPORTED_MODULE_7__boxes_SpEditingPopup___default.a,
    ReservationPopup: __WEBPACK_IMPORTED_MODULE_8__boxes_SpReservationPopup___default.a,
    ReschedulingPopup: __WEBPACK_IMPORTED_MODULE_9__boxes_SpReschedulingPopup___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(['getClassrooms', 'getReservations', 'getLectures', 'getClassrooms', 'getAttendance']), {
    test: function test() {
      alert(1);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])(['tableWidth', 'getCurDateFormated']), {
    getStyle: function getStyle() {
      this.style.width = this.tableWidth + 'px';
      return this.style;
    },
    filteredclassroomNames: function filteredclassroomNames() {
      if (this.lastOnlineState !== this.$store.state.showOnline) {
        console.log('getting classrooms');
        this.getClassrooms(this.$store.state.userInfo.school_id);
      }
      this.lastOnlineState = this.$store.state.showOnline;
      this.classroom = this.$store.state.classrooms;
      if (this.$store.state.showOnline) {
        this.classroom = this.classroom.filter(function (c) {
          return c.name.match(/^オンライン/);
        });
      } else {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match(/^オンライン/);
        });
      }
      if (this.$store.state.userInfo.user_type !== 'viewer' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'admin') {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match('301');
        });
        this.$store.state.classrooms = this.classroom;
        return this.classroom;
      }
      this.$store.state.classrooms = this.classroom;
      return this.classroom;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_11_axios___default.a.all([this.getReservations({
      all: 1,
      date: this.getCurDateFormated,
      school_id: this.$store.state.userInfo.school_id
    }), this.$store.dispatch('getLectures', {}), this.$store.dispatch('getUserInfo')]).then(__WEBPACK_IMPORTED_MODULE_11_axios___default.a.spread(function (res1, res2, res3) {
      if (_this.$store.state.userInfo.user_type === 'admin') {
        _this.$store.dispatch('getAttendance');
      }
    }));
    this.getClassrooms(this.$store.state.userInfo.school_id).then(function () {
      _this.classrooms = _this.$store.state.classrooms;
    });
  },
  created: function created() {
    var _this2 = this;

    this.getClassrooms(this.$store.state.userInfo.school_id).then(function () {
      _this2.classrooms = _this2.$store.state.classrooms;
    });
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      time: new Date(),
      style: {
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification * 16 + this.$store.state.rulerWidth + 'px',
        height: '0px',
        left: '0px',
        top: '0px',
        'margin-left': '0px'
      },
      intID: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['tableWidth', 'timeToPosition']), {
    getStyle: function getStyle() {
      return this.style;
    }
  }),
  methods: {
    updateStyle: function updateStyle() {
      if (this.time.getHours() < 10 || this.time.getHours() >= 22 && this.time.getMinutes() >= 0) {
        this.style.top = '0px';
        clearInterval(this.intID);
      }
      var top = this.timeToPosition(this.time.getHours() + ':' + this.time.getMinutes()) + this.$store.state.tbHeaderHeight + this.$store.state.headerHeight;
      this.style.top = top - 40 + 'px';
    },
    isEnable: function isEnable() {
      return !(this.time.getHours() < 10 || this.time.getHours() >= 22 && this.time.getMinutes() >= 0) && this.time.getDate() === this.$store.state.curDate.getDate() && this.time.getMonth() === this.$store.state.curDate.getMonth();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.updateStyle();
      _this.intID = setInterval(function () {
        _this.time = new Date();
        _this.updateStyle();
      }, 1000 * 60);
    });
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timeline',
  props: ['classroom', 'dragging'],
  data: function data() {
    return {
      style: {
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification + 'px' }
    };
  },

  methods: {
    mousedownHandler: function mousedownHandler(event) {
      this.$emit('tlmousedown', {
        e: event,
        classroom: this.classroom
      });
    },
    mousemoveHandler: function mousemoveHandler(event) {
      if (this.dragging) {
        this.$emit('tlmousemove', {
          e: event,
          classroom: this.classroom
        });
      }
    },
    mouseupHandler: function mouseupHandler(event) {
      this.$emit('tlmouseup', {
        e: event,
        classroom: this.classroom
      });
    },
    clickHandler: function clickHandler(event) {
      this.$emit('tlclick', {
        e: event,
        classroom: this.classroom
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['timelineHeight', 'positionToTime', 'getLeftPosOfClassroom', 'getClassroomAt', 'edgeClassrooms']), {
    getStyle: function getStyle() {
      var _this = this;

      this.style.height = this.timelineHeight * this.$store.state.mobileHeightMagnification + 'px';
      this.style.left = this.getLeftPosOfClassroom(this.classroom) * this.$store.state.mobileWidthMagnification + 'px';
      if (this.edgeClassrooms.some(function (elem, index, self) {
        return elem.name === _this.classroom;
      })) {
        this.style['border-right-width'] = '2px';
        this.style['border-right-style'] = 'solid';
        this.style['border-right-color'] = 'black';
      }

      return this.style;
    }
  })
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpTimeline__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpTimeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SpTimeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boxes_SpReservationBox__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boxes_SpReservationBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__boxes_SpReservationBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__boxes_SpPreviewBox__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__boxes_SpPreviewBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__boxes_SpPreviewBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_time__ = __webpack_require__(26);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timeline-container',
  components: {
    timeline: __WEBPACK_IMPORTED_MODULE_3__SpTimeline___default.a,
    reservationBox: __WEBPACK_IMPORTED_MODULE_4__boxes_SpReservationBox___default.a,
    previewBox: __WEBPACK_IMPORTED_MODULE_5__boxes_SpPreviewBox___default.a
  },
  data: function data() {
    return {
      tlTicksStyle: {
        height: this.$store.state.rowHeight * this.$store.state.mobileHeightMagnification + 'px' },
      hasDraggingTl: false,
      focusedClassroom: '',
      dragStartTime: new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */]('00:00'),
      dragEndTime: new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */]('00:00'),
      mousedownTime: 0,
      clickthreshold: 200,
      isFuture: true,
      isBeforeDeadline: true };
  },

  methods: {
    getTicksClass: function getTicksClass(index) {
      if (index === 0) {
        return 'tickTop';
      } else if (index % 2 === 0) {
        return 'ticksMain';
      } else {
        return 'ticksSub';
      }
    },
    clickHandler: function clickHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["p" /* PREVIEWBOX_CLASSROOM_UPDATE */], argobj.classroom);
      var nearestTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
        start: nearestTime.toString(),
        end: nearestTime.addMinuites(60).toString()
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["q" /* PREVIEWBOX_SHOW_POPUP */]);

      if (this.$store.state.lectureInfo.length === 0) {
        this.$store.dispatch('getLectures', {});
      }
    },
    mousedownHandler: function mousedownHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && !this.isAfterRelease) {
        return;
      }
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.dragStartTime = new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */]('00:00');
      }

      this.mousedownTime = new Date().getTime();
      var nearestTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));
      var clickedTime = new Date(this.$store.state.curDate.getFullYear(), this.$store.state.curDate.getMonth(), this.$store.state.curDate.getDate(), nearestTime.getMinutes() / 60, nearestTime.getMinutes() % 60);
      this.isFuture = clickedTime.getTime() > this.mousedownTime;
      if (!this.isFuture && this.$store.state.userInfo.user_type !== 'admin') {
        alert('過去への予約は出来ません');
        return;
      }

      var now = new Date();
      var dateDiff = (new Date(clickedTime.getFullYear(), clickedTime.getMonth(), clickedTime.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 1000 / 60 / 60 / 24;
      this.isBeforeDeadLine = clickedTime.getDay() === 1 && (dateDiff > 2 || dateDiff === 2 && now.getHours() < 22) || clickedTime.getDay() !== 1 && (dateDiff > 1 || dateDiff === 1 && now.getHours() < 22);
      if (!this.isBeforeDeadLine && this.$store.state.userInfo.user_type !== 'admin') {
        alert('指定された時刻への予約は締め切られました');
        return;
      }
      this.dragStartTime = nearestTime;
      this.hasDraggingTl = true;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["p" /* PREVIEWBOX_CLASSROOM_UPDATE */], argobj.classroom);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
        start: this.dragStartTime.toString(),
        end: this.dragEndTime.toString()
      });
    },
    mousemoveHandler: function mousemoveHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }
      if (this.hasDraggingTl && (this.$store.state.userInfo.user_type === 'admin' || this.isFuture) && this.isBeforeDeadline) {
        if (this.timelineHeight - this.$store.state.rowHeight < argobj.e.offsetY) {
          argobj.e.offsetY = this.timelineHeight - this.$store.state.rowHeight;
        }

        this.dragEndTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));
        if (this.isReversed()) {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
            start: this.dragEndTime.toString(),
            end: this.dragStartTime.toString()
          });
          return;
        } else {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
            end: this.dragEndTime.toString()
          });
        }
      }
    },
    mouseupHandler: function mouseupHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && !this.isAfterRelease) {
        return;
      }
      if ((!this.isFuture || !this.isBeforeDeadline) && this.$store.state.userInfo.user_type !== 'admin') {
        return;
      }
      var mouseDownSpan = new Date().getTime() - this.mousedownTime;
      if (mouseDownSpan < this.clickthreshold) {
        this.clickHandler(argobj);
        this.mousedownTime = undefined;
        this.hasDraggingTl = false;
        return;
      }
      this.hasDraggingTl = false;
      var dragEndTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));

      var nowTime = new Date().getTime();
      var mouseUpTime = new Date(this.getCurDateFormated + ' ' + dragEndTime.toString()).getTime();
      if (mouseUpTime < nowTime && this.$store.state.userInfo.user_type !== 'admin') {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], { start: '10:00', end: '10:00' });
        return;
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["q" /* PREVIEWBOX_SHOW_POPUP */]);

      if (this.isReversed()) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: dragEndTime.toString()
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          end: dragEndTime.toString()
        });
      }

      if (this.$store.state.lectureInfo.length === 0) {
        this.$store.dispatch('getLectures', {});
      }
    },
    stopDragging: function stopDragging() {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }
      this.hasDraggingTl = false;
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.dragStartTime = new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */]('00:00');
      }
    },
    dragoverHandler: function dragoverHandler(e) {
      e.preventDefault();
    },
    dropHandler: function dropHandler(e) {
      e.preventDefault();
      var clrect = this.$el.getBoundingClientRect();
      var offsets = JSON.parse(e.dataTransfer.getData('text/json'));
      var top = e.pageY - clrect.top - window.pageYOffset - offsets.y;
      var start = this.fitToNearDivTime(this.positionToTime(top)).toString();
      var span = new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */](this.$store.state.editingState.end).getMinutes() - new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */](this.$store.state.editingState.start).getMinutes();
      var end = this.fitToNearDivTime(this.positionToTime(top)).addMinuites(span).toString();

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
        start: start,
        end: end
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], this.getClassroomAt(e.pageX - clrect.left - window.pageXOffset));
    },
    escHandler: function escHandler(event) {
      this.hasDraggingTl = false;
    },
    isReversed: function isReversed() {
      if (this.dragEndTime.getMinutes() < this.dragStartTime.getMinutes()) {
        return true;
      }
      return false;
    },
    isOver2200: function isOver2200(t) {
      if (t.getMinutes() > new __WEBPACK_IMPORTED_MODULE_6__modules_time__["a" /* default */]('22:00').getMinutes()) {
        return true;
      }
      return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['timelinesWidth', 'timelineHeight', 'fitToNearDivTime', 'timeToPosition', 'positionToTime', 'getClassroomAt', 'getCurDateFormated', 'getLeftPosOfClassroom', 'classroomNames']), {
    getContainerStyle: function getContainerStyle() {
      var style = {
        width: this.timelinesWidth * this.$store.state.mobileWidthMagnification + 'px',
        height: this.timelineHeight * this.$store.state.mobileHeightMagnification + 'px'
      };

      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.left = this.$store.state.rulerWidth + 'px';
        style.top = this.$store.state.tbHeaderHeight + this.$store.state.headerHeight + 'px';
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute';
        style.left = this.$store.state.rulerWidth + 'px';
      } else if (this.$window.scrollY > 0) {
        style.position = 'relative';
        style.top = this.$store.state.tbHeaderHeight + 'px';
      } else {}
      return style;
    },
    isAfterRelease: function isAfterRelease() {
      var theday = new Date(2017, 10, 20, 14, 0, 0);
      var now = new Date();
      return now.getTime() > theday.getTime();
    },
    filteredreservation: function filteredreservation() {
      if (this.$store.state.userInfo.user_type !== 'admin' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'viewer') {
        if (this.$store.state.reservations !== undefined) {
          this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
            return !c.classroom.match('301');
          });
        }
        return this.$store.state.reservations;
      }
      return this.$store.state.reservations;
    }
  })
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['suggestions', 'type', 'value', 'placeholder'],
  data: function data() {
    return {
      input: '',
      open: false,
      current: 0
    };
  },

  computed: {
    matches: function matches() {
      var _this = this;

      return this.suggestions.sort(function (a, b) {
        return a.kana > b.kana ? 1 : a.kana < b.kana ? -1 : -1;
      }).filter(function (obj) {
        return obj.fullname.indexOf(_this.input) >= 0;
      });
    },
    openSuggestion: function openSuggestion() {
      return this.matches.length !== 0 && this.open === true;
    }
  },
  methods: {
    updateValue: function updateValue(value) {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.input = value;
    },
    enter: function enter() {
      var id = '';
      var matchObj = this.matches[this.current];
      var name = '';
      id = matchObj.id;
      if (!id === undefined) {
        id = matchObj.user_id;
      }
      name = matchObj.fullname;
      this.$emit('input', id);
      this.input = name;
      this.open = false;
    },
    up: function up() {
      if (this.current > 0) {
        this.current--;
      }
    },
    click: function click() {
      this.open = !this.open;
      this.input = '';
      this.$emit('input', 0);
    },
    down: function down() {
      if (this.current < this.matches.length - 1) {
        this.current++;
      }
    },
    isActive: function isActive(index) {
      return index === this.current;
    },
    suggestionClick: function suggestionClick(index) {
      var id = '';
      var matchObj = this.matches[index];
      var name = '';
      id = matchObj.id;
      if (!id) {
        id = matchObj.user_id;
      }
      name = matchObj.fullname;
      this.$emit('input', id);
      this.input = name;
      this.open = false;
    },
    suggestionDisplay: function suggestionDisplay(suggestion) {
      return suggestion.fullname;
    },
    exactFullname: function exactFullname() {
      var _this2 = this;

      if (this.value === 0) {
        return '';
      }
      var theuser = this.suggestions.find(function (elem, array, self) {
        return elem.id === _this2.value;
      });
      return theuser.fullname;
    }
  },
  mounted: function mounted() {
    this.input = this.exactFullname();
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SpTemporaryLecturePanel__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SpTemporaryLecturePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SpTemporaryLecturePanel__);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      width: 450,
      isAllEditing: false,
      dialogEditVisible: false,
      dialogDeleteVisible: false,
      formatstarttime: null,
      formatendtime: null
    };
  },

  components: {
    'recurrent-panel': __WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel___default.a,
    'time-select': __WEBPACK_IMPORTED_MODULE_6_element_ui__["TimeSelect"],
    'autocomplete': __WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection___default.a,
    'temporaryLecturePanel': __WEBPACK_IMPORTED_MODULE_7__SpTemporaryLecturePanel___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getReservations', 'editReservation', 'deleteReservation', 'updateUserList', 'postRecurrentReservations', 'editRecurrentReservations', 'deleteRecurrentReservations']), {
    updateStartTime: function updateStartTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], { start: val });
    },
    updateEndTime: function updateEndTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], { end: val });
    },
    doEdit: function doEdit() {
      var _this = this;

      var rType = this.reservationType;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      if (!this.isAllEditing) {
        this.editReservation({ id: this.$store.state.editingState.id,
          reservation: {
            student: this.student,
            teacher: this.teacher,
            start_time: this.$store.state.editingState.start,
            end_time: this.$store.state.editingState.end,
            classroom: this.$store.state.editingState.classroom,
            date: this.getCurDateFormated,
            has_test: this.hasTest,
            reservation_type: rType,
            message: this.$store.state.editingState.message,
            online: this.$store.state.editingState.online
          }
        }).then(function () {
          _this.closePopup();

          _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        });
        return;
      } else if (this.isAllEditing) {
        this.editRecurrentReservations({
          id: this.$store.state.editingState.recurrence_id,
          reservation: {
            student: this.student,
            teacher: this.teacher,
            start_time: this.$store.state.editingState.start,
            end_time: this.$store.state.editingState.end,
            classroom: this.$store.state.editingState.classroom,
            rrule: this.$store.state.recurrentRule,
            has_test: this.hasTest,
            reservation_type: rType,
            message: this.$store.state.editingState.message,
            from_reservaiton_id: this.$store.state.editingState.id,
            online: this.$store.state.editingState.online
          }
        }).then(function (res) {
          if (res.data.overlapping_datetimes.length !== 0) {
            var message = '次の日付は，重複のため予約に失敗しました．';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.overlapping_datetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var dates = _step.value;

                message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + ')';
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            alert(message);
          }
          _this.closePopup();

          _this.getReservations({
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        });
      } else {
        this.deleteReservation(this.$store.state.editingState.id).then(function () {
          _this.postRecurrentReservations({
            student: _this.student,
            teacher: _this.teacher,
            start_time: _this.$store.state.editingState.start,
            end_time: _this.$store.state.editingState.end,
            classroom: _this.$store.state.editingState.classroom,
            rrule: _this.$store.state.recurrentRule,
            has_test: _this.hasTest,
            reservation_type: rType,
            message: _this.$store.state.editingState.message,
            online: _this.$store.state.editingState.online
          }).then(function (res) {
            if (res.data.overlapping_datetimes.length !== 0) {
              var message = '次の日付は，重複のため予約に失敗しました．';
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.overlapping_datetimes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var dates = _step2.value;

                  message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + '), ';
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              alert(message);
            }
            _this.closePopup();

            _this.getReservations({
              date: _this.getCurDateFormated,
              school_id: _this.$store.state.userInfo.school_id
            });
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
          });
        });
      }
    },
    completeEdit: function completeEdit() {
      if (this.student === 0 || this.teacher === 0) {
        alert('空欄では予約できません');
        return;
      }

      if (this.$store.state.editingState.start < '10:00' || this.$store.state.editingState.end > '23:00' || this.$store.state.editingState.end < this.$store.state.editingState.start) {
        alert('予約時間帯のチェック');
        return;
      }

      if (this.$store.state.editingState.classroom.match('307')) {
        if (this.$store.state.editingState.start < '15:00' && this.$store.state.userInfo.user_type !== 'admin') {
          alert('15時以前307教室は使用できません');
          return;
        }
      }

      if (this.isRecurrent) {
        this.dialogEditVisible = true;
      } else {
        this.doEdit();
      }
    },
    doDelete: function doDelete() {
      var _this2 = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      if (!this.isAllEditing) {
        this.deleteReservation(this.$store.state.editingState.id).then(function () {
          _this2.getReservations({
            date: _this2.getCurDateFormated,
            school_id: _this2.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      } else {
        this.deleteRecurrentReservations({ id: this.$store.state.editingState.recurrence_id, fromReservaitonId: this.$store.state.editingState.id }).then(function () {
          _this2.getReservations({
            all: 1,
            date: _this2.getCurDateFormated,
            school_id: _this2.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      }
    },
    eraseReservation: function eraseReservation() {
      if (this.isRecurrent) {
        this.dialogDeleteVisible = true;
      } else {
        var ret = confirm('削除します．よろしいですか？');
        if (ret) {
          this.doDelete();
        }
      }
    },
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
        start: '10:00',
        end: '10:00'
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
    },
    setHiddenID: function setHiddenID() {
      if (this.$store.state.userInfo.user_type === 'student') {
        this.student = this.$store.state.userInfo.user_id;
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        this.teacher = this.$store.state.userInfo.user_id;
      }
      return this.$store.state.userInfo.user_id;
    },
    changeClassroomLeft: function changeClassroomLeft() {
      var index = this.classroomNames.indexOf(this.$store.state.editingState.classroom);
      if (index > 0) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], this.classroomNames[index - 1]);
      }
    },
    changeClassroomRight: function changeClassroomRight() {
      var index = this.classroomNames.indexOf(this.$store.state.editingState.classroom);
      if (index < this.classroomNames.length - 1) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], this.classroomNames[index + 1]);
      }
    },
    getStyle: function getStyle() {
      var style = {
        width: this.width + 'px'
      };
      return style;
    },
    message: function message() {
      return this.$store.state.editingState.message;
    },
    isOnline: function isOnline() {
      console.log(this.$store.state.editingState.online);
      return this.$store.state.editingState.online;
    },
    getTeacherList: function getTeacherList() {
      var _this3 = this;

      if (this.student !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this3.student === lect.student.id;
        }).map(function (lect, index, self) {
          return lect.teacher;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'teacher';
      });
    },
    getStudentList: function getStudentList() {
      var _this4 = this;

      if (this.teacher !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this4.teacher === lect.teacher.id;
        }).map(function (lect, index, self) {
          return lect.student;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'student' && !(_this4.reservationType === '通常' && (/temp/.test(user.user_status) || user.user_status === 'trial'));
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['tableWidth', 'timelineHeight', 'getCurDateFormated', 'classroomNames', 'reservationsInRange']), {
    canTakeResv: function canTakeResv() {
      if (this.teacher === 0 || this.student === 0) {
        return false;
      }

      if (this.isSomeDuplicatedReservation) {
        return false;
      }
      return true;
    },

    isRecurrent: {
      get: function get() {
        return this.$store.state.editingState.isRecurrent;
      }
    },
    student: {
      get: function get() {
        return this.$store.state.editingState.student;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["N" /* EDITINGSTATE_SET_STUDENT */], value);
      }
    },
    teacher: {
      get: function get() {
        return this.$store.state.editingState.teacher;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["M" /* EDITINGSTATE_SET_TEACHER */], value);
      }
    },
    hasTest: {
      get: function get() {
        return this.$store.state.editingState.hasTest;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["P" /* EDITINGSTATE_SET_HAS_TEST */], value);
      }
    },
    isTanki: {
      get: function get() {
        return this.$store.state.editingState.reservationType !== '通常' && this.$store.state.editingState.reservationType !== '通常初回' && this.$store.state.editingState.reservationType !== '短期';
      },
      set: function set(value) {
        this.$store.commit('EDITINGSTATE_SET_TYPE', value);
      }
    },
    reservationType: {
      get: function get() {
        return this.$store.state.editingState.reservationType;
      },
      set: function set(value) {
        this.$store.commit('EDITINGSTATE_SET_TYPE', value);
      }
    },
    online: {
      get: function get() {
        return this.$store.state.editingState.online === 'true';
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["S" /* EDITINGSTATE_SET_IS_ONLINE */], value);
      }
    },
    isSomeDuplicatedReservation: function isSomeDuplicatedReservation() {
      var _this5 = this;

      return this.reservationsInRange(this.$store.state.editingState.start, this.$store.state.editingState.end).filter(function (elem, index, self) {
        return elem.id !== _this5.$store.state.editingState.id;
      }).some(function (elem, index, self) {
        return elem.teacher.id === _this5.$store.state.editingState.teacher || elem.student.id === _this5.$store.state.editingState.student;
      });
    }
  })
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      width: 400,
      isAllEditing: false,
      dialogDeleteVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getLeftPosOfClassroom', 'timelinesWidth', 'timelineHeight', 'timeToPosition', 'getCurDateFormated'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['deleteReservation', 'deleteRecurrentReservations', 'getReservations']), {
    isTanki: function isTanki() {
      var st = this.$store.state.informationPopup.reservation.student.status;
      return st === 'temporal' || st === 'trial' || st === 'temp/temp' || st === 'temp/norm';
    },
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
    },
    enterEdit: function enterEdit() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["u" /* RESERVATIONBOX_ENTER_EDIT */], this.$store.state.informationPopup.reservation);
    },
    enterRescheduling: function enterRescheduling() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["C" /* RESERVATIONBOX_ENTER_RESCHEDULING */], this.$store.state.informationPopup.reservation);
    },
    enterDelete: function enterDelete() {
      this.eraseReservation();
    },
    doDelete: function doDelete() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      var recurrenceId = this.$store.state.informationPopup.reservation.recurrence_id;
      if (!this.isAllEditing) {
        this.deleteReservation(this.$store.state.informationPopup.reservation.id).then(function () {
          _this.getReservations({
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      } else {
        this.deleteRecurrentReservations({ id: recurrenceId, fromReservaitonId: this.$store.state.informationPopup.reservation.id }).then(function () {
          _this.getReservations({
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
    },
    eraseReservation: function eraseReservation() {
      if (this.$store.state.informationPopup.reservation.recurrence_id !== null) {
        this.dialogDeleteVisible = true;
      } else {
        var ret = confirm('削除します．よろしいですか？');
        if (ret) {
          this.doDelete();
        }
      }
    },
    isEditable: function isEditable() {
      var userType = this.$store.state.userInfo.user_type;
      return userType !== 'student' && (userType === 'admin' || this.$store.state.informationPopup.reservation.teacher.id === this.$store.state.userInfo.user_id) && this.isFuture() && this.isBeforeDeadline();
    },
    isFuture: function isFuture() {
      var today = new Date();
      var date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);
      return today.getTime() < reservationDate.getTime() || this.$store.state.userInfo.user_type === 'admin';
    },
    isBeforeDeadline: function isBeforeDeadline() {
      if (this.$store.state.userInfo.user_type === 'admin') {
        return true;
      }
      var today = new Date();
      var date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);

      var dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) - new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24;
      return reservationDate.getDay() === 1 && (dateDiff > 2 || dateDiff === 2 && today.getHours() < 22) || reservationDate.getDay() !== 1 && (dateDiff > 1 || dateDiff === 1 && today.getHours() < 22);
    }
  })
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'preview-box',
  props: ['dragging'],
  data: function data() {
    return {
      state: this.$store.state.previewBox
    };
  },

  methods: {
    mousedownHandler: function mousedownHandler(event) {
      this.$emit('pvmousedown', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      });
    },
    show_reservationpopup: function show_reservationpopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["s" /* RESERVATION_SHOW_POPUP */]);
    },
    mousemoveHandler: function mousemoveHandler(event) {
      this.$emit('pvmousemove', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      });
    },
    mouseupHandler: function mouseupHandler(event) {
      this.$emit('pvmouseup', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      });
    },
    getUpdatedStyle: function getUpdatedStyle() {
      var top = this.timeToPosition(this.$store.state.previewBox.start);
      var bottom = this.timeToPosition(this.$store.state.previewBox.end);
      var height = bottom - top;
      var left = this.getLeftPosOfClassroom(this.$store.state.previewBox.classroom);
      var style = {
        top: top,
        bottom: bottom,
        height: height,
        left: left
      };
      return style;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['timeToPosition', 'positionToTime', 'getLeftPosOfClassroom']), {
    hasHeight: function hasHeight() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["o" /* PREVIEWBOX_STYLE_UPDATE */], this.getUpdatedStyle());
      return this.$store.state.previewBox.style.height !== 0;
    },
    getStyle: function getStyle() {
      var style = {
        top: this.$store.state.previewBox.style.top * this.$store.state.mobileHeightMagnification + 'px',
        left: this.$store.state.previewBox.style.left * this.$store.state.mobileWidthMagnification + 'px',
        bottom: this.$store.state.previewBox.style.bottom + 'px',
        height: this.$store.state.previewBox.style.height * this.$store.state.mobileHeightMagnification + 'px',
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification + 'px'
      };
      return style;
    }
  })
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'recurrent-panel',
  data: function data() {
    return {
      freq: 'WEEKLY',
      byday: this.$store.state.curDate.getDay(),
      span: '0' };
  },

  methods: {
    onChange: function onChange() {
      var theday = this.$store.state.curDate;
      var DTSTART = this.getDateFormated(theday);
      var finday = new Date(theday);
      finday.setDate(finday.getDate() + parseInt(this.span));
      var UNTIL = this.getDateFormated(finday);
      if (this.freq === 'WEEKLY' || this.freq === 'MONTHLY') {
        var rrule = 'DTSTART: ' + DTSTART + '\nRRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL + ';BYDAY=' + this.getBYDAYString(this.byday);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], rrule);
        return;
      } else {
        var _rrule = 'DTSTART: ' + DTSTART + '\n        RRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL;
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], _rrule);
        return;
      }
    },
    getBYDAYString: function getBYDAYString(day) {
      switch (day) {
        case 0:
          return 'SU';
        case 1:
          return 'MO';
        case 2:
          return 'TU';
        case 3:
          return 'WE';
        case 4:
          return 'TH';
        case 5:
          return 'FR';
        case 6:
          return 'SA';
        default:
          break;
      }
    },
    getDateFormated: function getDateFormated(date) {
      var day = date.getDate();

      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return '' + year + month + day;
    }
  },
  created: function created() {
    var theday = this.$store.state.curDate;
    var DTSTART = this.getDateFormated(theday);

    var finday = new Date(theday.getFullYear(), theday.getMonth() + 1, 0);
    var UNTIL = this.getDateFormated(finday);
    if (this.freq === 'WEEKLY' || this.freq === 'MONTHLY') {
      var rrule = 'DTSTART: ' + DTSTART + '\nRRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL + ';BYDAY=' + this.getBYDAYString(this.byday);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], rrule);
      return;
    } else {
      var _rrule2 = 'DTSTART: ' + DTSTART + '\n      RRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], _rrule2);
      return;
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReschedulingPage_ReschedulingOptionForm__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReschedulingPage_ReschedulingOptionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReschedulingPage_ReschedulingOptionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      targetReservation: null,
      candidateDatetimes: [{
        date: '',
        mode: 'range',
        startTime: '',
        endTime: '',
        duration: 60
      }],
      reason: '',
      reservationOption: {
        reservationType: '通常',
        hasTest: false,
        reservationMessage: ''
      }
    };
  },

  components: {
    'reschedulingOptionForm': __WEBPACK_IMPORTED_MODULE_2__ReschedulingPage_ReschedulingOptionForm___default.a
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setReschedulingInfo']), {
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["D" /* RESCHEDULING_POPUP_HIDE */]);
    },
    makeReschedulingInfo: function makeReschedulingInfo() {
      this.targetReservation = {
        classroom: this.$store.state.rescherdulingState.classroom,
        date: this.$store.state.rescherdulingState.date,
        endTime: this.$store.state.rescherdulingState.end,
        hasTest: this.$store.state.rescherdulingState.hasTest,
        id: this.$store.state.rescherdulingState.id,
        isPopupShown: this.$store.state.rescherdulingState.isPopupShown,
        isRecurrent: this.$store.state.rescherdulingState.isRecurrent,
        message: this.$store.state.rescherdulingState.message,
        recurrence_id: this.$store.state.rescherdulingState.recurrence_id,
        reservationType: this.$store.state.rescherdulingState.reservationType,
        startTime: this.$store.state.rescherdulingState.start,
        student: this.$store.state.rescherdulingState.student,
        teacher: this.$store.state.rescherdulingState.teacher,
        school_id: this.$store.state.userInfo.school_id
      };
      var sender = this.$store.state.userInfo.user_id;
      var receiver = sender === this.targetReservation.student ? this.targetReservation.teacher : this.targetReservation.student;
      var targetReservation = this.targetReservation;
      return {
        sender: sender,
        receiver: receiver,
        targetReservation: targetReservation,
        candidateDatetimes: this.candidateDatetimes,
        reason: this.reason,
        reservationOption: this.reservationOption
      };
    },
    addEmptyCandidate: function addEmptyCandidate() {
      this.candidateDatetimes.push({
        date: '',
        mode: 'slot',
        startTime: '',
        endTime: '',
        duration: null
      });
      this.$nextTick(function () {
        var list = document.getElementById('candidate-list');
        list.scrollTop = list.scrollHeight;
      });
    },
    deleteCandidate: function deleteCandidate(index) {
      this.candidateDatetimes.splice(index, 1);
    },
    getWeekday: function getWeekday(date) {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      var _this = this;

      if (!this.isFirstCompleted) {
        alert('日時指定に不備があります');
        return;
      } else if (!this.isSecondCompleted) {
        alert('理由は必須です');
        return;
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        if (!this.isThirdCompleted) {
          alert('授業の詳細を入力してください');
          return;
        }
      }

      this.setReschedulingInfo(this.makeReschedulingInfo()).then(function () {
        _this.closePopup();
      }).then(function () {
        _this.$router.push('/SpSenderConfirmation');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])([]), {
    isFirstCompleted: function isFirstCompleted() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.candidateDatetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var candidate = _step.value;

          if (!candidate.date || !candidate.startTime || !candidate.endTime) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    isSecondCompleted: function isSecondCompleted() {
      return !!this.reason;
    },
    isThirdCompleted: function isThirdCompleted() {
      return this.$store.state.userInfo.user_type === 'teacher' && this.reservationOption.reservationType !== null && this.has_test !== null;
    }
  })
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpReservationStates__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpReservationStates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SpReservationStates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_time__ = __webpack_require__(26);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'statelist': __WEBPACK_IMPORTED_MODULE_3__SpReservationStates___default.a
  },
  props: ['reservation'],
  data: function data() {
    return {
      style: {},
      hover: false
    };
  },

  methods: {
    reduceTimeExp: function reduceTimeExp(timeStr) {
      return timeStr.slice(0, 5);
    },
    clickHandler: function clickHandler(event) {
      if (this.canDisplay) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["L" /* SHOW_INFORMATION_POPUP */], this.reservation);
      }
    },
    mousemoveHandler: function mousemoveHandler(event) {
      this.hover = true;
      this.$emit('pvmousemove', {
        e: {
          offsetY: event.layerY + this.timeToPosition(this.reservation.start_time)
        },
        classroom: this.reservation.classroom
      });
    },
    mouseupHandler: function mouseupHandler(event) {
      this.$emit('pvmouseup', {
        e: {
          offsetY: event.layerY + this.timeToPosition(this.reservation.start_time)
        },
        classroom: this.reservation.classroom
      });
    },
    enterEdit: function enterEdit() {
      this.$store.commit('RESERVATIONBOX_ENTER_EDIT', this.reservation);
      this.$store.commit('EDITINGBOX_STYLE_UPDATE', this.getStyle);
    },
    toggleAttendance: function toggleAttendance(userId) {
      var _this = this;

      this.$store.dispatch('toggleAttendance', userId).then(function () {
        _this.$store.dispatch('getAttendance');
      });
    },
    isAttending: function isAttending(id) {
      return this.$store.state.attendance.includes(id);
    },
    attendingState: function attendingState(id) {
      return this.isAttending(id) ? '☑' : '□';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getLeftPosOfClassroom', 'timeToPosition']), {
    getStyle: function getStyle() {
      var width = this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification;
      var top = this.timeToPosition(new __WEBPACK_IMPORTED_MODULE_4__modules_time__["a" /* default */](this.reservation.start_time).toString()) * this.$store.state.mobileHeightMagnification;
      var bottom = this.timeToPosition(new __WEBPACK_IMPORTED_MODULE_4__modules_time__["a" /* default */](this.reservation.end_time).toString()) * this.$store.state.mobileHeightMagnification;
      var height = bottom - top;
      var left = this.getLeftPosOfClassroom(this.reservation.classroom) * this.$store.state.mobileWidthMagnification;
      var opacity = 1.0;
      if (this.isEditing && this.reservation.id === this.$store.state.editingState.id) {
        opacity = 0.5;
      }
      return {
        width: width + 'px',
        height: height + 'px',
        top: top + 'px',
        left: left + 'px',
        opacity: opacity
      };
    },
    isEditing: function isEditing() {
      return this.$store.state.editingState.id !== 0;
    },
    isEditable: function isEditable() {
      var userType = this.$store.state.userInfo.user_type;
      return userType !== 'student' && (userType === 'admin' || this.reservation.teacher.id === this.$store.state.userInfo.user_id) && this.isFuture && this.isBeforeDeadline;
    },
    isFuture: function isFuture() {
      var today = new Date();
      var date = this.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);
      return today.getTime() < reservationDate.getTime();
    },
    isBeforeDeadline: function isBeforeDeadline() {
      var today = new Date();
      var date = this.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);

      var dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) - new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24;
      return reservationDate.getDay() === 1 && (dateDiff > 2 || dateDiff === 2 && today.getHours() < 22) || reservationDate.getDay() !== 1 && (dateDiff > 1 || dateDiff === 1 && today.getHours() < 22);
    },
    isVailedCheck: function isVailedCheck() {
      var today = new Date();
      if (this.$store.state.userInfo.user_type === 'admin' && this.$store.state.curDate.getMonth() === today.getMonth() && this.$store.state.curDate.getDate() === today.getDate()) {
        return true;
      } else {
        return false;
      }
    },
    canDisplay: function canDisplay() {
      var userType = this.$store.state.userInfo.user_type;
      var userId = this.$store.state.userInfo.user_id;
      return userType === 'admin' || userType === 'viewer' || userType === 'teacher' && this.reservation.teacher.id === userId || userType === 'student' && this.reservation.student.id === userId;
    }
  })
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SpTemporaryLecturePanel__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SpTemporaryLecturePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SpTemporaryLecturePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'time-select': __WEBPACK_IMPORTED_MODULE_2_element_ui__["TimeSelect"],
    'recurrent-panel': __WEBPACK_IMPORTED_MODULE_4__SpRecurrentReservePanel___default.a,
    'autocomplete': __WEBPACK_IMPORTED_MODULE_5__SpAutocompleteSelection___default.a,
    'temporaryLecturePanel': __WEBPACK_IMPORTED_MODULE_6__SpTemporaryLecturePanel___default.a
  },
  data: function data() {
    return {
      student: this.$store.state.userInfo.user_type === 'student' ? this.$store.state.userInfo.user_id : 0,
      teacher: this.$store.state.userInfo.user_type === 'teacher' ? this.$store.state.userInfo.user_id : 0,
      width: '100vw',
      isRecurrent: false,
      hasTest: false,
      _isTanki: false,
      type: '通常',
      message: '',
      isOnline: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['getReservations', 'postReservation', 'updateUserList', 'postRecurrentReservations', 'changeStatus', 'getLectures']), {
    updateStartTime: function updateStartTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], { start: val });
    },
    updateEndTime: function updateEndTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], { end: val });
    },
    takeReservation: function takeReservation() {
      var _this = this;

      if (this.student === 0 || this.teacher === 0) {
        alert('空欄では予約できません');
        return;
      }

      if (this.$store.state.previewBox.classroom.match('307')) {
        if (this.$store.state.previewBox.start < '15:00' && this.$store.state.userInfo.user_type !== 'admin') {
          alert('15時以前307教室は使用できません');
          return;
        }
      }

      if (this.$store.state.previewBox.start < '10:00' || this.$store.state.previewBox.end > '23:00' || this.$store.state.previewBox.end < this.$store.state.previewBox.start) {
        alert('ERROR:予約時間帯が不正です');
        return;
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["H" /* SPINNER_SHOW */]);

      if (this.type === '通常初回') {
        var std = this.$store.state.lectureInfo.find(function (usr, index) {
          return _this.student === usr.student.id;
        });
        console.log(std);
        this.updateStatus(this.student, std.student.status);
      }
      if (!this.isRecurrent) {
        this.postReservation({
          student: this.student,
          teacher: this.teacher,
          start_time: this.$store.state.previewBox.start,
          end_time: this.$store.state.previewBox.end,
          classroom: this.$store.state.previewBox.classroom,
          date: this.getCurDateFormated,
          has_test: this.hasTest,
          reservation_type: this.type,
          message: this.message,
          school_id: this.$store.state.userInfo.school_id,
          online: this.isOnline
        }).then(function () {
          _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        return;
      } else {
        this.postRecurrentReservations({
          student: this.student,
          teacher: this.teacher,
          start_time: this.$store.state.previewBox.start,
          end_time: this.$store.state.previewBox.end,
          classroom: this.$store.state.previewBox.classroom,
          rrule: this.$store.state.recurrentRule,
          has_test: this.hasTest,
          reservation_type: this.type,
          message: this.message,
          school_id: this.$store.state.userInfo.school_id,
          online: this.isOnline
        }).then(function (res) {
          if (res.data.overlapping_datetimes.length > 0) {
            var message = '次の日付は，重複のため予約に失敗しました．';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.overlapping_datetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var dates = _step.value;

                message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + '), ';
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            alert(message);
          }
        }).then(function () {
          _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        return;
      }
    },
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["t" /* RESERVATION_HIDE_POPUP */]);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
        start: '10:00',
        end: '10:00'
      });
    },
    setHiddenID: function setHiddenID() {
      if (this.$store.state.userInfo.user_type === 'student') {
        this.student = this.$store.state.userInfo.user_id;
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        this.teacher = this.$store.state.userInfo.user_id;
      }
      return this.$store.state.userInfo.user_id;
    },
    selectorUpdate: function selectorUpdate(val) {
      console.log(val);
    },
    getTeacherList: function getTeacherList() {
      var _this2 = this;

      if (this.student !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this2.student === lect.student.id;
        }).map(function (lect, index, self) {
          return lect.teacher;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'teacher';
      });
    },
    getStudentList: function getStudentList() {
      var _this3 = this;

      if (this.teacher !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this3.teacher === lect.teacher.id;
        }).map(function (lect, index, self) {
          return lect.student;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'student';
      });
    },
    updateStatus: function updateStatus(id, status) {
      var newStatus = 'normal';
      switch (status) {
        case 'temporal':
        case 'temp/temp':
        case 'temp/norm':
          newStatus = 'temp/norm';
          break;
        case 'trial':
          newStatus = 'normal';
          break;
      }
      this.changeStatus({
        id: id,
        newStatus: newStatus
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])(['tableWidth', 'timelineHeight', 'getCurDateFormated', 'reservationsInRange']), {
    isTanki: {
      get: function get() {
        return this.type !== '通常' && this.type !== '通常初回' && this.type !== '短期';
      },
      set: function set(value) {
        this._isTanki = value;
      }
    },
    getStyle: function getStyle() {
      var style = {
        width: this.width + 'px'
      };
      return style;
    },
    canTakeResv: function canTakeResv() {
      if (this.teacher === 0 || this.student === 0) {
        return false;
      }

      if (this.isSomeDuplicatedReservation) {
        return false;
      }

      return true;
    },
    isSomeDuplicatedReservation: function isSomeDuplicatedReservation() {
      var _this4 = this;

      return this.reservationsInRange(this.$store.state.previewBox.start, this.$store.state.previewBox.end).some(function (elem, index, self) {
        return elem.teacher.id === _this4.teacher || elem.student.id === _this4.student;
      });
    }
  })
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservation'],
  computed: {
    reservationType: function reservationType() {
      return this.reservation.reservation_type;
    },
    hasConfTest: function hasConfTest() {
      return this.reservation.has_test;
    },
    hasSomethingToShow: function hasSomethingToShow() {
      return this.reservationType !== '通常' || this.hasConfTest || this.hasMessage();
    }
  },
  methods: {
    hasMessage: function hasMessage() {
      if (this.reservation.message.trim() !== '') {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vanilla_autokana__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vanilla_autokana___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vanilla_autokana__);









var autokana = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fullname: '',
      kana: '',
      hasTest: false,
      message: '',
      type: '通常',
      status: '',
      isOnline: false
    };
  },

  props: ['teacher', 'isEdit', 'reservationType'],
  mounted: function mounted() {
    autokana = __WEBPACK_IMPORTED_MODULE_5_vanilla_autokana__["bind"]('#fullname', '#kana', { katakana: true });
    if (this.isEdit) {
      this.fullname = this.$store.state.informationPopup.reservation.student.fullname;
      this.kana = this.$store.state.informationPopup.reservation.student.kana;
      this.status = this.$store.state.informationPopup.reservation.student.status;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['addUser', 'addLecture', 'postReservation', 'getReservations', 'editReservation', 'deleteReservation', 'updateUserList', 'getLectures', 'getTemporalStudentByFullname', 'getNotTemporalStudentByFullname', 'changeFullname', 'changeStatus', 'deleteUser']), {
    reserve: function reserve() {
      var _this = this;

      if (this.fullname === '') {
        alert('生徒の名前が空欄です．');
        return;
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["H" /* SPINNER_SHOW */]);

      var preStudent = this.isEdit ? this.$store.state.informationPopup.reservation.student : 0;
      var preId = this.isEdit ? preStudent.id : -2;
      var temporalStudentId = -1;

      this.getNotTemporalStudentByFullname(this.fullname).then(function (res) {
        temporalStudentId = res.data.not_temporal_student;

        _this.updateStatus(temporalStudentId, 'normal', _this.reservationType);

        if (_this.isEdit && (preStudent.status === 'trial' || preStudent.status === 'temporal')) {
          _this.deleteUserHandler(preId, preStudent.fullname);
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (err) {
        if (err.response.status === 404) {
          return _this.getTemporalStudentByFullname(_this.fullname).then(function (res) {
            temporalStudentId = res.data.temporal_student;

            if (!(preId === temporalStudentId)) {
              _this.updateStatus(temporalStudentId, 'temporal', _this.reservationType);

              if (preStudent.status === 'trial' || preStudent.status === 'temporal') {
                _this.deleteUserHandler(preId, preStudent.fullname);
              }
            }

            if (_this.kana !== '') {
              return _this.changeFullname({ id: res.data.temporal_student, newFullname: _this.fullname, newKana: _this.kana }).then(function () {
                if (_this.$store.state.userInfo.user_type === 'admin') {
                  _this.updateUserList();
                }
              });
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
            }
          }).catch(function (err) {
            if (err.response.status === 404) {
              if (!_this.isEdit || _this.isEdit && _this.status !== 'trial' && _this.status !== 'temporal') {
                var userName = 'tanki_' + Math.random().toString(36).slice(-8);
                var user = {
                  user_name: userName,
                  password: Math.random().toString(36).slice(-8),
                  fullname: _this.fullname,
                  type: 'student',
                  kana: _this.kana === '' ? '短期' : _this.kana,
                  school_id: _this.$store.state.userInfo.school_id,
                  status: _this.reservationType === '体験' ? 'trial' : 'temporal'
                };
                return _this.addUser(user).then(function (res) {
                  temporalStudentId = res.data.id;
                  if (_this.$store.state.userInfo.user_type === 'admin') {
                    _this.updateUserList();
                  }
                });
              } else {
                temporalStudentId = _this.$store.state.informationPopup.reservation.student.id;
                return _this.changeFullname({ id: _this.$store.state.informationPopup.reservation.student.id, newFullname: _this.fullname, newKana: _this.kana }).then(function () {
                  if (_this.$store.state.userInfo.user_type === 'admin') {
                    _this.updateUserList();
                  }
                });
              }
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
            }
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
        }
      }).then(function () {
        return _this.getLectures({}).then(function () {
          var lectures = _this.$store.state.lectureInfo;
          var alreadyExists = false;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lectures), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var lect = _step.value;

              if (lect.student.id === temporalStudentId && lect.teacher.id === _this.teacher) {
                alreadyExists = true;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (!alreadyExists) {
            return _this.addLecture({
              student: temporalStudentId,
              teacher: _this.teacher
            }).then(function () {
              return _this.getLectures({});
            });
          }
        }).then(function (res) {
          var rType = _this.reservationType;
          if (!_this.isEdit) {
            return _this.postReservation({
              student: temporalStudentId,
              teacher: _this.teacher,
              start_time: _this.$store.state.previewBox.start,
              end_time: _this.$store.state.previewBox.end,
              classroom: _this.$store.state.previewBox.classroom,
              date: _this.getCurDateFormated,
              has_test: _this.hasTest,
              reservation_type: rType,
              message: _this.message,
              school_id: _this.$store.state.userInfo.school_id,
              online: _this.isOnline
            });
          } else {
            return _this.editReservation({
              id: _this.$store.state.editingState.id,
              reservation: {
                student: temporalStudentId,
                teacher: _this.teacher,
                start_time: _this.$store.state.editingState.start,
                end_time: _this.$store.state.editingState.end,
                classroom: _this.$store.state.editingState.classroom,
                date: _this.getCurDateFormated,
                has_test: _this.hasTest,
                reservation_type: rType,
                message: _this.message,
                school_id: _this.$store.state.userInfo.school_id,
                online: _this.isOnline
              }
            });
          }
        }).then(function () {
          return _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
      }).then(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["t" /* RESERVATION_HIDE_POPUP */]);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);

        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (err) {
        console.error(err);
        alert('予約に関してエラーが発生しました');
      });
    },
    deleteResv: function deleteResv() {
      var _this2 = this;

      var ret = confirm('削除します．よろしいですか？');
      if (ret) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
        this.deleteReservation(this.$store.state.editingState.id).then(function (res) {
          _this2.getReservations({
            all: 1,
            date: _this2.getCurDateFormated,
            school_id: _this2.$store.state.userInfo.school_id
          });
        });

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      }
    },
    cancel: function cancel() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["t" /* RESERVATION_HIDE_POPUP */]);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
        start: '10:00',
        end: '10:00'
      });
    },
    handleNameInput: function handleNameInput() {
      this.kana = autokana.getFurigana();
    },
    updateStatus: function updateStatus(id, status, rsvType) {
      var newStatus = '';
      if (rsvType === '短期初回') {
        switch (status) {
          case 'normal':
            newStatus = 'temp/norm';
            break;
          case 'temporal':
            newStatus = 'temp/temp';
            break;
        }
      } else {
        switch (status) {
          case 'normal':
            break;
          case 'temporal':
            newStatus = 'temp/temp';
            break;
        }
      }
      if (newStatus !== '') {
        this.changeStatus({
          id: id,
          newStatus: newStatus
        });
      }
    },
    deleteUserHandler: function deleteUserHandler(id, name) {
      var _this3 = this;

      var yesno = confirm('編集前に新規登録されていたユーザー：「' + name + '」を削除しますか？');
      if (yesno) {
        this.deleteUser(id).then(function (res) {
          alert('ユーザーの削除に成功しました。');
          _this3.updateUserList();
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getCurDateFormated']))
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notificationBox',
  props: {
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return value === 'ok' || value === 'warning';
      }
    },
    text: String }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  name: 'reschedulingListPage'
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reschedulingOptionForm',
  props: {
    reservationOption: {
      type: Object,
      default: function _default() {
        return {
          reservationType: '通常',
          hasTest: false,
          reservationMessage: ''
        };
      }
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reschedulingReceiverClassroom',
  components: {},
  data: function data() {
    return {
      reschedulingInfo: null,
      reservations: null,
      classrooms: null,
      reschedulingclassroom: null,
      errormessage: ''
    };
  },
  created: function created() {
    var _this = this;

    this.reschedulingInfo = this.$store.state.reschedulingInfo;
    this.getClassrooms(this.$store.state.userInfo.school_id).then(function () {
      _this.classrooms = _this.$store.state.classrooms;
    }).then(function () {
      _this.getReservations({ date: _this.reschedulingInfo.rescheduled_reservation.date }).then(function () {
        _this.reservations = _this.$store.state.reservations;
        for (var i = 0; i < _this.reservations.length; ++i) {
          if (_this.reservations[i].start_time <= _this.reschedulingInfo.rescheduled_reservation.end_time && _this.reservations[i].end_time >= _this.reschedulingInfo.rescheduled_reservation.start_time) {
            for (var j = 0; j < _this.classrooms.length; ++j) {
              if (_this.classrooms[j].name === _this.reservations[i].classroom) {
                if (_this.reservations[i].id !== _this.reschedulingInfo.target_reservation.id) {
                  _this.classrooms[j].name = 'prohibited';
                }
              }
            }
          }
        }
      }).then(function () {
        console.log(_this.classrooms instanceof Object);
        if (!(_this.classrooms instanceof Object)) {
          console.log(_this.classrooms);
          alert('教室のフィルタリングに失敗しました。戻って修正するを押して前のページに戻って再度やり直してください。');
        }
        _this.classrooms.forEach(function (value, index) {
          if (this.sender.id !== 18 && this.receiver.id !== 18) {
            if (value.name.match('301')) {
              value.name = 'prohibited';
            }
          }
          if (this.rescheduled_reservation.start_time < '15:00') {
            if (value.name.match('307')) {
              value.name = 'prohibited';
            }
          }
        }, _this.reschedulingInfo);
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getReservations', 'getClassrooms', 'setReschedulingInfo']), {
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    timeDuplicateCheck: function timeDuplicateCheck(date1, date2) {
      return date1.start_time <= date2.end_time && date1.end_time >= date2.start_time;
    },
    selectedclassroom: function selectedclassroom(value) {
      this.reschedulingclassroom = value;
    },
    cancelButtonClicked: function cancelButtonClicked() {
      this.classrooms = null;
      this.reschedulingclassroom = null;
      this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash);
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      if (this.reschedulingclassroom === null) {
        this.errormessage = '教室が選択されていません';
      } else {
        this.reschedulingInfo.rescheduled_reservation.classroom_name = this.reschedulingclassroom;

        this.setReschedulingInfo(this.reschedulingInfo);

        this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash + '/confirmation_rcvr');
      }
    }
  })
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reschedulingInfo: this.$store.state.reschedulingInfo
    };
  },

  computed: {
    senderDisplayName: function senderDisplayName() {
      return this.reschedulingInfo.sender.fullname + (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様');
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reschedulingInfo: this.$store.state.reschedulingInfo,
      receiverInfo: null
    };
  },

  name: 'reschedulingReceiverConfirmation',
  moundted: function moundted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['postReservation', 'updateReschedulingInfo', 'postReschedulings', 'setReschedulingInfo', 'editReservation', 'sendMailReschedulingResult', 'sendMailReschedulingRequest', 'getReschedulingetList']), {
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    cancelButtonClicked: function cancelButtonClicked() {
      this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash);
    },
    updateReservationDB: function updateReservationDB(teacherId, studentId, reschedulingInfo) {
      if (!reschedulingInfo.target_reservation.id) {
        return this.postReservation({
          student: studentId,
          teacher: teacherId,
          start_time: reschedulingInfo.rescheduled_reservation.start_time,
          end_time: reschedulingInfo.rescheduled_reservation.end_time,
          classroom: reschedulingInfo.rescheduled_reservation.classroom_name,
          date: reschedulingInfo.rescheduled_reservation.date,
          has_test: reschedulingInfo.rescheduled_reservation.has_test,
          reservation_type: reschedulingInfo.rescheduled_reservation.reservation_type,
          message: reschedulingInfo.rescheduled_reservation.reservation_message
        });
      } else {
        return this.editReservation({
          id: reschedulingInfo.target_reservation.id,
          reservation: {
            student: studentId,
            teacher: teacherId,
            start_time: reschedulingInfo.rescheduled_reservation.start_time,
            end_time: reschedulingInfo.rescheduled_reservation.end_time,
            classroom: reschedulingInfo.rescheduled_reservation.classroom_name,
            date: reschedulingInfo.rescheduled_reservation.date,
            has_test: reschedulingInfo.rescheduled_reservation.has_test,
            reservation_type: reschedulingInfo.rescheduled_reservation.reservation_type,
            message: reschedulingInfo.rescheduled_reservation.reservation_message
          }
        });
      }
    },
    confirmButtonClicked: function confirmButtonClicked() {
      var _this = this;

      var teacherId = void 0;
      var studentId = void 0;
      var targetId = void 0;
      if (this.reschedulingInfo.sender.user_type === 'teacher') {
        teacherId = this.reschedulingInfo.sender.id;
        studentId = this.reschedulingInfo.receiver.id;
      } else {
        teacherId = this.reschedulingInfo.receiver.id;
        studentId = this.reschedulingInfo.sender.id;
      }
      console.log(this.reschedulingInfo);
      this.updateReservationDB(teacherId, studentId, this.reschedulingInfo).then(function (res) {
        if (res) {
          targetId = res.data.id;
        } else {
          targetId = parseInt(_this.reschedulingInfo.target_reservation.id);
        }
        _this.updateReschedulingInfo({
          hash: _this.reschedulingInfo.hash,
          reservation: {
            is_status: 'accepted',
            rescheduled_reservation: targetId,
            receiver_message: _this.reschedulingInfo.receiver_message
          }
        }).then(function (res) {
          _this.sendMailReschedulingResult(_this.reschedulingInfo.hash);
        }).then(function () {
          _this.getReschedulingetList(_this.$store.state.userInfo.user_id).then(function (res) {
            if (res.data.length > 0) {
              console.log(res);
              _this.reschedulinglist = true;
            } else {
              _this.reschedulinglist = false;
            }
          });

          _this.reschedulingInfo.status = 'accepted';

          console.log(_this.reschedulingInfo);
          _this.setReschedulingInfo(_this.reschedulingInfo);
          console.log(_this.reschedulingInfo);
          _this.$router.push('/rescheduling/' + _this.$route.params.rescheduling_hash + '/final_confirmation');
        });
      });
    },
    denyButtonClicked: function denyButtonClicked() {
      var _this2 = this;

      this.updateReschedulingInfo({
        hash: this.reschedulingInfo.hash,
        reservation: {
          is_status: 'denied',
          rescheduled_reservation: this.reschedulingInfo.target_reservation.id,
          receiver_message: this.reschedulingInfo.receiver_message,
          alternative_datetimes: this.reschedulingInfo.alternative_datetimes
        }
      }).then(function () {
        var paramTargetReservation = _this2.reschedulingInfo.target_reservation.id ? {
          id: _this2.reschedulingInfo.target_reservation.id
        } : {
          date: _this2.reschedulingInfo.target_reservation.date,
          start_time: _this2.reschedulingInfo.target_reservation.startTime,
          end_time: _this2.reschedulingInfo.target_reservation.endTime
        };
        var paramCandidateDatetimes = _this2.reschedulingInfo.alternative_datetimes.map(function (cand) {
          return {
            date: cand.date,
            start_time: cand.start_time,
            end_time: cand.end_time,
            mode: cand.mode,
            duration: cand.duration
          };
        });
        var paramReservationOption = {
          reservation_type: _this2.reschedulingInfo.rescheduled_reservation.reservation_type,
          has_test: _this2.reschedulingInfo.rescheduled_reservation.has_test,
          reservation_message: _this2.reschedulingInfo.rescheduled_reservation.reservation_message
        };
        console.log('------------------------');
        console.log(_this2.reschedulingInfo);
        console.log('------------------------');
        _this2.postReschedulings({
          sender: _this2.reschedulingInfo.receiver.id,
          receiver: _this2.reschedulingInfo.sender.id,
          target_reservation: paramTargetReservation,
          candidate_datetimes: paramCandidateDatetimes,
          reason: '依頼の日程の都合が悪いため代替の日程を提案します',
          reservation_option: paramReservationOption,
          school_id: _this2.$store.state.userInfo.school_id
        }).then(function (res) {
          _this2.getReschedulingetList(_this2.$store.state.userInfo.user_id).then(function (res) {
            if (res.data.length > 0) {
              console.log(res);
              _this2.reschedulinglist = true;
            } else {
              _this2.reschedulinglist = false;
            }
          });

          _this2.reschedulingInfo.status = 'denied';

          _this2.setReschedulingInfo(_this2.reschedulingInfo);

          _this2.sendMailReschedulingResult({
            hash: _this2.reschedulingInfo.hash,
            newhash: res.data.hash
          }).then(function () {
            _this2.$router.push('/rescheduling/' + _this2.$route.params.rescheduling_hash + '/final_confirmation');
          }).catch(function (err) {
            console.log(err);
          });
        }).catch(function (err) {
          console.log(err);
        });
      });
    }
  }),
  computed: {
    senderDisplayName: function senderDisplayName() {
      return this.reschedulingInfo.sender.fullname + (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様');
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationBox__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotificationBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReschedulingOptionForm__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReschedulingOptionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReschedulingOptionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reschedulingReceiverForm',
  components: {
    'notificationBox': __WEBPACK_IMPORTED_MODULE_3__NotificationBox___default.a,
    'reschedulingOptionForm': __WEBPACK_IMPORTED_MODULE_4__ReschedulingOptionForm___default.a
  },
  data: function data() {
    return {
      reschedulingInfo: null,
      windowWidth: document.documentElement.clientWidth,
      selectedCandidate: null,
      isDenying: false,
      commitMessage: '座席を選択する',
      check: 0,
      timeslot: {
        start_time: null,
        end_time: null
      },
      reservationOption: {
        reservationType: '通常',
        hasTest: false,
        reservationMessage: ''
      },
      isCompletenessChecking: false,
      reservationsOnCandidateDates: {},
      alternative_datetimes: [{
        date: '',
        mode: 'slot',
        start_time: '',
        end_time: '',
        duration: null
      }],
      otherReservation: {
        date: '',
        startTime: '',
        endTime: '',
        receiver: 0
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getReschedulingByHash(this.$route.params.rescheduling_hash).then(function (res) {
      if (res) {
        _this.reschedulingInfo = res.data;
        _this.alternative_datetimes[0].duration = _this.reschedulingInfo.candidate_datetimes[0].duration;
        var candidateDates = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(res.data.candidate_datetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cand = _step.value;

            if (candidateDates.indexOf(cand.date) === -1) {
              candidateDates.push(cand.date);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _loop = function _loop(date) {
          _this.getReservations({
            date: date,
            school_id: _this.$store.state.userInfo.school_id
          }).then(function () {
            _this.reservationsOnCandidateDates[date] = _this.$store.state.reservations;
          });
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(candidateDates), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var date = _step2.value;

            _loop(date);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    });
    window.addEventListener('resize', function () {
      _this.windowWidth = document.documentElement.clientWidth;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['getReschedulingByHash', 'getReservations', 'setReschedulingInfo', 'updateReschedulingInfo', 'sendMailReschedulingResult']), {
    moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a,
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    selectedCandidateChanged: function selectedCandidateChanged() {
      if (this.selectedCandidate.mode === 'slot') {
        this.timeslot.start_time = this.selectedCandidate.start_time;
        this.timeslot.end_time = this.selectedCandidate.end_time;
      } else {
        this.timeslot.start_time = null;
        this.timeslot.end_time = null;
      }
    },
    timeslotStartTimeChanged: function timeslotStartTimeChanged() {
      if (this.timeslot.start_time) {
        this.timeslot.end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.timeslot.start_time, 'HH:mm').add(this.selectedCandidate.duration, 'minutes').format('HH:mm');
      } else {
        this.timeslot.end_time = null;
      }
    },
    timeslotEndTimeChanged: function timeslotEndTimeChanged() {
      if (this.timeslot.end_time) {
        this.timeslot.start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.timeslot.end_time, 'HH:mm').add(-this.selectedCandidate.duration, 'minutes').format('HH:mm');
      } else {
        this.timeslot.start_time = null;
      }
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      if (this.isSelectionCompleted && this.isTimeslotCompleted && !this.isDenying) {
        var date = this.selectedCandidate.date;
        this.check = 0;
        console.log(this.reschedulingInfo);
        for (var i = 0; i < this.reservationsOnCandidateDates[date].length; i++) {
          if (this.reservationsOnCandidateDates[date][i].student.id === this.reschedulingInfo.receiver.id || this.reservationsOnCandidateDates[date][i].student.id === this.reschedulingInfo.sender.id) {
            if (this.timeslot.start_time <= this.reservationsOnCandidateDates[date][i].end_time && this.timeslot.end_time >= this.reservationsOnCandidateDates[date][i].start_time) {
              if (this.reschedulingInfo.receiver.user_type === 'student') {
                alert(this.reschedulingInfo.receiver.fullname + '様が同時間帯に他の授業を予約しています');
              } else {
                alert(this.reschedulingInfo.sender.fullname + '様が同時間帯に他の授業を予約しています');
              }
              this.check = 1;
              return;
            }
          }
          if (this.reservationsOnCandidateDates[date][i].teacher.id === this.reschedulingInfo.sender.id || this.reservationsOnCandidateDates[date][i].teacher.id === this.reschedulingInfo.receiver.id) {
            if (this.timeslot.start_time <= this.reservationsOnCandidateDates[date][i].end_time && this.timeslot.end_time >= this.reservationsOnCandidateDates[date][i].start_time) {
              if (this.reschedulingInfo.receiver.user_type === 'teacher') {
                alert(this.reschedulingInfo.receiver.fullname + '様が同時間帯に他の授業を予約しています');
              } else {
                alert(this.reschedulingInfo.sender.fullname + '様が同時間帯に他の授業を予約しています');
              }
              this.check = 1;
              return;
            }
          }
        }
        if (this.check === 0) {
          this.reschedulingInfo.rescheduled_reservation.date = this.selectedCandidate.date;
          this.reschedulingInfo.rescheduled_reservation.start_time = this.timeslot.start_time;
          this.reschedulingInfo.rescheduled_reservation.end_time = this.timeslot.end_time;

          if (this.reschedulingInfo.receiver.user_type === 'teacher') {
            this.reschedulingInfo.reservationOption = this.reservationOption;
            this.reschedulingInfo.rescheduled_reservation.has_test = this.reservationOption.hasTest;
            this.reschedulingInfo.rescheduled_reservation.reservation_message = this.reservationOption.reservationMessage;
            this.reschedulingInfo.rescheduled_reservation.reservation_type = this.reservationOption.reservationType;
          }

          this.reschedulingInfo.isDenying = this.isDenying;
          console.log(this.reschedulingInfo);

          this.setReschedulingInfo(this.reschedulingInfo);

          this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash + '/ReschedulingReceiverClassroom');
        }
      } else {
        this.isCompletenessChecking = true;
        alert('入力内容にエラーがあります！');
        window.scrollTo(0, 0);
      }
    },
    denyButtonClicked: function denyButtonClicked() {
      var _this2 = this;

      if (this.isDenying && this.isAlternativeDatetimes) {
        this.reschedulingInfo.isDenying = this.isDenying;
        this.reschedulingInfo.alternative_datetimes = this.alternative_datetimes;
        if (this.reschedulingInfo.receiver.user_type === 'teacher') {
          this.reschedulingInfo.reservationOption = this.reservationOption;
          this.reschedulingInfo.rescheduled_reservation.has_test = this.reservationOption.hasTest;
          this.reschedulingInfo.rescheduled_reservation.reservation_message = this.reservationOption.reservationMessage;
          this.reschedulingInfo.rescheduled_reservation.reservation_type = this.reservationOption.reservationType;
        }
        this.setReschedulingInfo(this.reschedulingInfo).then(function () {
          console.log(_this2.reschedulingInfo);
          _this2.$router.push('/rescheduling/' + _this2.$route.params.rescheduling_hash + '/confirmation_rcvr');
        });
      } else {
        this.isCompletenessChecking = true;
        alert('入力内容にエラーがあります！');
        window.scrollTo(0, 0);
      }
    },
    deleteCandidate: function deleteCandidate(index) {
      this.alternative_datetimes.splice(index, 1);
    },
    getWeekday: function getWeekday(date) {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    },
    disabledDate: function disabledDate(date) {
      var nowdt = new Date();
      nowdt.setDate(nowdt.getDate() + 1);
      var stdt = new Date(nowdt.getFullYear(), nowdt.getMonth(), nowdt.getDate(), 0, 0, 0);
      var enddt = new Date();
      enddt.setMonth(enddt.getMonth() + 1);
      return date < stdt || !this.$store.state.userInfo.is_Sunday_user && date.getDay() === 0 || date > enddt;
    },
    getMaxStartTime: function getMaxStartTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.end_time ? cand.end_time : '23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    getMinEndTime: function getMinEndTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.start_time ? cand.start_time : '10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    candidateStartTimeChanged: function candidateStartTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.start_time) {
          cand.end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.start_time, 'HH:mm').add(this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.end_time = null;
        }
      }
    },
    candidateEndTimeChanged: function candidateEndTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.end_time) {
          cand.start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(cand.end_time, 'HH:mm').add(-this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.start_time = null;
        }
      }
    },
    addEmptyCandidate: function addEmptyCandidate() {
      this.alternative_datetimes.push({
        date: '',
        mode: 'slot',
        start_time: '',
        end_time: '',
        duration: this.reservationDuration
      });
      this.$nextTick(function () {
        var list = document.getElementById('candidate-list');
        console.log(list);
        list.scrollTop = list.scrollHeight;
      });
    }
  }),
  computed: {
    senderDisplayName: function senderDisplayName() {
      return this.reschedulingInfo.sender.fullname + (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様');
    },
    receiverDisplayName: function receiverDisplayName() {
      return this.reschedulingInfo.receiver.fullname + (this.reschedulingInfo.receiver.user_type === 'teacher' ? '先生' : '様');
    },
    isNarrowMode: function isNarrowMode() {
      return this.windowWidth < 670;
    },
    isSelectionCompleted: function isSelectionCompleted() {
      return this.isDenying || this.selectedCandidate !== null;
    },
    isTimeslotCompleted: function isTimeslotCompleted() {
      return this.isDenying || this.selectedCandidate.mode === 'slot' || this.timeslot.start_time && this.timeslot.end_time;
    },
    isAlternativeDatetimes: function isAlternativeDatetimes() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.alternative_datetimes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var candidate = _step3.value;

          if (!candidate.date || !candidate.start_time || !candidate.end_time) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return true;
    },
    checkExpireDate: function checkExpireDate() {
      var regdate = this.reschedulingInfo.registered_datetime.split(' ');
      var date = regdate[0].split('-');
      var time = regdate[1].split(':');
      if (date[1] !== '10') {
        date[1] = date[1].replace('0', '');
      }
      date[1] = Number(date[1]) - 1;
      var scheduledDate = new Date(date[0], date[1], date[2], time[0], time[1], time[2]);
      scheduledDate.setDate(scheduledDate.getDate() + 1);
      return new Date() < scheduledDate;
    },
    reservationDuration: function reservationDuration() {
      var calcMinutesDiff = function calcMinutesDiff(t1, t2) {
        var tmpDate = '2018-01-01';
        return (new Date(tmpDate + 'T' + t1).getTime() - new Date(tmpDate + 'T' + t2).getTime()) / 1000 / 60;
      };
      if (this.reschedulingInfo.target_reservation && !this.isOther) {
        return calcMinutesDiff(this.reschedulingInfo.target_reservation.end_time.slice(0, -3), this.reschedulingInfo.target_reservation.start_time.slice(0, -3));
      } else if (this.isOther && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime) {
        return calcMinutesDiff(this.otherReservation.endTime, this.otherReservation.startTime);
      } else {
        return 0;
      }
    }
  },
  watch: {
    isDenying: function isDenying() {
      if (this.isDenying) {
        this.commitMessage = '確認画面へ';
      } else {
        this.commitMessage = '座席を選択する';
      }
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      help_cliked: false
    };
  },

  methods: {
    helpCliked: function helpCliked() {
      if (!this.help_cliked) {
        this.help_cliked = true;
      } else {
        this.help_cliked = false;
      }
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reschedulingInfo: this.$store.state.reschedulingInfo,
      receiverInfo: {},
      ClickCheck: 0,
      Message: ''
    };
  },

  name: 'reschedulingSenderConfirmation',
  mounted: function mounted() {
    var _this = this;

    var receiverId = this.reschedulingInfo.receiver;
    this.getLectures({}).then(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.$store.state.lectureInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lecture = _step.value;

          if (lecture.teacher.id === receiverId) {
            _this.receiverInfo = lecture.teacher;
            _this.receiverInfo.user_type = 'teacher';
          } else if (lecture.student.id === receiverId) {
            _this.receiverInfo = lecture.student;
            _this.receiverInfo.user_type = 'student';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
    window.addEventListener('beforeunload', function (e) {
      e.returnValue = 'まだ振替依頼は完了していません';
      return 'まだ振替依頼は完了していません';
    });
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getLectures', 'postReschedulings', 'sendMailReschedulingRequest', 'setReschedulingInfo', 'updateReschedulingInfo', 'sendMailReschedulingError']), {
    formattedDate: function formattedDate(date) {
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.lang('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
      });
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）');
    },
    cancelButtonClicked: function cancelButtonClicked() {
      this.$router.push('/rescheduling');
    },
    okButtonClicked: function okButtonClicked() {
      var _this2 = this;

      if (this.ClickCheck === 0) {
        this.ClickCheck = 1;
        var paramTargetReservation = this.reschedulingInfo.targetReservation.id ? {
          id: this.reschedulingInfo.targetReservation.id
        } : {
          date: this.reschedulingInfo.targetReservation.date,
          start_time: this.reschedulingInfo.targetReservation.startTime,
          end_time: this.reschedulingInfo.targetReservation.endTime
        };
        var paramCandidateDatetimes = this.reschedulingInfo.candidateDatetimes.map(function (cand) {
          return {
            date: cand.date,
            start_time: cand.startTime,
            end_time: cand.endTime,
            mode: cand.mode,
            duration: cand.duration
          };
        });
        var paramReservationOption = {
          reservation_type: this.reschedulingInfo.reservationOption.reservationType,
          has_test: this.reschedulingInfo.reservationOption.hasTest,
          reservation_message: this.reschedulingInfo.reservationOption.reservationMessage
        };
        this.postReschedulings({
          sender: this.reschedulingInfo.sender,
          receiver: this.reschedulingInfo.receiver,
          target_reservation: paramTargetReservation,
          candidate_datetimes: paramCandidateDatetimes,
          reason: this.reschedulingInfo.reason,
          reservation_option: paramReservationOption,
          school_id: this.$store.state.userInfo.school_id
        }).then(function (res) {
          _this2.reschedulingInfo.hash = res.data.hash;
          _this2.sendMailReschedulingRequest(res.data.hash).then(function (response) {
            _this2.$store.state.reschedulingInfo = null;
            _this2.$router.push('/rescheduling/completion');
          }).catch(function (err) {
            console.log(err);
            console.log(_this2.reschedulingInfo);
            _this2.updateReschedulingInfo({
              hash: _this2.reschedulingInfo.hash,
              reservation: {
                is_status: 'error',
                rescheduled_reservation: _this2.reschedulingInfo.targetReservation.id,
                receiver_message: _this2.reschedulingInfo.reason,
                alternative_datetimes: _this2.reschedulingInfo.candidateDatetimes
              }
            }).then(function (res) {
              _this2.sendMailReschedulingError(_this2.reschedulingInfo.hash).catch(function (err) {
                console.log(err);
              });
            }).then(function () {
              _this2.reschedulingInfo.status = 'error';
              console.log(_this2.reschedulingInfo);
              _this2.setReschedulingInfo(_this2.reschedulingInfo);
              _this2.ClickCheck = 0;
            });
          });
        }).catch(function (err) {
          console.log(err);
          _this2.ClickCheck = 0;
        });
      } else {
        this.Message = '処理中です。少々お待ちください。';
      }
    }
  })
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBox__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NotificationBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReschedulingOptionForm__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReschedulingOptionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ReschedulingOptionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      studentList: null,
      teacherList: null,
      selectedReservation: null,
      isOther: false,
      otherReservation: {
        date: '',
        startTime: '',
        endTime: '',
        receiver: 0
      },
      reservations: [],
      candidateDatetimes: [{
        date: '',
        mode: 'slot',
        startTime: '',
        endTime: '',
        duration: 0
      }],
      reason: '',
      isCompletenessChecking: false,
      reservationOption: {
        reservationType: '通常',
        hasTest: false,
        reservationMessage: ''
      }
    };
  },

  name: 'reschedulingSenderForm',
  components: {
    'autocomplete': __WEBPACK_IMPORTED_MODULE_2__timetable_AutocompleteSelection___default.a,
    'datepicker': __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a,
    'notificationBox': __WEBPACK_IMPORTED_MODULE_5__NotificationBox___default.a,
    'reschedulingOptionForm': __WEBPACK_IMPORTED_MODULE_6__ReschedulingOptionForm___default.a
  },
  computed: {
    isFirstCompleted: function isFirstCompleted() {
      return this.selectedReservation && !this.isOther || this.isOther && this.otherReservation.receiver && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime;
    },
    isSecondCompleted: function isSecondCompleted() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.candidateDatetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var candidate = _step.value;

          if (!candidate.date || !candidate.startTime || !candidate.endTime) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    isThirdCompleted: function isThirdCompleted() {
      return !!this.reason;
    },
    isFourthCompleted: function isFourthCompleted() {
      return this.$store.state.userInfo.user_type === 'teacher' && this.reservationOption.reservationType !== null && this.has_test !== null;
    },
    reservationDuration: function reservationDuration() {
      var calcMinutesDiff = function calcMinutesDiff(t1, t2) {
        var tmpDate = '2018-01-01';
        return (new Date(tmpDate + 'T' + t1).getTime() - new Date(tmpDate + 'T' + t2).getTime()) / 1000 / 60;
      };
      if (this.selectedReservation && !this.isOther) {
        return calcMinutesDiff(this.selectedReservation.endTime, this.selectedReservation.startTime);
      } else if (this.isOther && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime) {
        return calcMinutesDiff(this.otherReservation.endTime, this.otherReservation.startTime);
      } else {
        return 0;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['getReservations', 'setReschedulingInfo', 'getLectures']), {
    moment: __WEBPACK_IMPORTED_MODULE_4_moment___default.a,
    parseDateTime: function parseDateTime(date) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      date = date.split('-');
      if (time) {
        time = time.split(':');
        return new Date(date[0], date[1] - 1, date[2], time[0], time[1]);
      } else {
        return new Date(date[0], date[1] - 1, date[2]);
      }
    },
    disabledDate: function disabledDate(date) {
      var nowdt = new Date();
      nowdt.setDate(nowdt.getDate() + 1);
      var stdt = new Date(nowdt.getFullYear(), nowdt.getMonth(), nowdt.getDate(), 0, 0, 0);
      var enddt = new Date();
      enddt.setMonth(enddt.getMonth() + 1);
      return date < stdt || !this.$store.state.userInfo.is_Sunday_user && date.getDay() === 0 || date > enddt;
    },
    getWeekday: function getWeekday(date) {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    },
    addEmptyCandidate: function addEmptyCandidate() {
      this.candidateDatetimes.push({
        date: '',
        mode: 'slot',
        startTime: '',
        endTime: '',
        duration: this.reservationDuration
      });
      this.$nextTick(function () {
        var list = document.getElementById('candidate-list');
        console.log(list);
        list.scrollTop = list.scrollHeight;
      });
    },
    deleteCandidate: function deleteCandidate(index) {
      this.candidateDatetimes.splice(index, 1);
    },
    onConfirmButtonClicked: function onConfirmButtonClicked() {
      if (!this.selectedReservation.mailCheck) {
        alert('生徒様または講師様のメールアドレスがシステムに登録されていないため，授業振替依頼をご使用いただくことが出来ません\n究進塾事務局までご連絡ください');
        return;
      }
      if (!this.isOther) {
        var st = this.selectedReservation.status;
        if (st === 'temporal' || st === 'temp/temp' || st === 'trial') {
          alert('恐れ入りますが、短期利用者の振り替え依頼は究進塾事務局(info@kyushinjuku.com)へ、授業前日22時までにご連絡ください。');
          return;
        }
      }
      if (this.isFirstCompleted && this.isSecondCompleted && this.isThirdCompleted) {
        this.setReschedulingInfo(this.makeReschedulingInfo());
        this.$router.push('/rescheduling/confirmation');
      } else {
        this.isCompletenessChecking = true;
        alert('入力内容にエラーがあります！');
        window.scrollTo(0, 0);
      }
    },
    candidateStartTimeChanged: function candidateStartTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.startTime) {
          cand.endTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.startTime, 'HH:mm').add(this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.endTime = null;
        }
      }
    },
    candidateEndTimeChanged: function candidateEndTimeChanged(cand) {
      if (cand.mode === 'slot') {
        if (cand.endTime) {
          cand.startTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.endTime, 'HH:mm').add(-this.reservationDuration, 'minutes').format('HH:mm');
        } else {
          cand.startTime = null;
        }
      }
    },
    reservationChanged: function reservationChanged() {
      console.log(this.selectedReservation);
      this.clearCandidateTimes();
      if (this.$store.state.userInfo.user_type === 'teacher') {
        if (this.selectedReservation) {
          this.reservationOption.reservationType = this.selectedReservation.type;
          this.reservationOption.hasTest = this.selectedReservation.has_test;
          this.reservationOption.reservationMessage = this.selectedReservation.message;
        } else {
          this.reservationOption.reservationType = '通常';
          this.reservationOption.hasTest = false;
          this.reservationOption.reservationMessage = '';
        }
      }
    },
    clearCandidateTimes: function clearCandidateTimes() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.candidateDatetimes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var cand = _step2.value;

          cand.startTime = null;
          cand.endTime = null;
          cand.duration = this.reservationDuration;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    getMaxStartTime: function getMaxStartTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()('23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.endTime ? cand.endTime : '23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    getMinEndTime: function getMinEndTime(cand) {
      if (cand.mode === 'slot') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()('10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else if (cand.mode === 'range') {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(cand.startTime ? cand.startTime : '10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm');
      } else {
        return '';
      }
    },
    makeReschedulingInfo: function makeReschedulingInfo() {
      var sender = this.$store.state.userInfo.user_id;
      var receiver = this.selectedReservation && !this.isOther ? this.selectedReservation.receiver : this.otherReservation.receiver;
      var targetReservation = this.selectedReservation && !this.isOther ? this.selectedReservation : {
        date: this.otherReservation.date,
        startTime: this.otherReservation.startTime + ':00',
        endTime: this.otherReservation.endTime + ':00'
      };
      return {
        sender: sender,
        receiver: receiver,
        targetReservation: targetReservation,
        candidateDatetimes: this.candidateDatetimes,
        reason: this.reason,
        reservationOption: this.reservationOption
      };
    },
    check_tankiuser: function check_tankiuser() {
      var st = this.$store.state.userInfo.user_status;
      if (st === 'temporal' || st === 'temp/temp' || st === 'trial') {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.getReservations({ user_id: this.$store.state.userInfo.user_id }).then(function () {
      var filteredList = _this.$store.state.reservations.filter(function (reservation) {
        return _this.parseDateTime(reservation.date) > new Date();
      });
      filteredList.sort(function (a, b) {
        var dateA = _this.parseDateTime(a.date, a.start_time);
        var dateB = _this.parseDateTime(b.date, b.start_time);
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filteredList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var r = _step3.value;

          var selectedDate = _this.parseDateTime(r.date, r.start_time);
          if (selectedDate.getDay() === 1) {
            selectedDate.setDate(selectedDate.getDate() - 2);
          } else {
            selectedDate.setDate(selectedDate.getDate() - 1);
          }
          var limitDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 22, 0, 0);
          _this.reservations.push({
            id: r.id,
            date: r.date,
            startTime: r.start_time,
            endTime: r.end_time,
            type: r.reservation_type,
            has_test: r.has_test,
            message: r.message,
            receiver: _this.$store.state.userInfo.user_type === 'teacher' ? r.student.id : r.teacher.id,
            receiverUserName: r.student.user_name,
            text: (_this.$store.state.userInfo.user_type === 'teacher' ? r.student.fullname + ' 様' : r.teacher.fullname + ' 先生') + '　' + r.date.replace(/-/g, '/') + '　' + r.start_time.slice(0, -3) + ' 〜 ' + r.end_time.slice(0, -3),
            expireCheck: new Date() > limitDate,
            mailCheck: r.student.mail_address != null && r.teacher.mail_address != null,
            status: r.student.user_status
          });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }).catch(function (err) {
      console.log(err);
    });
    this.getLectures({}).then(function () {
      if (_this.$store.state.userInfo.user_type === 'teacher') {
        _this.studentList = _this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this.$store.state.userInfo.user_id === lect.teacher.id && /norm/.test(lect.student.status);
        }).map(function (lect, index, self) {
          return lect.student;
        });
      } else if (_this.$store.state.userInfo.user_type === 'student') {
        _this.teacherList = _this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this.$store.state.userInfo.user_id === lect.student.id;
        }).map(function (lect, index, self) {
          return lect.teacher;
        });
      }
    }).catch(function (err) {
      console.log(err);
    });
    if (this.$store.state.reschedulingInfo) {
      var reschedulingInfo = this.$store.state.reschedulingInfo;
      if (reschedulingInfo.targetReservation.id) {
        this.selectedReservation = reschedulingInfo.targetReservation;
        this.isOther = false;
      } else {
        this.selectedReservation = null;
        this.isOther = true;
        this.otherReservation = reschedulingInfo.targetReservation;
        this.otherReservation.receiver = reschedulingInfo.receiver;
      }
      this.candidateDatetimes = reschedulingInfo.candidateDatetimes;
      this.reason = reschedulingInfo.reason;
      if (this.$store.state.userInfo.user_type === 'teacher') {
        this.reservationOption = reschedulingInfo.reservationOption;
      }
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      help_cliked: false
    };
  },

  methods: {
    helpCliked: function helpCliked() {
      if (!this.help_cliked) {
        this.help_cliked = true;
      } else {
        this.help_cliked = false;
      }
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_sort__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reservationslist',
  data: function data() {
    return {
      help_cliked: false,
      month: null,
      sheetsID: null,
      reservationlist: [],
      lectureInfo: null,
      studentname: '',
      SheetsID: '',
      SheetsName: '',
      loading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getLectures', 'getReservations', 'exportRport']), {
    success: function success() {
      this.$notify({
        title: '成功',
        message: 'スプレッドシートへの記入に成功しました',
        type: 'success',
        offset: 50
      });
    },
    errorM: function errorM() {
      this.$notify({
        title: '失敗',
        message: 'スプレッドシートへの記入に失敗しました',
        type: 'error',
        offset: 50
      });
    },
    helpCliked: function helpCliked() {
      if (!this.help_cliked) {
        this.help_cliked = true;
      } else {
        this.help_cliked = false;
      }
    },
    showTable: function showTable() {
      var _this = this;

      this.loading = true;
      this.getReservations({
        user_id: this.$store.state.userInfo.user_id,
        school_id: this.$store.state.userInfo.school_id
      }).then(function () {
        _this.reservationlist = _this.$store.state.reservations;
        _this.reservationlist = _this.reservationlist.filter(function (v) {
          return v.student.id === _this.studentname && v.date.match(_this.month);
        });
        _this.reservationlist = __WEBPACK_IMPORTED_MODULE_1_array_sort___default()(_this.reservationlist, 'date');
        _this.loading = false;
      });
    },
    sendtoGCP: function sendtoGCP() {
      var _this2 = this;

      if (confirm('内容をスプレッドシートに入力しますか?')) {
        this.loading = true;
        var sendData = {
          'ID': this.SheetsID,
          'sheetsName': this.SheetsName,
          'date': this.reservationlist
        };
        this.exportRport(sendData).then(function (res) {
          if (res.status === 200) {
            _this2.success();
          } else {
            _this2.errorM();
          }
          _this2.loading = false;
        });
      }
    }
  }),
  created: function created() {
    this.$store.dispatch('getLectures', {});
    this.lectureInfo = this.$store.state.lectureInfo;
  },

  watch: {
    month: function month() {
      if (this.studentname) {
        this.showTable();
      }
      var yaer = Number(this.month.slice(0, 4));
      var mon = Number(this.month.slice(5, 8));
      var name = String(yaer) + '年' + String(mon) + '月';
      this.SheetsName = name;
    },
    studentname: function studentname() {
      if (this.month) {
        this.showTable();
      }
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_reservations__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reservations: [{
        id: 0,
        student: { fullname: '' },
        teacher: { fullname: '' },
        classroom: '',
        date: '1990-01-01',
        start_time: '10:00',
        end_time: '10:00',
        recurrence_id: 0
      }],
      sort: {
        isDecending: false,
        column: 'date'
      },
      Keyword: null,
      date: null
    };
  },

  methods: {
    getWhetherRecurrent: function getWhetherRecurrent(rid) {
      if (rid === 0 || rid === undefined || rid === null) {
        return 'NO';
      } else {
        return 'YES (id:' + rid + ')';
      }
    },
    columnClickHandler: function columnClickHandler(column) {
      this.sort.column = column;
      this.sort.isDecending = !this.sort.isDecending;
    },
    getAssendingArrow: function getAssendingArrow(column) {
      if (this.sort.column === column) {
        return this.sort.isDecending ? '↑' : ' ↓';
      }
      return '';
    },
    kanaToHira: function kanaToHira(str) {
      return str.replace(/[\u3041-\u3096]/g, function (match) {
        var chr = match.charCodeAt(0) + 0x60;
        return String.fromCharCode(chr);
      });
    },
    getReservations: function getReservations() {
      var _this = this;

      var updateList = function updateList() {
        if (_this.$store.state.userInfo.user_type === 'admin') {
          __WEBPACK_IMPORTED_MODULE_1__api_reservations__["a" /* default */].get(_this.$store.state.userInfo.school_id).then(function (res) {
            _this.reservations = res.data.reservations;
          }).catch(function (err) {
            if (err.response) {
              var status = err.response.status;
              var message = err.response.data.message;
              if (status === 401) {
                alert('セッションがタイムアウトしました　再度ログインして下さい');
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/login');
              } else {
                console.log(message);
                alert('予約情報取得に失敗しました：' + message);
              }
            } else {
              alert('Error:' + err.message);
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1__api_reservations__["a" /* default */].getByUserId(_this.$store.state.userInfo.user_id).then(function (res) {
            _this.reservations = res.data.reservations;
          }).catch(function (err) {
            if (err.response) {
              var status = err.response.status;
              var message = err.response.data.message;
              if (status === 401) {
                alert('セッションがタイムアウトしました　再度ログインして下さい');
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/login');
              } else {
                console.log(message);
                alert('予約情報取得に失敗しました：' + message);
              }
            } else {
              alert('Error:' + err.message);
            }
          });
        }
      };
      if (!this.$store.state.userInfo['user_type']) {
        this.$store.dispatch('getUserInfo').then(updateList);
      } else {
        updateList();
      }
    }
  },
  mounted: function mounted() {
    this.getReservations();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['school_id']), {
    SortedList: function SortedList() {
      var _this2 = this;

      if (this.date && this.Keyword) {
        return this.reservations.filter(function (data, index, array) {
          return data.date.match(_this2.date) && (data.student.fullname.match(_this2.Keyword) || data.student.kana.match(_this2.Keyword) || data.student.kana.match(_this2.kanaToHira(_this2.Keyword)) || data.teacher.fullname.match(_this2.Keyword) || data.teacher.kana.match(_this2.Keyword) || data.teacher.kana.match(_this2.kanaToHira(_this2.Keyword)));
        });
      }
      if (this.date && !this.Keyword) {
        return this.reservations.filter(function (data, index, array) {
          return data.date.match(_this2.date);
        });
      }
      if (!this.date && this.Keyword) {
        return this.reservations.filter(function (data, index, array) {
          return data.student.fullname.match(_this2.Keyword) || data.student.kana.match(_this2.Keyword) || data.student.kana.match(_this2.kanaToHira(_this2.Keyword)) || data.teacher.fullname.match(_this2.Keyword) || data.teacher.kana.match(_this2.Keyword) || data.teacher.kana.match(_this2.kanaToHira(_this2.Keyword));
        });
      }
      return this.reservations;
    }
  }),
  watch: {
    school_id: function school_id() {
      this.getReservations();
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      new_fullname: this.current_fullname,
      new_kana: this.current_kana
    };
  },

  props: ['user_id', 'current_fullname', 'current_kana'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeFullname']), {
    checkKana: function checkKana() {
      if (!this.new_kana.match(/^[ァ-ヴ]+$/)) {
        return false;
      }
      return true;
    },
    changeFullnameLocal: function changeFullnameLocal() {
      var _this = this;

      if (!this.checkKana()) {
        alert('フリガナは全角カナのみで入力してください');
        return;
      }
      this.changeFullname({
        id: this.user_id,
        newFullname: this.new_fullname,
        newKana: this.new_kana
      }).then(function (res) {
        if (res) {
          _this.$emit('changed');
          alert('氏名の変更に成功しました.');
        }
      });
    }
  })
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      new_mail_address: this.current_mail
    };
  },

  props: ['user_id', 'current_mail'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeMailAddress']), {
    changeMailLocal: function changeMailLocal() {
      var _this = this;

      this.changeMailAddress({
        id: this.user_id,
        newMailAddress: this.new_mail_address
      }).then(function (res) {
        if (res) {
          _this.$emit('ehanged');
          alert('変更に成功しました');
        }
      });
    }
  })
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      current_password: '',
      new_password: '',
      isShownPasswords: false
    };
  },

  props: ['user_id'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeUserPassword']), {
    changePassword: function changePassword() {
      this.changeUserPassword({
        id: this.user_id,
        currentPassword: this.current_password,
        newPassword: this.new_password
      }).then(function (res) {
        if (res) {
          alert('パスワードの変更に成功しました.');
        }
      });
    }
  })
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      new_status: this.current_status
    };
  },

  props: ['user_id', 'current_status'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeStatus']), {
    changeStatusLocal: function changeStatusLocal() {
      var _this = this;

      this.changeStatus({
        id: this.user_id,
        newStatus: this.new_status
      }).then(function (res) {
        if (res) {
          _this.$emit('ehanged');
          alert('変更に成功しました');
        }
      });
    }
  })
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PasswordChangePanel__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PasswordChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PasswordChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserNameChangePanel__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserNameChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserNameChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MailAddressChangePanel__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MailAddressChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MailAddressChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatusChangePanel__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatusChangePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StatusChangePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'password-change-panel': __WEBPACK_IMPORTED_MODULE_1__PasswordChangePanel___default.a,
    'user-name-change-panel': __WEBPACK_IMPORTED_MODULE_2__UserNameChangePanel___default.a,
    'mail-address-change-panel': __WEBPACK_IMPORTED_MODULE_3__MailAddressChangePanel___default.a,
    'status-change-panel': __WEBPACK_IMPORTED_MODULE_4__StatusChangePanel___default.a
  },
  computed: {
    userType: function userType() {
      switch (this.$store.state.userInfo.user_type) {
        case 'admin':
          return '管理者';
        case 'teacher':
          return '教師';
        case 'student':
          return '生徒';
        case 'viewer':
          return '閲覧者';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['getUserInfo', 'getInformation']), {
    getinformation: function getinformation() {
      var _this = this;

      this.getInformation().then(function (res) {
        console.log(_this.$store.state.information);
      });
    }
  }),
  created: function created() {
    var _this2 = this;

    this.getUserInfo().then(function (res) {
      console.log('UserInfo');
      console.log(_this2.$store.state.userInfo);
    });
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      new_user_name: this.current_user_name
    };
  },

  props: ['user_id', 'current_user_name'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeUserName']), {
    changeUserNameLocal: function changeUserNameLocal() {
      var _this = this;

      this.changeUserName({
        id: this.user_id,
        newUserName: this.new_user_name
      }).then(function (res) {
        if (res) {
          _this.$emit('changed');
          alert('ユーザ名の変更に成功しました.');
        }
      });
    }
  })
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hover: ''
    };
  },

  components: {
    'datepicker': __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a,
    'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner_src_components_Pencil_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['getCurDateFormated']), {
    isAdmin: function isAdmin() {
      if (this.$store.state.userInfo.user_type) {
        return this.$store.state.userInfo.user_type === 'admin';
      }
      return false;
    },
    isTeacher: function isTeacher() {
      if (this.$store.state.userInfo.user_type) {
        return this.$store.state.userInfo.user_type === 'teacher';
      }
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getReservations', 'getClassrooms']), {
    dateSelectHandler: function dateSelectHandler(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["a" /* TIMETABLE_CHANGE_DATE */], {
        date: payload
      });
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      });
    },
    beforeLogout: function beforeLogout() {
      var isYes = confirm('ログアウトします．よろしいでしょうか．');
      if (isYes) {
        this.$router.push('/logout');
      }
    },
    getDisableDays: function getDisableDays() {
      var ddays = {
        days: [0]
      };
      if (this.$store.state.userInfo.is_Sunday_user === true) {
        return { days: [] };
      } else {
        return ddays;
      }
    },
    schoolChange: function schoolChange() {
      if (this.$store.state.userInfo.school_id === '1') {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["b" /* CHANGE_SCHOOL */], '2');
        this.getClassrooms(this.$store.state.userInfo.school_id);
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["b" /* CHANGE_SCHOOL */], '1');
        this.getClassrooms(this.$store.state.userInfo.school_id);
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        });
      }
    },
    showOnline: function showOnline(event) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["c" /* SHOW_ONLINE */], event.target.classList.contains('offline'));
      console.log(this.$store.state.showOnline);
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      });
    }
  })
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['suggestions', 'type', 'value', 'placeholder'],
  data: function data() {
    return {
      input: '',
      open: false,
      current: 0
    };
  },

  computed: {
    matches: function matches() {
      var _this = this;

      return this.suggestions.sort(function (a, b) {
        return a.kana > b.kana ? 1 : a.kana < b.kana ? -1 : -1;
      }).filter(function (obj) {
        return obj.fullname.indexOf(_this.input) >= 0;
      });
    },
    openSuggestion: function openSuggestion() {
      return this.matches.length !== 0 && this.open === true;
    }
  },
  methods: {
    updateValue: function updateValue(value) {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.input = value;
    },
    enter: function enter() {
      var id = '';
      var matchObj = this.matches[this.current];
      var name = '';
      id = matchObj.id;
      if (!id === undefined) {
        id = matchObj.user_id;
      }
      name = matchObj.fullname;
      this.$emit('input', id);
      this.input = name;
      this.open = false;
    },
    up: function up() {
      if (this.current > 0) {
        this.current--;
      }
    },
    click: function click() {
      this.open = !this.open;
      this.input = '';
      this.$emit('input', 0);
    },
    down: function down() {
      if (this.current < this.matches.length - 1) {
        this.current++;
      }
    },
    isActive: function isActive(index) {
      return index === this.current;
    },
    suggestionClick: function suggestionClick(index) {
      var id = '';
      var matchObj = this.matches[index];
      var name = '';
      id = matchObj.id;
      if (!id) {
        id = matchObj.user_id;
      }
      name = matchObj.fullname;
      this.$emit('input', id);
      this.input = name;
      this.open = false;
    },
    suggestionDisplay: function suggestionDisplay(suggestion) {
      return suggestion.fullname;
    },
    exactFullname: function exactFullname() {
      var _this2 = this;

      if (this.value === 0) {
        return '';
      }
      var theuser = this.suggestions.find(function (elem, array, self) {
        return elem.id === _this2.value;
      });
      return theuser.fullname;
    }
  },
  mounted: function mounted() {
    this.input = this.exactFullname();
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['timeToPosition', 'getLeftPosOfClassroom']), {
    getStyle: function getStyle() {
      var top = this.timeToPosition(this.$store.state.editingState.start.replace(/px/g, ''));
      var bottom = this.timeToPosition(this.$store.state.editingState.end.replace(/px/g, ''));
      var height = bottom - top;
      var left = this.getLeftPosOfClassroom(this.$store.state.editingState.classroom);
      var style = {
        top: top + 'px',
        left: left + 'px',
        height: height + 'px',
        width: this.$store.state.columnWidth + 'px'
      };
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["x" /* EDITINGBOX_STYLE_UPDATE */], style);
      return style;
    }
  }),
  methods: {
    getTeacher: function getTeacher() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$store.state.lectureInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lect = _step.value;

          if (lect.teacher.id === this.$store.state.editingState.teacher) {
            return lect.teacher.fullname;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    getStudent: function getStudent() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$store.state.lectureInfo), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var lect = _step2.value;

          if (lect.student.id === this.$store.state.editingState.student) {
            return lect.student.fullname;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    dragstartHandler: function dragstartHandler(e) {
      var offsets = {
        x: e.layerX,
        y: e.layerY
      };
      e.dataTransfer.setData('text/json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(offsets));
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["A" /* EDITINGBOX_DRAG_START */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);
    },
    dragendHandler: function dragendHandler(e) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["B" /* EDITINGBOX_DRAG_END */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["y" /* EDITING_POPUP_SHOW */]);
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TemporaryLecturePanel__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TemporaryLecturePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TemporaryLecturePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_ClassroomConstants__ = __webpack_require__(93);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      width: 450,
      isAllEditing: false,
      dialogEditVisible: false,
      dialogDeleteVisible: false
    };
  },

  components: {
    'recurrent-panel': __WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel___default.a,
    'time-select': __WEBPACK_IMPORTED_MODULE_6_element_ui__["TimeSelect"],
    'autocomplete': __WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection___default.a,
    'temporaryLecturePanel': __WEBPACK_IMPORTED_MODULE_7__TemporaryLecturePanel___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getReservations', 'editReservation', 'deleteReservation', 'updateUserList', 'postRecurrentReservations', 'editRecurrentReservations', 'deleteRecurrentReservations']), {
    updateStartTime: function updateStartTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], { start: val });
    },
    updateEndTime: function updateEndTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], { end: val });
    },
    doEdit: function doEdit() {
      var _this = this;

      var rType = this.reservationType;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      if (!this.isAllEditing) {
        console.log(this.$store.state.editingState.online);
        this.editReservation({ id: this.$store.state.editingState.id,
          reservation: {
            student: this.student,
            teacher: this.teacher,
            start_time: this.$store.state.editingState.start,
            end_time: this.$store.state.editingState.end,
            classroom: this.$store.state.editingState.classroom,
            date: this.getCurDateFormated,
            has_test: this.hasTest,
            reservation_type: rType,
            message: this.$store.state.editingState.message,
            online: this.$store.state.editingState.online
          }
        }).then(function () {
          _this.closePopup();

          _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        });
        return;
      } else if (this.isAllEditing) {
        this.editRecurrentReservations({
          id: this.$store.state.editingState.recurrence_id,
          reservation: {
            student: this.student,
            teacher: this.teacher,
            start_time: this.$store.state.editingState.start,
            end_time: this.$store.state.editingState.end,
            classroom: this.$store.state.editingState.classroom,
            rrule: this.$store.state.recurrentRule,
            has_test: this.hasTest,
            reservation_type: rType,
            message: this.$store.state.editingState.message,
            from_reservaiton_id: this.$store.state.editingState.id,
            school_id: this.$store.state.userInfo.school_id,
            online: this.$store.state.editingState.online
          }
        }).then(function (res) {
          if (res.data.overlapping_datetimes.length !== 0) {
            var message = '次の日付は，重複のため予約に失敗しました．';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.overlapping_datetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var dates = _step.value;

                message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + ')';
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            alert(message);
          }
          _this.closePopup();

          _this.getReservations({
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        });
      } else {
        this.deleteReservation(this.$store.state.editingState.id).then(function () {
          _this.postRecurrentReservations({
            student: _this.student,
            teacher: _this.teacher,
            start_time: _this.$store.state.editingState.start,
            end_time: _this.$store.state.editingState.end,
            classroom: _this.$store.state.editingState.classroom,
            rrule: _this.$store.state.recurrentRule,
            has_test: _this.hasTest,
            reservation_type: rType,
            message: _this.$store.state.editingState.message,
            school_id: _this.$store.state.userInfo.school_id,
            online: _this.$store.state.editingState.online
          }).then(function (res) {
            if (res.data.overlapping_datetimes.length !== 0) {
              var message = '次の日付は，重複のため予約に失敗しました．';
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.overlapping_datetimes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var dates = _step2.value;

                  message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + '), ';
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              alert(message);
            }
            _this.closePopup();

            _this.getReservations({
              date: _this.getCurDateFormated,
              school_id: _this.$store.state.userInfo.school_id
            });
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
          });
        });
      }
    },
    completeEdit: function completeEdit() {
      if (this.student === 0 || this.teacher === 0) {
        alert('空欄では予約できません');
        return;
      }

      if (this.$store.state.editingState.classroom.match('307')) {
        if (this.$store.state.editingState.start < '15:00' && this.$store.state.userInfo.user_type !== 'admin') {
          alert('15時以前307教室は使用できません');
          return;
        }
      }

      if (this.isRecurrent) {
        this.dialogEditVisible = true;
      } else {
        this.doEdit();
      }
    },
    doDelete: function doDelete() {
      var _this2 = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      if (!this.isAllEditing) {
        this.deleteReservation(this.$store.state.editingState.id).then(function () {
          _this2.getReservations({
            date: _this2.getCurDateFormated,
            school_id: _this2.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      } else {
        this.deleteRecurrentReservations({ id: this.$store.state.editingState.recurrence_id, fromReservaitonId: this.$store.state.editingState.id }).then(function () {
          _this2.getReservations({
            all: 1,
            date: _this2.getCurDateFormated,
            school_id: _this2.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      }
    },
    eraseReservation: function eraseReservation() {
      if (this.isRecurrent) {
        this.dialogDeleteVisible = true;
      } else {
        var ret = confirm('削除します．よろしいですか？');
        if (ret) {
          this.doDelete();
        }
      }
    },
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
        start: '10:00',
        end: '10:00'
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
    },
    setHiddenID: function setHiddenID() {
      if (this.$store.state.userInfo.user_type === 'student') {
        this.student = this.$store.state.userInfo.user_id;
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        this.teacher = this.$store.state.userInfo.user_id;
      }
      return this.$store.state.userInfo.user_id;
    },
    changeClassroomLeft: function changeClassroomLeft() {
      var index = this.classroomNames.indexOf(this.$store.state.editingState.classroom);
      if (index > 0) {
        if (this.$store.state.userInfo.user_type !== 'admin' && __WEBPACK_IMPORTED_MODULE_8__constants_ClassroomConstants__["a" /* default */].spareRooms.indexOf(this.classroomNames[index - 1]) !== -1) {
          alert('予備席には予約できません');
        } else {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], this.classroomNames[index - 1]);
        }
      }
    },
    changeClassroomRight: function changeClassroomRight() {
      var index = this.classroomNames.indexOf(this.$store.state.editingState.classroom);
      if (index < this.classroomNames.length - 1) {
        if (this.$store.state.userInfo.user_type !== 'admin' && __WEBPACK_IMPORTED_MODULE_8__constants_ClassroomConstants__["a" /* default */].spareRooms.indexOf(this.classroomNames[index + 1]) !== -1) {
          alert('予備席には予約できません');
        } else {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], this.classroomNames[index + 1]);
        }
      }
    },
    getStyle: function getStyle() {
      var style = {
        width: this.width + 'px'
      };
      var ss = this.$store.state.editingState.style;
      var s = {
        left: parseInt(ss.left.replace(/px/g, '')),
        top: parseInt(ss.top.replace(/px/g, ''))
      };
      var clientWidth = document.getElementsByTagName('body')[0].clientWidth;
      var clientHeight = document.getElementsByTagName('body')[0].clientHeight;

      if (s.left < clientWidth / 2) {
        style.left = s.left + this.$store.state.columnWidth + 'px';
        style.right = undefined;
      } else {
        style.left = s.left - this.width - 5 + 'px';
      }
      if (s.top < clientHeight / 2) {
        style.top = s.top + 'px';
        style.bottom = undefined;
      } else {
        style.top = s.top + 'px';
      }
      return style;
    },
    message: function message() {
      return this.$store.state.editingState.message;
    },
    isOnline: function isOnline() {
      console.log(this.$store.state.editingState.online);
      return this.$store.state.editingState.online;
    },
    getTeacherList: function getTeacherList() {
      var _this3 = this;

      if (this.student !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this3.student === lect.student.id;
        }).map(function (lect, index, self) {
          return lect.teacher;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'teacher';
      });
    },
    getStudentList: function getStudentList() {
      var _this4 = this;

      if (this.teacher !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this4.teacher === lect.teacher.id;
        }).map(function (lect, index, self) {
          return lect.student;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'student' && !(_this4.reservationType === '通常' && (/temp/.test(user.user_status) || user.user_status === 'trial'));
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['tableWidth', 'timelineHeight', 'getCurDateFormated', 'classroomNames', 'reservationsInRange']), {
    canTakeResv: function canTakeResv() {
      if (this.teacher === 0 || this.student === 0) {
        return false;
      }

      if (this.isSomeDuplicatedReservation) {
        return false;
      }
      return true;
    },

    isRecurrent: {
      get: function get() {
        return this.$store.state.editingState.isRecurrent;
      }
    },
    student: {
      get: function get() {
        return this.$store.state.editingState.student;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["N" /* EDITINGSTATE_SET_STUDENT */], value);
      }
    },
    teacher: {
      get: function get() {
        return this.$store.state.editingState.teacher;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["M" /* EDITINGSTATE_SET_TEACHER */], value);
      }
    },
    hasTest: {
      get: function get() {
        return this.$store.state.editingState.hasTest;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["P" /* EDITINGSTATE_SET_HAS_TEST */], value);
      }
    },
    isTanki: {
      get: function get() {
        return this.$store.state.editingState.reservationType !== '通常' && this.$store.state.editingState.reservationType !== '通常初回' && this.$store.state.editingState.reservationType !== '短期';
      },
      set: function set(value) {
        this.$store.commit('EDITINGSTATE_SET_TYPE', value);
      }
    },
    reservationType: {
      get: function get() {
        return this.$store.state.editingState.reservationType;
      },
      set: function set(value) {
        this.$store.commit('EDITINGSTATE_SET_TYPE', value);
      }
    },
    online: {
      get: function get() {
        return this.$store.state.editingState.online === 'true';
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__vuex_mutation_types__["S" /* EDITINGSTATE_SET_IS_ONLINE */], value);
      }
    },
    isSomeDuplicatedReservation: function isSomeDuplicatedReservation() {
      var _this5 = this;

      return this.reservationsInRange(this.$store.state.editingState.start, this.$store.state.editingState.end).filter(function (elem, index, self) {
        return elem.id !== _this5.$store.state.editingState.id;
      }).some(function (elem, index, self) {
        return elem.teacher.id === _this5.$store.state.editingState.teacher || elem.student.id === _this5.$store.state.editingState.student;
      });
    }
  })
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_time__ = __webpack_require__(26);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      width: 400,
      isAllEditing: false,
      dialogDeleteVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getLeftPosOfClassroom', 'timelinesWidth', 'timelineHeight', 'timeToPosition', 'getCurDateFormated'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['deleteReservation', 'deleteRecurrentReservations', 'getReservations']), {
    getStyle: function getStyle() {
      var style = {
        width: this.width + 'px'
      };
      var reservation = this.$store.state.informationPopup.reservation;
      var targetBox = {
        width: this.$store.state.columnWidth,
        top: this.timeToPosition(new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */](reservation.start_time).toString()),
        bottom: this.timeToPosition(new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */](reservation.end_time).toString()),
        left: this.getLeftPosOfClassroom(reservation.classroom)
      };
      targetBox['height'] = targetBox.bottom - targetBox.top;

      if (targetBox.left < this.timelinesWidth / 2) {
        style.left = targetBox.left + this.$store.state.columnWidth + 'px';
        style.right = undefined;
      } else {
        style.left = targetBox.left - this.width - 5 + 'px';
      }
      if (targetBox.top < this.timelineHeight / 2) {
        style.top = targetBox.top + 'px';
        style.bottom = undefined;
      } else {
        style.top = targetBox.top + 'px';
      }
      return style;
    },
    isTanki: function isTanki() {
      var st = this.$store.state.informationPopup.reservation.student.status;
      return st === 'temporal' || st === 'trial' || st === 'temp/temp' || st === 'temp/norm';
    },
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
    },
    enterEdit: function enterEdit() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["u" /* RESERVATIONBOX_ENTER_EDIT */], this.$store.state.informationPopup.reservation);
    },
    enterDelete: function enterDelete() {
      this.eraseReservation();
    },
    doDelete: function doDelete() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      var recurrenceId = this.$store.state.informationPopup.reservation.recurrence_id;
      if (!this.isAllEditing) {
        this.deleteReservation(this.$store.state.informationPopup.reservation.id).then(function () {
          _this.getReservations({
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      } else {
        this.deleteRecurrentReservations({ id: recurrenceId, fromReservaitonId: this.$store.state.informationPopup.reservation.id }).then(function () {
          _this.getReservations({
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
    },
    eraseReservation: function eraseReservation() {
      if (this.$store.state.informationPopup.reservation.recurrence_id !== null) {
        this.dialogDeleteVisible = true;
      } else {
        var ret = confirm('削除します．よろしいですか？');
        if (ret) {
          this.doDelete();
        }
      }
    },
    isEditable: function isEditable() {
      var userType = this.$store.state.userInfo.user_type;
      return userType !== 'student' && (userType === 'admin' || this.$store.state.informationPopup.reservation.teacher.id === this.$store.state.userInfo.user_id) && this.isFuture() && this.isBeforeDeadline();
    },
    isFuture: function isFuture() {
      var today = new Date();
      var date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);
      return today.getTime() < reservationDate.getTime() || this.$store.state.userInfo.user_type === 'admin';
    },
    isBeforeDeadline: function isBeforeDeadline() {
      if (this.$store.state.userInfo.user_type === 'admin') {
        return true;
      }
      var today = new Date();
      var date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);

      var dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) - new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24;
      return reservationDate.getDay() === 1 && (dateDiff > 2 || dateDiff === 2 && today.getHours() < 22) || reservationDate.getDay() !== 1 && (dateDiff > 1 || dateDiff === 1 && today.getHours() < 22);
    }
  })
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'preview-box',
  props: ['dragging'],
  data: function data() {
    return {
      state: this.$store.state.previewBox
    };
  },

  methods: {
    mousedownHandler: function mousedownHandler(event) {
      this.$emit('pvmousedown', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      });
    },
    mousemoveHandler: function mousemoveHandler(event) {
      this.$emit('pvmousemove', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      });
    },
    mouseupHandler: function mouseupHandler(event) {
      this.$emit('pvmouseup', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      });
    },
    getUpdatedStyle: function getUpdatedStyle() {
      var top = this.timeToPosition(this.$store.state.previewBox.start);
      var bottom = this.timeToPosition(this.$store.state.previewBox.end);
      var height = bottom - top;
      var left = this.getLeftPosOfClassroom(this.$store.state.previewBox.classroom);
      var style = {
        top: top,
        bottom: bottom,
        height: height,
        left: left
      };
      return style;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['timeToPosition', 'positionToTime', 'getLeftPosOfClassroom']), {
    hasHeight: function hasHeight() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["o" /* PREVIEWBOX_STYLE_UPDATE */], this.getUpdatedStyle());
      return this.$store.state.previewBox.style.height !== 0;
    },
    getStyle: function getStyle() {
      var style = {
        top: this.$store.state.previewBox.style.top + 'px',
        left: this.$store.state.previewBox.style.left + 'px',
        bottom: this.$store.state.previewBox.style.bottom + 'px',
        height: this.$store.state.previewBox.style.height + 'px',
        width: this.$store.state.columnWidth + 'px'
      };
      return style;
    }
  })
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'recurrent-panel',
  data: function data() {
    return {
      freq: 'WEEKLY',
      byday: this.$store.state.curDate.getDay(),
      span: '0' };
  },

  methods: {
    onChange: function onChange() {
      var theday = this.$store.state.curDate;
      var DTSTART = this.getDateFormated(theday);
      var finday = new Date(theday);
      finday.setDate(finday.getDate() + parseInt(this.span));
      var UNTIL = this.getDateFormated(finday);
      if (this.freq === 'WEEKLY' || this.freq === 'MONTHLY') {
        var rrule = 'DTSTART: ' + DTSTART + '\nRRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL + ';BYDAY=' + this.getBYDAYString(this.byday);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], rrule);
        return;
      } else {
        var _rrule = 'DTSTART: ' + DTSTART + '\n        RRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL;
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], _rrule);
        return;
      }
    },
    getBYDAYString: function getBYDAYString(day) {
      switch (day) {
        case 0:
          return 'SU';
        case 1:
          return 'MO';
        case 2:
          return 'TU';
        case 3:
          return 'WE';
        case 4:
          return 'TH';
        case 5:
          return 'FR';
        case 6:
          return 'SA';
        default:
          break;
      }
    },
    getDateFormated: function getDateFormated(date) {
      var day = date.getDate();

      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return '' + year + month + day;
    }
  },
  created: function created() {
    var theday = this.$store.state.curDate;
    var DTSTART = this.getDateFormated(theday);

    var finday = new Date(theday.getFullYear(), theday.getMonth() + 1, 0);
    var UNTIL = this.getDateFormated(finday);
    if (this.freq === 'WEEKLY' || this.freq === 'MONTHLY') {
      var rrule = 'DTSTART: ' + DTSTART + '\nRRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL + ';BYDAY=' + this.getBYDAYString(this.byday);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], rrule);
      return;
    } else {
      var _rrule2 = 'DTSTART: ' + DTSTART + '\n      RRULE:FREQ=' + this.freq + ';UNTIL=' + UNTIL;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["F" /* RRULE_UPDATE */], _rrule2);
      return;
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hover: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getReservations']), {
    refreshTable: function refreshTable() {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated
      }).then(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getCurDateFormated']), {
    getStyle: function getStyle() {
      if (this.hover) {
        return { opacity: 1.0 };
      } else {
        return { opacity: 0.5 };
      }
    }
  })
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReservationStates__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReservationStates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ReservationStates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_time__ = __webpack_require__(26);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'statelist': __WEBPACK_IMPORTED_MODULE_3__ReservationStates___default.a
  },
  props: ['reservation'],
  data: function data() {
    return {
      style: {},
      hover: false
    };
  },

  methods: {
    reduceTimeExp: function reduceTimeExp(timeStr) {
      return timeStr.slice(0, 5);
    },
    clickHandler: function clickHandler(event) {
      if (this.canDisplay) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["K" /* HIDE_INFORMATION_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["L" /* SHOW_INFORMATION_POPUP */], this.reservation);
      }
    },
    mousemoveHandler: function mousemoveHandler(event) {
      this.hover = true;
      this.$emit('pvmousemove', {
        e: {
          offsetY: event.layerY + this.timeToPosition(this.reservation.start_time)
        },
        classroom: this.reservation.classroom
      });
    },
    mouseupHandler: function mouseupHandler(event) {
      this.$emit('pvmouseup', {
        e: {
          offsetY: event.layerY + this.timeToPosition(this.reservation.start_time)
        },
        classroom: this.reservation.classroom
      });
    },
    enterEdit: function enterEdit() {
      this.$store.commit('RESERVATIONBOX_ENTER_EDIT', this.reservation);
      this.$store.commit('EDITINGBOX_STYLE_UPDATE', this.getStyle);
    },
    toggleAttendance: function toggleAttendance(userId) {
      var _this = this;

      this.$store.dispatch('toggleAttendance', userId).then(function () {
        _this.$store.dispatch('getAttendance');
      });
    },
    isAttending: function isAttending(id) {
      return this.$store.state.attendance.includes(id);
    },
    attendingState: function attendingState(id) {
      return this.isAttending(id) ? '☑' : '□';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getLeftPosOfClassroom', 'timeToPosition']), {
    getStyle: function getStyle() {
      var width = this.$store.state.columnWidth;
      var top = this.timeToPosition(new __WEBPACK_IMPORTED_MODULE_4__modules_time__["a" /* default */](this.reservation.start_time).toString());
      var bottom = this.timeToPosition(new __WEBPACK_IMPORTED_MODULE_4__modules_time__["a" /* default */](this.reservation.end_time).toString());
      var height = bottom - top;
      var left = this.getLeftPosOfClassroom(this.reservation.classroom);
      var opacity = 1.0;
      if (this.isEditing && this.reservation.id === this.$store.state.editingState.id) {
        opacity = 0.5;
      }
      return {
        width: width + 'px',
        height: height + 'px',
        top: top + 'px',
        left: left + 'px',
        opacity: opacity
      };
    },
    isEditing: function isEditing() {
      return this.$store.state.editingState.id !== 0;
    },
    isEditable: function isEditable() {
      var userType = this.$store.state.userInfo.user_type;
      return userType !== 'student' && (userType === 'admin' || this.reservation.teacher.id === this.$store.state.userInfo.user_id) && this.isFuture && this.isBeforeDeadline;
    },
    isFuture: function isFuture() {
      var today = new Date();
      var date = this.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);
      return today.getTime() < reservationDate.getTime();
    },
    isBeforeDeadline: function isBeforeDeadline() {
      var today = new Date();
      var date = this.reservation.date.split(' ')[0].split('-').map(function (x) {
        return parseInt(x);
      });
      var startTime = this.reservation.start_time.split(' ')[0].split(':').map(function (x) {
        return parseInt(x);
      });
      var reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1]);

      var dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) - new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24;
      return reservationDate.getDay() === 1 && (dateDiff > 2 || dateDiff === 2 && today.getHours() < 22) || reservationDate.getDay() !== 1 && (dateDiff > 1 || dateDiff === 1 && today.getHours() < 22);
    },
    isVailedCheck: function isVailedCheck() {
      var today = new Date();
      if (this.$store.state.userInfo.user_type === 'admin' && this.$store.state.curDate.getMonth() === today.getMonth() && this.$store.state.curDate.getDate() === today.getDate()) {
        return true;
      } else {
        return false;
      }
    },
    canDisplay: function canDisplay() {
      var userType = this.$store.state.userInfo.user_type;
      var userId = this.$store.state.userInfo.user_id;
      var myStudent = false;
      if (userType === 'teacher') {
        for (var k in this.$store.state.lectureInfo) {
          if (this.$store.state.lectureInfo[k].student.id === this.reservation.student.id) {
            myStudent = true;
            break;
          }
        }
      }
      return userType === 'admin' || userType === 'viewer' || userType === 'teacher' && this.reservation.teacher.id === userId || myStudent || userType === 'student' && this.reservation.student.id === userId;
    }
  })
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TemporaryLecturePanel_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TemporaryLecturePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TemporaryLecturePanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'time-select': __WEBPACK_IMPORTED_MODULE_2_element_ui__["TimeSelect"],
    'recurrent-panel': __WEBPACK_IMPORTED_MODULE_4__RecurrentReservePanel_vue___default.a,
    'autocomplete': __WEBPACK_IMPORTED_MODULE_5__AutocompleteSelection___default.a,
    'temporaryLecturePanel': __WEBPACK_IMPORTED_MODULE_6__TemporaryLecturePanel_vue___default.a
  },
  data: function data() {
    return {
      student: this.$store.state.userInfo.user_type === 'student' ? this.$store.state.userInfo.user_id : 0,
      teacher: this.$store.state.userInfo.user_type === 'teacher' ? this.$store.state.userInfo.user_id : 0,
      width: 450,
      isRecurrent: false,
      hasTest: false,
      _isTanki: false,
      type: '通常',
      message: '',
      isOnline: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['getReservations', 'postReservation', 'updateUserList', 'postRecurrentReservations', 'changeStatus']), {
    updateStartTime: function updateStartTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], { start: val });
    },
    updateEndTime: function updateEndTime(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], { end: val });
    },
    takeReservation: function takeReservation() {
      var _this = this;

      if (this.student === 0 || this.teacher === 0) {
        alert('空欄では予約できません');
        return;
      }

      if (this.$store.state.previewBox.classroom.match('307')) {
        if (this.$store.state.previewBox.start < '15:00' && this.$store.state.userInfo.user_type !== 'admin') {
          alert('15時以前307教室は使用できません');
          return;
        }
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["H" /* SPINNER_SHOW */]);

      if (this.type === '通常初回') {
        console.log(this.$store.state);
        var std = this.$store.state.lectureInfo.find(function (info, index) {
          return _this.student === info.student.id;
        });
        console.log(std);
        this.updateStatus(this.student, std.student.id);
      }
      if (!this.isRecurrent) {
        this.postReservation({
          student: this.student,
          teacher: this.teacher,
          start_time: this.$store.state.previewBox.start,
          end_time: this.$store.state.previewBox.end,
          classroom: this.$store.state.previewBox.classroom,
          date: this.getCurDateFormated,
          has_test: this.hasTest,
          reservation_type: this.type,
          message: this.message,
          school_id: this.$store.state.userInfo.school_id,
          online: this.isOnline
        }).then(function () {
          _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        return;
      } else {
        this.postRecurrentReservations({
          student: this.student,
          teacher: this.teacher,
          start_time: this.$store.state.previewBox.start,
          end_time: this.$store.state.previewBox.end,
          classroom: this.$store.state.previewBox.classroom,
          rrule: this.$store.state.recurrentRule,
          has_test: this.hasTest,
          reservation_type: this.type,
          message: this.message,
          school_id: this.$store.state.userInfo.school_id,
          online: this.isOnline
        }).then(function (res) {
          console.log(res);
          if (res.data.overlapping_datetimes.length > 0) {
            var message = '次の日付は，重複のため予約に失敗しました．';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data.overlapping_datetimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var dates = _step.value;

                message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + '), ';
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            alert(message);
          }
        }).then(function () {
          _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
        this.closePopup();
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        return;
      }
    },
    closePopup: function closePopup() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
        start: '10:00',
        end: '10:00'
      });
    },
    setHiddenID: function setHiddenID() {
      if (this.$store.state.userInfo.user_type === 'student') {
        this.student = this.$store.state.userInfo.user_id;
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        this.teacher = this.$store.state.userInfo.user_id;
      }
      return this.$store.state.userInfo.user_id;
    },
    selectorUpdate: function selectorUpdate(val) {
      console.log(val);
    },
    getTeacherList: function getTeacherList() {
      var _this2 = this;

      if (this.student !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this2.student === lect.student.id;
        }).map(function (lect, index, self) {
          return lect.teacher;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'teacher';
      });
    },
    getStudentList: function getStudentList() {
      var _this3 = this;

      if (this.teacher !== 0) {
        return this.$store.state.lectureInfo.filter(function (lect, index, self) {
          return _this3.teacher === lect.teacher.id;
        }).map(function (lect, index, self) {
          return lect.student;
        });
      }

      if (this.$store.state.userlist.length === 0) {
        this.updateUserList();
      }
      return this.$store.state.userlist.filter(function (user, index, self) {
        return user.user_type === 'student' && user.school_id === Number(_this3.$store.state.userInfo.school_id);
      });
    },
    updateStatus: function updateStatus(id, status) {
      var newStatus = 'normal';
      switch (status) {
        case 'temporal':
        case 'temp/temp':
        case 'temp/norm':
          newStatus = 'temp/norm';
          break;
        case 'trial':
          newStatus = 'normal';
          break;
      }
      this.changeStatus({
        id: id,
        newStatus: newStatus
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])(['tableWidth', 'timelineHeight', 'getCurDateFormated', 'reservationsInRange']), {
    isTanki: {
      get: function get() {
        return this.type !== '通常' && this.type !== '通常初回' && this.type !== '短期';
      },
      set: function set(value) {
        this._isTanki = value;
      }
    },
    getStyle: function getStyle() {
      var style = {
        width: this.width + 'px',
        'z-index': 1100
      };
      var s = this.$store.state.previewBox.style;

      if (s.left < this.tableWidth / 2) {
        style.left = s.left + this.$store.state.columnWidth + 'px';
        style.right = undefined;
      } else {
        style.left = s.left - this.width - 5 + 'px';
      }
      if (s.top < this.timelineHeight / 2) {
        style.top = s.top + 'px';
        style.bottom = undefined;
      } else {
        style.top = s.top + 'px';
      }
      return style;
    },
    canTakeResv: function canTakeResv() {
      if (this.teacher === 0 || this.student === 0) {
        return false;
      }

      if (this.isSomeDuplicatedReservation) {
        return false;
      }

      return true;
    },
    isSomeDuplicatedReservation: function isSomeDuplicatedReservation() {
      var _this4 = this;

      return this.reservationsInRange(this.$store.state.previewBox.start, this.$store.state.previewBox.end).some(function (elem, index, self) {
        return elem.teacher.id === _this4.teacher || elem.student.id === _this4.student;
      });
    }
  })
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservation'],
  computed: {
    reservationType: function reservationType() {
      return this.reservation.reservation_type;
    },
    hasConfTest: function hasConfTest() {
      return this.reservation.has_test;
    },
    hasSomethingToShow: function hasSomethingToShow() {
      return this.reservationType !== '通常' || this.hasConfTest || this.hasMessage();
    }
  },
  methods: {
    hasMessage: function hasMessage() {
      if (this.reservation.message.trim() !== '') {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ruler',
  data: function data() {
    return {
      ticksCellStyle: {
        height: this.$store.state.rowHeight + 'px'
      }
    };
  },

  methods: {
    getTicksClass: function getTicksClass(index) {
      if (index === 0) {
        return 'tickTop';
      } else if (index % 2 === 0) {
        return 'ticksMain';
      } else {
        return 'ticksSub';
      }
    }
  },
  computed: {
    getStyle: function getStyle() {
      var style = {};
      style.width = this.$store.state.rulerWidth + 'px';

      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.top = this.$store.state.tbHeaderHeight + this.$store.state.headerHeight + 2 + 'px';
        style.left = this.$window.scrollX + 2 + 'px';
        style['z-index'] = 1000;
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute';
        style.left = this.$window.scrollX + 2 + 'px';
        style.top = this.$store.state.tbHeaderHeight + this.$store.state.headerHeight + 3 + 'px';
        style['border-left'] = 'solid 2px black';
        style['z-index'] = 1000;
      } else if (this.$window.scrollY > 0) {
        style.position = 'relative';
        style.top = this.$store.state.tbHeaderHeight + 'px';
        style['z-index'] = 1000;
      } else {
        style['margin-top'] = '-1px';
      }
      return style;
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['classroom'],
  computed: {
    getStyle: function getStyle() {
      var style = {};
      style.height = this.$store.state.tbHeaderHeight + 'px';
      style.width = this.$store.state.rulerWidth + 'px';
      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.top = '0px';
        style.left = this.$window.scrollX + 'px';
        style['border-top'] = 'solid 1px black';
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px';
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute';
        style.left = this.$window.scrollX + 2 + 'px';
        style.top = this.$store.state.headerHeight + 2 + 'px';
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px';
        style['border-left'] = 'solid 2px black';
      } else if (this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.left = this.$window.scrollX + 'px';
        style.top = '0px';
        style['border-left'] = 'solid 1px black';
        style['border-top'] = 'solid 1px black';
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px';
      } else {}
      return style;
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vanilla_autokana__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vanilla_autokana___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vanilla_autokana__);









var autokana = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fullname: '',
      kana: '',
      hasTest: false,
      message: '',
      type: '通常',
      status: '',
      isOnline: false
    };
  },

  props: ['teacher', 'isEdit', 'reservationType'],
  mounted: function mounted() {
    autokana = __WEBPACK_IMPORTED_MODULE_5_vanilla_autokana__["bind"]('#fullname', '#kana', { katakana: true });
    if (this.isEdit) {
      this.fullname = this.$store.state.informationPopup.reservation.student.fullname;
      this.kana = this.$store.state.informationPopup.reservation.student.kana;
      this.status = this.$store.state.informationPopup.reservation.student.status;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['addUser', 'addLecture', 'postReservation', 'getReservations', 'editReservation', 'deleteReservation', 'updateUserList', 'getLectures', 'getTemporalStudentByFullname', 'getNotTemporalStudentByFullname', 'changeFullname', 'changeStatus', 'deleteUser']), {
    reserve: function reserve() {
      var _this = this;

      if (this.fullname === '') {
        alert('生徒の名前が空欄です．');
        return;
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["H" /* SPINNER_SHOW */]);

      var preStudent = this.isEdit ? this.$store.state.informationPopup.reservation.student : 0;
      var preId = this.isEdit ? preStudent.id : -2;
      var temporalStudentId = -1;

      this.getNotTemporalStudentByFullname(this.fullname).then(function (res) {
        temporalStudentId = res.data.not_temporal_student;

        _this.updateStatus(temporalStudentId, 'normal', _this.reservationType);

        if (_this.isEdit && (preStudent.status === 'trial' || preStudent.status === 'temporal')) {
          _this.deleteUserHandler(preId, preStudent.fullname);
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (err) {
        if (err.response.status === 404) {
          return _this.getTemporalStudentByFullname(_this.fullname).then(function (res) {
            temporalStudentId = res.data.temporal_student;

            if (!(preId === temporalStudentId)) {
              _this.updateStatus(temporalStudentId, 'temporal', _this.reservationType);

              if (preStudent.status === 'trial' || preStudent.status === 'temporal') {
                _this.deleteUserHandler(preId, preStudent.fullname);
              }
            }

            if (_this.kana !== '') {
              return _this.changeFullname({ id: res.data.temporal_student, newFullname: _this.fullname, newKana: _this.kana }).then(function () {
                if (_this.$store.state.userInfo.user_type === 'admin') {
                  _this.updateUserList();
                }
              });
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
            }
          }).catch(function (err) {
            if (err.response.status === 404) {
              if (!_this.isEdit || _this.isEdit && _this.status !== 'trial' && _this.status !== 'temporal') {
                var userName = 'tanki_' + Math.random().toString(36).slice(-8);
                var user = {
                  user_name: userName,
                  password: Math.random().toString(36).slice(-8),
                  fullname: _this.fullname,
                  type: 'student',
                  kana: _this.kana === '' ? '短期' : _this.kana,
                  school_id: _this.$store.state.userInfo.school_id,
                  status: _this.reservationType === '体験' ? 'trial' : 'temporal'
                };
                return _this.addUser(user).then(function (res) {
                  temporalStudentId = res.data.id;
                  if (_this.$store.state.userInfo.user_type === 'admin') {
                    _this.updateUserList();
                  }
                });
              } else {
                temporalStudentId = preId;
                return _this.changeFullname({ id: preId, newFullname: _this.fullname, newKana: _this.kana }).then(function () {
                  if (_this.$store.state.userInfo.user_type === 'admin') {
                    _this.updateUserList();
                  }
                });
              }
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
            }
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
        }
      }).then(function () {
        return _this.getLectures({}).then(function () {
          var lectures = _this.$store.state.lectureInfo;
          var alreadyExists = false;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lectures), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var lect = _step.value;

              if (lect.student.id === temporalStudentId && lect.teacher.id === _this.teacher) {
                alreadyExists = true;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (!alreadyExists) {
            return _this.addLecture({
              student: temporalStudentId,
              teacher: _this.teacher
            }).then(function () {
              return _this.getLectures({});
            });
          }
        }).then(function (res) {
          var rType = _this.reservationType;
          if (!_this.isEdit) {
            return _this.postReservation({
              student: temporalStudentId,
              teacher: _this.teacher,
              start_time: _this.$store.state.previewBox.start,
              end_time: _this.$store.state.previewBox.end,
              classroom: _this.$store.state.previewBox.classroom,
              date: _this.getCurDateFormated,
              has_test: _this.hasTest,
              reservation_type: rType,
              message: _this.message,
              school_id: _this.$store.state.userInfo.school_id,
              online: _this.isOnline
            });
          } else {
            return _this.editReservation({
              id: _this.$store.state.editingState.id,
              reservation: {
                student: temporalStudentId,
                teacher: _this.teacher,
                start_time: _this.$store.state.editingState.start,
                end_time: _this.$store.state.editingState.end,
                classroom: _this.$store.state.editingState.classroom,
                date: _this.getCurDateFormated,
                has_test: _this.hasTest,
                reservation_type: rType,
                message: _this.message,
                school_id: _this.$store.state.userInfo.school_id,
                online: _this.isOnline
              }
            });
          }
        }).then(function () {
          return _this.getReservations({
            all: 1,
            date: _this.getCurDateFormated,
            school_id: _this.$store.state.userInfo.school_id
          });
        });
      }).then(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);

        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (err) {
        console.log(err);
        alert('予約に関してエラーが発生しました');
      });
    },
    deleteResv: function deleteResv() {
      var _this2 = this;

      var ret = confirm('削除します．よろしいですか？');
      if (ret) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["H" /* SPINNER_SHOW */]);
        this.deleteReservation(this.$store.state.editingState.id).then(function (res) {
          _this2.getReservations({
            all: 1,
            date: _this2.getCurDateFormated,
            school_id: _this2.$store.state.userInfo.school_id
          });
        });

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["I" /* SPINNER_HIDE */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
      }
    },
    cancel: function cancel() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["z" /* EDITING_POPUP_HIDE */]);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
        start: '10:00',
        end: '10:00'
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["E" /* RESERVATIONBOX_FINISH_EDIT */]);
    },
    handleNameInput: function handleNameInput() {
      this.kana = autokana.getFurigana();
    },
    updateStatus: function updateStatus(id, status, rsvType) {
      var newStatus = '';
      if (rsvType === '短期初回') {
        switch (status) {
          case 'normal':
            newStatus = 'temp/norm';
            break;
          case 'temporal':
            newStatus = 'temp/temp';
            break;
        }
      } else {
        switch (status) {
          case 'normal':
            break;
          case 'temporal':
            newStatus = 'temp/temp';
            break;
        }
      }
      if (newStatus !== '') {
        this.changeStatus({
          id: id,
          newStatus: newStatus
        });
      }
    },
    deleteUserHandler: function deleteUserHandler(id, name) {
      var _this3 = this;

      var yesno = confirm('編集前に新規登録されていたユーザー：「' + name + '」を削除しますか？');
      if (yesno) {
        this.deleteUser(id).then(function (res) {
          alert('ユーザーの削除に成功しました。');
          _this3.updateUserList();
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getCurDateFormated']))
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      time: new Date(),
      style: {
        width: this.tableWidth + 'px',
        height: '0px',
        left: '0px',
        top: '0px',
        'margin-left': '0px'
      },
      intID: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['tableWidth', 'timeToPosition']), {
    getStyle: function getStyle() {
      return this.style;
    }
  }),
  methods: {
    updateStyle: function updateStyle() {
      if (this.time.getHours() < 10 || this.time.getHours() >= 22 && this.time.getMinutes() >= 0) {
        this.style.top = '0px';
        clearInterval(this.intID);
      }
      var top = this.timeToPosition(this.time.getHours() + ':' + this.time.getMinutes()) + this.$store.state.tbHeaderHeight + this.$store.state.headerHeight;
      var width = window.innerWidth;
      this.style.top = top + 'px';
      this.style.width = width + 'px';
    },
    isEnable: function isEnable() {
      return !(this.time.getHours() < 10 || this.time.getHours() >= 22 && this.time.getMinutes() >= 0) && this.time.getDate() === this.$store.state.curDate.getDate() && this.time.getMonth() === this.$store.state.curDate.getMonth();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.updateStyle();
      _this.intID = setInterval(function () {
        _this.time = new Date();
        _this.updateStyle();
      }, 1000 * 60);
    });
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timeline',
  props: ['classroom', 'dragging'],
  data: function data() {
    return {
      style: {
        width: this.$store.state.columnWidth + 'px'
      }
    };
  },

  methods: {
    mousedownHandler: function mousedownHandler(event) {
      this.$emit('tlmousedown', {
        e: event,
        classroom: this.classroom
      });
    },
    mousemoveHandler: function mousemoveHandler(event) {
      if (this.dragging) {
        this.$emit('tlmousemove', {
          e: event,
          classroom: this.classroom
        });
      }
    },
    mouseupHandler: function mouseupHandler(event) {
      this.$emit('tlmouseup', {
        e: event,
        classroom: this.classroom
      });
    },
    clickHandler: function clickHandler(event) {
      this.$emit('tlclick', {
        e: event,
        classroom: this.classroom
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['timelineHeight', 'positionToTime', 'getLeftPosOfClassroom', 'getClassroomAt', 'edgeClassrooms']), {
    getStyle: function getStyle() {
      var _this = this;

      this.style.height = this.timelineHeight + 'px';
      this.style.left = this.getLeftPosOfClassroom(this.classroom) + 'px';
      if (this.edgeClassrooms.some(function (elem, index, self) {
        return elem.name === _this.classroom;
      })) {
        this.style['border-right-width'] = '2px';
        this.style['border-right-style'] = 'solid';
        this.style['border-right-color'] = 'black';
      }

      return this.style;
    }
  })
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_time__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timeline__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PreviewBox__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PreviewBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PreviewBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReservationPopup__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReservationPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ReservationPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReservationBox__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReservationBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ReservationBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EditingBox__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EditingBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EditingBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditingPopup__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditingPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__EditingPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InformationPopup__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InformationPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InformationPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_ClassroomConstants__ = __webpack_require__(93);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timeline-container',
  components: {
    'timeline': __WEBPACK_IMPORTED_MODULE_4__Timeline___default.a,
    'preview-box': __WEBPACK_IMPORTED_MODULE_5__PreviewBox___default.a,
    'reservation-popup': __WEBPACK_IMPORTED_MODULE_6__ReservationPopup___default.a,
    'reservation-box': __WEBPACK_IMPORTED_MODULE_7__ReservationBox___default.a,
    'editing-box': __WEBPACK_IMPORTED_MODULE_8__EditingBox___default.a,
    'editing-popup': __WEBPACK_IMPORTED_MODULE_9__EditingPopup___default.a,
    'information-popup': __WEBPACK_IMPORTED_MODULE_10__InformationPopup___default.a
  },
  data: function data() {
    return {
      tlTicksStyle: {
        height: this.$store.state.rowHeight + 'px'
      },
      hasDraggingTl: false,
      focusedClassroom: '',
      dragStartTime: new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */]('00:00'),
      dragEndTime: new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */]('00:00'),
      mousedownTime: 0,
      clickthreshold: 200,
      isFuture: true,
      isBeforeDeadline: true };
  },

  methods: {
    getTicksClass: function getTicksClass(index) {
      if (index === 0) {
        return 'tickTop';
      } else if (index % 2 === 0) {
        return 'ticksMain';
      } else {
        return 'ticksSub';
      }
    },
    clickHandler: function clickHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && __WEBPACK_IMPORTED_MODULE_11__constants_ClassroomConstants__["a" /* default */].spareRooms.indexOf(argobj.classroom) !== -1) {
        return;
      }

      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["p" /* PREVIEWBOX_CLASSROOM_UPDATE */], argobj.classroom);
      var nearestTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
        start: nearestTime.toString(),
        end: nearestTime.addMinuites(60).toString()
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["q" /* PREVIEWBOX_SHOW_POPUP */]);

      if (this.$store.state.lectureInfo.length === 0) {
        this.$store.dispatch('getLectures', {});
      }
    },
    mousedownHandler: function mousedownHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && __WEBPACK_IMPORTED_MODULE_11__constants_ClassroomConstants__["a" /* default */].spareRooms.indexOf(argobj.classroom) !== -1) {
        alert('予備席には予約できません');
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && !this.isAfterRelease) {
        return;
      }
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.dragStartTime = new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */]('00:00');
      }

      this.mousedownTime = new Date().getTime();
      var nearestTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));
      var clickedTime = new Date(this.$store.state.curDate.getFullYear(), this.$store.state.curDate.getMonth(), this.$store.state.curDate.getDate(), nearestTime.getMinutes() / 60, nearestTime.getMinutes() % 60);
      this.isFuture = clickedTime.getTime() > this.mousedownTime;
      if (!this.isFuture && this.$store.state.userInfo.user_type !== 'admin') {
        alert('過去への予約は出来ません');
        return;
      }

      var now = new Date();
      var dateDiff = (new Date(clickedTime.getFullYear(), clickedTime.getMonth(), clickedTime.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 1000 / 60 / 60 / 24;
      this.isBeforeDeadLine = clickedTime.getDay() === 1 && (dateDiff > 2 || dateDiff === 2 && now.getHours() < 22) || clickedTime.getDay() !== 1 && (dateDiff > 1 || dateDiff === 1 && now.getHours() < 22);
      if (!this.isBeforeDeadLine && this.$store.state.userInfo.user_type !== 'admin') {
        alert('指定された時刻への予約は締め切られました');
        return;
      }
      this.dragStartTime = nearestTime;
      this.hasDraggingTl = true;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["p" /* PREVIEWBOX_CLASSROOM_UPDATE */], argobj.classroom);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
        start: this.dragStartTime.toString(),
        end: this.dragEndTime.toString()
      });
    },
    mousemoveHandler: function mousemoveHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && __WEBPACK_IMPORTED_MODULE_11__constants_ClassroomConstants__["a" /* default */].spareRooms.indexOf(argobj.classroom) !== -1) {
        return;
      }
      if (this.hasDraggingTl && (this.$store.state.userInfo.user_type === 'admin' || this.isFuture) && this.isBeforeDeadline) {
        if (this.timelineHeight - this.$store.state.rowHeight < argobj.e.offsetY) {
          argobj.e.offsetY = this.timelineHeight - this.$store.state.rowHeight;
        }

        this.dragEndTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));
        if (this.isReversed()) {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
            start: this.dragEndTime.toString(),
            end: this.dragStartTime.toString()
          });
          return;
        } else {
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
            end: this.dragEndTime.toString()
          });
        }
      }
    },
    mouseupHandler: function mouseupHandler(argobj) {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }

      if (this.$store.state.userInfo.user_type !== 'admin' && !this.isAfterRelease) {
        return;
      }
      if ((!this.isFuture || !this.isBeforeDeadline) && this.$store.state.userInfo.user_type !== 'admin') {
        return;
      }
      var mouseDownSpan = new Date().getTime() - this.mousedownTime;
      if (mouseDownSpan < this.clickthreshold) {
        this.clickHandler(argobj);
        this.mousedownTime = undefined;
        this.hasDraggingTl = false;
        return;
      }
      this.hasDraggingTl = false;
      var dragEndTime = this.fitToNearDivTime(this.positionToTime(argobj.e.offsetY));

      var nowTime = new Date().getTime();
      var mouseUpTime = new Date(this.getCurDateFormated + ' ' + dragEndTime.toString()).getTime();
      if (mouseUpTime < nowTime && this.$store.state.userInfo.user_type !== 'admin') {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], { start: '10:00', end: '10:00' });
        return;
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["q" /* PREVIEWBOX_SHOW_POPUP */]);

      if (this.isReversed()) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: dragEndTime.toString()
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          end: dragEndTime.toString()
        });
      }

      if (this.$store.state.lectureInfo.length === 0) {
        this.$store.dispatch('getLectures', {});
      }
    },
    stopDragging: function stopDragging() {
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return;
      }
      this.hasDraggingTl = false;
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["r" /* PREVIEWBOX_HIDE_POPUP */]);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["n" /* PREVIEWBOX_TIME_UPDATE */], {
          start: '10:00',
          end: '10:00'
        });
        this.dragStartTime = new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */]('00:00');
      }
    },
    dragoverHandler: function dragoverHandler(e) {
      e.preventDefault();
    },
    dropHandler: function dropHandler(e) {
      e.preventDefault();
      var clrect = this.$el.getBoundingClientRect();
      var offsets = JSON.parse(e.dataTransfer.getData('text/json'));
      var top = e.pageY - clrect.top - window.pageYOffset - offsets.y;
      var start = this.fitToNearDivTime(this.positionToTime(top)).toString();
      var span = new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */](this.$store.state.editingState.end).getMinutes() - new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */](this.$store.state.editingState.start).getMinutes();
      var end = this.fitToNearDivTime(this.positionToTime(top)).addMinuites(span).toString();

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["v" /* EDITINGBOX_TIME_UPDATE */], {
        start: start,
        end: end
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_mutation_types__["w" /* EDITINGBOX_CLASSROOM_UPDATE */], this.getClassroomAt(e.pageX - clrect.left - window.pageXOffset));
    },
    escHandler: function escHandler(event) {
      this.hasDraggingTl = false;
    },
    isReversed: function isReversed() {
      if (this.dragEndTime.getMinutes() < this.dragStartTime.getMinutes()) {
        return true;
      }
      return false;
    },
    isOver2200: function isOver2200(t) {
      if (t.getMinutes() > new __WEBPACK_IMPORTED_MODULE_3__modules_time__["a" /* default */]('22:00').getMinutes()) {
        return true;
      }
      return false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['timelinesWidth', 'timelineHeight', 'fitToNearDivTime', 'timeToPosition', 'positionToTime', 'getClassroomAt', 'getCurDateFormated', 'getLeftPosOfClassroom', 'classroomNames']), {
    getContainerStyle: function getContainerStyle() {
      var style = {
        width: this.timelinesWidth + 'px',
        height: this.timelineHeight + 'px'
      };

      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.left = this.$store.state.rulerWidth + 'px';
        style.top = this.$store.state.tbHeaderHeight + this.$store.state.headerHeight + 2 + 'px';
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute';
        style.left = this.$store.state.rulerWidth + 'px';
      } else if (this.$window.scrollY > 0) {
        style.position = 'relative';
        style.top = this.$store.state.tbHeaderHeight + 'px';
      } else {}
      return style;
    },
    isAfterRelease: function isAfterRelease() {
      var theday = new Date(2017, 10, 20, 14, 0, 0);
      var now = new Date();
      return now.getTime() > theday.getTime();
    },
    filteredreservation: function filteredreservation() {
      if (this.$store.state.userInfo.user_type !== 'admin' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'viewer') {
        if (this.$store.state.reservations !== undefined) {
          this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
            return !c.classroom.match('301');
          });
        }
      }
      console.log(this.$store.state.reservations);
      if (this.$store.state.showOnline) {
        this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
          return c.classroom.match(/^オンライン/);
        });
      } else {
        this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
          return !c.classroom.match(/^オンライン/);
        });
      }
      console.log(this.$store.state.reservations);
      return this.$store.state.reservations;
    }
  })
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tl-header',
  props: ['classroom'],
  computed: {
    getStyle: function getStyle() {
      var style = {
        width: this.$store.state.columnWidth + 'px',
        height: this.$store.state.tbHeaderHeight + 'px',
        'border-top-style': 'none',
        'border-top-width': '0px'
      };
      return style;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__vuex_mutation_types__["J" /* UPDATE_HEADER_HEIGHT */], _this.$el.getBoundingClientRect().height);
    });
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimetableHeader__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimetableHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TimetableHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimetableBody__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimetableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TimetableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RefreshButton__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RefreshButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RefreshButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timetable',
  props: [],
  data: function data() {
    return {
      style: {}
    };
  },

  components: {
    'timetable-header': __WEBPACK_IMPORTED_MODULE_1__TimetableHeader___default.a,
    'timetable-body': __WEBPACK_IMPORTED_MODULE_2__TimetableBody___default.a,
    'refresh-button': __WEBPACK_IMPORTED_MODULE_3__RefreshButton___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['tableWidth', 'getCurDateFormated']), {
    getStyle: function getStyle() {
      this.style.width = this.tableWidth + 'px';
      return this.style;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getReservations', 'getLectures', 'getClassrooms', 'getAttendance'])),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.all([this.getReservations({
      all: 1,
      date: this.getCurDateFormated,
      school_id: this.$store.state.userInfo.school_id
    }), this.$store.dispatch('getLectures', {}), this.$store.dispatch('getUserInfo')]).then(__WEBPACK_IMPORTED_MODULE_5_axios___default.a.spread(function (res1, res2, res3) {
      if (_this.$store.state.userInfo.user_type === 'admin') {
        _this.$store.dispatch('getAttendance');
      }
    })).then(function () {
      _this.getClassrooms(_this.$store.state.userInfo.school_id);
    });
  },
  created: function created() {
    this.getClassrooms(this.$store.state.userInfo.school_id);
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ticker__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ticker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Ticker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineContainer__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TimelineContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Ruler__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Ruler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Ruler__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'ticker': __WEBPACK_IMPORTED_MODULE_0__Ticker___default.a,
    'ruler': __WEBPACK_IMPORTED_MODULE_2__Ruler___default.a,
    'timeline-container': __WEBPACK_IMPORTED_MODULE_1__TimelineContainer___default.a
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineHeader__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TimelineHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RulerHeader__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RulerHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RulerHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timetable-header',
  data: function data() {
    return {
      classroom: '',
      lastOnlineState: false
    };
  },

  props: ['classrooms'],
  components: {
    'timeline-header': __WEBPACK_IMPORTED_MODULE_1__TimelineHeader___default.a,
    'ruler-header': __WEBPACK_IMPORTED_MODULE_2__RulerHeader___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['classroomNames', 'tableWidth']), {
    getStyle: function getStyle() {
      var style = {};
      style.width = this.tableWidth + 'px';
      if (this.$window.scrollY > 0) {
        style.position = 'absolute';
        style.top = this.$window.scrollY + 50 + 'px';
        style['z-index'] = 1003;
        style['border-top-style'] = 'solid';
        style['border-top-width'] = '2px';
        style['border-top-color'] = 'black';
      }
      return style;
    },
    filteredclassroomNames: function filteredclassroomNames() {
      if (this.lastOnlineState !== this.$store.state.showOnline) {
        console.log('getting classrooms');
        this.getClassrooms(this.$store.state.userInfo.school_id);
      }
      this.classroom = this.$store.state.classrooms;
      this.lastOnlineState = this.$store.state.showOnline;
      if (this.$store.state.showOnline) {
        this.classroom = this.classroom.filter(function (c) {
          return c.name.match(/^オンライン/);
        });
      } else {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match(/^オンライン/);
        });
      }
      if (this.$store.state.userInfo.user_type !== 'viewer' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'admin') {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match('301');
        });
        this.$store.state.classrooms = this.classroom;
        return this.classroom;
      }
      this.$store.state.classrooms = this.classroom;
      return this.classroom;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getClassrooms', 'getReservations']))
});

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 124,
	"./af.js": 124,
	"./ar": 131,
	"./ar-dz": 125,
	"./ar-dz.js": 125,
	"./ar-kw": 126,
	"./ar-kw.js": 126,
	"./ar-ly": 127,
	"./ar-ly.js": 127,
	"./ar-ma": 128,
	"./ar-ma.js": 128,
	"./ar-sa": 129,
	"./ar-sa.js": 129,
	"./ar-tn": 130,
	"./ar-tn.js": 130,
	"./ar.js": 131,
	"./az": 132,
	"./az.js": 132,
	"./be": 133,
	"./be.js": 133,
	"./bg": 134,
	"./bg.js": 134,
	"./bm": 135,
	"./bm.js": 135,
	"./bn": 136,
	"./bn.js": 136,
	"./bo": 137,
	"./bo.js": 137,
	"./br": 138,
	"./br.js": 138,
	"./bs": 139,
	"./bs.js": 139,
	"./ca": 140,
	"./ca.js": 140,
	"./cs": 141,
	"./cs.js": 141,
	"./cv": 142,
	"./cv.js": 142,
	"./cy": 143,
	"./cy.js": 143,
	"./da": 144,
	"./da.js": 144,
	"./de": 147,
	"./de-at": 145,
	"./de-at.js": 145,
	"./de-ch": 146,
	"./de-ch.js": 146,
	"./de.js": 147,
	"./dv": 148,
	"./dv.js": 148,
	"./el": 149,
	"./el.js": 149,
	"./en-au": 150,
	"./en-au.js": 150,
	"./en-ca": 151,
	"./en-ca.js": 151,
	"./en-gb": 152,
	"./en-gb.js": 152,
	"./en-ie": 153,
	"./en-ie.js": 153,
	"./en-il": 154,
	"./en-il.js": 154,
	"./en-nz": 155,
	"./en-nz.js": 155,
	"./eo": 156,
	"./eo.js": 156,
	"./es": 159,
	"./es-do": 157,
	"./es-do.js": 157,
	"./es-us": 158,
	"./es-us.js": 158,
	"./es.js": 159,
	"./et": 160,
	"./et.js": 160,
	"./eu": 161,
	"./eu.js": 161,
	"./fa": 162,
	"./fa.js": 162,
	"./fi": 163,
	"./fi.js": 163,
	"./fo": 164,
	"./fo.js": 164,
	"./fr": 167,
	"./fr-ca": 165,
	"./fr-ca.js": 165,
	"./fr-ch": 166,
	"./fr-ch.js": 166,
	"./fr.js": 167,
	"./fy": 168,
	"./fy.js": 168,
	"./gd": 169,
	"./gd.js": 169,
	"./gl": 170,
	"./gl.js": 170,
	"./gom-latn": 171,
	"./gom-latn.js": 171,
	"./gu": 172,
	"./gu.js": 172,
	"./he": 173,
	"./he.js": 173,
	"./hi": 174,
	"./hi.js": 174,
	"./hr": 175,
	"./hr.js": 175,
	"./hu": 176,
	"./hu.js": 176,
	"./hy-am": 177,
	"./hy-am.js": 177,
	"./id": 178,
	"./id.js": 178,
	"./is": 179,
	"./is.js": 179,
	"./it": 180,
	"./it.js": 180,
	"./ja": 181,
	"./ja.js": 181,
	"./jv": 182,
	"./jv.js": 182,
	"./ka": 183,
	"./ka.js": 183,
	"./kk": 184,
	"./kk.js": 184,
	"./km": 185,
	"./km.js": 185,
	"./kn": 186,
	"./kn.js": 186,
	"./ko": 187,
	"./ko.js": 187,
	"./ky": 188,
	"./ky.js": 188,
	"./lb": 189,
	"./lb.js": 189,
	"./lo": 190,
	"./lo.js": 190,
	"./lt": 191,
	"./lt.js": 191,
	"./lv": 192,
	"./lv.js": 192,
	"./me": 193,
	"./me.js": 193,
	"./mi": 194,
	"./mi.js": 194,
	"./mk": 195,
	"./mk.js": 195,
	"./ml": 196,
	"./ml.js": 196,
	"./mn": 197,
	"./mn.js": 197,
	"./mr": 198,
	"./mr.js": 198,
	"./ms": 200,
	"./ms-my": 199,
	"./ms-my.js": 199,
	"./ms.js": 200,
	"./mt": 201,
	"./mt.js": 201,
	"./my": 202,
	"./my.js": 202,
	"./nb": 203,
	"./nb.js": 203,
	"./ne": 204,
	"./ne.js": 204,
	"./nl": 206,
	"./nl-be": 205,
	"./nl-be.js": 205,
	"./nl.js": 206,
	"./nn": 207,
	"./nn.js": 207,
	"./pa-in": 208,
	"./pa-in.js": 208,
	"./pl": 209,
	"./pl.js": 209,
	"./pt": 211,
	"./pt-br": 210,
	"./pt-br.js": 210,
	"./pt.js": 211,
	"./ro": 212,
	"./ro.js": 212,
	"./ru": 213,
	"./ru.js": 213,
	"./sd": 214,
	"./sd.js": 214,
	"./se": 215,
	"./se.js": 215,
	"./si": 216,
	"./si.js": 216,
	"./sk": 217,
	"./sk.js": 217,
	"./sl": 218,
	"./sl.js": 218,
	"./sq": 219,
	"./sq.js": 219,
	"./sr": 221,
	"./sr-cyrl": 220,
	"./sr-cyrl.js": 220,
	"./sr.js": 221,
	"./ss": 222,
	"./ss.js": 222,
	"./sv": 223,
	"./sv.js": 223,
	"./sw": 224,
	"./sw.js": 224,
	"./ta": 225,
	"./ta.js": 225,
	"./te": 226,
	"./te.js": 226,
	"./tet": 227,
	"./tet.js": 227,
	"./tg": 228,
	"./tg.js": 228,
	"./th": 229,
	"./th.js": 229,
	"./tl-ph": 230,
	"./tl-ph.js": 230,
	"./tlh": 231,
	"./tlh.js": 231,
	"./tr": 232,
	"./tr.js": 232,
	"./tzl": 233,
	"./tzl.js": 233,
	"./tzm": 235,
	"./tzm-latn": 234,
	"./tzm-latn.js": 234,
	"./tzm.js": 235,
	"./ug-cn": 236,
	"./ug-cn.js": 236,
	"./uk": 237,
	"./uk.js": 237,
	"./ur": 238,
	"./ur.js": 238,
	"./uz": 240,
	"./uz-latn": 239,
	"./uz-latn.js": 239,
	"./uz.js": 240,
	"./vi": 241,
	"./vi.js": 241,
	"./x-pseudo": 242,
	"./x-pseudo.js": 242,
	"./yo": 243,
	"./yo.js": 243,
	"./zh-cn": 244,
	"./zh-cn.js": 244,
	"./zh-hk": 245,
	"./zh-hk.js": 245,
	"./zh-tw": 246,
	"./zh-tw.js": 246
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;

/***/ }),
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhJAAPAMQQAPfXzOR6Vfzy7txSIvK8qu+vmfTKu+JsRN9fM+eHZtpEEeqUd/rk3eyiiP///9c3AP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFlgAQACwAAAAAJAAPAAAFm+AjjmRpnmiqrmzrmo6gPI0zOrjDiIT9GI7Bg7ETORol3ILme+gajeVj4QgMqw+B4YYk6Xa1W3EUcCwGT7TU2b0VzGHjmBsQMAhlq7G9JwDiTjltAAwLDA2FTWxJDQcOQGJQeg9+BQULAohefIuETTomVIWOAAUkAUKbDwk4kVEjjg4IgQkkAACMIgyfOXMxurK2uC/ExcbHyCQhACH5BAUKABAALAMAAQAGAAsAAAUjoCMoUOOcS+lADAO9UOGkb0MAcHM4BvywvsTK93r8jMjiIwQAIfkEBQoAEAAsAwABAA4ACwAABT/gI0IjBDmow0CCYr4n0zTLWcMmIz4Qo+OmHaTguMFSDRMBkMTNAqaDw4DTlSCAFRBiTDhwKYajKX7trsDzIwQAIfkEBQoAEAAsAwABABoACwAABXzgI45k+RCOaDjDwzDm6MwO/CxO4OaPsAqKRyMlqjUaC1HAsRgYnTimkPiomRyNgIBBWC5fU5mNBGAsGA1zylFgDmW0xogAKBQWgnS1QX8X0VkjOGYHDnV7hStiJoUOCFUOCXsPZVRGSCQOAiIMjpMJM3AzYzFFcjulqSMhACH5BAUKABAALAwAAQAWAAsAAAVo4COOZFk6jfkQjmg4w8MwI+rcDv0sTiD3D4Gh1sg1GgtRwLEYGJ1JkU1HQgUEDMLSJy1SRwDGgtEQt4g41IgAKBQWgjIp4CQ3uLvc4uBokwAAOSZ8DggPNwl/gXZRUgIiDIUmaV8qJiEAIfkEBQoAEAAsEwABAA8ACwAABU/gI45kaZ5OQzii4QwPw4zp4gTx/QgG3QSOxcDBaAwXvkcqIGAQgDhR6gFgLIpWVpIAKBQWgsZsFIDZrAdHlwQAPNIOhNKRYLuVAhEjbgoBADs="

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/報告書説明.b7cf0ae.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(695),
  /* scopeId */
  "data-v-4542f3a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  "data-v-1b834834",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  "data-v-2239a1dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(490)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  "data-v-05a175c5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(689),
  /* scopeId */
  "data-v-38de5644",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  "data-v-bcd4aea0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  "data-v-18763524",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(489)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  "data-v-04a074d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  "data-v-58251128",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  "data-v-785963ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  "data-v-5b5eb55d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(706),
  /* scopeId */
  "data-v-4eaa402a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(685),
  /* scopeId */
  "data-v-36216f29",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  "data-v-1f11f081",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  "data-v-70a30bc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  "data-v-59996ed1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  "data-v-5b6c72a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  "data-v-587d7a7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  "data-v-18474b8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  "data-v-5f1e0f18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  "data-v-7a9171d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  "data-v-fb7a68ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(691),
  /* scopeId */
  "data-v-3ccb94f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  "data-v-e06c833c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(697),
  /* scopeId */
  "data-v-4622845c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  "data-v-b32a1496",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  "data-v-cf95ff40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(698),
  /* scopeId */
  "data-v-4726fee8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  "data-v-02e8f8b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  "data-v-785946d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  "data-v-0aa223d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(682),
  /* scopeId */
  "data-v-31af4561",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  "data-v-50e9d393",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  "data-v-a9f9fc18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  "data-v-1d5e30ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  "data-v-8de6e8da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  "data-v-4560d364",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  "data-v-5db4e41e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  "data-v-445cf68a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  "data-v-aed3b6ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  "data-v-80d6c638",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  "data-v-55a74192",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  "data-v-61f48e50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  "data-v-ad663b42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  "data-v-7f694aac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-e91c654c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  "data-v-15ef8389",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  "data-v-201dfa4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-0af810e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  "data-v-a3103a68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  "data-v-4b18ec90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  "data-v-56c25c76",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  "data-v-918a0c92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  "data-v-7cb9a1d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(703),
  /* scopeId */
  "data-v-4a78af74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(687),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(692),
  /* scopeId */
  "data-v-42fb67fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  "data-v-4b7db8e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(690),
  /* scopeId */
  "data-v-3a08ebf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(699),
  /* scopeId */
  "data-v-47a6e666",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--pencil",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 677.34762 182.15429"
    }
  }, [_c('g', [_c('path', {
    staticClass: "body-pencil",
    attrs: {
      "d": "M128.273 0l-3.9 2.77L0 91.078l128.273 91.076 549.075-.006V.008L128.273 0zm20.852 30l498.223.006V152.15l-498.223.007V30zm-25 9.74v102.678l-49.033-34.813-.578-32.64 49.61-35.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M134.482 157.147v25l518.57.008.002-25-518.572-.008z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.editingState.isPopupShown) ? _c('div', {
    attrs: {
      "id": "editingPopup"
    }
  }, [_c('span', [_vm._v("予約の編集")]), _c('br'), _vm._v(" "), _c('a', [_vm._v("現在の教室:" + _vm._s(_vm.$store.state.editingState.classroom))]), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.changeClassroomLeft()
      }
    }
  }, [_vm._v("教室を左に移動")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.changeClassroomRight()
      }
    }
  }, [_vm._v("教室を右に移動")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "editingForm"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('table', {
    class: {
      errorDuplication: _vm.isSomeDuplicatedReservation
    },
    attrs: {
      "title": _vm.isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : ''
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.editingState.start),
      expression: "$store.state.editingState.start"
    }],
    staticClass: "time_Selector",
    attrs: {
      "type": "time",
      "min": "10:00",
      "max": "23:00"
    },
    domProps: {
      "value": (_vm.$store.state.editingState.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.editingState, "start", $event.target.value)
      }
    }
  })]), _vm._v("〜\n        "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.editingState.end),
      expression: "$store.state.editingState.end"
    }],
    staticClass: "time_Selector",
    attrs: {
      "type": "time",
      "min": "10:00",
      "max": "23:00"
    },
    domProps: {
      "value": (_vm.$store.state.editingState.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.editingState, "end", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n          "), _c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationType),
      expression: "reservationType"
    }],
    attrs: {
      "name": "example"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reservationType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("通常")]), _vm._v(" "), _c('option', [_vm._v("通常初回")]), _vm._v(" "), _c('option', [_vm._v("体験")]), _vm._v(" "), _c('option', [_vm._v("短期")]), _vm._v(" "), _c('option', [_vm._v("短期初回")])]), _vm._v("\n            授業\n        ")])])]), _vm._v(" "), _c('div', [(!_vm.isTanki) ? [_c('div', [_c('span', [_vm._v("生徒のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'student') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getStudentList(),
      "type": 'student',
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getStudentList(),
      "type": 'admin',
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })]], 2), _vm._v(" "), _c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'teacher',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'admin',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]] : _vm._e()], 2), _vm._v(" "), (!_vm.isTanki) ? [(_vm.isRecurrent) ? _c('recurrent-panel') : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n                  有り\n                ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n                  無し\n                ")])])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isOnline()
    },
    on: {
      "change": function($event) {
        _vm.$store.commit('EDITINGSTATE_SET_IS_ONLINE', !_vm.isOnline())
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": _vm.message()
    },
    on: {
      "input": function($event) {
        _vm.$store.commit('EDITINGSTATE_SET_MESSAGE', $event.target.value)
      }
    }
  }), _vm._v(" "), (false) ? _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllEditing),
      expression: "isAllEditing"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllEditing) ? _vm._i(_vm.isAllEditing, null) > -1 : (_vm.isAllEditing)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isAllEditing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllEditing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isAllEditing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllEditing = $$c
        }
      }
    }
  }), _vm._v("\n                以降の予約全てを変更する\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ender"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "編集を完了する",
      "disabled": !_vm.canTakeResv
    },
    on: {
      "click": _vm.completeEdit
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "eraseButton",
      "type": "button",
      "value": "予約を削除する"
    },
    on: {
      "click": _vm.eraseReservation
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "キャンセル"
    },
    on: {
      "click": _vm.closePopup
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.isTanki) ? [_c('temporaryLecturePanel', {
    attrs: {
      "teacher": _vm.teacher,
      "isEdit": true,
      "reservationType": _vm.reservationType
    }
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'teacher',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'admin',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "変更の確認",
      "visible": _vm.dialogEditVisible,
      "width": "80%",
      "modal-append-to-body": false,
      "top": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEditVisible = $event
      }
    }
  }, [_c('p', [_vm._v("この予約は月末まで毎週予約されています。")]), _vm._v(" "), _c('p', [_vm._v("以降の予約を全て変更しますか？この予約のみを変更しますか？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function () {
        _vm.isAllEditing = true
        _vm.dialogEditVisible = false
        _vm.doEdit()
      }
    }
  }, [_vm._v("\n              以降の予約全てを変更\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function () {
        _vm.isAllEditing = false
        _vm.dialogEditVisible = false
        _vm.doEdit()
      }
    }
  }, [_vm._v("\n              この予約のみ変更\n            ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "削除の確認",
      "visible": _vm.dialogDeleteVisible,
      "width": "80%",
      "modal-append-to-body": false,
      "top": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDeleteVisible = $event
      }
    }
  }, [_c('p', [_vm._v("この予約は月末まで毎週予約されています。")]), _vm._v(" "), _c('p', [_vm._v("以降の予約を全て削除しますか？この予約のみを削除しますか？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function () {
        _vm.isAllEditing = true
        _vm.dialogDeleteVisible = false
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n              以降の予約全てを削除\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function () {
        _vm.isAllEditing = false
        _vm.dialogDeleteVisible = false
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n              この予約のみ削除\n            ")])], 1)])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("時間: ")])])
}]}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "managementPage"
    }
  }, [_c('div', {
    staticClass: "side-menu"
  }, [_c('p', [_vm._v("メニュー")]), _vm._v(" "), _c('ul', {
    staticClass: "side-menu-items"
  }, [_c('router-link', {
    attrs: {
      "to": "/management/users",
      "tag": "li"
    }
  }, [_vm._v("\n        ユーザー一覧\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/user_registration",
      "tag": "li"
    }
  }, [_vm._v("\n        ユーザー登録\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/lecture_registration",
      "tag": "li"
    }
  }, [_vm._v("\n        講義情報編集\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/classroom_registration",
      "tag": "li"
    }
  }, [_vm._v("\n        教室情報編集\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/reschedulings",
      "tag": "li"
    }
  }, [_vm._v("\n        振替依頼一覧\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/information",
      "tag": "li"
    }
  }, [_vm._v("\n        お知らせ\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/InformationNotification",
      "tag": "li"
    }
  }, [_vm._v("\n        通知\n      ")])], 1)]), _vm._v(" "), _c('router-view', {
    staticClass: "child-component"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editClassroomPage"
    }
  }, [_c('p', {
    staticClass: "schoolTab"
  }), _vm._v(" "), _c('table', {
    attrs: {
      "id": "userPartnerList"
    }
  }, [_c('caption', [_vm._v("教室の情報を変更します．")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.$store.state.classrooms), function(classroom, index) {
    return (classroom.school_id == _vm.$store.state.userInfo.school_id) ? _c('tr', {
      key: classroom.id,
      class: {
        evenRow: index % 2 === 0
      }
    }, [_c('td', [_vm._v(_vm._s(classroom.id))]), _vm._v(" "), (_vm.editingId !== classroom.id) ? _c('td', {
      on: {
        "dblclick": function($event) {
          _vm.startEditClassroom(classroom.id)
        }
      }
    }, [_c('pre', {
      staticClass: "classroom-name"
    }, [_vm._v(_vm._s(classroom.name))])]) : _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingClassroomName),
        expression: "editingClassroomName"
      }],
      attrs: {
        "rows": "3"
      },
      domProps: {
        "value": (_vm.editingClassroomName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingClassroomName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.editClassroomName()
        }
      }
    }, [_vm._v("変更")]), _vm._v(" "), _c('button', {
      on: {
        "click": _vm.cancelEdit
      }
    }, [_vm._v("キャンセル")])]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.eraseClassroom(classroom)
        }
      }
    }, [_vm._v("x")])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("教室を追加する")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.classroomName),
      expression: "classroomName"
    }],
    attrs: {
      "placeholder": "教室名を入力してください"
    },
    domProps: {
      "value": (_vm.classroomName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.classroomName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    on: {
      "click": function($event) {
        _vm.addClassroom()
      }
    }
  }, [_vm._v("追加")])])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          ID\n        ")]), _vm._v(" "), _c('th', [_vm._v("教室名")]), _vm._v(" "), _c('th', [_vm._v("削除")])])])
}]}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasHeight) ? _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "previewBox"
    },
    on: {
      "mousedown": function($event) {
        _vm.mousedownHandler($event)
      },
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.$emit('keyup.esc')
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$store.state.previewBox.start) + " ~\n  " + _vm._s(_vm.$store.state.previewBox.end) + "\n  "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "show_reservationpopup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_reservationpopup()
      }
    }
  }, [_vm._v("予約を作成する")]), _c('br')]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userinfo"
    }
  }, [_c('h1', [_vm._v("ユーザー情報")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "user_information",
      "border": "1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cate1"
  }, [_vm._v("\n          名前\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          :\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.$store.state.userInfo.fullname) + "（" + _vm._s(_vm.userType) + "）\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cate1"
  }, [_vm._v("ユーザー名(ID)")]), _vm._v(" "), _c('td', [_vm._v("\n          :\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.user_name))])])])]), _vm._v(" "), (_vm.$store.state.userInfo.user_type !== 'viewer') ? _c('div', [_c('password-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id
    }
  }), _vm._v(" "), _c('user-name-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id,
      "current_user_name": _vm.$store.state.userInfo.user_name
    },
    on: {
      "changed": function($event) {
        _vm.getUserInfo()
      }
    }
  }), _vm._v(" "), _c('mail-address-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id,
      "current_mail": _vm.$store.state.userInfo.mail_address
    }
  }), _vm._v(" "), _c('status-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id,
      "current_status": _vm.$store.state.userInfo.status
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "square_btn1",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getinformation
    }
  }, [_vm._v("OK")])])
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "recurrentReservePanel"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temporaryLecturePanel"
    }
  }, [_c('div', [_c('p', [_vm._v("生徒のお名前")]), _vm._v(" "), _c('div', {
    staticClass: "student-name-block"
  }, [_c('div', [_c('p', [_vm._v("氏名(必須)　　："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    attrs: {
      "id": "fullname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }, _vm.handleNameInput]
    }
  })]), _vm._v(" "), _c('p', [_vm._v("フリガナ(任意)："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kana),
      expression: "kana"
    }],
    attrs: {
      "id": "kana",
      "type": "text"
    },
    domProps: {
      "value": (_vm.kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kana = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', [_vm._t("default")], 2), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n      有り\n    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n      無し\n    ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isEdit) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reserve()
      }
    }
  }, [_vm._v("予約する")]) : [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reserve()
      }
    }
  }, [_vm._v("編集の完了をする")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "eraseButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteResv()
      }
    }
  }, [_vm._v("予約の削除をする")])], _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel()
      }
    }
  }, [_vm._v("キャンセル")])], 2)
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temporaryLecturePanel"
    }
  }, [_c('div', [_c('p', [_vm._v("生徒のお名前")]), _vm._v(" "), _c('div', {
    staticClass: "student-name-block"
  }, [_c('div', [_c('p', [_vm._v("氏名(必須)　　："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    attrs: {
      "id": "fullname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }, _vm.handleNameInput]
    }
  })]), _vm._v(" "), _c('p', [_vm._v("フリガナ(任意)："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kana),
      expression: "kana"
    }],
    attrs: {
      "id": "kana",
      "type": "text"
    },
    domProps: {
      "value": (_vm.kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kana = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', [_vm._t("default")], 2), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n      有り\n    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n      無し\n    ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isEdit) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reserve()
      }
    }
  }, [_vm._v("予約する")]) : [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reserve()
      }
    }
  }, [_vm._v("編集の完了をする")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "eraseButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteResv()
      }
    }
  }, [_vm._v("予約の削除をする")])], _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel()
      }
    }
  }, [_vm._v("キャンセル")])], 2)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "id": "helpPage"
    }
  }, [_c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("座席予約表を見る")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("予約・変更・削除の締め切りは前日22時です（翌週月曜の座席予約は土曜22時までとなっております）")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1",
    staticStyle: {
      "tcolor": "red"
    }
  }, [_vm._v("上記時刻を過ぎて予約をしたい場合は、究進塾事務局(info@kyushinjuku.com)へご連絡ください")]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約をする")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl",
    staticStyle: {
      "color": "#5B5B5B"
    }
  }, [_c('li', [_vm._v("予約したい時刻と、予約したい教室がクロスするマスをクリック")]), _vm._v(" "), _c('li', [_vm._v("「開始時間」「終了時間」「授業の種類（通常・体験・初回・短期）」「生徒のお名前」「先生のお名前」「配布物（有り・無し）」「連絡事項（必要であれば記入）」を記入")]), _vm._v(" "), _c('li', [_vm._v("「予約する」をクリック")])]), _vm._v(" "), _c('p', {
    staticClass: "caption cap2"
  }, [_vm._v("同時間帯・同教室で月末まで予約したい場合は、「月末まで毎週予約する」にチェックを入れてください")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※予約時に、「生徒のお名前」に担当生徒の氏名が表示されない場合※")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("先生と生徒の紐づけが未完了です")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("恐れ入りますが、究進塾事務局(info@kyushinjuku.com)へご連絡ください。また、臨時的に下記手順でご予約をお願い致します。")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl",
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('li', [_vm._v("「授業の種類」で「短期」を選択")]), _vm._v(" "), _c('li', [_vm._v("「生徒のお名前」を “直接” 入力")])])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約を変更する")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("変更したい予約をクリック")]), _vm._v(" "), _c('li', [_vm._v("ポップアップの最下部「編集する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("予約を編集")]), _vm._v(" "), _c('li', [_vm._v("「編集を完了する」をクリック")])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約を削除する")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("削除したい予約をクリック")]), _vm._v(" "), _c('li', [_vm._v("ポップアップの最下部「編集する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("「予約を削除する」をクリック")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("振替依頼")]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をする場合")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("座席予約表へログイン後、画面左上の「振替を依頼する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2"
  }, [_c('li', [_vm._v("①振替を希望する授業をリストから選択")]), _vm._v(" "), _c('li', [_vm._v("②振替候補日時を選択")]), _vm._v(" "), _c('li', [_vm._v("③振替を希望する理由を入力")]), _vm._v(" "), _c('li', [_vm._v("（講師のみ、④振替後の授業の情報を入力）")])]), _vm._v(" "), _c('li', [_vm._v("入力項目を確認し、「振替依頼をする」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("完了画面を確認し、「座席表トップへ」をクリック")])]), _vm._v(" "), _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("振替依頼をしたあとは・・・")]), _vm._v(" "), _c('p', [_vm._v("24時間以内に振替の承認・不承認の結果がメールで届きます。"), _c('br'), _vm._v("\n\t\t\t承認された場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n\t\t\t不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。")])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をされた場合")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く")]), _vm._v(" "), _c('li', [_vm._v("メール内のURLをクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①振替候補日時からご都合の良い日時を選択")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②振替後の授業を予約する座席を選択")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替を確定する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表トップへ」をクリック")])]), _c('br'), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【不承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①「振替を不承認する」にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②他の振替候補日時を入力")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替依頼を不承認する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表」をクリック")])])])]), _vm._v(" "), _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("承認/不承認をしたあとは・・・")]), _vm._v("\n\t\t\t承認・不承認の結果がメールで依頼者に届きます。"), _c('br'), _vm._v("\n\t\t\t承認した場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n\t\t\t不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。\n\t")]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1"
  }, [_vm._v("ヘルプ")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1"
  }, [_vm._v("本画面です")]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1"
  }, [_vm._v("ユーザ情報")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1"
  }, [_vm._v("パスワードおよびユーザ名（ID）の変更が出来ます")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※ご注意ください※")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("初回設定以外のパスワードに変更される場合は、"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("事務局では変更内容を確認出来ません")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("変更後のパスワードは各個人で保管いただきますようお願い申し上げます")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('p', {
    staticClass: "cap1",
    staticStyle: {
      "text-align": "left",
      "margin-left": "40px",
      "font-size": "14px",
      "color": "#5B5B5B",
      "margin-top": "10px"
    }
  }, [_vm._v("ログアウトが出来ます")]), _vm._v(" "), _c('p', {
    staticClass: "cap1",
    staticStyle: {
      "text-align": "left",
      "margin-left": "40px",
      "font-size": "14px",
      "color": "red",
      "margin-bottom": "100px"
    }
  }, [_vm._v("究進塾のPCで座席予約表を操作される場合は、セキュリティ上必ずログアウトしていただきますようお願い致します")])])
}]}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reservationListPage"
    }
  }, [_c('h2', [_vm._v("予約リスト")]), _vm._v(" "), _c('div', {
    staticClass: "cp_iptxt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Keyword),
      expression: "Keyword"
    }],
    staticClass: "ef",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("お名前")]), _vm._v(" "), _c('span', {
    staticClass: "focus_line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    attrs: {
      "type": "month"
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "reservationList",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.SortedList), function(reservation, index) {
    return _c('tr', {
      key: reservation.id,
      class: {
        evenRow: index % 2 === 0
      }
    }, [_c('td', {
      staticClass: "colID"
    }, [_vm._v(_vm._s(reservation.id))]), _vm._v(" "), _c('td', {
      staticClass: "colDate"
    }, [_vm._v(_vm._s(reservation.date))]), _vm._v(" "), _c('td', {
      staticClass: "colStartTime"
    }, [_vm._v(_vm._s(reservation.start_time.slice(0, 5)))]), _vm._v(" "), _c('td', {
      staticClass: "colEndTime"
    }, [_vm._v(_vm._s(reservation.end_time.slice(0, 5)))]), _vm._v(" "), _c('td', {
      staticClass: "colStudent"
    }, [_vm._v(_vm._s(reservation.student.fullname))]), _vm._v(" "), _c('td', {
      staticClass: "colTeacher"
    }, [_vm._v(_vm._s(reservation.teacher.fullname))]), _vm._v(" "), _c('td', {
      staticClass: "colClassroom"
    }, [_vm._v(_vm._s(reservation.classroom))]), _vm._v(" "), _c('td', {
      staticClass: "colRecurrence"
    }, [_vm._v(_vm._s(_vm.getWhetherRecurrent(reservation.recurrence_id)))]), _vm._v(" "), _c('td', {
      staticClass: "colOnline"
    }, [_vm._v(_vm._s(Number(reservation.online) === 1 ? "オンライン" : "対面"))])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bluedBackground"
  }, [_c('th', {
    staticClass: "colID"
  }, [_vm._v("予約番号")]), _vm._v(" "), _c('th', {
    staticClass: "colDate"
  }, [_vm._v("日付")]), _vm._v(" "), _c('th', {
    staticClass: "colStartTime"
  }, [_vm._v("開始時刻")]), _vm._v(" "), _c('th', {
    staticClass: "colEndTime"
  }, [_vm._v("終了時刻")]), _vm._v(" "), _c('th', {
    staticClass: "colStudent"
  }, [_vm._v("生徒名")]), _vm._v(" "), _c('th', {
    staticClass: "colTeacher"
  }, [_vm._v("教師名")]), _vm._v(" "), _c('th', {
    staticClass: "colClassroom"
  }, [_vm._v("教室名")]), _vm._v(" "), _c('th', {
    staticClass: "colRecurrence"
  }, [_vm._v("繰り返し予約")]), _vm._v(" "), _c('th', {
    staticClass: "colOnline"
  }, [_vm._v("授業形態")])])
}]}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SpSenderForm"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼をする")]), _vm._v(" "), (_vm.check_tankiuser()) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.check_tankiuser()) ? _c('div', [_c('section', {
    staticClass: "section",
    attrs: {
      "id": "first-section"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("振替を希望する授業を以下のリストから選択してください")]), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.selectedReservation && !_vm.isOther) ? _c('div', {
    key: "warning-first-unselected"
  }, [_c('notificationBox', {
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "振替を希望する授業を選択してください"
    }
  })], 1) : (_vm.isCompletenessChecking && !_vm.isFirstCompleted) ? _c('notificationBox', {
    key: "warning-first-unspecified",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "授業の情報を全て指定してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isFirstCompleted) ? _c('notificationBox', {
    key: "ok-first",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("授業数：" + _vm._s(_vm.reservations.length) + "件")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "reservation-list"
    }
  }, _vm._l((_vm.reservations), function(reservation, index) {
    return _c('li', {
      key: 'reservation' + index,
      staticClass: "list-item list-item-reservation"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedReservation),
        expression: "selectedReservation"
      }],
      attrs: {
        "id": 'list-item-reservation-radio' + index,
        "type": "radio",
        "disabled": _vm.isOther || reservation.expireCheck
      },
      domProps: {
        "value": reservation,
        "checked": _vm._q(_vm.selectedReservation, reservation)
      },
      on: {
        "change": [function($event) {
          _vm.selectedReservation = reservation
        }, function($event) {
          _vm.reservationChanged()
        }]
      }
    }), _vm._v(" "), (!reservation.expireCheck) ? _c('label', {
      attrs: {
        "for": 'list-item-reservation-radio' + index
      }
    }, [_vm._v(_vm._s(reservation.text))]) : _c('label', {
      staticStyle: {
        "color": "#989898"
      },
      attrs: {
        "for": 'list-item-reservation-radio' + index
      },
      on: {
        "click": function($event) {
          _vm.alert('授業振替ではなく授業キャンセルとなるので、別途究進塾にご連絡（電話orメール）ください')
        }
      }
    }, [_vm._v(_vm._s(reservation.text) + "  期限切れです")])])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOther),
      expression: "isOther"
    }],
    attrs: {
      "id": "otherCheck",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOther) ? _vm._i(_vm.isOther, null) > -1 : (_vm.isOther)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isOther,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOther = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOther = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOther = $$c
        }
      }, function($event) {
        _vm.reservationChanged()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "otherCheck"
    }
  }, [_vm._v("上記以外の授業")]), _vm._v(" "), (_vm.isOther) ? _c('div', {
    key: "other-reservation",
    attrs: {
      "id": "other-reservation-box"
    }
  }, [(_vm.$store.state.userInfo.user_type === 'teacher') ? _c('div', {
    key: "select-student"
  }, [_c('label', [_vm._v("生徒のお名前：")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggestions": _vm.studentList
    },
    model: {
      value: (_vm.otherReservation.receiver),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "receiver", $$v)
      },
      expression: "otherReservation.receiver"
    }
  })], 1) : (_vm.$store.state.userInfo.user_type === 'student') ? _c('div', {
    key: "select-teacher"
  }, [_c('label', [_vm._v("先生のお名前：")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggestions": _vm.teacherList
    },
    model: {
      value: (_vm.otherReservation.receiver),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "receiver", $$v)
      },
      expression: "otherReservation.receiver"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "placeholder": "日付を選択",
      "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(_vm.otherReservation.date)) + ')',
      "value-format": "yyyy-MM-dd",
      "picker-options": {
        disabledDate: _vm.disabledDate
      }
    },
    model: {
      value: (_vm.otherReservation.date),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "date", $$v)
      },
      expression: "otherReservation.date"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "開始時刻を選択",
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        maxTime: _vm.otherReservation.endTime,
      }
    },
    model: {
      value: (_vm.otherReservation.startTime),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "startTime", $$v)
      },
      expression: "otherReservation.startTime"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "終了時刻を選択",
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        minTime: _vm.otherReservation.startTime
      }
    },
    model: {
      value: (_vm.otherReservation.endTime),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "endTime", $$v)
      },
      expression: "otherReservation.endTime"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "second-section"
    }
  }, [_vm._m(3), _vm._v(" "), (!_vm.isFirstCompleted) ? _c('notificationBox', {
    key: "warning-second-uncompleted-first",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "候補日時を指定する前に振替を希望する授業を選択してください"
    }
  }) : (_vm.isCompletenessChecking && !_vm.isSecondCompleted) ? _c('notificationBox', {
    key: "warning-second-unspecified",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "全ての候補日時の日付、開始時刻，終了時刻を指定してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isSecondCompleted) ? _c('notificationBox', {
    key: "ok-second",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFirstCompleted) ? _c('div', {
    key: "candidate-list"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.candidateDatetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.candidateDatetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
      staticStyle: {
        "width": "190px"
      },
      attrs: {
        "placeholder": "日付を選択",
        "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(cand.date)) + ')',
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: _vm.disabledDate
        }
      },
      model: {
        value: (cand.date),
        callback: function($$v) {
          _vm.$set(cand, "date", $$v)
        },
        expression: "cand.date"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-slot-mode' + index,
        "type": "radio",
        "value": "slot",
        "readonly": "readonly"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "slot")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "slot")
        }, function($event) {
          cand.startTime = null;
          cand.endTime = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-slot-mode' + index
      }
    }, [_vm._v("1コマ分を指定")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-range-mode' + index,
        "type": "radio",
        "value": "range"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "range")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "range")
        }, function($event) {
          cand.startTime = null;
          cand.endTime = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-range-mode' + index
      }
    }, [_vm._v("範囲で指定")])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "開始時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          maxTime: _vm.getMaxStartTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateStartTimeChanged(cand)
        }
      },
      model: {
        value: (cand.startTime),
        callback: function($$v) {
          _vm.$set(cand, "startTime", $$v)
        },
        expression: "cand.startTime"
      }
    }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "終了時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: _vm.getMinEndTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateEndTimeChanged(cand)
        }
      },
      model: {
        value: (cand.endTime),
        callback: function($$v) {
          _vm.$set(cand, "endTime", $$v)
        },
        expression: "cand.endTime"
      }
    }), _vm._v(" "), (cand.mode === 'slot') ? _c('label', {
      key: "slot-mode"
    }, [_vm._v("\n                  の1コマ\n                ")]) : (cand.mode === 'range') ? _c('label', {
      key: "range-mode"
    }, [_vm._v("\n                  の中で" + _vm._s(_vm.reservationDuration) + "分間\n                ")]) : _vm._e()], 1)])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  }, [_vm._v("\n          ＋ 候補日時を追加する\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "third-section"
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isThirdCompleted) ? _c('notificationBox', {
    key: "warning-third",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "理由は必須項目です"
    }
  }) : (_vm.isCompletenessChecking && _vm.isThirdCompleted) ? _c('notificationBox', {
    key: "ok-third",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-area"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "理由を入力してください",
      "rows": "3"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', {
    key: "fourth-section",
    attrs: {
      "id": "fourth-section"
    }
  }, [_vm._m(5), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isFourthCompleted) ? _c('notificationBox', {
    key: "warning-fourth",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "授業の種類，配布物の有無を入力してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isFourthCompleted) ? _c('notificationBox', {
    key: "ok-fourth",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_vm._v("\n      入力内容を確認する\n    ")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('p', [_vm._v("恐れ入りますが、短期コースを受講されている方は振替機能をご利用いただけません。")]), _vm._v(" "), _c('p', [_vm._v("振替をご希望の方は究進塾事務局")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@kyushinjuku.com"
    }
  }, [_vm._v("(info@kyushinjuku.com)")]), _vm._v(" "), _c('p', [_vm._v("へ、授業前日22時までにご連絡ください。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 1")]), _vm._v(" : 授業の選択")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('p', [_vm._v("振替依頼は、必ず授業前日22:00までに完了してください。")]), _vm._v(" "), _c('p', [_vm._v("それ以降は振替依頼をすることが出来ません。")]), _vm._v(" "), _c('p', [_vm._v("授業前日22:00を過ぎた場合は振替ではなくキャンセルとなりますので、")]), _vm._v(" "), _c('p', [_vm._v("お電話またはメールにて事務局までご連絡ください。")]), _vm._v(" "), _c('p', [_vm._v("TEL:03-5927-1660 (日曜/年末年始を除く13:00-21:00)")]), _vm._v(" "), _c('p', [_vm._v("MAIL : info@kyushinjuku.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 2")]), _vm._v(" :   振替候補日時を指定してください")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 3")]), _vm._v(" :   振替を希望する理由を入力してください（必須）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 4")]), _vm._v(" :   振替"), _c('b', [_vm._v("後")]), _vm._v("の授業の情報を指定してください")])
}]}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "InformationNotification"
    }
  }, [_c('h1', [_vm._v("未通知ユーザー一覧")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto"
    },
    attrs: {
      "data": _vm.userlistFiltered
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "ID",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "ユーザー名",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullname",
      "label": "氏名",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kana",
      "label": "フリガナ"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_type",
      "label": "種類"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ステータス"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      " + _vm._s(_vm.userStatusDisplay(scope.row.user_status)) + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.show(scope.row)
            }
          }
        }, [_vm._v("通知")])]
      }
    }])
  })], 1), _vm._v(" "), _c('modal', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "important_info",
    attrs: {
      "name": "important_info",
      "width": "60%"
    }
  }, [_c('h1', [_vm._v("通知作成")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.modal_form.fullname) + " 様")]), _vm._v(" "), _c('div', {
    staticClass: "important_text"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("ID:")]), _vm._v(" "), _c('td', [_c('el-input', {
    attrs: {
      "placeholder": "ID"
    },
    model: {
      value: (_vm.modal_form.user_name),
      callback: function($$v) {
        _vm.$set(_vm.modal_form, "user_name", $$v)
      },
      expression: "modal_form.user_name"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("pass:")]), _vm._v(" "), _c('td', [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "パスワード",
      "show-password": ""
    },
    model: {
      value: (_vm.modal_form.pass),
      callback: function($$v) {
        _vm.$set(_vm.modal_form, "pass", $$v)
      },
      expression: "modal_form.pass"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("mail:")]), _vm._v(" "), _c('td', [_c('el-input', {
    attrs: {
      "placeholder": "info@kyushinjuku.com"
    },
    model: {
      value: (_vm.modal_form.mail_address),
      callback: function($$v) {
        _vm.$set(_vm.modal_form, "mail_address", $$v)
      },
      expression: "modal_form.mail_address"
    }
  })], 1)])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("通知")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "確認画面",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_c('p', [_vm._v("以下の内容で情報を変更し通知メールを送信します。")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "dialog_info"
  }, [_c('p', [_vm._v(_vm._s(this.modal_form.fullname) + "様宛に")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("ID")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(this.modal_form.user_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("パスワード")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(this.modal_form.pass))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("メールアドレス")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(this.modal_form.mail_address))])])])])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("よろしいですか？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false, _vm.loading = false
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("送信")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logoutPage"
    }
  }, [_vm._v("\n" + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasSomethingToShow) ? _c('div', {
    attrs: {
      "id": "StateListContainer"
    }
  }, [(_vm.reservationType !== '通常') ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "reservationTypeIcon"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.reservationType) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasConfTest) ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "confirmTestIcon"
    }
  }, [_vm._v("\n    配布物\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasMessage()) ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "hasMessage"
    }
  }, [_vm._v("\n    連絡有り\n  ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverClassroom"
    }
  }, [(_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.status !== 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(1)]) : _c('div', {
    key: "receiver-classroom"
  }, [_c('section', [_c('h1', [_vm._v("座席選択ページ")]), _vm._v(" "), _c('div', {
    staticClass: "Info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("選択された振替日時")]), _vm._v(" "), _c('div', {
    staticClass: "Info-data"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.rescheduled_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.start_time) + " 〜 " + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.end_time) + "の１コマ")])])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("その時間の空き教室状況")]), _vm._v(" "), _c('p', [_vm._v("座席を一つ選択してください")]), _vm._v(" "), _c('div', {
    staticClass: "classroom_List"
  }, _vm._l((_vm.classrooms), function(classroom) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('label', [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (classroom.name != 'prohibited'),
        expression: "classroom.name != 'prohibited'"
      }],
      staticClass: "content"
    }, [_c('input', {
      attrs: {
        "name": "classroom",
        "type": "radio"
      },
      on: {
        "change": function($event) {
          _vm.selectedclassroom(classroom.name)
        }
      }
    }), _vm._v("\n            " + _vm._s(classroom.name) + "\n          ")])])])
  }))]), _vm._v(" "), _c('div', [_c('p', [_c('span', {
    staticClass: "errormessage"
  }, [_vm._v(_vm._s(_vm.errormessage))])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_c('span', [_vm._v("\n        戻って修正する\n      ")])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_c('span', [_vm._v("\n        座席を確定する\n      ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
}]}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullnameChangePanel"
    }
  }, [_c('span', [_vm._v("氏名の変更")]), _vm._v(" "), _c('label', [_vm._v("新しい氏名:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_fullname),
      expression: "new_fullname"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_fullname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("新しいフリガナ:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_kana),
      expression: "new_kana"
    }],
    attrs: {
      "type": "text",
      "name": "kana"
    },
    domProps: {
      "value": (_vm.new_kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_kana = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.changeFullnameLocal
    }
  }, [_vm._v("氏名を変更")])])
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "recurrentReservePanel"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainpage"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "headerBlank"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationBox",
    class: {
      'ok': _vm.type === 'ok', 'warning': _vm.type === 'warning'
    }
  }, [_c('div', {
    staticClass: "content content-icon"
  }, [_c('i', {
    class: {
      'el-icon-success': _vm.type === 'ok', 'el-icon-warning': _vm.type === 'warning'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content-text"
  }, [_c('label', [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainpage"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "headerBlank"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.rescherdulingState.isPopupShown) ? _c('div', {
    attrs: {
      "id": "reschedulingPopup"
    }
  }, [_c('p', [_vm._v("振替依頼をする")]), _vm._v(" "), _c('section', [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.candidateDatetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.candidateDatetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-body"
    }, [_c('a', [_vm._v("日付　　:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.date),
        expression: "cand.date"
      }],
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (cand.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "date", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('a', [_vm._v("開始時間:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.startTime),
        expression: "cand.startTime"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (cand.startTime)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "startTime", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('a', [_vm._v("終了時間:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.endTime),
        expression: "cand.endTime"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (cand.endTime)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "endTime", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.duration),
        expression: "cand.duration"
      }],
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (cand.duration)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "duration", $event.target.value)
        }
      }
    }), _c('a', [_vm._v("分間")])])])])
  })), _vm._v(" "), _c('input', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "value": "＋ 候補日時を追加する"
    },
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  })]), _vm._v(" "), _c('section', [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("理由を入力してください（必須）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', [_c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "確認する"
    },
    on: {
      "click": _vm.onConfirmButtonClicked
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "cancel"
    },
    on: {
      "click": _vm.closePopup
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": '入力して検索'
    },
    domProps: {
      "value": _vm.input
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.click($event)
      },
      "input": function($event) {
        $event.preventDefault();
        _vm.updateValue($event.target.value)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.enter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.up($event)
      }]
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSuggestion),
      expression: "openSuggestion"
    }],
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "100%",
      "height": "300px",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          _vm.suggestionClick(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.suggestionDisplay(suggestion)))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SpHelpPage"
    }
  }, [_c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("座席予約表を見る")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("予約・変更・削除の締め切りは前日22時です（翌週月曜の座席予約は土曜22時までとなっております）")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1",
    staticStyle: {
      "tcolor": "red"
    }
  }, [_vm._v("上記時刻を過ぎて予約をしたい場合は、究進塾事務局(info@kyushinjuku.com)へご連絡ください")]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約をする")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl",
    staticStyle: {
      "color": "#5B5B5B"
    }
  }, [_c('li', [_vm._v("予約したい時刻と、予約したい教室がクロスするマスをクリック")]), _vm._v(" "), _c('li', [_vm._v("「開始時間」「終了時間」「授業の種類（通常・通常初回・体験・短期・短期初回）」「生徒のお名前」「先生のお名前」「配布物（有り・無し）」「連絡事項（必要であれば記入）」を記入")]), _vm._v(" "), _c('li', [_vm._v("「予約する」をクリック")])]), _vm._v(" "), _c('p', {
    staticClass: "caption cap2"
  }, [_vm._v("同時間帯・同教室で月末まで予約したい場合は、「月末まで毎週予約する」にチェックを入れてください")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※予約時に、「生徒のお名前」に担当生徒の氏名が表示されない場合※")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("先生と生徒の紐づけが未完了です")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("恐れ入りますが、究進塾事務局(info@kyushinjuku.com)へご連絡ください。また、臨時的に下記手順でご予約をお願い致します。")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl",
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('li', [_vm._v("「授業の種類」で「短期」を選択")]), _vm._v(" "), _c('li', [_vm._v("「生徒のお名前」を “直接” 入力")])])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約を変更する")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("変更したい予約をクリック")]), _vm._v(" "), _c('li', [_vm._v("ポップアップの最下部「編集する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("予約を編集")]), _vm._v(" "), _c('li', [_vm._v("「編集を完了する」をクリック")])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約を削除する")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("削除したい予約をクリック")]), _vm._v(" "), _c('li', [_vm._v("ポップアップの最下部「編集する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("「予約を削除する」をクリック")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("振替依頼")]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をする場合")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("座席予約表へログイン後、画面左上の「振替を依頼する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("①振替を希望する授業をリストから選択")]), _vm._v(" "), _c('li', [_vm._v("②振替候補日時を選択")]), _vm._v(" "), _c('li', [_vm._v("③振替を希望する理由を入力")]), _vm._v(" "), _c('li', [_vm._v("（講師のみ、④振替後の授業の情報を入力）")])]), _vm._v(" "), _c('li', [_vm._v("入力項目を確認し、「振替依頼をする」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("完了画面を確認し、「座席表トップへ」をクリック")])]), _vm._v(" "), _c('div', {
    staticClass: "box27"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("振替依頼をしたあとは・・・")]), _vm._v(" "), _c('p', [_vm._v("24時間以内に振替の承認・不承認の結果がメールで届きます。"), _c('br'), _vm._v("\n        承認された場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n        不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。")])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をされた場合")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く")]), _vm._v(" "), _c('li', [_vm._v("メール内のURLをクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【承認する場合】")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("①振替候補日時からご都合の良い日時を選択")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②振替後の授業を予約する座席を選択")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替を確定する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表トップへ」をクリック")])]), _c('br'), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【不承認する場合】")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("①「振替を不承認する」にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②他の振替候補日時を入力")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替依頼を不承認する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表」をクリック")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box27"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("承認/不承認をしたあとは・・・")]), _vm._v(" "), _c('p', [_vm._v("承認・不承認の結果がメールで依頼者に届きます。"), _c('br'), _vm._v("\n      承認した場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n      不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1"
  }, [_vm._v("ヘルプ")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1"
  }, [_vm._v("本画面です")]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1"
  }, [_vm._v("ユーザ情報")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1"
  }, [_vm._v("パスワードおよびユーザ名（ID）の変更が出来ます")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※ご注意ください※")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("初回設定以外のパスワードに変更される場合は、"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("事務局では変更内容を確認出来ません")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("変更後のパスワードは各個人で保管いただきますようお願い申し上げます")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('p', {
    staticClass: "cap1",
    staticStyle: {
      "text-align": "left",
      "margin-left": "40px",
      "font-size": "14px",
      "color": "#5B5B5B",
      "margin-top": "10px"
    }
  }, [_vm._v("ログアウトが出来ます")]), _vm._v(" "), _c('p', {
    staticClass: "cap1",
    staticStyle: {
      "text-align": "left",
      "margin-left": "40px",
      "font-size": "14px",
      "color": "red",
      "margin-bottom": "100px"
    }
  }, [_vm._v("究進塾のPCで座席予約表を操作される場合は、セキュリティ上必ずログアウトしていただきますようお願い致します")])])
}]}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getContainerStyle),
    attrs: {
      "id": "timelineContainer"
    },
    on: {
      "!keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.stopDragging()
      },
      "dragover": function($event) {
        _vm.dragoverHandler($event)
      },
      "!drop": function($event) {
        _vm.dropHandler($event)
      }
    }
  }, [_vm._l((_vm.$store.state.timeScaleTicks), function(tick, index) {
    return _c('div', {
      staticClass: "tlTicksCells",
      class: _vm.getTicksClass(index),
      style: (_vm.tlTicksStyle)
    })
  }), _vm._v(" "), _vm._l((_vm.classroomNames), function(classroom) {
    return _c('timeline', {
      key: classroom,
      attrs: {
        "classroom": classroom,
        "dragging": _vm.hasDraggingTl
      },
      on: {
        "tlmousedown": _vm.mousedownHandler,
        "tlmousemove": _vm.mousemoveHandler,
        "tlmouseup": _vm.mouseupHandler
      }
    })
  }), _vm._v(" "), _vm._l((_vm.filteredreservation), function(r) {
    return _c('reservationBox', {
      key: r.id,
      attrs: {
        "reservation": r
      },
      on: {
        "pvmousedown": _vm.mousedownHandler,
        "pvmousemove": _vm.mousemoveHandler
      }
    })
  }), _vm._v(" "), _c('previewBox', {
    attrs: {
      "dragging": _vm.hasDraggingTl
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.stopDragging()
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "ruler"
    }
  }, _vm._l((_vm.$store.state.timeScaleTicks), function(ticks, index) {
    return _c('div', {
      staticClass: "rulerTicksCell",
      class: _vm.getTicksClass(index),
      style: (_vm.ticksCellStyle)
    }, [_c('span', {
      staticClass: "rulerTicks"
    }, [_vm._v(_vm._s(ticks))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasHeight) ? _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "previewBox"
    },
    on: {
      "mousedown": function($event) {
        _vm.mousedownHandler($event)
      },
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.$emit('keyup.esc')
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$store.state.previewBox.start) + " ~\n  " + _vm._s(_vm.$store.state.previewBox.end) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "EditInformationPage"
    }
  }, [(_vm.edit_trigger) ? _c('div', {
    staticClass: "brs"
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "round": ""
    },
    on: {
      "click": _vm.show
    }
  }, [_vm._v("お知らせの追加をする")]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("お知らせ一覧")]), _vm._v(" "), _c('ol', {
    staticClass: "information_lists",
    attrs: {
      "id": "information_list"
    }
  }, _vm._l((_vm.information_list), function(information_list, index) {
    return _c('li', {
      key: 'information_list' + index
    }, [_c('p', {
      attrs: {
        "id": "information_list_body"
      }
    }, [_c('table', [_c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('a', {
      staticClass: "information_list_day"
    }, [_vm._v(_vm._s(information_list.day))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_c('a', {
      attrs: {
        "id": "information_list_text"
      },
      domProps: {
        "innerHTML": _vm._s(information_list.text)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('i', {
      staticClass: "delete_button icon-trash",
      on: {
        "click": function($event) {
          _vm.delete_information(information_list.information_id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('i', {
      staticClass: "delete_button icon-editalt",
      on: {
        "click": function($event) {
          _vm.Edit_trigger(index)
        }
      }
    })])])])])])
  }))]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "edit",
      "scrollable": true,
      "classes": "",
      "width": 800,
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "Edit_information"
  }, [_c('h1', [_vm._v("編集画面")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "editor",
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.edit_text),
      callback: function($$v) {
        _vm.edit_text = $$v
      },
      expression: "edit_text"
    }
  }), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('el-input', {
    attrs: {
      "placeholder": "対象者"
    },
    model: {
      value: (_vm.edit_target),
      callback: function($$v) {
        _vm.edit_target = $$v
      },
      expression: "edit_target"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "placeholder": "重要度"
    },
    model: {
      value: (_vm.edit_importance),
      callback: function($$v) {
        _vm.edit_importance = $$v
      },
      expression: "edit_importance"
    }
  }, _vm._l((_vm.importance), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "add_button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.Edit_information
    }
  }, [_vm._v("追加")])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "hello-world",
      "scrollable": true,
      "classes": "",
      "width": 800,
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "new_information"
  }, [_c('h1', [_vm._v("お知らせ新規作成")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "editor",
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.information_text),
      callback: function($$v) {
        _vm.information_text = $$v
      },
      expression: "information_text"
    }
  }), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('el-input', {
    attrs: {
      "placeholder": "対象者"
    },
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "placeholder": "重要度"
    },
    model: {
      value: (_vm.importance_value),
      callback: function($$v) {
        _vm.importance_value = $$v
      },
      expression: "importance_value"
    }
  }, _vm._l((_vm.importance), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.importance_value == '緊急') ? _c('td', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "表示期間"
    },
    model: {
      value: (_vm.show_date),
      callback: function($$v) {
        _vm.show_date = $$v
      },
      expression: "show_date"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "add_button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.add_information
    }
  }, [_vm._v("追加")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle)
  }, [_c('span', {
    staticClass: "tlHeaderText"
  }, [_vm._v(_vm._s(_vm.classroom))])])
},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userinfo"
    }
  }, [_c('h1', [_vm._v("ユーザー情報")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("名前")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.fullname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("カナ")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ユーザー名(ID)")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_name),
      expression: "user_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("mail")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail_address),
      expression: "mail_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mail_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("現在のパスワード")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_password),
      expression: "current_password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("新しいパスワード")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "button",
      "to": "/Spuser",
      "title": "キャンセル"
    }
  }, [_c('span', [_vm._v("キャンセル")])]), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "value": "変更を適用"
    },
    on: {
      "click": _vm.Apply
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle),
    attrs: {
      "id": "rulerHeader"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tlHeaderText",
    staticStyle: {
      "font-size": "12px",
      "margin": "auto"
    }
  }, [_vm._v("教室"), _c('br'), _vm._v("＼"), _c('br'), _vm._v("時刻")])
}]}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "passowordChangePanel"
    }
  }, [_c('h1', [_vm._v("パスワードの変更")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type !== 'admin') ? _c('label', {
    key: "current_password",
    staticClass: "cate2"
  }, [_vm._v("\n    現在のパスワード:\n    "), (!_vm.isShownPasswords) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_password),
      expression: "current_password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShownPasswords) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_password),
      expression: "current_password"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_password = $event.target.value
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいパスワード:\n    "), (!_vm.isShownPasswords) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShownPasswords) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "opt1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShownPasswords),
      expression: "isShownPasswords"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShownPasswords) ? _vm._i(_vm.isShownPasswords, null) > -1 : (_vm.isShownPasswords)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShownPasswords,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShownPasswords = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShownPasswords = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShownPasswords = $$c
        }
      }
    }
  }), _vm._v("パスワードを表示する")]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("パスワードを変更")])])
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.status !== 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(1)]) : _c('div', {
    key: "receiver-confirmation"
  }, [(!_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("以下の内容で授業振替を承認します")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「振替を確定する」ボタンを押してください")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替前の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.reschedulingInfo.sender.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n              先生のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 先生\n            ")]) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.sender.user_type === 'student') ? _c('label', {
    key: "student-name"
  }, [_vm._v("\n              生徒のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 様\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -2)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -2)) + "の１コマ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("座席　　　　：" + _vm._s(_vm.reschedulingInfo.target_reservation.classroom_name))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替後の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.reschedulingInfo.sender.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n              先生のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 先生\n            ")]) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.sender.user_type === 'student') ? _c('label', {
    key: "student-name"
  }, [_vm._v("\n              生徒のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 様\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.rescheduled_reservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.start_time) + " 〜 " + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.end_time) + "の１コマ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("座席　　　　：" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.classroom_name))])]), _vm._v(" "), (_vm.reschedulingInfo.receiver.user_type === 'teacher') ? _c('div', [_c('div', [_c('label', [_vm._v("授業の種類　　　　　　：" + _vm._s(_vm.reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : _vm.reschedulingInfo.reservationOption.reservationType + '授業'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("配布物（確認テスト等）：" + _vm._s(_vm.reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし'))])]), _vm._v(" "), (_vm.reschedulingInfo.reservationOption.reservationMessage) ? _c('div', [_c('label', [_vm._v("連絡事項：")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reservationOption.reservationMessage.split('\n')), function(row) {
    return _c('div', {
      key: "message-row",
      staticClass: "message-row"
    }, [_c('label', [_vm._v("　" + _vm._s(row))])])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n        戻って修正する\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.confirmButtonClicked()
      }
    }
  }, [_vm._v("\n        振替を確定する\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替依頼を不承認し、他の振替候補日時を提案します")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「完了」ボタンを押してください")]), _vm._v(" "), (_vm.reschedulingInfo.receiver_message) ? _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へのメッセージ")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('label', [_vm._v(_vm._s(_vm.reschedulingInfo.receiver_message))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("他の振替候補日時")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.alternative_datetimes), function(alternative_datetimes, index) {
    return _c('li', {
      key: 'alternative_datetimes' + index
    }, [_c('div', {
      staticClass: "alternative_datetimes-caption"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(" "), _c('label', [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "alternative_datetimes-content"
    }, [_c('div', [_c('label', [_vm._v("日付：" + _vm._s(_vm.formattedDate(alternative_datetimes.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：" + _vm._s(alternative_datetimes.start_time) + " 〜 " + _vm._s(alternative_datetimes.end_time))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(alternative_datetimes.mode === 'slot' ? 'の1コマ' : 'の中で' + alternative_datetimes.duration + '分間'))])])])])
  }))])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n        戻って修正する\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.denyButtonClicked()
      }
    }
  }, [_vm._v("\n        完了\n      ")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "el-icon-back down-arrow"
  })])
}]}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loginPage"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(80)
    }
  }), _vm._v(" "), _c('h1', [_vm._v("座席表ログインページ")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "loginform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doLogin()
      }
    }
  }, [_c('div', {
    staticClass: "inputArea"
  }, [_c('div', [_c('label', {
    staticClass: "labels",
    attrs: {
      "for": "idtext"
    }
  }, [_vm._v("ユーザーID:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idtext),
      expression: "idtext"
    }],
    attrs: {
      "type": "text",
      "id": "idtext",
      "placeholder": "id",
      "pattern": "^[0-9A-Za-z\\._]+$"
    },
    domProps: {
      "value": (_vm.idtext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idtext = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "labels",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("パスワード：")]), _vm._v(" "), (!_vm.isShownPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "password",
      "pattern": "^[0-9A-Za-z\\._]+$"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShownPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "id": "password",
      "placeholder": "password",
      "pattern": "^[0-9A-Za-z\\._]+$"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShownPassword),
      expression: "isShownPassword"
    }],
    attrs: {
      "type": "checkbox",
      "id": "showPass"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShownPassword) ? _vm._i(_vm.isShownPassword, null) > -1 : (_vm.isShownPassword)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShownPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShownPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShownPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShownPassword = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showPass"
    }
  }, [_vm._v("パスワードを表示する")])])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("ログイン")]), _c('br'), _c('br')], 1), _vm._v(" "), _c('section', [_c('div', [_c('h1', {
    staticClass: "information_list_title"
  }, [_vm._v("お知らせ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "information_list"
    }
  }, [_c('table', {
    staticClass: "kokuban",
    attrs: {
      "id": "information_list"
    }
  }, _vm._l((_vm.information_list), function(information_list, index) {
    return _c('span', {
      key: 'information_list' + index,
      staticClass: "tablea"
    }, [_c('tr', {
      staticClass: "info_Heading"
    }, [_c('td', {
      staticStyle: {
        "width": "40px"
      }
    }, [_c('span', {
      staticClass: "information_img"
    }, [(_vm.checke_date(information_list)) ? _c('img', {
      attrs: {
        "src": __webpack_require__(588)
      }
    }) : _vm._e()])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "id": "information_list_day"
      }
    }, [_vm._v(_vm._s(information_list.day))]), _vm._v(" "), _c('a', {
      class: [{
          emergency: information_list.importance == '緊急'
        },
        {
          important_2: information_list.importance == '最重要'
        },
        {
          important_1: information_list.importance == '重要'
        },
        {
          failure: information_list.importance == '障害情報'
        }
      ]
    }, [_vm._v("\n                  【" + _vm._s(information_list.importance) + "】\n                ")]), _vm._v(" "), _c('a', [_vm._v("【" + _vm._s(information_list.target) + "】")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
      attrs: {
        "id": "information_list_text"
      }
    }, [_c('a', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(information_list.text)
      }
    })])])]), _vm._v(" "), _c('tr')])
  }))])])]), _vm._v(" "), _c('modal', {
    staticClass: "important_info",
    attrs: {
      "name": "important_info",
      "width": "60%"
    }
  }, [_c('h1', [_vm._v("重要なお知らせ")]), _vm._v(" "), _c('div', {
    staticClass: "important_text"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.modal_text)
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverClassroom"
    }
  }, [(_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.status !== 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(1)]) : _c('div', {
    key: "receiver-classroom"
  }, [_c('section', [_c('h1', [_vm._v("座席選択ページ")]), _vm._v(" "), _c('div', {
    staticClass: "Info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("選択された振替日時")]), _vm._v(" "), _c('div', {
    staticClass: "Info-data"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.rescheduled_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.start_time) + " 〜 " + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.end_time) + "の１コマ")])])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("その時間の空き教室状況")]), _vm._v(" "), _c('p', [_vm._v("座席を一つ選択してください")]), _vm._v(" "), _c('div', {
    staticClass: "classroom_List"
  }, _vm._l((_vm.classrooms), function(classroom) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('label', [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (classroom.name != 'prohibited'),
        expression: "classroom.name != 'prohibited'"
      }],
      staticClass: "content"
    }, [_c('input', {
      attrs: {
        "name": "classroom",
        "type": "radio"
      },
      on: {
        "change": function($event) {
          _vm.selectedclassroom(classroom.name)
        }
      }
    }), _vm._v("\n            " + _vm._s(classroom.name) + "\n          ")])])])
  }))]), _vm._v(" "), _c('div', [_c('p', [_c('span', {
    staticClass: "errormessage"
  }, [_vm._v(_vm._s(_vm.errormessage))])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_c('span', [_vm._v("\n        戻って修正する\n      ")])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_c('span', [_vm._v("\n        座席を確定する\n      ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
}]}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle)
  }, [_c('span', {
    staticClass: "tlHeaderText"
  }, [_vm._v(_vm._s(_vm.classroom))])])
},staticRenderFns: []}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEnable()),
      expression: "isEnable()"
    }],
    style: (_vm.getStyle),
    attrs: {
      "id": "ticker"
    }
  }, [_vm._v("↑now")])
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    style: (_vm.getStyle),
    attrs: {
      "id": "timetableHeader"
    }
  }, [_c('thead', [_c('ruler-header', {
    attrs: {
      "classroom": ""
    }
  }), _vm._v(" "), _vm._l((_vm.filteredclassroomNames), function(classroom) {
    return _c('timeline-header', {
      key: classroom.name,
      attrs: {
        "classroom": classroom.name
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline",
    style: (_vm.getStyle),
    on: {
      "mousedown": function($event) {
        _vm.mousedownHandler($event)
      },
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "click": function($event) {
        _vm.clickHandler($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "MailAddressChangePanel"
    }
  }, [_c('h1', [_vm._v("メールアドレスの変更")]), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいメールアドレス:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_mail_address),
      expression: "new_mail_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_mail_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_mail_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changeMailLocal
    }
  }, [_vm._v("メールアドレスを変更")])])
},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": '入力して検索'
    },
    domProps: {
      "value": _vm.input
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.click($event)
      },
      "input": function($event) {
        $event.preventDefault();
        _vm.updateValue($event.target.value)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.enter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.up($event)
      }]
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSuggestion),
      expression: "openSuggestion"
    }],
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "100%",
      "height": "300px",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          _vm.suggestionClick(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.suggestionDisplay(suggestion)))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasSomethingToShow) ? _c('div', {
    attrs: {
      "id": "StateListContainer"
    }
  }, [(_vm.reservationType !== '通常') ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "reservationTypeIcon"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.reservationType) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasConfTest) ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "confirmTestIcon"
    }
  }, [_vm._v("\n    配布物\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasMessage()) ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "hasMessage"
    }
  }, [_vm._v("\n    連絡有り\n  ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.isInfoPopupShown) ? _c('div', {
    style: (_vm.getStyle()),
    attrs: {
      "id": "informationPopup"
    }
  }, [_c('span', [_vm._v("予約の情報")]), _vm._v(" "), _c('button', {
    staticClass: "closeButton",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableTimes"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.informationPopup.reservation.start_time
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.informationPopup.reservation.end_time
    }
  })])])]), _vm._v(" "), (_vm.isTanki()) ? _c('label', [_vm._v("短期講座")]) : _vm._e(), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableNames"
    }
  }, [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.informationPopup.reservation.student.fullname
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.informationPopup.reservation.teacher.fullname
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類"), _c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.informationPopup.reservation.reservation_type
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("\n      配布物: " + _vm._s(_vm.$store.state.informationPopup.reservation.has_test ? '有り' : '無し') + "\n    ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "messageContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "messageSubject"
    }
  }, [_vm._v("連絡事項")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "messageBody",
      "readonly": "",
      "rows": _vm.$store.state.informationPopup.reservation.message === '' ? 1 : 2
    },
    domProps: {
      "value": _vm.$store.state.informationPopup.reservation.message
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "isOnline"
    }
  }, [_vm._v("\n      授業形態: " + _vm._s(Number(_vm.$store.state.informationPopup.reservation.online) === 1 ? 'オンライン' : '対面') + "\n    ")]), _vm._v(" "), (_vm.isEditable()) ? _c('button', {
    on: {
      "click": _vm.enterEdit
    }
  }, [_vm._v("編集する")]) : _vm._e(), _vm._v(" "), (!_vm.isEditable() && _vm.isFuture()) ? _c('div', {
    attrs: {
      "id": "delete-block"
    }
  }, [_c('span', [_vm._v("※この時間は予約の削除のみ可能です")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.enterDelete
    }
  }, [_vm._v("予約を削除する")]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "削除の確認",
      "visible": _vm.dialogDeleteVisible,
      "width": "50%",
      "modal-append-to-body": false,
      "top": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDeleteVisible = $event
      }
    }
  }, [_c('p', [_vm._v("この予約は月末まで毎週予約されています。")]), _vm._v(" "), _c('p', [_vm._v("以降の予約を全て削除しますか？この予約のみを削除しますか？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function () {
        _vm.isAllEditing = true
        _vm.dialogDeleteVisible = false
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n          以降の予約全てを削除\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function () {
        _vm.isAllEditing = false
        _vm.dialogDeleteVisible = false
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n          この予約のみ削除\n        ")])], 1)])], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("開始: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("終了: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("生徒のお名前：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("先生のお名前：")])])
}]}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEnable()),
      expression: "isEnable()"
    }],
    style: (_vm.getStyle),
    attrs: {
      "id": "ticker"
    }
  }, [_vm._v("↑now")])
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userRegistrationForm"
    }
  }, [_c('table', {
    staticClass: "registration-form"
  }, [_c('tr', [_c('td', [_vm._v("ユーザー名:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.name),
      expression: "additionalUser.name"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "ユーザー名"
    },
    domProps: {
      "value": (_vm.additionalUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("パスワード:")]), _vm._v(" "), _c('td', [(_vm.isPasswordShown) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.password),
      expression: "additionalUser.password"
    }],
    attrs: {
      "type": "text",
      "name": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.additionalUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "password", $event.target.value)
      }
    }
  })] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.password),
      expression: "additionalUser.password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.additionalUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "password", $event.target.value)
      }
    }
  })]], 2), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPasswordShown),
      expression: "isPasswordShown"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPasswordShown) ? _vm._i(_vm.isPasswordShown, null) > -1 : (_vm.isPasswordShown)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPasswordShown,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPasswordShown = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPasswordShown = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPasswordShown = $$c
        }
      }
    }
  }), _vm._v("パスワードを表示する")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("氏名:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.fullname),
      expression: "additionalUser.fullname"
    }],
    attrs: {
      "type": "text",
      "name": "fullname",
      "placeholder": "氏名"
    },
    domProps: {
      "value": (_vm.additionalUser.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "fullname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("フリガナ:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.kana),
      expression: "additionalUser.kana"
    }],
    attrs: {
      "type": "text",
      "name": "kana",
      "placeholder": "フリガナ"
    },
    domProps: {
      "value": (_vm.additionalUser.kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("mail:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.mail_address),
      expression: "additionalUser.mail_address"
    }],
    attrs: {
      "type": "text",
      "name": "mail_address",
      "placeholder": "mail_address"
    },
    domProps: {
      "value": (_vm.additionalUser.mail_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "mail_address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ユーザー種別：")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.type),
      expression: "additionalUser.type"
    }],
    staticClass: "typeSelect",
    attrs: {
      "name": "usertype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.additionalUser, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "student",
      "selected": ""
    }
  }, [_vm._v("生徒")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "teacher"
    }
  }, [_vm._v("教師")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "admin"
    }
  }, [_vm._v("管理者")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "viewer"
    }
  }, [_vm._v("閲覧者")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ユーザー状態：")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.status),
      expression: "additionalUser.status"
    }],
    staticClass: "statusSelect",
    attrs: {
      "name": "userstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.additionalUser, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "normal",
      "selected": ""
    }
  }, [_vm._v("通常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temporal"
    }
  }, [_vm._v("短期（単一）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "trial"
    }
  }, [_vm._v("体験")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/temp"
    }
  }, [_vm._v("短期（複数、元体験生）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/norm"
    }
  }, [_vm._v("短期及び長期")])])])])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.registerUser
    }
  }, [_vm._v("ユーザーを登録する")])])
},staticRenderFns: []}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservationBox",
    class: {
      firstTime: _vm.canDisplay && _vm.reservation.reservation_type === '初回',
        trial: _vm.canDisplay && _vm.reservation.reservation_type === '体験',
        hasTest: _vm.canDisplay && _vm.reservation.hasTest,
        hasMessage: _vm.canDisplay && _vm.reservation.message !== '',
        grayedOut: !_vm.canDisplay
    },
    style: (_vm.getStyle),
    on: {
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "mouseout": function($event) {
        _vm.hover = false
      },
      "click": _vm.clickHandler
    }
  }, [(_vm.canDisplay) ? _c('statelist', {
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.reduceTimeExp(_vm.reservation.start_time)) + "〜\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.reduceTimeExp(_vm.reservation.end_time)) + "\n  ")]), _vm._v(" "), (_vm.canDisplay) ? _c('div', [_c('div', [_vm._v("\n      " + _vm._s(_vm.reservation.student.fullname) + " 様\n      "), (_vm.isVailedCheck) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAttendance(_vm.reservation.student.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.attendingState(_vm.reservation.student.id)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.reservation.teacher.fullname) + " 先生\n      "), (_vm.isVailedCheck) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAttendance(_vm.reservation.teacher.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.attendingState(_vm.reservation.teacher.id)) + "\n      ")]) : _vm._e()])]) : _c('p', [_vm._v("予約済み")])], 1)
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationBox",
    class: {
      'ok': _vm.type === 'ok', 'warning': _vm.type === 'warning'
    }
  }, [_c('div', {
    staticClass: "content content-icon"
  }, [_c('i', {
    class: {
      'el-icon-success': _vm.type === 'ok', 'el-icon-warning': _vm.type === 'warning'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content-text"
  }, [_c('label', [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替依頼が完了しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("依頼が承認または不承認されたらメールが届きますのでしばらくお待ちください")])])])
}]}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('ruler')], 1), _vm._v(" "), _c('td', [_c('ticker'), _vm._v(" "), _c('timeline-container')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "orangedBackground",
    style: (_vm.getStyle),
    attrs: {
      "id": "refreshButton",
      "type": "button",
      "title": "表を更新します"
    },
    on: {
      "click": _vm.refreshTable,
      "mouseenter": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('i', {
    staticClass: "icon-refresh"
  })])
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingList"
    }
  }, [_c('p', [_vm._v("振替情報一覧")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_type),
      expression: "display_type"
    }],
    attrs: {
      "type": "radio",
      "id": "all",
      "value": "all"
    },
    domProps: {
      "checked": _vm._q(_vm.display_type, "all")
    },
    on: {
      "change": function($event) {
        _vm.display_type = "all"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "all"
    }
  }, [_vm._v("すべて表示")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_type),
      expression: "display_type"
    }],
    attrs: {
      "type": "radio",
      "id": "accepted",
      "value": "accepted"
    },
    domProps: {
      "checked": _vm._q(_vm.display_type, "accepted")
    },
    on: {
      "change": function($event) {
        _vm.display_type = "accepted"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "accepted"
    }
  }, [_vm._v("承認済み")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_type),
      expression: "display_type"
    }],
    attrs: {
      "type": "radio",
      "id": "denied",
      "value": "denied"
    },
    domProps: {
      "checked": _vm._q(_vm.display_type, "denied")
    },
    on: {
      "change": function($event) {
        _vm.display_type = "denied"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "denied"
    }
  }, [_vm._v("不承認済み")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_type),
      expression: "display_type"
    }],
    attrs: {
      "type": "radio",
      "id": "pending",
      "value": "pending"
    },
    domProps: {
      "checked": _vm._q(_vm.display_type, "pending")
    },
    on: {
      "change": function($event) {
        _vm.display_type = "pending"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pending"
    }
  }, [_vm._v("進行中")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_type),
      expression: "display_type"
    }],
    attrs: {
      "type": "radio",
      "id": "error",
      "value": "error"
    },
    domProps: {
      "checked": _vm._q(_vm.display_type, "error")
    },
    on: {
      "change": function($event) {
        _vm.display_type = "error"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "error"
    }
  }, [_vm._v("エラー")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "rescheduling-table"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredReschedulings), function(rescheduling, index) {
    return (rescheduling.school_id == _vm.$store.state.userInfo.school_id) ? _c('tr', {
      key: rescheduling.id,
      staticClass: "rescheduling-item",
      class: {
        itemEven: index % 2 === 0
      }
    }, [_c('td', [_c('p', [_vm._v(_vm._s(_vm.formattedDate(rescheduling.registered_datetime)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedTime(rescheduling.registered_datetime)))])]), _vm._v(" "), (rescheduling.updated_datetime) ? _c('td', [_c('p', [_vm._v(_vm._s(_vm.formattedDate(rescheduling.updated_datetime)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedTime(rescheduling.updated_datetime)))])]) : _c('td', [_vm._v(" ---- ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userDisplayName(rescheduling.sender)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userDisplayName(rescheduling.receiver)))]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(_vm.formattedDate(rescheduling.target_reservation.date, 'YYYY-MM-DD')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedTime(rescheduling.target_reservation.start_time, 'HH:mm:ss') +
      '〜' + _vm.formattedTime(rescheduling.target_reservation.end_time, 'HH:mm:ss')))]), _vm._v(" "), (rescheduling.target_reservation.classroom_name) ? _c('p', [_vm._v(_vm._s(rescheduling.target_reservation.classroom_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "30px"
      }
    }, [_vm._v("⇨")]), _vm._v(" "), (rescheduling.status === 'accepted') ? _c('td', [_c('p', [_vm._v(_vm._s(_vm.formattedDate(rescheduling.rescheduled_reservation.date, 'YYYY-MM-DD')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedTime(rescheduling.rescheduled_reservation.start_time, 'HH:mm:ss') +
      '〜' + _vm.formattedTime(rescheduling.rescheduled_reservation.end_time, 'HH:mm:ss')))]), _vm._v(" "), (rescheduling.rescheduled_reservation.classroom_name) ? _c('p', [_vm._v(_vm._s(rescheduling.rescheduled_reservation.classroom_name))]) : _vm._e()]) : _c('td', [_vm._v(" ---- ")]), _vm._v(" "), _c('td', {
      class: rescheduling.status
    }, [_vm._v(_vm._s(_vm.reschedulingStatus(rescheduling)))])]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("登録日時")]), _vm._v(" "), _c('th', [_vm._v("完了日時")]), _vm._v(" "), _c('th', [_vm._v("依頼者")]), _vm._v(" "), _c('th', [_vm._v("相手")]), _vm._v(" "), _c('th', [_vm._v("振替前の情報")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("振替後の情報")]), _vm._v(" "), _c('th', [_vm._v("状態")])])])
}]}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderConfirmation"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼をする")]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("以下の内容で授業振替依頼を行います")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「振替依頼をする」ボタンを押してください")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替を希望する授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.receiverInfo.user_type === 'student') ? _c('lable', {
    key: "student-name"
  }, [_vm._v("\n            生徒のお名前：" + _vm._s(_vm.receiverInfo.fullname) + "様\n          ")]) : _vm._e(), _vm._v(" "), (_vm.receiverInfo.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n            先生のお名前：" + _vm._s(_vm.receiverInfo.fullname) + "先生\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.targetReservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.targetReservation.startTime) + " 〜 " + _vm._s(_vm.reschedulingInfo.targetReservation.endTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替候補日時")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.candidateDatetimes), function(candidate, index) {
    return _c('li', {
      key: 'candidate' + index
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(" "), _c('label', [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('div', [_c('label', [_vm._v("日付：" + _vm._s(_vm.formattedDate(candidate.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：" + _vm._s(candidate.startTime) + " 〜 " + _vm._s(candidate.endTime))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間'))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替希望理由")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, _vm._l((_vm.reschedulingInfo.reason.split('\n')), function(row) {
    return _c('div', {
      key: "reason-row"
    }, [_c('label', [_vm._v(_vm._s(row))])])
  }))]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('div', {
    key: "reservation-option",
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替後の授業情報")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [_c('label', [_vm._v("授業の種類　　　　　　：" + _vm._s(_vm.reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : _vm.reschedulingInfo.reservationOption.reservationType + '授業'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("配布物（確認テスト等）：" + _vm._s(_vm.reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("連絡事項：")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reservationOption.reservationMessage.split('\n')), function(row) {
    return _c('div', {
      key: "message-row",
      staticClass: "message-row"
    }, [_c('label', [_vm._v(_vm._s(row))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.Message) + "\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n      戻って修正する\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.okButtonClicked()
      }
    }
  }, [_vm._v("\n      振替依頼をする\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverForm"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼を承認／不承認する")]), _vm._v(" "), (!_vm.reschedulingInfo) ? _c('div', {
    key: "not-found"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(1)]) : (_vm.reschedulingInfo.status != 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(2)]) : (!_vm.checkExpireDate) ? _c('div', {
    key: "expiration"
  }, [_vm._m(3)]) : _c('div', {
    key: "receiver-form"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "が以下の授業振替を依頼されています")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("対象の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -3)))])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替希望理由")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reason.split('\n')), function(row) {
    return _c('p', {
      key: "reason-row",
      staticClass: "info-content reason-row"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替を"), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("承認")]), _vm._v("する場合は"), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("候補日時のうちの1つを選択")]), _vm._v("してください")], 1), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替を"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("不承認")]), _vm._v("する場合は"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("「振替を不承認する」にチェック")]), _vm._v("してください")], 1), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isSelectionCompleted) ? _c('notificationBox', {
    key: "warning-selection",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "候補日時のうち1つを選択するか、「振替を不承認する」にチェックしてください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isSelectionCompleted) ? _c('notificationBox', {
    key: "ok-selection",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDenying),
      expression: "isDenying"
    }],
    attrs: {
      "id": "denying-checkbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDenying) ? _vm._i(_vm.isDenying, null) > -1 : (_vm.isDenying)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDenying,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDenying = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDenying = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDenying = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "denying-checkbox"
    }
  }, [_vm._v("振替を不承認する")])]), _vm._v(" "), (!_vm.isDenying) ? _c('div', {
    key: "select-datetime-area",
    attrs: {
      "id": "select-datetime-area"
    }
  }, [_c('div', {
    staticClass: "info",
    class: {
      'info-inline-block': !_vm.isNarrowMode
    }
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("元の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -3)))])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-back",
    class: {
      'right-arrow': !_vm.isNarrowMode, 'down-arrow': _vm.isNarrowMode
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info",
    class: {
      'info-inline-block': !_vm.isNarrowMode
    }
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("候補日時")]), _vm._v(" "), _c('ul', {
    staticClass: "info-content",
    class: {
      'narrow-list': !_vm.isNarrowMode
    },
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.candidate_datetimes), function(candidate, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item-candidate-index"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCandidate),
        expression: "selectedCandidate"
      }],
      attrs: {
        "id": 'list-item-candidate-radio' + index,
        "type": "radio",
        "disabled": _vm.isDenying
      },
      domProps: {
        "value": candidate,
        "checked": _vm._q(_vm.selectedCandidate, candidate)
      },
      on: {
        "change": [function($event) {
          _vm.selectedCandidate = candidate
        }, function($event) {
          _vm.selectedCandidateChanged()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'list-item-candidate-radio' + index
      }
    }, [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('p', [_vm._v("日付：" + _vm._s(_vm.formattedDate(candidate.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：" + _vm._s(candidate.start_time) + " 〜 " + _vm._s(candidate.end_time) + _vm._s(candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間'))])])])
  }))])]) : _vm._e()], 1), _vm._v(" "), (!_vm.isDenying && _vm.selectedCandidate && _vm.selectedCandidate.mode === 'range') ? _c('section', {
    key: "timeslot",
    staticClass: "section"
  }, [_c('div', [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.selectedCandidate.start_time) + " 〜 " + _vm._s(_vm.selectedCandidate.end_time) + "の中で" + _vm._s(_vm.selectedCandidate.duration) + "分間、都合の良い時間帯を1つ選んでください")]), _vm._v(" "), _c('p', [_vm._v("（開始時刻か終了時刻のどちらかを指定すると、自動的にもう一方も指定されます）")]), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isTimeslotCompleted) ? _c('notificationBox', {
    key: "warning-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "開始時刻と終了時刻を選択してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isTimeslotCompleted) ? _c('notificationBox', {
    key: "ok-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "開始時刻を選択",
      "picker-options": {
        start: _vm.selectedCandidate.start_time,
        end: _vm.selectedCandidate.end_time,
        step: '00:05',
        maxTime: _vm.moment(_vm.selectedCandidate.end_time, 'HH:mm').add(-_vm.selectedCandidate.duration + 1, 'minutes').format('HH:mm')
      }
    },
    on: {
      "change": function($event) {
        _vm.timeslotStartTimeChanged()
      }
    },
    model: {
      value: (_vm.timeslot.start_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_time", $$v)
      },
      expression: "timeslot.start_time"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "終了時刻を選択",
      "picker-options": {
        start: _vm.selectedCandidate.start_time,
        end: _vm.selectedCandidate.end_time,
        step: '00:05',
        minTime: _vm.moment(_vm.selectedCandidate.start_time, 'HH:mm').add(_vm.selectedCandidate.duration - 1, 'minutes').format('HH:mm')
      }
    },
    on: {
      "change": function($event) {
        _vm.timeslotEndTimeChanged()
      }
    },
    model: {
      value: (_vm.timeslot.end_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_time", $$v)
      },
      expression: "timeslot.end_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("不承認の場合、他の候補日時を複数記入してください。")]), _vm._v(" "), (!_vm.isAlternativeDatetimes && _vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "warning-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "開始時刻と終了時刻を選択してください"
    }
  }) : (_vm.isAlternativeDatetimes && _vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "ok-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: "candidate-list"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.alternative_datetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.alternative_datetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
      staticStyle: {
        "width": "190px"
      },
      attrs: {
        "placeholder": "日付を選択",
        "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(cand.date)) + ')',
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: _vm.disabledDate
        }
      },
      model: {
        value: (cand.date),
        callback: function($$v) {
          _vm.$set(cand, "date", $$v)
        },
        expression: "cand.date"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-slot-mode' + index,
        "type": "radio",
        "value": "slot"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "slot")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "slot")
        }, function($event) {
          cand.start_time = null;
          cand.end_time = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-slot-mode' + index
      }
    }, [_vm._v("1コマ分を指定")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-range-mode' + index,
        "type": "radio",
        "value": "range"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "range")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "range")
        }, function($event) {
          cand.start_time = null;
          cand.end_time = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-range-mode' + index
      }
    }, [_vm._v("範囲で指定")])]), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "開始時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          maxTime: _vm.getMaxStartTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateStartTimeChanged(cand)
        }
      },
      model: {
        value: (cand.start_time),
        callback: function($$v) {
          _vm.$set(cand, "start_time", $$v)
        },
        expression: "cand.start_time"
      }
    }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "終了時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: _vm.getMinEndTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateEndTimeChanged(cand)
        }
      },
      model: {
        value: (cand.end_time),
        callback: function($$v) {
          _vm.$set(cand, "end_time", $$v)
        },
        expression: "cand.end_time"
      }
    }), _vm._v(" "), (cand.mode === 'slot') ? _c('label', {
      key: "slot-mode"
    }, [_vm._v("\n                  の1コマ\n                ")]) : (cand.mode === 'range') ? _c('label', {
      key: "range-mode"
    }, [_vm._v("\n                  の中で" + _vm._s(_vm.reservationDuration) + "分間\n                ")]) : _vm._e()], 1)])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  }, [_vm._v("\n          ＋ 候補日時を追加する\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', {
    key: "option-section",
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替後の授業の情報を指定してください")]), _vm._v(" "), (_vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "ok-reservation-option",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDenying) ? _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.commitMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDenying) ? _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.denyButtonClicked()
      }
    }
  }, [_vm._v("\n      確認画面に進む\n    ")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報が見つかりません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報の承認期限が過ぎております")])])
}]}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getContainerStyle),
    attrs: {
      "id": "timelineContainer"
    },
    on: {
      "!keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.stopDragging()
      },
      "dragover": function($event) {
        _vm.dragoverHandler($event)
      },
      "!drop": function($event) {
        _vm.dropHandler($event)
      }
    }
  }, [_vm._l((_vm.$store.state.timeScaleTicks), function(tick, index) {
    return _c('div', {
      staticClass: "tlTicksCells",
      class: _vm.getTicksClass(index),
      style: (_vm.tlTicksStyle)
    })
  }), _vm._v(" "), _vm._l((_vm.classroomNames), function(classroom) {
    return _c('timeline', {
      key: classroom,
      attrs: {
        "classroom": classroom,
        "dragging": _vm.hasDraggingTl
      },
      on: {
        "tlmousedown": _vm.mousedownHandler,
        "tlmousemove": _vm.mousemoveHandler,
        "tlmouseup": _vm.mouseupHandler
      }
    })
  }), _vm._v(" "), _vm._l((_vm.filteredreservation), function(r) {
    return _c('reservation-box', {
      key: r.id,
      attrs: {
        "reservation": r
      },
      on: {
        "pvmousedown": _vm.mousedownHandler,
        "pvmousemove": _vm.mousemoveHandler
      }
    })
  }), _vm._v(" "), _c('preview-box', {
    attrs: {
      "dragging": _vm.hasDraggingTl
    },
    on: {
      "pvmousedown": _vm.mousedownHandler,
      "pvmousemove": _vm.mousemoveHandler,
      "pvmouseup": _vm.mouseupHandler,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.stopDragging()
      }
    }
  }), _vm._v(" "), (_vm.$store.state.previewBox.isPopupShown &&
    _vm.$store.state.previewBox.style.height !== 0) ? _c('reservation-popup') : _vm._e(), _vm._v(" "), _c('editing-box'), _vm._v(" "), _c('editing-popup'), _vm._v(" "), _c('information-popup')], 2)
},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userPage"
  }, [_c('router-link', {
    attrs: {
      "tag": "button",
      "to": {
        name: 'ManagementPage'
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('h1', [_vm._v("講義情報")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "userPartnerList"
    }
  }, [_c('caption', [_vm._v("ユーザー：" + _vm._s(_vm.getWho.fullname))]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', [(_vm.getWho.type === 'teacher') ? [_c('div', [_vm._v("生徒一覧")])] : _vm._e(), _vm._v(" "), (_vm.getWho.type === 'student') ? [_c('div', [_vm._v("先生一覧")])] : _vm._e()], 2), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("削除")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.partnerList), function(partner, index) {
    return _c('tr', {
      key: partner.id,
      class: {
        evenRow: index % 2 === 0
      }
    }, [_c('th', [_vm._v("\n          " + _vm._s(partner.fullname) + "\n        ")]), _vm._v(" "), _c('th', [_c('button', {
      on: {
        "click": function($event) {
          _vm.purgeLecture(partner)
        }
      }
    }, [_vm._v("x")])])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "EditLecturePanel"
    }
  }, [_c('table', {
    attrs: {
      "border": "1"
    }
  }, [_c('caption', [_vm._v("\n        講義情報を追加する\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.getWho.type === 'teacher') ? _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.getWho.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.setHiddenID('teacher')
    }
  })]) : _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lecture.teacher),
      expression: "lecture.teacher"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.lecture, "teacher", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortedTeacherList), function(teacher, index) {
    return _c('option', {
      key: teacher.user_id,
      domProps: {
        "value": teacher.user_id
      }
    }, [_vm._v(_vm._s(teacher.fullname))])
  }))]), _vm._v(" "), (_vm.getWho.type === 'student') ? _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.getWho.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.setHiddenID('student')
    }
  })]) : _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lecture.student),
      expression: "lecture.student"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.lecture, "student", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortedStudentList), function(student, index) {
    return _c('option', {
      key: student.user_id,
      domProps: {
        "value": student.user_id
      }
    }, [_vm._v(_vm._s(student.fullname))])
  }))]), _vm._v(" "), _c('td', [_c('button', {
    on: {
      "click": function($event) {
        _vm.registerLecture()
      }
    }
  }, [_vm._v("登録")])])])])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'EditLecturePage'
      }
    }
  }), _vm._v(" "), (_vm.getWho.type === 'teacher') ? _c('div', [_c('table', {
    attrs: {
      "border": "1"
    }
  }, [_c('tr', [_c('td', [_vm._v("\n          日曜日の講義\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.isSunday ? '有り' : '無し') + "\n        ")]), _vm._v(" "), _c('td', [(!_vm.isSunday) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.registerSunday
    }
  }, [_vm._v("登録")]) : _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteSunday
    }
  }, [_vm._v("削除")])])])])]) : _vm._e(), _vm._v(" "), _c('password-change-panel', {
    attrs: {
      "user_id": _vm.getWho.id
    }
  }), _vm._v(" "), _c('user-name-change-panel', {
    attrs: {
      "user_id": _vm.getWho.id,
      "current_user_name": _vm.getWho.user_name
    },
    on: {
      "changed": function($event) {
        _vm.userInfoChanged()
      }
    }
  }), _vm._v(" "), _c('fullname-change-panel', {
    attrs: {
      "user_id": _vm.getWho.id,
      "current_fullname": _vm.getWho.fullname,
      "current_kana": _vm.getWho.kana
    },
    on: {
      "changed": function($event) {
        _vm.userInfoChanged()
      }
    }
  }), _vm._v(" "), _c('mail-address-change-panel', {
    attrs: {
      "user_id": _vm.getWho.id,
      "current_mail": _vm.getWho.mail_address
    }
  }), _vm._v(" "), _c('status-change-panel', {
    attrs: {
      "user_id": _vm.getWho.id,
      "current_status": _vm.getWho.status
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("教師名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("生徒名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  })])
}]}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpTable",
      "title": "座席予約表に戻る"
    }
  }, [_c('span', [_vm._v("座席予約表に戻る")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替依頼が完了しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("依頼が承認または不承認されたらメールが届きますのでしばらくお待ちください")])])
}]}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.editingState.id !== 0) ? _c('div', {
    staticClass: "editing-box",
    style: (_vm.getStyle),
    attrs: {
      "draggable": "true"
    },
    on: {
      "dragstart": _vm.dragstartHandler,
      "dragend": _vm.dragendHandler
    }
  }, [_c('div', [_vm._v("\n    " + _vm._s(_vm.$store.state.editingState.start) + " ~\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.$store.state.editingState.end) + "\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.getStudent()) + " 様\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.getTeacher()) + " 先生\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888888"
    }
  }, [_vm._v("\n    ドラッグで移動\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [(!_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替が確定しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へご入力内容を通知するメールが届きます")])]) : _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替依頼を不承認し、他の振替候補日時を提案しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へご入力内容を通知するメールが届きます")])])])
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.status !== 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(1)]) : _c('div', {
    key: "receiver-confirmation"
  }, [(!_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("以下の内容で授業振替を承認します")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「振替を確定する」ボタンを押してください")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替前の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.reschedulingInfo.sender.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n              先生のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 先生\n            ")]) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.sender.user_type === 'student') ? _c('label', {
    key: "student-name"
  }, [_vm._v("\n              生徒のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 様\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -2)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -2)) + "の１コマ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("座席　　　　：" + _vm._s(_vm.reschedulingInfo.target_reservation.classroom_name))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替後の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.reschedulingInfo.sender.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n              先生のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 先生\n            ")]) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.sender.user_type === 'student') ? _c('label', {
    key: "student-name"
  }, [_vm._v("\n              生徒のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 様\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.rescheduled_reservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.start_time) + " 〜 " + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.end_time) + "の１コマ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("座席　　　　：" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.classroom_name))])]), _vm._v(" "), (_vm.reschedulingInfo.receiver.user_type === 'teacher') ? _c('div', [_c('div', [_c('label', [_vm._v("授業の種類　　　　　　：" + _vm._s(_vm.reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : _vm.reschedulingInfo.reservationOption.reservationType + '授業'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("配布物（確認テスト等）：" + _vm._s(_vm.reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし'))])]), _vm._v(" "), (_vm.reschedulingInfo.reservationOption.reservationMessage) ? _c('div', [_c('label', [_vm._v("連絡事項：")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reservationOption.reservationMessage.split('\n')), function(row) {
    return _c('div', {
      key: "message-row",
      staticClass: "message-row"
    }, [_c('label', [_vm._v("　" + _vm._s(row))])])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n        戻って修正する\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.confirmButtonClicked()
      }
    }
  }, [_vm._v("\n        振替を確定する\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替依頼を不承認し、他の振替候補日時を提案します")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「完了」ボタンを押してください")]), _vm._v(" "), (_vm.reschedulingInfo.receiver_message) ? _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へのメッセージ")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('label', [_vm._v(_vm._s(_vm.reschedulingInfo.receiver_message))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("他の振替候補日時")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.alternative_datetimes), function(alternative_datetimes, index) {
    return _c('li', {
      key: 'alternative_datetimes' + index
    }, [_c('div', {
      staticClass: "alternative_datetimes-caption"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(" "), _c('label', [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "alternative_datetimes-content"
    }, [_c('div', [_c('label', [_vm._v("日付：" + _vm._s(_vm.formattedDate(alternative_datetimes.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：" + _vm._s(alternative_datetimes.start_time) + " 〜 " + _vm._s(alternative_datetimes.end_time))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(alternative_datetimes.mode === 'slot' ? 'の1コマ' : 'の中で' + alternative_datetimes.duration + '分間'))])])])])
  }))])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n        戻って修正する\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.denyButtonClicked()
      }
    }
  }, [_vm._v("\n        完了\n      ")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "el-icon-back down-arrow"
  })])
}]}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderConfirmation"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼をする")]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("以下の内容で授業振替依頼を行います")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「振替依頼をする」ボタンを押してください")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替を希望する授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.receiverInfo.user_type === 'student') ? _c('lable', {
    key: "student-name"
  }, [_vm._v("\n            生徒のお名前：" + _vm._s(_vm.receiverInfo.fullname) + "様\n          ")]) : _vm._e(), _vm._v(" "), (_vm.receiverInfo.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n            先生のお名前：" + _vm._s(_vm.receiverInfo.fullname) + "先生\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.targetReservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.targetReservation.startTime.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.targetReservation.endTime.slice(0, -3)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替候補日時")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.candidateDatetimes), function(candidate, index) {
    return _c('li', {
      key: 'candidate' + index
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(" "), _c('label', [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('div', [_c('label', [_vm._v("日付：" + _vm._s(_vm.formattedDate(candidate.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：" + _vm._s(candidate.startTime) + " 〜 " + _vm._s(candidate.endTime))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間'))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替希望理由")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, _vm._l((_vm.reschedulingInfo.reason.split('\n')), function(row) {
    return _c('div', {
      key: "reason-row"
    }, [_c('label', [_vm._v(_vm._s(row))])])
  }))]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('div', {
    key: "reservation-option",
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替後の授業情報")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [_c('label', [_vm._v("授業の種類　　　　　　：" + _vm._s(_vm.reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : _vm.reschedulingInfo.reservationOption.reservationType + '授業'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("配布物（確認テスト等）：" + _vm._s(_vm.reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("連絡事項：")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reservationOption.reservationMessage.split('\n')), function(row) {
    return _c('div', {
      key: "message-row",
      staticClass: "message-row"
    }, [_c('label', [_vm._v(_vm._s(row))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.Message) + "\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n      戻って修正する\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.okButtonClicked()
      }
    }
  }, [_vm._v("\n      振替依頼をする\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "StatusChangePanel"
    }
  }, [_c('h1', [_vm._v("ステータスの変更")]), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいステータス:\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_status),
      expression: "new_status"
    }],
    staticClass: "statusSelect",
    attrs: {
      "name": "userstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.new_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "normal",
      "selected": ""
    }
  }, [_vm._v("通常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temporal"
    }
  }, [_vm._v("短期（単一）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "trial"
    }
  }, [_vm._v("体験")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/temp"
    }
  }, [_vm._v("短期（複数、元体験生）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/norm"
    }
  }, [_vm._v("短期及び長期")])])]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changeStatusLocal
    }
  }, [_vm._v("ステータスを変更")])])
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userNameChangePanel"
    }
  }, [_c('h1', [_vm._v("ユーザ名の変更")]), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいユーザ名:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user_name),
      expression: "new_user_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changeUserNameLocal
    }
  }, [_vm._v("ユーザ名を変更")])])
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [(!_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替が確定しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へご入力内容を通知するメールが届きます")])]) : _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替依頼を不承認し、他の振替候補日時を提案しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へご入力内容を通知するメールが届きます")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpTable",
      "title": "座席予約表に戻る"
    }
  }, [_c('span', [_vm._v("座席予約表に戻る")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.isInfoPopupShown) ? _c('div', {
    attrs: {
      "id": "informationPopup"
    }
  }, [_c('span', [_vm._v("予約の情報")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableTimes"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.informationPopup.reservation.start_time) + "\n      ")])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.informationPopup.reservation.end_time) + "\n      ")])])]), _vm._v(" "), (_vm.isTanki()) ? _c('label', [_vm._v("短期講座")]) : _vm._e(), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableNames"
    }
  }, [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.informationPopup.reservation.student.fullname))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.informationPopup.reservation.teacher.fullname))])])]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類: " + _vm._s(_vm.$store.state.informationPopup.reservation.reservation_type))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("\n      配布物: " + _vm._s(_vm.$store.state.informationPopup.reservation.has_test ? '有り' : '無し') + "\n    ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "messageContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "messageSubject"
    }
  }, [_vm._v("連絡事項")]), _vm._v(" "), (_vm.$store.state.informationPopup.reservation.message) ? _c('div', {
    staticClass: "reservationMessage"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.state.informationPopup.reservation.message) + "\n    ")]) : _c('div', {
    staticClass: "reservationMessage"
  }, [_vm._v("\n      なし\n    ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "isOnline"
    }
  }, [_vm._v("\n      授業形態: " + _vm._s(Number(_vm.$store.state.informationPopup.reservation.online) === 1 ? 'オンライン' : '対面') + "\n    ")]), _vm._v(" "), (_vm.isEditable()) ? _c('button', {
    on: {
      "click": _vm.enterEdit
    }
  }, [_vm._v("編集する")]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.enterRescheduling
    }
  }, [_vm._v("振替を依頼する")]), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("閉じる")])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("開始: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("終了: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("生徒のお名前：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("先生のお名前：")])])
}]}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userList"
    }
  }, [_c('table', {
    attrs: {
      "id": "userListTable"
    }
  }, [_c('caption', [_vm._v("ユーザー一覧")]), _vm._v(" "), _c('caption', [_c('div', {
    staticClass: "cp_iptxt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "ef",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("氏名")]), _vm._v(" "), _c('span', {
    staticClass: "focus_line"
  })])]), _vm._v(" "), _c('caption', [_c('el-checkbox', {
    attrs: {
      "label": "管理者を表示する"
    },
    model: {
      value: (_vm.isShowAdmin),
      callback: function($$v) {
        _vm.isShowAdmin = $$v
      },
      expression: "isShowAdmin"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "生徒を表示する"
    },
    model: {
      value: (_vm.isShowStudent),
      callback: function($$v) {
        _vm.isShowStudent = $$v
      },
      expression: "isShowStudent"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "教師を表示する"
    },
    model: {
      value: (_vm.isShowTeacher),
      callback: function($$v) {
        _vm.isShowTeacher = $$v
      },
      expression: "isShowTeacher"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.userlistFiltered), function(user, index) {
    return (user.school_id == _vm.$store.state.userInfo.school_id || user.user_type == 'teacher') ? _c('tr', {
      key: user.id,
      staticClass: "userlist",
      class: {
        itemEven: index % 2 === 0
      }
    }, [_c('td', [_vm._v(_vm._s(user.user_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.user_name))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "colFullname",
      attrs: {
        "to": {
          path: '/management/user/' + user.user_id
        }
      }
    }, [_vm._v(_vm._s(user.fullname))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.kana))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userTypeDisplay(user.user_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userStatusDisplay(user.user_status)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "colDeleteButton",
      on: {
        "click": function($event) {
          _vm.deleteUserHandler(user.user_id)
        }
      }
    }, [_vm._v("削除")])])]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("ユーザー名")]), _vm._v(" "), _c('th', [_vm._v("氏名")]), _vm._v(" "), _c('th', [_vm._v("フリガナ")]), _vm._v(" "), _c('th', [_vm._v("種類")]), _vm._v(" "), _c('th', [_vm._v("ステータス")]), _vm._v(" "), _c('th', [_vm._v("削除")])])])
}]}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SpReschedulingList"
    }
  }, [_c('h1', [_vm._v("あなたに届いている依頼")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.list), function(content, index) {
    return _c('tr', {
      key: content.data
    }, [_c('td', [_vm._v(_vm._s(_vm.getUsername(content.sender)) + " 様")]), (content.reason) ? _c('td', [_vm._v(_vm._s(content.reason))]) : _vm._e(), (content.rescheduling_hash) ? _c('td', [_c('a', {
      attrs: {
        "href": 'SpRescheduling/' + content.rescheduling_hash
      }
    }, [_vm._v("処理ページへ")])]) : _vm._e()])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("依頼主")]), _c('th', [_vm._v("理由")]), _c('th', [_vm._v("処理ページ")])])
}]}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fontinfo effect1",
    style: (_vm.getStyle),
    attrs: {
      "id": "reservationPopup"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("予約")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "reservationForm"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('table', {
    class: {
      errorDuplication: _vm.isSomeDuplicatedReservation
    },
    attrs: {
      "title": _vm.isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : '',
      "id": "timeinfo"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "timeinput"
  }, [_c('time-select', {
    attrs: {
      "value": _vm.$store.state.previewBox.start,
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
      }
    },
    on: {
      "input": _vm.updateStartTime
    }
  })], 1)]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "timeinput"
  }, [_c('time-select', {
    attrs: {
      "value": _vm.$store.state.previewBox.end,
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        minTime: _vm.$store.state.previewBox.start
      }
    },
    on: {
      "input": _vm.updateEndTime
    }
  })], 1)])]), _vm._v(" "), _c('div', [(_vm.$store.state.userInfo.user_type === 'student') ? _c('div', [_c('label', {
    attrs: {
      "id": "type"
    }
  }, [_vm._v("授業の種類：\n      "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormal",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormalFirst",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormalFirst"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShort",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "短期")
    },
    on: {
      "change": function($event) {
        _vm.type = "短期"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShort"
    }
  }, [_vm._v("短期講座")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher' || _vm.$store.state.userInfo.user_type === 'admin') ? _c('div', [_c('label', {
    attrs: {
      "id": "type"
    }
  }, [_vm._v("授業の種類：\n      "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormal",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormalFirst",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormalFirst"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioTrial",
      "value": "体験"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "体験")
    },
    on: {
      "change": function($event) {
        _vm.type = "体験"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioTrial"
    }
  }, [_vm._v("体験授業")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShort",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "短期")
    },
    on: {
      "change": function($event) {
        _vm.type = "短期"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShort"
    }
  }, [_vm._v("短期講座")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShortFirst",
      "value": "短期初回"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "短期初回")
    },
    on: {
      "change": function($event) {
        _vm.type = "短期初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShortFirst"
    }
  }, [_vm._v("短期初回講座")])])]) : _vm._e()]), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("生徒のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'student') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('autocomplete', {
    attrs: {
      "type": 'student',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e(), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('label', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n          有り\n        ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n          無し\n        ")])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message_area",
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "予約をする",
      "disabled": !_vm.canTakeResv
    },
    on: {
      "click": _vm.takeReservation
    }
  }), _vm._v(" "), (_vm.type == '通常' || '短期') ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRecurrent),
      expression: "isRecurrent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRecurrent) ? _vm._i(_vm.isRecurrent, null) > -1 : (_vm.isRecurrent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isRecurrent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRecurrent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRecurrent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRecurrent = $$c
        }
      }
    }
  }), _vm._v("月末まで毎週予約する")]) : _vm._e(), _vm._v(" "), (_vm.isRecurrent) ? _c('recurrent-panel') : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isTanki) ? [_c('temporaryLecturePanel', {
    attrs: {
      "teacher": _vm.teacher,
      "reservationType": _vm.type
    }
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("開始: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("終了: ")])])
}]}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigationBar"
    }
  }, [_c('ul', {
    staticClass: "listButtons leftButtons"
  }, [_c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/table",
      "title": "座席予約表を見る"
    }
  }, [_c('i', {
    staticClass: "icon-timeline"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("座席予約表を見る")])]), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/reservation_list",
      "title": "予約のリスト"
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("予約のリスト")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/rescheduling",
      "title": "予約変更"
    }
  }, [_c('i', {
    staticClass: "icon-alarm"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("振替を依頼する")])]), _vm._v(" "), (this.$route.path === '/table') ? _c('datepicker', {
    staticStyle: {
      "display": "inline-block",
      "width": "140px"
    },
    attrs: {
      "language": "ja",
      "format": 'yyyy年MM月dd日(D)',
      "value": _vm.$store.state.curDate.toISOString(),
      "disabled": _vm.getDisableDays()
    },
    on: {
      "selected": _vm.dateSelectHandler
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.$store.state.spinning) ? _c('img', {
    staticClass: "kyushinjuku-logo",
    attrs: {
      "src": __webpack_require__(80)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.$store.state.spinning) ? _c('spinner', {
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "color": 'white',
      "size": '40px'
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "headerButtons"
  }, [(_vm.$store.state.userInfo.user_type !== 'student') ? _c('span', {
    staticClass: "school",
    on: {
      "click": _vm.schoolChange
    }
  }, [(_vm.$store.state.userInfo.school_id === '1') ? _c('a', {
    staticClass: "school_ike"
  }, [_vm._v("池袋校")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.school_id === '2') ? _c('a', {
    staticClass: "school_yoko"
  }, [_vm._v("横浜校")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "on_off",
    on: {
      "click": _vm.showOnline
    }
  }, [(_vm.$store.state.showOnline) ? _c('a', {
    staticClass: "online"
  }, [_vm._v("Online")]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.showOnline) ? _c('a', {
    staticClass: "offline"
  }, [_vm._v("Offline")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "listButtons rightButtons"
  }, [_c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/help",
      "title": "ヘルプ"
    }
  }, [_c('i', {
    staticClass: "icon-question-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ヘルプ")])]), _vm._v(" "), (_vm.isTeacher) ? _c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/reservationlist",
      "title": "月末報告"
    }
  }, [_c('i', {
    staticClass: "icon-appointment-agenda"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("月末報告")])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/management",
      "title": "管理画面"
    }
  }, [_c('i', {
    staticClass: "icon-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("管理画面")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "button",
      "to": "/userinfo",
      "title": "ユーザー情報"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ユーザー情報")])]), _vm._v(" "), _c('button', {
    attrs: {
      "title": "ログアウト"
    },
    on: {
      "click": _vm.beforeLogout
    }
  }, [_c('i', {
    staticClass: "icon-exit"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ログアウト")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottomline"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderPage"
    }
  }, [_c('div', {
    staticClass: "help"
  }, [_c('span', {
    staticClass: "help-icon",
    on: {
      "click": function($event) {
        _vm.helpCliked()
      }
    }
  }, [(!_vm.help_cliked) ? _c('i', {
    staticClass: "icon-question-sign"
  }) : _vm._e(), _vm._v(" "), (_vm.help_cliked) ? _c('i', {
    staticClass: "icon-circledelete"
  }) : _vm._e()]), _vm._v(" "), (_vm.help_cliked) ? _c('div', {
    staticClass: "help_information"
  }, [_c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をする場合")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$router.push('/table')
      }
    }
  }, [_vm._v("\n    座席予約表トップへ\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("座席予約表へログイン後、画面左上の「振替を依頼する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2"
  }, [_c('li', [_vm._v("①振替を希望する授業をリストから選択")]), _vm._v(" "), _c('li', [_vm._v("②振替候補日時を選択")]), _vm._v(" "), _c('li', [_vm._v("③振替を希望する理由を入力")]), _vm._v(" "), _c('li', [_vm._v("（講師のみ、④振替後の授業の情報を入力）")])]), _vm._v(" "), _c('li', [_vm._v("入力項目を確認し、「振替依頼をする」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("完了画面を確認し、「座席表トップへ」をクリック")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("振替依頼をしたあとは・・・")]), _vm._v(" "), _c('p', [_vm._v("24時間以内に振替の承認・不承認の結果がメールで届きます。"), _c('br'), _vm._v("\n  \t\t\t\t承認された場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n  \t\t\t\t不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。")])])
}]}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverPage"
    }
  }, [_c('div', {
    staticClass: "help"
  }, [_c('span', {
    staticClass: "help-icon",
    on: {
      "click": function($event) {
        _vm.helpCliked()
      }
    }
  }, [(!_vm.help_cliked) ? _c('i', {
    staticClass: "icon-question-sign"
  }) : _vm._e(), _vm._v(" "), (_vm.help_cliked) ? _c('i', {
    staticClass: "icon-circledelete"
  }) : _vm._e()]), _vm._v(" "), (_vm.help_cliked) ? _c('div', {
    staticClass: "help_information"
  }, [_c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をされた場合")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$router.push('/table')
      }
    }
  }, [_vm._v("\n    座席予約表トップへ\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く")]), _vm._v(" "), _c('li', [_vm._v("メール内のURLをクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①振替候補日時からご都合の良い日時を選択")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②振替後の授業を予約する座席を選択")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替を確定する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表トップへ」をクリック")])]), _c('br'), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【不承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①「振替を不承認する」にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②他の振替候補日時を入力")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替依頼を不承認する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表」をクリック")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("承認/不承認をしたあとは・・・")]), _vm._v("\n  \t\t\t\t承認・不承認の結果がメールで依頼者に届きます。"), _c('br'), _vm._v("\n  \t\t\t\t承認した場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n  \t\t\t\t不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。\n  \t\t")])
}]}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingListPage"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼の一覧ページ")]), _vm._v(" "), _c('h2', [_vm._v("以下の授業振替依頼が届いております。依頼を承諾または拒否してください")])])
}]}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservationBox",
    class: {
      firstTime: _vm.canDisplay && _vm.reservation.reservation_type === '初回',
        trial: _vm.canDisplay && _vm.reservation.reservation_type === '体験',
        hasTest: _vm.canDisplay && _vm.reservation.hasTest,
        hasMessage: _vm.canDisplay && _vm.reservation.message !== '',
        grayedOut: !_vm.canDisplay
    },
    style: (_vm.getStyle),
    on: {
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "mouseout": function($event) {
        _vm.hover = false
      },
      "click": _vm.clickHandler
    }
  }, [(_vm.canDisplay) ? _c('statelist', {
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.reduceTimeExp(_vm.reservation.start_time)) + "〜\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.reduceTimeExp(_vm.reservation.end_time)) + "\n  ")]), _vm._v(" "), (_vm.canDisplay) ? _c('div', [_c('div', [_vm._v("\n      " + _vm._s(_vm.reservation.student.fullname) + " 様\n      "), (_vm.isVailedCheck) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAttendance(_vm.reservation.student.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.attendingState(_vm.reservation.student.id)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.reservation.teacher.fullname) + " 先生\n      "), (_vm.isVailedCheck) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAttendance(_vm.reservation.teacher.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.attendingState(_vm.reservation.teacher.id)) + "\n      ")]) : _vm._e()])]) : _c('p', [_vm._v("予約済み")])], 1)
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingOptionForm"
    }
  }, [_c('div', {
    attrs: {
      "id": "option-box"
    }
  }, [_c('div', {
    staticClass: "option-content"
  }, [_c('label', [_vm._v("授業の種類：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-normal",
      "type": "radio",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "通常")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "通常")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-normal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-normal-first",
      "type": "radio",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "通常初回")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-normal-first"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-short",
      "type": "radio",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "短期")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "短期")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-short"
    }
  }, [_vm._v("短期講座")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-short",
      "type": "radio",
      "value": "短期初回"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "短期初回")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "短期初回")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-short-first"
    }
  }, [_vm._v("短期初回講座")])]), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, [_c('label', [_vm._v("配布物（確認テスト）等：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.hasTest),
      expression: "reservationOption.hasTest"
    }],
    attrs: {
      "id": "radio-test-false",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.reservationOption.hasTest, false)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "hasTest", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-test-false"
    }
  }, [_vm._v("なし")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.hasTest),
      expression: "reservationOption.hasTest"
    }],
    attrs: {
      "id": "radio-test-true",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.reservationOption.hasTest, true)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "hasTest", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-test-true"
    }
  }, [_vm._v("あり")])]), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, [_c('label', [_vm._v("授業での連絡事項があれば記入してください（任意）")]), _vm._v(" "), _c('div', {
    staticClass: "text-area"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "連絡事項があれば入力してください",
      "rows": "3"
    },
    model: {
      value: (_vm.reservationOption.reservationMessage),
      callback: function($$v) {
        _vm.$set(_vm.reservationOption, "reservationMessage", $$v)
      },
      expression: "reservationOption.reservationMessage"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.editingState.isPopupShown) ? _c('div', {
    style: (_vm.getStyle()),
    attrs: {
      "id": "editingPopup"
    }
  }, [_c('span', [_vm._v("予約の編集")]), _vm._v(" "), _c('button', {
    staticClass: "closeButton",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.changeClassroomLeft()
      }
    }
  }, [_vm._v("教室を左に移動")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.changeClassroomRight()
      }
    }
  }, [_vm._v("教室を右に移動")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "editingForm"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('table', {
    class: {
      errorDuplication: _vm.isSomeDuplicatedReservation
    },
    attrs: {
      "title": _vm.isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : ''
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('time-select', {
    attrs: {
      "value": _vm.$store.state.editingState.start,
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        maxTime: _vm.$store.state.editingState.end
      }
    },
    on: {
      "input": _vm.updateStartTime
    }
  })], 1)]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('time-select', {
    attrs: {
      "value": _vm.$store.state.editingState.end,
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        minTime: _vm.$store.state.editingState.start
      }
    },
    on: {
      "input": _vm.updateEndTime
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n        "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationType),
      expression: "reservationType"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormal",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationType, "通常")
    },
    on: {
      "change": function($event) {
        _vm.reservationType = "通常"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationType),
      expression: "reservationType"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormalFirst",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationType, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.reservationType = "通常初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormalFirst"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationType),
      expression: "reservationType"
    }],
    attrs: {
      "type": "radio",
      "id": "radioTrial",
      "value": "体験"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationType, "体験")
    },
    on: {
      "change": function($event) {
        _vm.reservationType = "体験"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioTrial"
    }
  }, [_vm._v("体験授業")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationType),
      expression: "reservationType"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShort",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationType, "短期")
    },
    on: {
      "change": function($event) {
        _vm.reservationType = "短期"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShort"
    }
  }, [_vm._v("短期講座")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationType),
      expression: "reservationType"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShortFirst",
      "value": "短期初回"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationType, "短期初回")
    },
    on: {
      "change": function($event) {
        _vm.reservationType = "短期初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShortFirst"
    }
  }, [_vm._v("短期初回講座")])])]), _vm._v(" "), _c('div', [(!_vm.isTanki) ? [_c('div', [_c('span', [_vm._v("生徒のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'student') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getStudentList(),
      "type": 'student',
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getStudentList(),
      "type": 'admin',
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })]], 2), _vm._v(" "), _c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'teacher',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'admin',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]] : _vm._e()], 2), _vm._v(" "), (!_vm.isTanki) ? [(_vm.isRecurrent) ? _c('recurrent-panel') : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n                  有り\n                ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n                  無し\n                ")])])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isOnline()
    },
    on: {
      "change": function($event) {
        _vm.$store.commit('EDITINGSTATE_SET_IS_ONLINE', !_vm.isOnline())
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": _vm.message()
    },
    on: {
      "input": function($event) {
        _vm.$store.commit('EDITINGSTATE_SET_MESSAGE', $event.target.value)
      }
    }
  }), _vm._v(" "), (false) ? _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllEditing),
      expression: "isAllEditing"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllEditing) ? _vm._i(_vm.isAllEditing, null) > -1 : (_vm.isAllEditing)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isAllEditing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllEditing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isAllEditing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllEditing = $$c
        }
      }
    }
  }), _vm._v("\n                以降の予約全てを変更する\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "button",
      "value": "編集を完了する",
      "disabled": !_vm.canTakeResv
    },
    on: {
      "click": _vm.completeEdit
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "キャンセル"
    },
    on: {
      "click": _vm.closePopup
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "eraseButton",
      "type": "button",
      "value": "予約を削除する"
    },
    on: {
      "click": _vm.eraseReservation
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isTanki) ? [_c('temporaryLecturePanel', {
    attrs: {
      "teacher": _vm.teacher,
      "isEdit": true,
      "reservationType": _vm.reservationType
    }
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'teacher',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "suggestions": _vm.getTeacherList(),
      "type": 'admin',
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "変更の確認",
      "visible": _vm.dialogEditVisible,
      "width": "50%",
      "modal-append-to-body": false,
      "top": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEditVisible = $event
      }
    }
  }, [_c('p', [_vm._v("この予約は月末まで毎週予約されています。")]), _vm._v(" "), _c('p', [_vm._v("以降の予約を全て変更しますか？この予約のみを変更しますか？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function () {
        _vm.isAllEditing = true
        _vm.dialogEditVisible = false
        _vm.doEdit()
      }
    }
  }, [_vm._v("\n              以降の予約全てを変更\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function () {
        _vm.isAllEditing = false
        _vm.dialogEditVisible = false
        _vm.doEdit()
      }
    }
  }, [_vm._v("\n              この予約のみ変更\n            ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "削除の確認",
      "visible": _vm.dialogDeleteVisible,
      "width": "50%",
      "modal-append-to-body": false,
      "top": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDeleteVisible = $event
      }
    }
  }, [_c('p', [_vm._v("この予約は月末まで毎週予約されています。")]), _vm._v(" "), _c('p', [_vm._v("以降の予約を全て削除しますか？この予約のみを削除しますか？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function () {
        _vm.isAllEditing = true
        _vm.dialogDeleteVisible = false
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n              以降の予約全てを削除\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function () {
        _vm.isAllEditing = false
        _vm.dialogDeleteVisible = false
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n              この予約のみ削除\n            ")])], 1)])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("開始: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("終了: ")])])
}]}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fontinfo effect1",
    style: (_vm.getStyle),
    attrs: {
      "id": "reservationPopup"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("予約")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "reservationForm"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('table', {
    class: {
      errorDuplication: _vm.isSomeDuplicatedReservation
    },
    attrs: {
      "title": _vm.isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : ''
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.previewBox.start),
      expression: "$store.state.previewBox.start"
    }],
    staticClass: "time_Selector",
    attrs: {
      "type": "time",
      "min": "10:00",
      "max": "23:00"
    },
    domProps: {
      "value": (_vm.$store.state.previewBox.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.previewBox, "start", $event.target.value)
      }
    }
  })]), _vm._v("〜\n      "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.previewBox.end),
      expression: "$store.state.previewBox.end"
    }],
    staticClass: "time_Selector",
    attrs: {
      "type": "time",
      "min": "10:00",
      "max": "23:00"
    },
    domProps: {
      "value": (_vm.$store.state.previewBox.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.previewBox, "end", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [(_vm.$store.state.userInfo.user_type === 'student') ? _c('div', [_c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("通常")]), _vm._v(" "), _c('option', [_vm._v("通常初回")]), _vm._v(" "), _c('option', [_vm._v("短期")])]), _vm._v("\n      授業\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher' || _vm.$store.state.userInfo.user_type === 'admin') ? _c('div', [_c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("通常")]), _vm._v(" "), _c('option', [_vm._v("通常初回")]), _vm._v(" "), _c('option', [_vm._v("体験")]), _vm._v(" "), _c('option', [_vm._v("短期")]), _vm._v(" "), _c('option', [_vm._v("短期初回")])]), _vm._v("\n      授業\n    ")])]) : _vm._e()]), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("生徒のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'student') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('autocomplete', {
    attrs: {
      "type": 'student',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e(), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('label', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n          有り\n        ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n          無し\n        ")])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message_area",
    staticStyle: {
      "width": "50vw"
    },
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.type == '通常' || '短期') ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRecurrent),
      expression: "isRecurrent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRecurrent) ? _vm._i(_vm.isRecurrent, null) > -1 : (_vm.isRecurrent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isRecurrent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRecurrent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRecurrent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRecurrent = $$c
        }
      }
    }
  }), _vm._v("月末まで毎週予約する")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ender"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "予約をする",
      "disabled": !_vm.canTakeResv
    },
    on: {
      "click": _vm.takeReservation
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "キャンセル"
    },
    on: {
      "click": _vm.closePopup
    }
  })]), _vm._v(" "), (_vm.isRecurrent) ? _c('recurrent-panel') : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isTanki) ? [_c('temporaryLecturePanel', {
    attrs: {
      "teacher": _vm.teacher,
      "reservationType": _vm.type
    }
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("時間: ")])])
}]}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderForm"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼をする")]), _vm._v(" "), (_vm.check_tankiuser()) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.check_tankiuser()) ? _c('div', [_c('section', {
    staticClass: "section",
    attrs: {
      "id": "first-section"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.selectedReservation && !_vm.isOther) ? _c('div', {
    key: "warning-first-unselected"
  }, [_c('notificationBox', {
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "振替を希望する授業を選択してください"
    }
  })], 1) : (_vm.isCompletenessChecking && !_vm.isFirstCompleted) ? _c('notificationBox', {
    key: "warning-first-unspecified",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "授業の情報を全て指定してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isFirstCompleted) ? _c('notificationBox', {
    key: "ok-first",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("授業数：" + _vm._s(_vm.reservations.length) + "件")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "reservation-list"
    }
  }, _vm._l((_vm.reservations), function(reservation, index) {
    return _c('li', {
      key: 'reservation' + index,
      staticClass: "list-item list-item-reservation"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedReservation),
        expression: "selectedReservation"
      }],
      attrs: {
        "id": 'list-item-reservation-radio' + index,
        "type": "radio",
        "disabled": _vm.isOther || reservation.expireCheck
      },
      domProps: {
        "value": reservation,
        "checked": _vm._q(_vm.selectedReservation, reservation)
      },
      on: {
        "change": [function($event) {
          _vm.selectedReservation = reservation
        }, function($event) {
          _vm.reservationChanged()
        }]
      }
    }), _vm._v(" "), (!reservation.expireCheck) ? _c('label', {
      attrs: {
        "for": 'list-item-reservation-radio' + index
      }
    }, [_vm._v(_vm._s(reservation.text))]) : _c('label', {
      staticStyle: {
        "color": "#989898"
      },
      attrs: {
        "for": 'list-item-reservation-radio' + index
      },
      on: {
        "click": function($event) {
          _vm.alert('授業振替ではなく授業キャンセルとなるので、別途究進塾にご連絡（電話orメール）ください')
        }
      }
    }, [_vm._v(_vm._s(reservation.text) + "  期限切れです")])])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOther),
      expression: "isOther"
    }],
    attrs: {
      "id": "otherCheck",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOther) ? _vm._i(_vm.isOther, null) > -1 : (_vm.isOther)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isOther,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOther = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOther = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOther = $$c
        }
      }, function($event) {
        _vm.reservationChanged()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "otherCheck"
    }
  }, [_vm._v("上記以外の授業")]), _vm._v(" "), (_vm.isOther) ? _c('div', {
    key: "other-reservation",
    attrs: {
      "id": "other-reservation-box"
    }
  }, [(_vm.$store.state.userInfo.user_type === 'teacher') ? _c('div', {
    key: "select-student"
  }, [_c('label', [_vm._v("生徒のお名前：")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggestions": _vm.studentList
    },
    model: {
      value: (_vm.otherReservation.receiver),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "receiver", $$v)
      },
      expression: "otherReservation.receiver"
    }
  })], 1) : (_vm.$store.state.userInfo.user_type === 'student') ? _c('div', {
    key: "select-teacher"
  }, [_c('label', [_vm._v("先生のお名前：")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggestions": _vm.teacherList
    },
    model: {
      value: (_vm.otherReservation.receiver),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "receiver", $$v)
      },
      expression: "otherReservation.receiver"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "placeholder": "日付を選択",
      "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(_vm.otherReservation.date)) + ')',
      "value-format": "yyyy-MM-dd",
      "picker-options": {
        disabledDate: _vm.disabledDate
      }
    },
    model: {
      value: (_vm.otherReservation.date),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "date", $$v)
      },
      expression: "otherReservation.date"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "開始時刻を選択",
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        maxTime: _vm.otherReservation.endTime,
      }
    },
    model: {
      value: (_vm.otherReservation.startTime),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "startTime", $$v)
      },
      expression: "otherReservation.startTime"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "終了時刻を選択",
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        minTime: _vm.otherReservation.startTime
      }
    },
    model: {
      value: (_vm.otherReservation.endTime),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "endTime", $$v)
      },
      expression: "otherReservation.endTime"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "second-section"
    }
  }, [_vm._m(3), _vm._v(" "), (!_vm.isFirstCompleted) ? _c('notificationBox', {
    key: "warning-second-uncompleted-first",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "候補日時を指定する前に振替を希望する授業を選択してください"
    }
  }) : (_vm.isCompletenessChecking && !_vm.isSecondCompleted) ? _c('notificationBox', {
    key: "warning-second-unspecified",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "全ての候補日時の日付、開始時刻，終了時刻を指定してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isSecondCompleted) ? _c('notificationBox', {
    key: "ok-second",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFirstCompleted) ? _c('div', {
    key: "candidate-list"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.candidateDatetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.candidateDatetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
      staticStyle: {
        "width": "190px"
      },
      attrs: {
        "placeholder": "日付を選択",
        "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(cand.date)) + ')',
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: _vm.disabledDate
        }
      },
      model: {
        value: (cand.date),
        callback: function($$v) {
          _vm.$set(cand, "date", $$v)
        },
        expression: "cand.date"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-slot-mode' + index,
        "type": "radio",
        "value": "slot"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "slot")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "slot")
        }, function($event) {
          cand.startTime = null;
          cand.endTime = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-slot-mode' + index
      }
    }, [_vm._v("1コマ分を指定")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-range-mode' + index,
        "type": "radio",
        "value": "range"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "range")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "range")
        }, function($event) {
          cand.startTime = null;
          cand.endTime = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-range-mode' + index
      }
    }, [_vm._v("範囲で指定")])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "開始時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          maxTime: _vm.getMaxStartTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateStartTimeChanged(cand)
        }
      },
      model: {
        value: (cand.startTime),
        callback: function($$v) {
          _vm.$set(cand, "startTime", $$v)
        },
        expression: "cand.startTime"
      }
    }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "終了時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: _vm.getMinEndTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateEndTimeChanged(cand)
        }
      },
      model: {
        value: (cand.endTime),
        callback: function($$v) {
          _vm.$set(cand, "endTime", $$v)
        },
        expression: "cand.endTime"
      }
    }), _vm._v(" "), (cand.mode === 'slot') ? _c('label', {
      key: "slot-mode"
    }, [_vm._v("\n                  の1コマ\n                ")]) : (cand.mode === 'range') ? _c('label', {
      key: "range-mode"
    }, [_vm._v("\n                  の中で" + _vm._s(_vm.reservationDuration) + "分間\n                ")]) : _vm._e()], 1)])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  }, [_vm._v("\n          ＋ 候補日時を追加する\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "third-section"
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isThirdCompleted) ? _c('notificationBox', {
    key: "warning-third",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "理由は必須項目です"
    }
  }) : (_vm.isCompletenessChecking && _vm.isThirdCompleted) ? _c('notificationBox', {
    key: "ok-third",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-area"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "理由を入力してください",
      "rows": "3"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', {
    key: "fourth-section",
    attrs: {
      "id": "fourth-section"
    }
  }, [_vm._m(5), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isFourthCompleted) ? _c('notificationBox', {
    key: "warning-fourth",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "授業の種類，配布物の有無を入力してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isFourthCompleted) ? _c('notificationBox', {
    key: "ok-fourth",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_vm._v("\n      入力内容を確認する\n    ")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('a', [_vm._v("恐れ入りますが、短期コースを受講されている方は振替機能をご利用いただけません。"), _c('br'), _vm._v("\n        振替をご希望の方は究進塾事務局(info@kyushinjuku.com)へ、"), _c('br'), _vm._v("\n        授業前日22時までにご連絡ください。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 1")]), _vm._v(" :   振替を希望する授業を以下のリストから選択してください")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('p', [_vm._v("振替依頼は、必ず授業前日22:00までに完了してください。")]), _vm._v(" "), _c('p', [_vm._v("それ以降は振替依頼をすることが出来ません。")]), _vm._v(" "), _c('p', [_vm._v("授業前日22:00を過ぎた場合は振替ではなくキャンセルとなりますので、")]), _vm._v(" "), _c('p', [_vm._v("お電話またはメールにて事務局までご連絡ください。")]), _vm._v(" "), _c('p', [_vm._v("TEL:03-5927-1660 (日曜/年末年始を除く13:00-21:00)")]), _vm._v(" "), _c('p', [_vm._v("MAIL : info@kyushinjuku.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 2")]), _vm._v(" :   振替候補日時を指定してください")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 3")]), _vm._v(" :   振替を希望する理由を入力してください（必須）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 4")]), _vm._v(" :   振替"), _c('b', [_vm._v("後")]), _vm._v("の授業の情報を指定してください")])
}]}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverForm"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼を承認／不承認する")]), _vm._v(" "), (!_vm.reschedulingInfo) ? _c('div', {
    key: "not-found"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(1)]) : (_vm.reschedulingInfo.status != 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(2)]) : (!_vm.checkExpireDate) ? _c('div', {
    key: "expiration"
  }, [_vm._m(3)]) : _c('div', {
    key: "receiver-form"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "が以下の授業振替を依頼されています")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("対象の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -3)))])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替希望理由")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reason.split('\n')), function(row) {
    return _c('p', {
      key: "reason-row",
      staticClass: "info-content reason-row"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替を"), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("承認")]), _vm._v("する場合は"), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("候補日時のうちの1つを選択")]), _vm._v("してください")], 1), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替を"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("不承認")]), _vm._v("する場合は"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("「振替を不承認する」にチェック")]), _vm._v("してください")], 1), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isSelectionCompleted) ? _c('notificationBox', {
    key: "warning-selection",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "候補日時のうち1つを選択するか、「振替を不承認する」にチェックしてください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isSelectionCompleted) ? _c('notificationBox', {
    key: "ok-selection",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDenying),
      expression: "isDenying"
    }],
    attrs: {
      "id": "denying-checkbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDenying) ? _vm._i(_vm.isDenying, null) > -1 : (_vm.isDenying)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDenying,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDenying = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDenying = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDenying = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "denying-checkbox"
    }
  }, [_vm._v("振替を不承認する")])]), _vm._v(" "), (!_vm.isDenying) ? _c('div', {
    key: "select-datetime-area",
    attrs: {
      "id": "select-datetime-area"
    }
  }, [_c('div', {
    staticClass: "info",
    class: {
      'info-inline-block': !_vm.isNarrowMode
    }
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("元の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -3)))])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-back",
    class: {
      'right-arrow': !_vm.isNarrowMode, 'down-arrow': _vm.isNarrowMode
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info",
    class: {
      'info-inline-block': !_vm.isNarrowMode
    }
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("候補日時")]), _vm._v(" "), _c('ul', {
    staticClass: "info-content",
    class: {
      'narrow-list': !_vm.isNarrowMode
    },
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.candidate_datetimes), function(candidate, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item-candidate-index"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCandidate),
        expression: "selectedCandidate"
      }],
      attrs: {
        "id": 'list-item-candidate-radio' + index,
        "type": "radio",
        "disabled": _vm.isDenying
      },
      domProps: {
        "value": candidate,
        "checked": _vm._q(_vm.selectedCandidate, candidate)
      },
      on: {
        "change": [function($event) {
          _vm.selectedCandidate = candidate
        }, function($event) {
          _vm.selectedCandidateChanged()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'list-item-candidate-radio' + index
      }
    }, [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('p', [_vm._v("日付：" + _vm._s(_vm.formattedDate(candidate.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：" + _vm._s(candidate.start_time) + " 〜 " + _vm._s(candidate.end_time) + _vm._s(candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間'))])])])
  }))])]) : _vm._e()], 1), _vm._v(" "), (!_vm.isDenying && _vm.selectedCandidate && _vm.selectedCandidate.mode === 'range') ? _c('section', {
    key: "timeslot",
    staticClass: "section"
  }, [_c('div', [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.selectedCandidate.start_time) + " 〜 " + _vm._s(_vm.selectedCandidate.end_time) + "の中で" + _vm._s(_vm.selectedCandidate.duration) + "分間、都合の良い時間帯を1つ選んでください")]), _vm._v(" "), _c('p', [_vm._v("（開始時刻か終了時刻のどちらかを指定すると、自動的にもう一方も指定されます）")]), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isTimeslotCompleted) ? _c('notificationBox', {
    key: "warning-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "開始時刻と終了時刻を選択してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isTimeslotCompleted) ? _c('notificationBox', {
    key: "ok-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "開始時刻を選択",
      "picker-options": {
        start: _vm.selectedCandidate.start_time,
        end: _vm.selectedCandidate.end_time,
        step: '00:05',
        maxTime: _vm.moment(_vm.selectedCandidate.end_time, 'HH:mm').add(-_vm.selectedCandidate.duration + 1, 'minutes').format('HH:mm')
      }
    },
    on: {
      "change": function($event) {
        _vm.timeslotStartTimeChanged()
      }
    },
    model: {
      value: (_vm.timeslot.start_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_time", $$v)
      },
      expression: "timeslot.start_time"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "終了時刻を選択",
      "picker-options": {
        start: _vm.selectedCandidate.start_time,
        end: _vm.selectedCandidate.end_time,
        step: '00:05',
        minTime: _vm.moment(_vm.selectedCandidate.start_time, 'HH:mm').add(_vm.selectedCandidate.duration - 1, 'minutes').format('HH:mm')
      }
    },
    on: {
      "change": function($event) {
        _vm.timeslotEndTimeChanged()
      }
    },
    model: {
      value: (_vm.timeslot.end_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_time", $$v)
      },
      expression: "timeslot.end_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("不承認の場合、他の候補日時を複数記入してください。")]), _vm._v(" "), (!_vm.isAlternativeDatetimes && _vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "warning-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "開始時刻と終了時刻を選択してください"
    }
  }) : (_vm.isAlternativeDatetimes && _vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "ok-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: "candidate-list"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.alternative_datetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.alternative_datetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
      staticStyle: {
        "width": "190px"
      },
      attrs: {
        "placeholder": "日付を選択",
        "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(cand.date)) + ')',
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: _vm.disabledDate
        }
      },
      model: {
        value: (cand.date),
        callback: function($$v) {
          _vm.$set(cand, "date", $$v)
        },
        expression: "cand.date"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-slot-mode' + index,
        "type": "radio",
        "value": "slot"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "slot")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "slot")
        }, function($event) {
          cand.start_time = null;
          cand.end_time = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-slot-mode' + index
      }
    }, [_vm._v("1コマ分を指定")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-range-mode' + index,
        "type": "radio",
        "value": "range"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "range")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "range")
        }, function($event) {
          cand.start_time = null;
          cand.end_time = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-range-mode' + index
      }
    }, [_vm._v("範囲で指定")])]), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "開始時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          maxTime: _vm.getMaxStartTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateStartTimeChanged(cand)
        }
      },
      model: {
        value: (cand.start_time),
        callback: function($$v) {
          _vm.$set(cand, "start_time", $$v)
        },
        expression: "cand.start_time"
      }
    }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "終了時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: _vm.getMinEndTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateEndTimeChanged(cand)
        }
      },
      model: {
        value: (cand.end_time),
        callback: function($$v) {
          _vm.$set(cand, "end_time", $$v)
        },
        expression: "cand.end_time"
      }
    }), _vm._v(" "), (cand.mode === 'slot') ? _c('label', {
      key: "slot-mode"
    }, [_vm._v("\n                  の1コマ\n                ")]) : (cand.mode === 'range') ? _c('label', {
      key: "range-mode"
    }, [_vm._v("\n                  の中で" + _vm._s(_vm.reservationDuration) + "分間\n                ")]) : _vm._e()], 1)])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  }, [_vm._v("\n          ＋ 候補日時を追加する\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', {
    key: "option-section",
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替後の授業の情報を指定してください")]), _vm._v(" "), (_vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "ok-reservation-option",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDenying) ? _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.commitMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDenying) ? _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.denyButtonClicked()
      }
    }
  }, [_vm._v("\n      確認画面に進む\n    ")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報が見つかりません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報の承認期限が過ぎております")])])
}]}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle),
    attrs: {
      "id": "rulerHeader"
    }
  }, [_c('span', {
    staticClass: "tlHeaderText"
  }, [_vm._v("教室/時刻")])])
},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editLecturePage"
    }
  }, [_c('table', [_c('caption', [_vm._v("\n      講義情報一覧\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lecture.teacher),
      expression: "lecture.teacher"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.lecture, "teacher", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortedTeacherList), function(teacher, index) {
    return _c('option', {
      key: teacher.user_id,
      domProps: {
        "value": teacher.user_id
      }
    }, [_vm._v(_vm._s(teacher.fullname))])
  }))]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lecture.student),
      expression: "lecture.student"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.lecture, "student", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortedStudentList), function(student, index) {
    return _c('option', {
      key: student.user_id,
      domProps: {
        "value": student.user_id
      }
    }, [_vm._v(_vm._s(student.fullname))])
  }))]), _vm._v(" "), _c('td', [_c('button', {
    on: {
      "click": function($event) {
        _vm.registerLecture()
      }
    }
  }, [_vm._v("登録")])])]), _vm._v(" "), _vm._l((_vm.sortedLectureList), function(lecture, index) {
    return _c('tr', {
      key: index,
      class: {
        evenRow: index % 2 === 0
      }
    }, [_c('td', [_vm._v(_vm._s(lecture.teacher.fullname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lecture.student.fullname))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeLecture(lecture.id)
        }
      }
    }, [_vm._v("×")])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("教師名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("生徒名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  })])
}]}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "timetable"
    }
  }, [_c('table', [_c('ticker'), _vm._v(" "), _c('thead', {
    staticClass: "tableheader"
  }, [_c('tr', [_c('th', {
    staticClass: "blank"
  }, [_c('rulerHeader')], 1), _vm._v(" "), _vm._l((_vm.filteredclassroomNames), function(classroom) {
    return _c('classroomHeader', {
      key: classroom.name,
      attrs: {
        "classroom": classroom.name
      }
    })
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "tabletimeline"
  }, [_c('ruler')], 1), _vm._v(" "), _c('td', [_c('timelineContainer')], 1)])]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('informtionPopup'), _vm._v(" "), _c('editingPopup'), _vm._v(" "), _c('ReschedulingPopup'), _vm._v(" "), (_vm.$store.state.reservationbox.isPopupShown) ? _c('ReservationPopup') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('td')])
}]}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "ruler"
    }
  }, _vm._l((_vm.$store.state.timeScaleTicks), function(ticks, index) {
    return _c('div', {
      staticClass: "rulerTicksCell",
      class: _vm.getTicksClass(index),
      style: (_vm.ticksCellStyle)
    }, [_c('span', {
      staticClass: "rulerTicks"
    }, [_vm._v(_vm._s(ticks))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline",
    style: (_vm.getStyle),
    on: {
      "mousedown": function($event) {
        _vm.mousedownHandler($event)
      },
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "click": function($event) {
        _vm.clickHandler($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigationBar"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.$store.state.spinning) ? _c('img', {
    staticClass: "kyushinjuku-logo",
    attrs: {
      "src": __webpack_require__(80)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.$store.state.spinning) ? _c('spinner', {
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "color": 'white',
      "size": '40px'
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe.left",
      value: (_vm.swipeHandler),
      expression: "swipeHandler",
      arg: "swipe",
      modifiers: {
        "left": true
      }
    }]
  }, [_c('label', {
    on: {
      "click": _vm.open_Menu
    }
  }, [_c('span', [(!_vm.reschedulinglist) ? _c('i', {
    staticClass: "icon-menu menu_style"
  }) : _vm._e(), (_vm.reschedulinglist) ? _c('i', {
    staticClass: "icon-exclamation-sign attention"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-drawer"
    }
  }, [_c('input', {
    staticClass: "nav-unshown",
    attrs: {
      "id": "nav-input",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "nav-unshown",
    attrs: {
      "id": "nav-close",
      "for": "nav-input"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-content"
    }
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('h1', {
    staticClass: "mune_title"
  }, [_vm._v("Menu\n              "), (_vm.$store.state.userInfo.user_type !== 'student') ? _c('span', {
    staticClass: "school",
    on: {
      "click": [_vm.schoolChange, _vm.close_Menu]
    }
  }, [(_vm.$store.state.userInfo.school_id === '1') ? _c('a', {
    staticClass: "school_ike"
  }, [_vm._v("池袋校")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.school_id === '2') ? _c('a', {
    staticClass: "school_yoko"
  }, [_vm._v("横浜校")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('datepicker', {
    style: ('float:right;'),
    attrs: {
      "language": "ja",
      "format": 'yyyy年MM月dd日(D)',
      "value": _vm.$store.state.curDate.toISOString(),
      "inline": true,
      "disabled": _vm.getDisableDays()
    },
    on: {
      "selected": _vm.dateSelectHandler,
      "input": _vm.close_Menu
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpTable",
      "title": "座席予約表を見る"
    }
  }, [_c('i', {
    staticClass: "icon-timeline"
  }), _vm._v(" "), _c('span', [_vm._v("座席予約表を見る")])])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpRescheduling",
      "title": "予約変更"
    }
  }, [_c('i', {
    staticClass: "icon-alarm"
  }), _vm._v(" "), _c('span', [_vm._v("振替を依頼する")])])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpReschedulingList",
      "title": "依頼リスト"
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v(" "), _c('span', [_vm._v("依頼リスト")]), _vm._v(" "), (_vm.reschedulinglist) ? _c('i', {
    staticClass: "icon-exclamation-sign",
    staticStyle: {
      "color": "red",
      "font-size": "8vh"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpHelpPage",
      "title": "ヘルプ"
    }
  }, [_c('i', {
    staticClass: "icon-question-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ヘルプ")])])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/Spuser",
      "title": "ユーザー情報"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', [_vm._v("ユーザー情報")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "menubutton",
    attrs: {
      "title": "ログアウト"
    },
    on: {
      "click": _vm.beforeLogout
    }
  }, [_c('i', {
    staticClass: "icon-exit"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ログアウト")])]), _vm._v(" "), _c('span', {
    staticClass: "onlineCheckBox",
    attrs: {
      "id": "onlineCheckBox"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "showOnline",
      "name": "showOnline"
    },
    on: {
      "click": _vm.showOnline
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showOnline"
    }
  }, [_vm._v("オンライン授業表示")])])], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottomline"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reservationslist"
    }
  }, [_c('div', {
    staticClass: "help"
  }, [_c('span', {
    staticClass: "help-icon",
    on: {
      "click": function($event) {
        _vm.helpCliked()
      }
    }
  }, [(!_vm.help_cliked) ? _c('i', {
    staticClass: "icon-question-sign"
  }) : _vm._e(), _vm._v(" "), (_vm.help_cliked) ? _c('i', {
    staticClass: "icon-circledelete"
  }) : _vm._e()]), _vm._v(" "), (_vm.help_cliked) ? _c('div', {
    staticClass: "help_information"
  }, [_c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("月末報告の仕方")]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('el-select', {
    attrs: {
      "placeholder": "生徒名"
    },
    model: {
      value: (_vm.studentname),
      callback: function($$v) {
        _vm.studentname = $$v
      },
      expression: "studentname"
    }
  }, _vm._l((_vm.lectureInfo), function(item) {
    return _c('el-option', {
      key: item.student.id,
      attrs: {
        "label": item.student.fullname,
        "value": item.student.id
      }
    })
  }))], 1), _vm._v(" "), _c('td', [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "value-format": "yyyy-MM",
      "placeholder": "月を選択してください"
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input', {
    attrs: {
      "placeholder": "Sheets ID"
    },
    model: {
      value: (_vm.SheetsID),
      callback: function($$v) {
        _vm.SheetsID = $$v
      },
      expression: "SheetsID"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input', {
    attrs: {
      "placeholder": "シート名"
    },
    model: {
      value: (_vm.SheetsName),
      callback: function($$v) {
        _vm.SheetsName = $$v
      },
      expression: "SheetsName"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-upload"
    },
    on: {
      "click": function($event) {
        _vm.sendtoGCP()
      }
    }
  }, [_vm._v("発行")])], 1)])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "80%",
      "margin": "0 auto"
    },
    attrs: {
      "data": _vm.reservationlist
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "日付",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "開始時刻",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end_time",
      "label": "終了時刻",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "student.fullname",
      "label": "氏名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "classroom",
      "label": "教室"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', [_c('ol', {
    staticClass: "helpO2"
  }, [_c('li', [_vm._v("①発行したい生徒を選択する")]), _vm._v(" "), _c('li', [_vm._v("②発行したい月を選択する")]), _vm._v(" "), _c('li', [_vm._v("③データを記入したいスプレッドシートのIDをコピーペーストする。")]), _vm._v(" "), _c('li', [_vm._v("④データを記入したいスプレッドシートのシート名を記入する。")]), _vm._v(" "), _c('li', [_vm._v("⑤発行ボタンを押す。")])])]), _vm._v(" "), _c('td', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(589)
    }
  })])])])
}]}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "timetable"
    }
  }, [(_vm.$store.state.modal.trigger) ? _c('span', [_c('marquee', {
    attrs: {
      "bgcolor": "#000000"
    }
  }, [_c('font', {
    attrs: {
      "color": "#ffffff"
    }
  }, [_c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.modal.text)
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('timetable-header'), _vm._v(" "), _c('timetable-body'), _vm._v(" "), _c('refresh-button')], 1)
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userinfo"
    }
  }, [_c('h1', [_vm._v("ユーザー情報")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("名前")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.fullname) + "（" + _vm._s(_vm.userType) + "）")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("カナ")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ユーザー名(ID)")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.user_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("mail")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.mail_address))])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "button",
      "to": "/Spchangeuser",
      "title": "予約変更"
    }
  }, [_c('span', [_vm._v("情報を変更する")])])], 1)
},staticRenderFns: []}

/***/ })
],[324]);


// WEBPACK FOOTER //
// static/js/app.f2f23e6345a6ce7ee1cb.js